import { api } from '@/app/api/baseApi';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  AWSJSON: any;
  Long: any;
  bigint: any;
  date: any;
  jsonb: any;
  numeric: any;
};

export type Aggregate = {
  __typename?: 'Aggregate';
  count: Scalars['Int'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type Client = {
  __typename?: 'Client';
  clientInfo: ClientInfo;
  createdAt: Scalars['Long'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Long'];
};

/**  ## クライアントアプリ */
export type ClientInfo = {
  __typename?: 'ClientInfo';
  accessTokenExpiration?: Maybe<Scalars['Int']>;
  authorizationEndpoint?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientSecret?: Maybe<Scalars['String']>;
  idTokenExpiration?: Maybe<Scalars['Int']>;
  redirectUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  refreshTokenExpiration?: Maybe<Scalars['Int']>;
  scopes?: Maybe<Array<Maybe<Scalars['String']>>>;
  signOutUrls?: Maybe<Array<Maybe<Scalars['String']>>>;
  tokenEndpoint?: Maybe<Scalars['String']>;
};

export type ClientInfoInput = {
  accessTokenExpiration?: InputMaybe<Scalars['Int']>;
  authorizationEndpoint?: InputMaybe<Scalars['String']>;
  idTokenExpiration?: InputMaybe<Scalars['Int']>;
  redirectUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  refreshTokenExpiration?: InputMaybe<Scalars['Int']>;
  scopes?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  signOutUrls?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  tokenEndpoint?: InputMaybe<Scalars['String']>;
};

export type CreateClientInput = {
  clientInfo: ClientInfoInput;
  name: Scalars['String'];
  type: Scalars['String'];
  userGroupIds: Array<InputMaybe<Scalars['String']>>;
};

export type CreateGroupInput = {
  name: Scalars['String'];
  parentId?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
};

export type CreateInfo = {
  __typename?: 'CreateInfo';
  scopes: Array<Maybe<Scalars['String']>>;
  tenants: Array<Maybe<Tenant>>;
  userGroups: Array<Maybe<UserGroupForClientApp>>;
};

export type CreatePolicyInput = {
  name?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['AWSJSON']>;
};

export type CreateTenantInput = {
  alias?: InputMaybe<Scalars['String']>;
  changePasswordTemplate?: InputMaybe<Scalars['AWSJSON']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['AWSJSON']>;
  name?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

export type CreateTenantPublicInfoInput = {
  renderingResources?: InputMaybe<Scalars['AWSJSON']>;
};

export type CreateUserInput = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  createdAt?: InputMaybe<Scalars['Long']>;
  deletedAt?: InputMaybe<Scalars['Long']>;
  email: Scalars['String'];
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['Long']>;
  updatedByServiceId?: InputMaybe<Scalars['String']>;
  username: Scalars['String'];
};

export type GetItemClient = {
  __typename?: 'GetItemClient';
  clientInfo: ClientInfo;
  createdAt: Scalars['Long'];
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['Long'];
  userGroups: Array<Maybe<UserGroupForClientApp>>;
};

/**  ## グループ */
export type Group = {
  __typename?: 'Group';
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
};

export type GroupsOrderByInput = {
  updatedAt?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type ListClient = {
  __typename?: 'ListClient';
  id: Scalars['String'];
  name: Scalars['String'];
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
};

/**  ## 共通 */
export type Mutation = {
  __typename?: 'Mutation';
  /**  ## クライアントアプリ */
  createClient: Client;
  /**  ## グループ */
  createGroup?: Maybe<MutationGroupOutput>;
  /**  ## ポリシー */
  createPolicy?: Maybe<MutationPolicyOutput>;
  /**  ## テナント */
  createTenant?: Maybe<MutationTenantOutput>;
  /**  ## テナント公開情報 */
  createTenantPublicInfo?: Maybe<MutationTenantPublicInfoOutput>;
  /**  ## ユーザー */
  createUser?: Maybe<MutationUserOutput>;
  deleteClient: Scalars['String'];
  deleteGroups?: Maybe<MutationGroupOutput>;
  deletePolicies?: Maybe<MutationPolicyOutput>;
  deleteTenants?: Maybe<MutationTenantOutput>;
  deleteUsers?: Maybe<MutationUserOutput>;
  disableTenant?: Maybe<MutationTenantOutput>;
  updateClient: Client;
  updateGroups?: Maybe<MutationGroupOutput>;
  updatePolicies?: Maybe<MutationPolicyOutput>;
  updateTenantPublicInfo?: Maybe<MutationTenantPublicInfoOutput>;
  updateTenants?: Maybe<MutationTenantOutput>;
  updateUsers?: Maybe<MutationUserOutput>;
  /**  ## ユーザーグループ */
  updateUsersGroups?: Maybe<MutationUserGroupOutput>;
  /**  ## OIDCユーザー退会 */
  withdraw?: Maybe<MutationWithdrawOutput>;
};


/**  ## 共通 */
export type MutationCreateClientArgs = {
  input: CreateClientInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationCreateGroupArgs = {
  object: CreateGroupInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationCreatePolicyArgs = {
  object: CreatePolicyInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationCreateTenantArgs = {
  object: CreateTenantInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationCreateTenantPublicInfoArgs = {
  object: CreateTenantPublicInfoInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationCreateUserArgs = {
  object: CreateUserInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDeleteClientArgs = {
  clientId: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDeleteGroupsArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDeletePoliciesArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDeleteTenantsArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDeleteUsersArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationDisableTenantArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdateClientArgs = {
  clientId: Scalars['String'];
  input: UpdateClientInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdateGroupsArgs = {
  id: Scalars['String'];
  object: UpdateGroupsInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdatePoliciesArgs = {
  id: Scalars['String'];
  object: UpdatePoliciesInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdateTenantPublicInfoArgs = {
  _set: UpdateTenantPublicInfoInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<TenantPublicInfoWhereInput>;
};


/**  ## 共通 */
export type MutationUpdateTenantsArgs = {
  id: Scalars['String'];
  object: UpdateTenantsInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdateUsersArgs = {
  id: Scalars['String'];
  object: UpdateUsersInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/**  ## 共通 */
export type MutationUpdateUsersGroupsArgs = {
  groupId: Scalars['String'];
  object: UpdateUsersGroupsInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  userId: Scalars['String'];
};


/**  ## 共通 */
export type MutationWithdrawArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};

export type MutationGroupOutput = {
  __typename?: 'MutationGroupOutput';
  createdAt?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
};

export type MutationPolicyOutput = {
  __typename?: 'MutationPolicyOutput';
  createdAt?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  permission?: Maybe<Scalars['AWSJSON']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
};

export type MutationTenantOutput = {
  __typename?: 'MutationTenantOutput';
  alias?: Maybe<Scalars['String']>;
  changePasswordTemplate?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  forgottenPasswordTemplate?: Maybe<Scalars['AWSJSON']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  userPoolId?: Maybe<Scalars['String']>;
};

export type MutationTenantPublicInfoOutput = {
  __typename?: 'MutationTenantPublicInfoOutput';
  analyticsSettings?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  renderingResources?: Maybe<Scalars['AWSJSON']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
};

export type MutationUserGroupOutput = {
  __typename?: 'MutationUserGroupOutput';
  affected_rows?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  groupId?: Maybe<Scalars['String']>;
  groups?: Maybe<Group>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  userId?: Maybe<Scalars['String']>;
};

export type MutationUserOutput = {
  __typename?: 'MutationUserOutput';
  affected_rows?: Maybe<Scalars['Int']>;
  attributes?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/**  ## OIDCユーザー退会 */
export type MutationWithdrawOutput = {
  __typename?: 'MutationWithdrawOutput';
  attributes?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

export type PoliciesOrderByInput = {
  updatedAt?: InputMaybe<Scalars['String']>;
};

/**  ## ポリシー */
export type Policy = {
  __typename?: 'Policy';
  createdAt?: Maybe<Scalars['Long']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  permission?: Maybe<Scalars['AWSJSON']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
};

export type Query = {
  __typename?: 'Query';
  /**  ## クライアントアプリ */
  getClient: GetItemClient;
  getClientCreationInfo: CreateInfo;
  /**  ## グループ */
  group?: Maybe<Group>;
  groups: Array<Maybe<Group>>;
  listClients: Array<Maybe<ListClient>>;
  policies: Array<Maybe<Policy>>;
  /**  ## ポリシー */
  policy?: Maybe<Policy>;
  /**  ## テナント */
  tenant?: Maybe<Tenant>;
  tenantByShortId: Tenant;
  /**  ## テナント公開情報 */
  tenantPublicInfo: Array<Maybe<TenantPublicInfoByAppSync>>;
  tenants: Array<Maybe<Tenant>>;
  /**  ## ユーザー */
  user?: Maybe<User>;
  userGroups: Array<Maybe<UserGroup>>;
  users: Array<User>;
  usersAggregate: UsersAggregateOutput;
};


export type QueryGetClientArgs = {
  clientId: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryGetClientCreationInfoArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryGroupArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<GroupsOrderByInput>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryListClientsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryPoliciesArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<PoliciesOrderByInput>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryPolicyArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryTenantArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryTenantByShortIdArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  shortId: Scalars['Float'];
};


export type QueryTenantPublicInfoArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<TenantPublicInfoWhereInput>;
};


export type QueryTenantsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<TenantsOrderByInput>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryUserArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryUserGroupsArgs = {
  groupId: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type QueryUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderByInput>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type QueryUsersAggregateArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<UsersWhereInput>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

/**  ## テナント */
export type Tenant = {
  __typename?: 'Tenant';
  alias: Scalars['String'];
  changePasswordTemplate?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  forgottenPasswordTemplate?: Maybe<Scalars['AWSJSON']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  shortId?: Maybe<Scalars['Int']>;
  state?: Maybe<Scalars['String']>;
  tenantPublicInfo?: Maybe<Scalars['AWSJSON']>;
  updatedAt?: Maybe<Scalars['Long']>;
  userPoolId: Scalars['String'];
};

/**  ## テナント公開情報 */
export type TenantPublicInfoByAppSync = {
  __typename?: 'TenantPublicInfoByAppSync';
  analyticsSettings?: Maybe<Scalars['AWSJSON']>;
  createdAt?: Maybe<Scalars['Long']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  renderingResources?: Maybe<Scalars['AWSJSON']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['Long']>;
};

export type TenantPublicInfoEqStrFilter = {
  _eq?: InputMaybe<Scalars['String']>;
};

export type TenantPublicInfoWhereInput = {
  serviceId?: InputMaybe<TenantPublicInfoEqStrFilter>;
};

export type TenantsOrderByInput = {
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type UpdateClientInput = {
  clientInfo?: InputMaybe<ClientInfoInput>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  userGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type UpdateGroupsInput = {
  name?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
};

export type UpdatePoliciesInput = {
  name?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['AWSJSON']>;
};

export type UpdateTenantPublicInfoInput = {
  renderingResources?: InputMaybe<Scalars['AWSJSON']>;
};

export type UpdateTenantsInput = {
  alias?: InputMaybe<Scalars['String']>;
  changePasswordTemplate?: InputMaybe<Scalars['AWSJSON']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['AWSJSON']>;
  name?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['Int']>;
  state?: InputMaybe<Scalars['String']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

export type UpdateUsersGroupsInput = {
  groupId?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type UpdateUsersInput = {
  attributes?: InputMaybe<Scalars['AWSJSON']>;
  email?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  updatedByServiceId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/**  ## ユーザ */
export type User = {
  __typename?: 'User';
  attributes: Scalars['AWSJSON'];
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  email: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  role?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  usersGroups: Array<UserGroup>;
};


/**  ## ユーザ */
export type UserUsersGroupsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
};

/**  ## ユーザーグループ */
export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt?: Maybe<Scalars['Long']>;
  deletedAt?: Maybe<Scalars['Long']>;
  groupId: Scalars['String'];
  groups?: Maybe<Group>;
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['Long']>;
  userId: Scalars['String'];
};

export type UserGroupForClientApp = {
  __typename?: 'UserGroupForClientApp';
  id: Scalars['String'];
  name: Scalars['String'];
  tenantAlias: Scalars['String'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

export type UsersAggregateOutput = {
  __typename?: 'UsersAggregateOutput';
  aggregate?: Maybe<Aggregate>;
};

export type UsersEqStrFilter = {
  _eq?: InputMaybe<Scalars['String']>;
};

export type UsersGroupsFilter = {
  groupId?: InputMaybe<UsersEqStrFilter>;
};

export type UsersIlikeFilter = {
  _ilike?: InputMaybe<Scalars['String']>;
};

export type UsersOrFilter = {
  email?: InputMaybe<UsersIlikeFilter>;
  username?: InputMaybe<UsersIlikeFilter>;
};

export type UsersOrderByInput = {
  updatedAt?: InputMaybe<Scalars['String']>;
};

export type UsersStateFilter = {
  _neq?: InputMaybe<Scalars['String']>;
};

export type UsersWhereInput = {
  _or?: InputMaybe<UsersOrFilter>;
  state?: InputMaybe<UsersStateFilter>;
  username?: InputMaybe<UsersEqStrFilter>;
  usersGroups?: InputMaybe<UsersGroupsFilter>;
};

/** columns and relationships of "access_logs" */
export type AccessLogs = {
  __typename?: 'accessLogs';
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  messages: Scalars['jsonb'];
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  transactionId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "access_logs" */
export type AccessLogsMessagesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "access_logs" */
export type AccessLogs_Aggregate = {
  __typename?: 'accessLogs_aggregate';
  aggregate?: Maybe<AccessLogs_Aggregate_Fields>;
  nodes: Array<AccessLogs>;
};

/** aggregate fields of "access_logs" */
export type AccessLogs_Aggregate_Fields = {
  __typename?: 'accessLogs_aggregate_fields';
  avg?: Maybe<AccessLogs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AccessLogs_Max_Fields>;
  min?: Maybe<AccessLogs_Min_Fields>;
  stddev?: Maybe<AccessLogs_Stddev_Fields>;
  stddev_pop?: Maybe<AccessLogs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AccessLogs_Stddev_Samp_Fields>;
  sum?: Maybe<AccessLogs_Sum_Fields>;
  var_pop?: Maybe<AccessLogs_Var_Pop_Fields>;
  var_samp?: Maybe<AccessLogs_Var_Samp_Fields>;
  variance?: Maybe<AccessLogs_Variance_Fields>;
};


/** aggregate fields of "access_logs" */
export type AccessLogs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AccessLogs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AccessLogs_Append_Input = {
  messages?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AccessLogs_Avg_Fields = {
  __typename?: 'accessLogs_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "access_logs". All fields are combined with a logical 'AND'. */
export type AccessLogs_Bool_Exp = {
  _and?: InputMaybe<Array<AccessLogs_Bool_Exp>>;
  _not?: InputMaybe<AccessLogs_Bool_Exp>;
  _or?: InputMaybe<Array<AccessLogs_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  messages?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  transactionId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "access_logs" */
export enum AccessLogs_Constraint {
  /** unique or primary key constraint on columns "id" */
  AccessLogsPkey = 'access_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AccessLogs_Delete_At_Path_Input = {
  messages?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AccessLogs_Delete_Elem_Input = {
  messages?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AccessLogs_Delete_Key_Input = {
  messages?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "access_logs" */
export type AccessLogs_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "access_logs" */
export type AccessLogs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AccessLogs_Max_Fields = {
  __typename?: 'accessLogs_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AccessLogs_Min_Fields = {
  __typename?: 'accessLogs_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  transactionId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "access_logs" */
export type AccessLogs_Mutation_Response = {
  __typename?: 'accessLogs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AccessLogs>;
};

/** on_conflict condition type for table "access_logs" */
export type AccessLogs_On_Conflict = {
  constraint: AccessLogs_Constraint;
  update_columns?: Array<AccessLogs_Update_Column>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};

/** Ordering options when selecting data from "access_logs". */
export type AccessLogs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messages?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  transactionId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: access_logs */
export type AccessLogs_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AccessLogs_Prepend_Input = {
  messages?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "access_logs" */
export enum AccessLogs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Messages = 'messages',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "access_logs" */
export type AccessLogs_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AccessLogs_Stddev_Fields = {
  __typename?: 'accessLogs_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AccessLogs_Stddev_Pop_Fields = {
  __typename?: 'accessLogs_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AccessLogs_Stddev_Samp_Fields = {
  __typename?: 'accessLogs_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "accessLogs" */
export type AccessLogs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AccessLogs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AccessLogs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  messages?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  transactionId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AccessLogs_Sum_Fields = {
  __typename?: 'accessLogs_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "access_logs" */
export enum AccessLogs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Messages = 'messages',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TransactionId = 'transactionId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AccessLogs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AccessLogs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AccessLogs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AccessLogs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AccessLogs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AccessLogs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AccessLogs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AccessLogs_Set_Input>;
  /** filter the rows which have to be updated */
  where: AccessLogs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AccessLogs_Var_Pop_Fields = {
  __typename?: 'accessLogs_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AccessLogs_Var_Samp_Fields = {
  __typename?: 'accessLogs_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AccessLogs_Variance_Fields = {
  __typename?: 'accessLogs_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "asset_images" */
export type AssetImages = {
  __typename?: 'assetImages';
  assetId: Scalars['String'];
  /** An object relationship */
  assets?: Maybe<Assets>;
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  sortNumber?: Maybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};

/** aggregated selection of "asset_images" */
export type AssetImages_Aggregate = {
  __typename?: 'assetImages_aggregate';
  aggregate?: Maybe<AssetImages_Aggregate_Fields>;
  nodes: Array<AssetImages>;
};

export type AssetImages_Aggregate_Bool_Exp = {
  count?: InputMaybe<AssetImages_Aggregate_Bool_Exp_Count>;
};

export type AssetImages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AssetImages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetImages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_images" */
export type AssetImages_Aggregate_Fields = {
  __typename?: 'assetImages_aggregate_fields';
  avg?: Maybe<AssetImages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AssetImages_Max_Fields>;
  min?: Maybe<AssetImages_Min_Fields>;
  stddev?: Maybe<AssetImages_Stddev_Fields>;
  stddev_pop?: Maybe<AssetImages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AssetImages_Stddev_Samp_Fields>;
  sum?: Maybe<AssetImages_Sum_Fields>;
  var_pop?: Maybe<AssetImages_Var_Pop_Fields>;
  var_samp?: Maybe<AssetImages_Var_Samp_Fields>;
  variance?: Maybe<AssetImages_Variance_Fields>;
};


/** aggregate fields of "asset_images" */
export type AssetImages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AssetImages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_images" */
export type AssetImages_Aggregate_Order_By = {
  avg?: InputMaybe<AssetImages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AssetImages_Max_Order_By>;
  min?: InputMaybe<AssetImages_Min_Order_By>;
  stddev?: InputMaybe<AssetImages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AssetImages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AssetImages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AssetImages_Sum_Order_By>;
  var_pop?: InputMaybe<AssetImages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AssetImages_Var_Samp_Order_By>;
  variance?: InputMaybe<AssetImages_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_images" */
export type AssetImages_Arr_Rel_Insert_Input = {
  data: Array<AssetImages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetImages_On_Conflict>;
};

/** aggregate avg on columns */
export type AssetImages_Avg_Fields = {
  __typename?: 'assetImages_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_images" */
export type AssetImages_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_images". All fields are combined with a logical 'AND'. */
export type AssetImages_Bool_Exp = {
  _and?: InputMaybe<Array<AssetImages_Bool_Exp>>;
  _not?: InputMaybe<AssetImages_Bool_Exp>;
  _or?: InputMaybe<Array<AssetImages_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  imageUrl?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  sortNumber?: InputMaybe<Int_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_images" */
export enum AssetImages_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetImagesPkey = 'asset_images_pkey'
}

/** input type for incrementing numeric columns in table "asset_images" */
export type AssetImages_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  sortNumber?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "asset_images" */
export type AssetImages_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  sortNumber?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AssetImages_Max_Fields = {
  __typename?: 'assetImages_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  sortNumber?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_images" */
export type AssetImages_Max_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AssetImages_Min_Fields = {
  __typename?: 'assetImages_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  sortNumber?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_images" */
export type AssetImages_Min_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_images" */
export type AssetImages_Mutation_Response = {
  __typename?: 'assetImages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetImages>;
};

/** on_conflict condition type for table "asset_images" */
export type AssetImages_On_Conflict = {
  constraint: AssetImages_Constraint;
  update_columns?: Array<AssetImages_Update_Column>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_images". */
export type AssetImages_Order_By = {
  assetId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  imageUrl?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_images */
export type AssetImages_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "asset_images" */
export enum AssetImages_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  SortNumber = 'sortNumber',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "asset_images" */
export type AssetImages_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  sortNumber?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AssetImages_Stddev_Fields = {
  __typename?: 'assetImages_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_images" */
export type AssetImages_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AssetImages_Stddev_Pop_Fields = {
  __typename?: 'assetImages_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_images" */
export type AssetImages_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AssetImages_Stddev_Samp_Fields = {
  __typename?: 'assetImages_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_images" */
export type AssetImages_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assetImages" */
export type AssetImages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AssetImages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetImages_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  sortNumber?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetImages_Sum_Fields = {
  __typename?: 'assetImages_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  sortNumber?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_images" */
export type AssetImages_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "asset_images" */
export enum AssetImages_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ImageUrl = 'imageUrl',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  SortNumber = 'sortNumber',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AssetImages_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AssetImages_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetImages_Set_Input>;
  /** filter the rows which have to be updated */
  where: AssetImages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AssetImages_Var_Pop_Fields = {
  __typename?: 'assetImages_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_images" */
export type AssetImages_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AssetImages_Var_Samp_Fields = {
  __typename?: 'assetImages_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_images" */
export type AssetImages_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AssetImages_Variance_Fields = {
  __typename?: 'assetImages_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sortNumber?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_images" */
export type AssetImages_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sortNumber?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_properties" */
export type AssetProperties = {
  __typename?: 'assetProperties';
  assetId: Scalars['String'];
  /** An object relationship */
  assets?: Maybe<Assets>;
  createdAt: Scalars['bigint'];
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: Maybe<Scalars['String']>;
  updatedAt: Scalars['bigint'];
  value: Scalars['jsonb'];
};


/** columns and relationships of "asset_properties" */
export type AssetPropertiesValueArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "asset_properties" */
export type AssetProperties_Aggregate = {
  __typename?: 'assetProperties_aggregate';
  aggregate?: Maybe<AssetProperties_Aggregate_Fields>;
  nodes: Array<AssetProperties>;
};

export type AssetProperties_Aggregate_Bool_Exp = {
  count?: InputMaybe<AssetProperties_Aggregate_Bool_Exp_Count>;
};

export type AssetProperties_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AssetProperties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetProperties_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_properties" */
export type AssetProperties_Aggregate_Fields = {
  __typename?: 'assetProperties_aggregate_fields';
  avg?: Maybe<AssetProperties_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AssetProperties_Max_Fields>;
  min?: Maybe<AssetProperties_Min_Fields>;
  stddev?: Maybe<AssetProperties_Stddev_Fields>;
  stddev_pop?: Maybe<AssetProperties_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AssetProperties_Stddev_Samp_Fields>;
  sum?: Maybe<AssetProperties_Sum_Fields>;
  var_pop?: Maybe<AssetProperties_Var_Pop_Fields>;
  var_samp?: Maybe<AssetProperties_Var_Samp_Fields>;
  variance?: Maybe<AssetProperties_Variance_Fields>;
};


/** aggregate fields of "asset_properties" */
export type AssetProperties_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AssetProperties_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_properties" */
export type AssetProperties_Aggregate_Order_By = {
  avg?: InputMaybe<AssetProperties_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AssetProperties_Max_Order_By>;
  min?: InputMaybe<AssetProperties_Min_Order_By>;
  stddev?: InputMaybe<AssetProperties_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AssetProperties_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AssetProperties_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AssetProperties_Sum_Order_By>;
  var_pop?: InputMaybe<AssetProperties_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AssetProperties_Var_Samp_Order_By>;
  variance?: InputMaybe<AssetProperties_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AssetProperties_Append_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "asset_properties" */
export type AssetProperties_Arr_Rel_Insert_Input = {
  data: Array<AssetProperties_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetProperties_On_Conflict>;
};

/** aggregate avg on columns */
export type AssetProperties_Avg_Fields = {
  __typename?: 'assetProperties_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_properties" */
export type AssetProperties_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_properties". All fields are combined with a logical 'AND'. */
export type AssetProperties_Bool_Exp = {
  _and?: InputMaybe<Array<AssetProperties_Bool_Exp>>;
  _not?: InputMaybe<AssetProperties_Bool_Exp>;
  _or?: InputMaybe<Array<AssetProperties_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  groupId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  value?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_properties" */
export enum AssetProperties_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetPropertiesPkey = 'asset_properties_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AssetProperties_Delete_At_Path_Input = {
  value?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AssetProperties_Delete_Elem_Input = {
  value?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AssetProperties_Delete_Key_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "asset_properties" */
export type AssetProperties_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "asset_properties" */
export type AssetProperties_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type AssetProperties_Max_Fields = {
  __typename?: 'assetProperties_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_properties" */
export type AssetProperties_Max_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AssetProperties_Min_Fields = {
  __typename?: 'assetProperties_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_properties" */
export type AssetProperties_Min_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_properties" */
export type AssetProperties_Mutation_Response = {
  __typename?: 'assetProperties_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetProperties>;
};

/** on_conflict condition type for table "asset_properties" */
export type AssetProperties_On_Conflict = {
  constraint: AssetProperties_Constraint;
  update_columns?: Array<AssetProperties_Update_Column>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_properties". */
export type AssetProperties_Order_By = {
  assetId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_properties */
export type AssetProperties_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AssetProperties_Prepend_Input = {
  value?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "asset_properties" */
export enum AssetProperties_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "asset_properties" */
export type AssetProperties_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type AssetProperties_Stddev_Fields = {
  __typename?: 'assetProperties_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_properties" */
export type AssetProperties_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AssetProperties_Stddev_Pop_Fields = {
  __typename?: 'assetProperties_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_properties" */
export type AssetProperties_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AssetProperties_Stddev_Samp_Fields = {
  __typename?: 'assetProperties_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_properties" */
export type AssetProperties_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assetProperties" */
export type AssetProperties_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AssetProperties_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetProperties_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  value?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type AssetProperties_Sum_Fields = {
  __typename?: 'assetProperties_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_properties" */
export type AssetProperties_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "asset_properties" */
export enum AssetProperties_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Value = 'value'
}

export type AssetProperties_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AssetProperties_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AssetProperties_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AssetProperties_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AssetProperties_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AssetProperties_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AssetProperties_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetProperties_Set_Input>;
  /** filter the rows which have to be updated */
  where: AssetProperties_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AssetProperties_Var_Pop_Fields = {
  __typename?: 'assetProperties_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_properties" */
export type AssetProperties_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AssetProperties_Var_Samp_Fields = {
  __typename?: 'assetProperties_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_properties" */
export type AssetProperties_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AssetProperties_Variance_Fields = {
  __typename?: 'assetProperties_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_properties" */
export type AssetProperties_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_tags" */
export type AssetTags = {
  __typename?: 'assetTags';
  assetId: Scalars['String'];
  /** An object relationship */
  assets?: Maybe<Assets>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "asset_tags" */
export type AssetTags_Aggregate = {
  __typename?: 'assetTags_aggregate';
  aggregate?: Maybe<AssetTags_Aggregate_Fields>;
  nodes: Array<AssetTags>;
};

export type AssetTags_Aggregate_Bool_Exp = {
  count?: InputMaybe<AssetTags_Aggregate_Bool_Exp_Count>;
};

export type AssetTags_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AssetTags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetTags_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "asset_tags" */
export type AssetTags_Aggregate_Fields = {
  __typename?: 'assetTags_aggregate_fields';
  avg?: Maybe<AssetTags_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AssetTags_Max_Fields>;
  min?: Maybe<AssetTags_Min_Fields>;
  stddev?: Maybe<AssetTags_Stddev_Fields>;
  stddev_pop?: Maybe<AssetTags_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AssetTags_Stddev_Samp_Fields>;
  sum?: Maybe<AssetTags_Sum_Fields>;
  var_pop?: Maybe<AssetTags_Var_Pop_Fields>;
  var_samp?: Maybe<AssetTags_Var_Samp_Fields>;
  variance?: Maybe<AssetTags_Variance_Fields>;
};


/** aggregate fields of "asset_tags" */
export type AssetTags_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AssetTags_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "asset_tags" */
export type AssetTags_Aggregate_Order_By = {
  avg?: InputMaybe<AssetTags_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AssetTags_Max_Order_By>;
  min?: InputMaybe<AssetTags_Min_Order_By>;
  stddev?: InputMaybe<AssetTags_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AssetTags_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AssetTags_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AssetTags_Sum_Order_By>;
  var_pop?: InputMaybe<AssetTags_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AssetTags_Var_Samp_Order_By>;
  variance?: InputMaybe<AssetTags_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "asset_tags" */
export type AssetTags_Arr_Rel_Insert_Input = {
  data: Array<AssetTags_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetTags_On_Conflict>;
};

/** aggregate avg on columns */
export type AssetTags_Avg_Fields = {
  __typename?: 'assetTags_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "asset_tags" */
export type AssetTags_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "asset_tags". All fields are combined with a logical 'AND'. */
export type AssetTags_Bool_Exp = {
  _and?: InputMaybe<Array<AssetTags_Bool_Exp>>;
  _not?: InputMaybe<AssetTags_Bool_Exp>;
  _or?: InputMaybe<Array<AssetTags_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_tags" */
export enum AssetTags_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTagsPkey = 'asset_tags_pkey',
  /** unique or primary key constraint on columns "asset_id", "name" */
  UniqueName = 'unique_name'
}

/** input type for incrementing numeric columns in table "asset_tags" */
export type AssetTags_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "asset_tags" */
export type AssetTags_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AssetTags_Max_Fields = {
  __typename?: 'assetTags_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "asset_tags" */
export type AssetTags_Max_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AssetTags_Min_Fields = {
  __typename?: 'assetTags_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "asset_tags" */
export type AssetTags_Min_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "asset_tags" */
export type AssetTags_Mutation_Response = {
  __typename?: 'assetTags_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetTags>;
};

/** on_conflict condition type for table "asset_tags" */
export type AssetTags_On_Conflict = {
  constraint: AssetTags_Constraint;
  update_columns?: Array<AssetTags_Update_Column>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_tags". */
export type AssetTags_Order_By = {
  assetId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_tags */
export type AssetTags_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "asset_tags" */
export enum AssetTags_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "asset_tags" */
export type AssetTags_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AssetTags_Stddev_Fields = {
  __typename?: 'assetTags_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "asset_tags" */
export type AssetTags_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AssetTags_Stddev_Pop_Fields = {
  __typename?: 'assetTags_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "asset_tags" */
export type AssetTags_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AssetTags_Stddev_Samp_Fields = {
  __typename?: 'assetTags_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "asset_tags" */
export type AssetTags_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assetTags" */
export type AssetTags_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AssetTags_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetTags_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetTags_Sum_Fields = {
  __typename?: 'assetTags_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "asset_tags" */
export type AssetTags_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "asset_tags" */
export enum AssetTags_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AssetTags_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AssetTags_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetTags_Set_Input>;
  /** filter the rows which have to be updated */
  where: AssetTags_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AssetTags_Var_Pop_Fields = {
  __typename?: 'assetTags_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "asset_tags" */
export type AssetTags_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AssetTags_Var_Samp_Fields = {
  __typename?: 'assetTags_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "asset_tags" */
export type AssetTags_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AssetTags_Variance_Fields = {
  __typename?: 'assetTags_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "asset_tags" */
export type AssetTags_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "asset_types" */
export type AssetTypes = {
  __typename?: 'assetTypes';
  assetAttributesSchema: Scalars['jsonb'];
  /** An array relationship */
  assets: Array<Assets>;
  /** An aggregate relationship */
  assets_aggregate: Assets_Aggregate;
  attributes: Scalars['jsonb'];
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  format: Scalars['jsonb'];
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  renderingResources: Scalars['jsonb'];
  serviceId?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesAssetAttributesSchemaArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesAssetsArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesFormatArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "asset_types" */
export type AssetTypesRenderingResourcesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "asset_types" */
export type AssetTypes_Aggregate = {
  __typename?: 'assetTypes_aggregate';
  aggregate?: Maybe<AssetTypes_Aggregate_Fields>;
  nodes: Array<AssetTypes>;
};

/** aggregate fields of "asset_types" */
export type AssetTypes_Aggregate_Fields = {
  __typename?: 'assetTypes_aggregate_fields';
  avg?: Maybe<AssetTypes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AssetTypes_Max_Fields>;
  min?: Maybe<AssetTypes_Min_Fields>;
  stddev?: Maybe<AssetTypes_Stddev_Fields>;
  stddev_pop?: Maybe<AssetTypes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AssetTypes_Stddev_Samp_Fields>;
  sum?: Maybe<AssetTypes_Sum_Fields>;
  var_pop?: Maybe<AssetTypes_Var_Pop_Fields>;
  var_samp?: Maybe<AssetTypes_Var_Samp_Fields>;
  variance?: Maybe<AssetTypes_Variance_Fields>;
};


/** aggregate fields of "asset_types" */
export type AssetTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AssetTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AssetTypes_Append_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  format?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AssetTypes_Avg_Fields = {
  __typename?: 'assetTypes_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "asset_types". All fields are combined with a logical 'AND'. */
export type AssetTypes_Bool_Exp = {
  _and?: InputMaybe<Array<AssetTypes_Bool_Exp>>;
  _not?: InputMaybe<AssetTypes_Bool_Exp>;
  _or?: InputMaybe<Array<AssetTypes_Bool_Exp>>;
  assetAttributesSchema?: InputMaybe<Jsonb_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  assets_aggregate?: InputMaybe<Assets_Aggregate_Bool_Exp>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  format?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  renderingResources?: InputMaybe<Jsonb_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  shortId?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_types" */
export enum AssetTypes_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetTypesPkey = 'asset_types_pkey',
  /** unique or primary key constraint on columns "short_id" */
  AssetTypesShortIdKey = 'asset_types_short_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AssetTypes_Delete_At_Path_Input = {
  assetAttributesSchema?: InputMaybe<Array<Scalars['String']>>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  format?: InputMaybe<Array<Scalars['String']>>;
  renderingResources?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AssetTypes_Delete_Elem_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Scalars['Int']>;
  format?: InputMaybe<Scalars['Int']>;
  renderingResources?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AssetTypes_Delete_Key_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "asset_types" */
export type AssetTypes_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "asset_types" */
export type AssetTypes_Insert_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['jsonb']>;
  assets?: InputMaybe<Assets_Arr_Rel_Insert_Input>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AssetTypes_Max_Fields = {
  __typename?: 'assetTypes_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type AssetTypes_Min_Fields = {
  __typename?: 'assetTypes_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "asset_types" */
export type AssetTypes_Mutation_Response = {
  __typename?: 'assetTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetTypes>;
};

/** input type for inserting object relation for remote table "asset_types" */
export type AssetTypes_Obj_Rel_Insert_Input = {
  data: AssetTypes_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetTypes_On_Conflict>;
};

/** on_conflict condition type for table "asset_types" */
export type AssetTypes_On_Conflict = {
  constraint: AssetTypes_Constraint;
  update_columns?: Array<AssetTypes_Update_Column>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_types". */
export type AssetTypes_Order_By = {
  assetAttributesSchema?: InputMaybe<Order_By>;
  assets_aggregate?: InputMaybe<Assets_Aggregate_Order_By>;
  attributes?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  format?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  renderingResources?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_types */
export type AssetTypes_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AssetTypes_Prepend_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  format?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "asset_types" */
export enum AssetTypes_Select_Column {
  /** column name */
  AssetAttributesSchema = 'assetAttributesSchema',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "asset_types" */
export type AssetTypes_Set_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AssetTypes_Stddev_Fields = {
  __typename?: 'assetTypes_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AssetTypes_Stddev_Pop_Fields = {
  __typename?: 'assetTypes_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AssetTypes_Stddev_Samp_Fields = {
  __typename?: 'assetTypes_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "assetTypes" */
export type AssetTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AssetTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetTypes_Stream_Cursor_Value_Input = {
  assetAttributesSchema?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  format?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetTypes_Sum_Fields = {
  __typename?: 'assetTypes_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "asset_types" */
export enum AssetTypes_Update_Column {
  /** column name */
  AssetAttributesSchema = 'assetAttributesSchema',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Format = 'format',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AssetTypes_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AssetTypes_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AssetTypes_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AssetTypes_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AssetTypes_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AssetTypes_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AssetTypes_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: AssetTypes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AssetTypes_Var_Pop_Fields = {
  __typename?: 'assetTypes_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AssetTypes_Var_Samp_Fields = {
  __typename?: 'assetTypes_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AssetTypes_Variance_Fields = {
  __typename?: 'assetTypes_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "asset_states" */
export type Asset_States = {
  __typename?: 'asset_states';
  serviceIds?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "asset_states" */
export type Asset_States_Aggregate = {
  __typename?: 'asset_states_aggregate';
  aggregate?: Maybe<Asset_States_Aggregate_Fields>;
  nodes: Array<Asset_States>;
};

/** aggregate fields of "asset_states" */
export type Asset_States_Aggregate_Fields = {
  __typename?: 'asset_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Asset_States_Max_Fields>;
  min?: Maybe<Asset_States_Min_Fields>;
};


/** aggregate fields of "asset_states" */
export type Asset_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Asset_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "asset_states". All fields are combined with a logical 'AND'. */
export type Asset_States_Bool_Exp = {
  _and?: InputMaybe<Array<Asset_States_Bool_Exp>>;
  _not?: InputMaybe<Asset_States_Bool_Exp>;
  _or?: InputMaybe<Array<Asset_States_Bool_Exp>>;
  serviceIds?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "asset_states" */
export enum Asset_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  AssetStatesPkey = 'asset_states_pkey'
}

export enum Asset_States_Enum {
  /** ELCOMPATH_SERVICE, CUCON_SERVICE, OPENDATA_SERVICE */
  Disabled = 'disabled',
  /** ELCOMPATH_SERVICE, CUCON_SERVICE, OPENDATA_SERVICE */
  Enabled = 'enabled',
  /** ELCOMPATH_SERVICE */
  Preview = 'preview'
}

/** Boolean expression to compare columns of type "asset_states_enum". All fields are combined with logical 'AND'. */
export type Asset_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Asset_States_Enum>;
  _in?: InputMaybe<Array<Asset_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Asset_States_Enum>;
  _nin?: InputMaybe<Array<Asset_States_Enum>>;
};

/** input type for inserting data into table "asset_states" */
export type Asset_States_Insert_Input = {
  serviceIds?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Asset_States_Max_Fields = {
  __typename?: 'asset_states_max_fields';
  serviceIds?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Asset_States_Min_Fields = {
  __typename?: 'asset_states_min_fields';
  serviceIds?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "asset_states" */
export type Asset_States_Mutation_Response = {
  __typename?: 'asset_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Asset_States>;
};

/** on_conflict condition type for table "asset_states" */
export type Asset_States_On_Conflict = {
  constraint: Asset_States_Constraint;
  update_columns?: Array<Asset_States_Update_Column>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};

/** Ordering options when selecting data from "asset_states". */
export type Asset_States_Order_By = {
  serviceIds?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: asset_states */
export type Asset_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "asset_states" */
export enum Asset_States_Select_Column {
  /** column name */
  ServiceIds = 'serviceIds',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "asset_states" */
export type Asset_States_Set_Input = {
  serviceIds?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "asset_states" */
export type Asset_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Asset_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Asset_States_Stream_Cursor_Value_Input = {
  serviceIds?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "asset_states" */
export enum Asset_States_Update_Column {
  /** column name */
  ServiceIds = 'serviceIds',
  /** column name */
  Value = 'value'
}

export type Asset_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Asset_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Asset_States_Bool_Exp;
};

/** columns and relationships of "assets" */
export type Assets = {
  __typename?: 'assets';
  /** An array relationship */
  UsersAssets: Array<UsersAssets>;
  /** An aggregate relationship */
  UsersAssets_aggregate: UsersAssets_Aggregate;
  /** An array relationship */
  assetImages: Array<AssetImages>;
  /** An aggregate relationship */
  assetImages_aggregate: AssetImages_Aggregate;
  /** An array relationship */
  assetProperties: Array<AssetProperties>;
  /** An aggregate relationship */
  assetProperties_aggregate: AssetProperties_Aggregate;
  /** An array relationship */
  assetTags: Array<AssetTags>;
  /** An aggregate relationship */
  assetTags_aggregate: AssetTags_Aggregate;
  assetTypeId?: Maybe<Scalars['String']>;
  /** An object relationship */
  assetTypes?: Maybe<AssetTypes>;
  attributes: Scalars['jsonb'];
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location: Scalars['jsonb'];
  /** An array relationship */
  members: Array<AssetsAssets>;
  /** An aggregate relationship */
  members_aggregate: AssetsAssets_Aggregate;
  /** An array relationship */
  messages: Array<Messages>;
  /** An aggregate relationship */
  messages_aggregate: Messages_Aggregate;
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  /** An array relationship */
  owners: Array<AssetsAssets>;
  /** An aggregate relationship */
  owners_aggregate: AssetsAssets_Aggregate;
  providerId?: Maybe<Scalars['String']>;
  /** An array relationship */
  providersAssets: Array<ProvidersAssets>;
  /** An aggregate relationship */
  providersAssets_aggregate: ProvidersAssets_Aggregate;
  renderingResources: Scalars['jsonb'];
  serviceId?: Maybe<Scalars['String']>;
  state: Asset_States_Enum;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "assets" */
export type AssetsUsersAssetsArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsUsersAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetImagesArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetImages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetPropertiesArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetProperties_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetTagsArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAssetTags_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "assets" */
export type AssetsLocationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "assets" */
export type AssetsMembersArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsMessages_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsOwnersArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsOwners_AggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsProvidersAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsProvidersAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


/** columns and relationships of "assets" */
export type AssetsRenderingResourcesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "assets_assets" */
export type AssetsAssets = {
  __typename?: 'assetsAssets';
  attachedFrom?: Maybe<Scalars['bigint']>;
  attachedTo?: Maybe<Scalars['bigint']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  /** An object relationship */
  memberAsset?: Maybe<Assets>;
  memberAssetId: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  /** An object relationship */
  ownerAsset?: Maybe<Assets>;
  ownerAssetId: Scalars['String'];
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "assets_assets" */
export type AssetsAssets_Aggregate = {
  __typename?: 'assetsAssets_aggregate';
  aggregate?: Maybe<AssetsAssets_Aggregate_Fields>;
  nodes: Array<AssetsAssets>;
};

export type AssetsAssets_Aggregate_Bool_Exp = {
  count?: InputMaybe<AssetsAssets_Aggregate_Bool_Exp_Count>;
};

export type AssetsAssets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<AssetsAssets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assets_assets" */
export type AssetsAssets_Aggregate_Fields = {
  __typename?: 'assetsAssets_aggregate_fields';
  avg?: Maybe<AssetsAssets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AssetsAssets_Max_Fields>;
  min?: Maybe<AssetsAssets_Min_Fields>;
  stddev?: Maybe<AssetsAssets_Stddev_Fields>;
  stddev_pop?: Maybe<AssetsAssets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AssetsAssets_Stddev_Samp_Fields>;
  sum?: Maybe<AssetsAssets_Sum_Fields>;
  var_pop?: Maybe<AssetsAssets_Var_Pop_Fields>;
  var_samp?: Maybe<AssetsAssets_Var_Samp_Fields>;
  variance?: Maybe<AssetsAssets_Variance_Fields>;
};


/** aggregate fields of "assets_assets" */
export type AssetsAssets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assets_assets" */
export type AssetsAssets_Aggregate_Order_By = {
  avg?: InputMaybe<AssetsAssets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<AssetsAssets_Max_Order_By>;
  min?: InputMaybe<AssetsAssets_Min_Order_By>;
  stddev?: InputMaybe<AssetsAssets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<AssetsAssets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<AssetsAssets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<AssetsAssets_Sum_Order_By>;
  var_pop?: InputMaybe<AssetsAssets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<AssetsAssets_Var_Samp_Order_By>;
  variance?: InputMaybe<AssetsAssets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "assets_assets" */
export type AssetsAssets_Arr_Rel_Insert_Input = {
  data: Array<AssetsAssets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<AssetsAssets_On_Conflict>;
};

/** aggregate avg on columns */
export type AssetsAssets_Avg_Fields = {
  __typename?: 'assetsAssets_avg_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assets_assets" */
export type AssetsAssets_Avg_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assets_assets". All fields are combined with a logical 'AND'. */
export type AssetsAssets_Bool_Exp = {
  _and?: InputMaybe<Array<AssetsAssets_Bool_Exp>>;
  _not?: InputMaybe<AssetsAssets_Bool_Exp>;
  _or?: InputMaybe<Array<AssetsAssets_Bool_Exp>>;
  attachedFrom?: InputMaybe<Bigint_Comparison_Exp>;
  attachedTo?: InputMaybe<Bigint_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  memberAsset?: InputMaybe<Assets_Bool_Exp>;
  memberAssetId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  ownerAsset?: InputMaybe<Assets_Bool_Exp>;
  ownerAssetId?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "assets_assets" */
export enum AssetsAssets_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetsAssetsPkey = 'assets_assets_pkey'
}

/** input type for incrementing numeric columns in table "assets_assets" */
export type AssetsAssets_Inc_Input = {
  attachedFrom?: InputMaybe<Scalars['bigint']>;
  attachedTo?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "assets_assets" */
export type AssetsAssets_Insert_Input = {
  attachedFrom?: InputMaybe<Scalars['bigint']>;
  attachedTo?: InputMaybe<Scalars['bigint']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  memberAsset?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  memberAssetId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  ownerAsset?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  ownerAssetId?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type AssetsAssets_Max_Fields = {
  __typename?: 'assetsAssets_max_fields';
  attachedFrom?: Maybe<Scalars['bigint']>;
  attachedTo?: Maybe<Scalars['bigint']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  memberAssetId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  ownerAssetId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "assets_assets" */
export type AssetsAssets_Max_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memberAssetId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  ownerAssetId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type AssetsAssets_Min_Fields = {
  __typename?: 'assetsAssets_min_fields';
  attachedFrom?: Maybe<Scalars['bigint']>;
  attachedTo?: Maybe<Scalars['bigint']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  memberAssetId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  ownerAssetId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "assets_assets" */
export type AssetsAssets_Min_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memberAssetId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  ownerAssetId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assets_assets" */
export type AssetsAssets_Mutation_Response = {
  __typename?: 'assetsAssets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AssetsAssets>;
};

/** on_conflict condition type for table "assets_assets" */
export type AssetsAssets_On_Conflict = {
  constraint: AssetsAssets_Constraint;
  update_columns?: Array<AssetsAssets_Update_Column>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};

/** Ordering options when selecting data from "assets_assets". */
export type AssetsAssets_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memberAsset?: InputMaybe<Assets_Order_By>;
  memberAssetId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  ownerAsset?: InputMaybe<Assets_Order_By>;
  ownerAssetId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assets_assets */
export type AssetsAssets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "assets_assets" */
export enum AssetsAssets_Select_Column {
  /** column name */
  AttachedFrom = 'attachedFrom',
  /** column name */
  AttachedTo = 'attachedTo',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MemberAssetId = 'memberAssetId',
  /** column name */
  Owner = 'owner',
  /** column name */
  OwnerAssetId = 'ownerAssetId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "assets_assets" */
export type AssetsAssets_Set_Input = {
  attachedFrom?: InputMaybe<Scalars['bigint']>;
  attachedTo?: InputMaybe<Scalars['bigint']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  memberAssetId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  ownerAssetId?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type AssetsAssets_Stddev_Fields = {
  __typename?: 'assetsAssets_stddev_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assets_assets" */
export type AssetsAssets_Stddev_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type AssetsAssets_Stddev_Pop_Fields = {
  __typename?: 'assetsAssets_stddev_pop_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assets_assets" */
export type AssetsAssets_Stddev_Pop_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type AssetsAssets_Stddev_Samp_Fields = {
  __typename?: 'assetsAssets_stddev_samp_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assets_assets" */
export type AssetsAssets_Stddev_Samp_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assetsAssets" */
export type AssetsAssets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AssetsAssets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AssetsAssets_Stream_Cursor_Value_Input = {
  attachedFrom?: InputMaybe<Scalars['bigint']>;
  attachedTo?: InputMaybe<Scalars['bigint']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  memberAssetId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  ownerAssetId?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type AssetsAssets_Sum_Fields = {
  __typename?: 'assetsAssets_sum_fields';
  attachedFrom?: Maybe<Scalars['bigint']>;
  attachedTo?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "assets_assets" */
export type AssetsAssets_Sum_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "assets_assets" */
export enum AssetsAssets_Update_Column {
  /** column name */
  AttachedFrom = 'attachedFrom',
  /** column name */
  AttachedTo = 'attachedTo',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  MemberAssetId = 'memberAssetId',
  /** column name */
  Owner = 'owner',
  /** column name */
  OwnerAssetId = 'ownerAssetId',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type AssetsAssets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AssetsAssets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AssetsAssets_Set_Input>;
  /** filter the rows which have to be updated */
  where: AssetsAssets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AssetsAssets_Var_Pop_Fields = {
  __typename?: 'assetsAssets_var_pop_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assets_assets" */
export type AssetsAssets_Var_Pop_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type AssetsAssets_Var_Samp_Fields = {
  __typename?: 'assetsAssets_var_samp_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assets_assets" */
export type AssetsAssets_Var_Samp_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type AssetsAssets_Variance_Fields = {
  __typename?: 'assetsAssets_variance_fields';
  attachedFrom?: Maybe<Scalars['Float']>;
  attachedTo?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assets_assets" */
export type AssetsAssets_Variance_Order_By = {
  attachedFrom?: InputMaybe<Order_By>;
  attachedTo?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregated selection of "assets" */
export type Assets_Aggregate = {
  __typename?: 'assets_aggregate';
  aggregate?: Maybe<Assets_Aggregate_Fields>;
  nodes: Array<Assets>;
};

export type Assets_Aggregate_Bool_Exp = {
  count?: InputMaybe<Assets_Aggregate_Bool_Exp_Count>;
};

export type Assets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Assets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "assets" */
export type Assets_Aggregate_Fields = {
  __typename?: 'assets_aggregate_fields';
  avg?: Maybe<Assets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Assets_Max_Fields>;
  min?: Maybe<Assets_Min_Fields>;
  stddev?: Maybe<Assets_Stddev_Fields>;
  stddev_pop?: Maybe<Assets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Assets_Stddev_Samp_Fields>;
  sum?: Maybe<Assets_Sum_Fields>;
  var_pop?: Maybe<Assets_Var_Pop_Fields>;
  var_samp?: Maybe<Assets_Var_Samp_Fields>;
  variance?: Maybe<Assets_Variance_Fields>;
};


/** aggregate fields of "assets" */
export type Assets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Assets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "assets" */
export type Assets_Aggregate_Order_By = {
  avg?: InputMaybe<Assets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Assets_Max_Order_By>;
  min?: InputMaybe<Assets_Min_Order_By>;
  stddev?: InputMaybe<Assets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Assets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Assets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Assets_Sum_Order_By>;
  var_pop?: InputMaybe<Assets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Assets_Var_Samp_Order_By>;
  variance?: InputMaybe<Assets_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Assets_Append_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
  location?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "assets" */
export type Assets_Arr_Rel_Insert_Input = {
  data: Array<Assets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Assets_On_Conflict>;
};

/** aggregate avg on columns */
export type Assets_Avg_Fields = {
  __typename?: 'assets_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "assets" */
export type Assets_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "assets". All fields are combined with a logical 'AND'. */
export type Assets_Bool_Exp = {
  UsersAssets?: InputMaybe<UsersAssets_Bool_Exp>;
  UsersAssets_aggregate?: InputMaybe<UsersAssets_Aggregate_Bool_Exp>;
  _and?: InputMaybe<Array<Assets_Bool_Exp>>;
  _not?: InputMaybe<Assets_Bool_Exp>;
  _or?: InputMaybe<Array<Assets_Bool_Exp>>;
  assetImages?: InputMaybe<AssetImages_Bool_Exp>;
  assetImages_aggregate?: InputMaybe<AssetImages_Aggregate_Bool_Exp>;
  assetProperties?: InputMaybe<AssetProperties_Bool_Exp>;
  assetProperties_aggregate?: InputMaybe<AssetProperties_Aggregate_Bool_Exp>;
  assetTags?: InputMaybe<AssetTags_Bool_Exp>;
  assetTags_aggregate?: InputMaybe<AssetTags_Aggregate_Bool_Exp>;
  assetTypeId?: InputMaybe<String_Comparison_Exp>;
  assetTypes?: InputMaybe<AssetTypes_Bool_Exp>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  groupId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  members?: InputMaybe<AssetsAssets_Bool_Exp>;
  members_aggregate?: InputMaybe<AssetsAssets_Aggregate_Bool_Exp>;
  messages?: InputMaybe<Messages_Bool_Exp>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  owners?: InputMaybe<AssetsAssets_Bool_Exp>;
  owners_aggregate?: InputMaybe<AssetsAssets_Aggregate_Bool_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providersAssets?: InputMaybe<ProvidersAssets_Bool_Exp>;
  providersAssets_aggregate?: InputMaybe<ProvidersAssets_Aggregate_Bool_Exp>;
  renderingResources?: InputMaybe<Jsonb_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Asset_States_Enum_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "assets" */
export enum Assets_Constraint {
  /** unique or primary key constraint on columns "id" */
  AssetsPkey = 'assets_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Assets_Delete_At_Path_Input = {
  attributes?: InputMaybe<Array<Scalars['String']>>;
  location?: InputMaybe<Array<Scalars['String']>>;
  renderingResources?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Assets_Delete_Elem_Input = {
  attributes?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<Scalars['Int']>;
  renderingResources?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Assets_Delete_Key_Input = {
  attributes?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "assets" */
export type Assets_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "assets" */
export type Assets_Insert_Input = {
  UsersAssets?: InputMaybe<UsersAssets_Arr_Rel_Insert_Input>;
  assetImages?: InputMaybe<AssetImages_Arr_Rel_Insert_Input>;
  assetProperties?: InputMaybe<AssetProperties_Arr_Rel_Insert_Input>;
  assetTags?: InputMaybe<AssetTags_Arr_Rel_Insert_Input>;
  assetTypeId?: InputMaybe<Scalars['String']>;
  assetTypes?: InputMaybe<AssetTypes_Obj_Rel_Insert_Input>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  members?: InputMaybe<AssetsAssets_Arr_Rel_Insert_Input>;
  messages?: InputMaybe<Messages_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  owners?: InputMaybe<AssetsAssets_Arr_Rel_Insert_Input>;
  providerId?: InputMaybe<Scalars['String']>;
  providersAssets?: InputMaybe<ProvidersAssets_Arr_Rel_Insert_Input>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Asset_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Assets_Max_Fields = {
  __typename?: 'assets_max_fields';
  assetTypeId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "assets" */
export type Assets_Max_Order_By = {
  assetTypeId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Assets_Min_Fields = {
  __typename?: 'assets_min_fields';
  assetTypeId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "assets" */
export type Assets_Min_Order_By = {
  assetTypeId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "assets" */
export type Assets_Mutation_Response = {
  __typename?: 'assets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Assets>;
};

/** input type for inserting object relation for remote table "assets" */
export type Assets_Obj_Rel_Insert_Input = {
  data: Assets_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Assets_On_Conflict>;
};

/** on_conflict condition type for table "assets" */
export type Assets_On_Conflict = {
  constraint: Assets_Constraint;
  update_columns?: Array<Assets_Update_Column>;
  where?: InputMaybe<Assets_Bool_Exp>;
};

/** Ordering options when selecting data from "assets". */
export type Assets_Order_By = {
  UsersAssets_aggregate?: InputMaybe<UsersAssets_Aggregate_Order_By>;
  assetImages_aggregate?: InputMaybe<AssetImages_Aggregate_Order_By>;
  assetProperties_aggregate?: InputMaybe<AssetProperties_Aggregate_Order_By>;
  assetTags_aggregate?: InputMaybe<AssetTags_Aggregate_Order_By>;
  assetTypeId?: InputMaybe<Order_By>;
  assetTypes?: InputMaybe<AssetTypes_Order_By>;
  attributes?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<AssetsAssets_Aggregate_Order_By>;
  messages_aggregate?: InputMaybe<Messages_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  owners_aggregate?: InputMaybe<AssetsAssets_Aggregate_Order_By>;
  providerId?: InputMaybe<Order_By>;
  providersAssets_aggregate?: InputMaybe<ProvidersAssets_Aggregate_Order_By>;
  renderingResources?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: assets */
export type Assets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Assets_Prepend_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
  location?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "assets" */
export enum Assets_Select_Column {
  /** column name */
  AssetTypeId = 'assetTypeId',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "assets" */
export type Assets_Set_Input = {
  assetTypeId?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Asset_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Assets_Stddev_Fields = {
  __typename?: 'assets_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "assets" */
export type Assets_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Assets_Stddev_Pop_Fields = {
  __typename?: 'assets_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "assets" */
export type Assets_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Assets_Stddev_Samp_Fields = {
  __typename?: 'assets_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "assets" */
export type Assets_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "assets" */
export type Assets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Assets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Assets_Stream_Cursor_Value_Input = {
  assetTypeId?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Asset_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Assets_Sum_Fields = {
  __typename?: 'assets_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "assets" */
export type Assets_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "assets" */
export enum Assets_Update_Column {
  /** column name */
  AssetTypeId = 'assetTypeId',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Assets_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Assets_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Assets_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Assets_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Assets_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Assets_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Assets_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Assets_Set_Input>;
  /** filter the rows which have to be updated */
  where: Assets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Assets_Var_Pop_Fields = {
  __typename?: 'assets_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "assets" */
export type Assets_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Assets_Var_Samp_Fields = {
  __typename?: 'assets_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "assets" */
export type Assets_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Assets_Variance_Fields = {
  __typename?: 'assets_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "assets" */
export type Assets_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "authorization_info" */
export type AuthorizationInfo = {
  __typename?: 'authorizationInfo';
  categoryId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientIds: Scalars['jsonb'];
  createdAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantAlias: Scalars['String'];
  tenantId: Scalars['String'];
  /** An object relationship */
  tenants?: Maybe<Tenants>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId?: Maybe<Scalars['String']>;
};


/** columns and relationships of "authorization_info" */
export type AuthorizationInfoClientIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "authorization_info" */
export type AuthorizationInfo_Aggregate = {
  __typename?: 'authorizationInfo_aggregate';
  aggregate?: Maybe<AuthorizationInfo_Aggregate_Fields>;
  nodes: Array<AuthorizationInfo>;
};

/** aggregate fields of "authorization_info" */
export type AuthorizationInfo_Aggregate_Fields = {
  __typename?: 'authorizationInfo_aggregate_fields';
  avg?: Maybe<AuthorizationInfo_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<AuthorizationInfo_Max_Fields>;
  min?: Maybe<AuthorizationInfo_Min_Fields>;
  stddev?: Maybe<AuthorizationInfo_Stddev_Fields>;
  stddev_pop?: Maybe<AuthorizationInfo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<AuthorizationInfo_Stddev_Samp_Fields>;
  sum?: Maybe<AuthorizationInfo_Sum_Fields>;
  var_pop?: Maybe<AuthorizationInfo_Var_Pop_Fields>;
  var_samp?: Maybe<AuthorizationInfo_Var_Samp_Fields>;
  variance?: Maybe<AuthorizationInfo_Variance_Fields>;
};


/** aggregate fields of "authorization_info" */
export type AuthorizationInfo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthorizationInfo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type AuthorizationInfo_Append_Input = {
  clientIds?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type AuthorizationInfo_Avg_Fields = {
  __typename?: 'authorizationInfo_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "authorization_info". All fields are combined with a logical 'AND'. */
export type AuthorizationInfo_Bool_Exp = {
  _and?: InputMaybe<Array<AuthorizationInfo_Bool_Exp>>;
  _not?: InputMaybe<AuthorizationInfo_Bool_Exp>;
  _or?: InputMaybe<Array<AuthorizationInfo_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  clientIds?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantAlias?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tenants?: InputMaybe<Tenants_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userPoolId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "authorization_info" */
export enum AuthorizationInfo_Constraint {
  /** unique or primary key constraint on columns "tenant_alias" */
  AuthorizationInfoPkey = 'authorization_info_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type AuthorizationInfo_Delete_At_Path_Input = {
  clientIds?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type AuthorizationInfo_Delete_Elem_Input = {
  clientIds?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type AuthorizationInfo_Delete_Key_Input = {
  clientIds?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "authorization_info" */
export type AuthorizationInfo_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "authorization_info" */
export type AuthorizationInfo_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantAlias?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tenants?: InputMaybe<Tenants_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type AuthorizationInfo_Max_Fields = {
  __typename?: 'authorizationInfo_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantAlias?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthorizationInfo_Min_Fields = {
  __typename?: 'authorizationInfo_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantAlias?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "authorization_info" */
export type AuthorizationInfo_Mutation_Response = {
  __typename?: 'authorizationInfo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<AuthorizationInfo>;
};

/** on_conflict condition type for table "authorization_info" */
export type AuthorizationInfo_On_Conflict = {
  constraint: AuthorizationInfo_Constraint;
  update_columns?: Array<AuthorizationInfo_Update_Column>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};

/** Ordering options when selecting data from "authorization_info". */
export type AuthorizationInfo_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientIds?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantAlias?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tenants?: InputMaybe<Tenants_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userPoolId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: authorization_info */
export type AuthorizationInfo_Pk_Columns_Input = {
  tenantAlias: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type AuthorizationInfo_Prepend_Input = {
  clientIds?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "authorization_info" */
export enum AuthorizationInfo_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientIds = 'clientIds',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantAlias = 'tenantAlias',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserPoolId = 'userPoolId'
}

/** input type for updating data in table "authorization_info" */
export type AuthorizationInfo_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantAlias?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type AuthorizationInfo_Stddev_Fields = {
  __typename?: 'authorizationInfo_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type AuthorizationInfo_Stddev_Pop_Fields = {
  __typename?: 'authorizationInfo_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type AuthorizationInfo_Stddev_Samp_Fields = {
  __typename?: 'authorizationInfo_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "authorizationInfo" */
export type AuthorizationInfo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthorizationInfo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthorizationInfo_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantAlias?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type AuthorizationInfo_Sum_Fields = {
  __typename?: 'authorizationInfo_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "authorization_info" */
export enum AuthorizationInfo_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientIds = 'clientIds',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantAlias = 'tenantAlias',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserPoolId = 'userPoolId'
}

export type AuthorizationInfo_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<AuthorizationInfo_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<AuthorizationInfo_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<AuthorizationInfo_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<AuthorizationInfo_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<AuthorizationInfo_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<AuthorizationInfo_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AuthorizationInfo_Set_Input>;
  /** filter the rows which have to be updated */
  where: AuthorizationInfo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type AuthorizationInfo_Var_Pop_Fields = {
  __typename?: 'authorizationInfo_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type AuthorizationInfo_Var_Samp_Fields = {
  __typename?: 'authorizationInfo_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type AuthorizationInfo_Variance_Fields = {
  __typename?: 'authorizationInfo_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfo = {
  __typename?: 'authorizationTenantServiceInfo';
  analytics_settings?: Maybe<Scalars['jsonb']>;
  apiKey?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  clientIds?: Maybe<Scalars['jsonb']>;
  owner?: Maybe<Scalars['String']>;
  renderingResources?: Maybe<Scalars['jsonb']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantAlias?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  userPoolId?: Maybe<Scalars['String']>;
};


/** columns and relationships of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfoAnalytics_SettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfoClientIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfoRenderingResourcesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfo_Aggregate = {
  __typename?: 'authorizationTenantServiceInfo_aggregate';
  aggregate?: Maybe<AuthorizationTenantServiceInfo_Aggregate_Fields>;
  nodes: Array<AuthorizationTenantServiceInfo>;
};

/** aggregate fields of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfo_Aggregate_Fields = {
  __typename?: 'authorizationTenantServiceInfo_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<AuthorizationTenantServiceInfo_Max_Fields>;
  min?: Maybe<AuthorizationTenantServiceInfo_Min_Fields>;
};


/** aggregate fields of "authorization_tenant_service_info" */
export type AuthorizationTenantServiceInfo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<AuthorizationTenantServiceInfo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "authorization_tenant_service_info". All fields are combined with a logical 'AND'. */
export type AuthorizationTenantServiceInfo_Bool_Exp = {
  _and?: InputMaybe<Array<AuthorizationTenantServiceInfo_Bool_Exp>>;
  _not?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
  _or?: InputMaybe<Array<AuthorizationTenantServiceInfo_Bool_Exp>>;
  analytics_settings?: InputMaybe<Jsonb_Comparison_Exp>;
  apiKey?: InputMaybe<String_Comparison_Exp>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  clientIds?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  renderingResources?: InputMaybe<Jsonb_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantAlias?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tenantName?: InputMaybe<String_Comparison_Exp>;
  userPoolId?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type AuthorizationTenantServiceInfo_Max_Fields = {
  __typename?: 'authorizationTenantServiceInfo_max_fields';
  apiKey?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantAlias?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type AuthorizationTenantServiceInfo_Min_Fields = {
  __typename?: 'authorizationTenantServiceInfo_min_fields';
  apiKey?: Maybe<Scalars['String']>;
  clientId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantAlias?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tenantName?: Maybe<Scalars['String']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "authorization_tenant_service_info". */
export type AuthorizationTenantServiceInfo_Order_By = {
  analytics_settings?: InputMaybe<Order_By>;
  apiKey?: InputMaybe<Order_By>;
  clientId?: InputMaybe<Order_By>;
  clientIds?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  renderingResources?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantAlias?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tenantName?: InputMaybe<Order_By>;
  userPoolId?: InputMaybe<Order_By>;
};

/** select columns of table "authorization_tenant_service_info" */
export enum AuthorizationTenantServiceInfo_Select_Column {
  /** column name */
  AnalyticsSettings = 'analytics_settings',
  /** column name */
  ApiKey = 'apiKey',
  /** column name */
  ClientId = 'clientId',
  /** column name */
  ClientIds = 'clientIds',
  /** column name */
  Owner = 'owner',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantAlias = 'tenantAlias',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantName = 'tenantName',
  /** column name */
  UserPoolId = 'userPoolId'
}

/** Streaming cursor of the table "authorizationTenantServiceInfo" */
export type AuthorizationTenantServiceInfo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: AuthorizationTenantServiceInfo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type AuthorizationTenantServiceInfo_Stream_Cursor_Value_Input = {
  analytics_settings?: InputMaybe<Scalars['jsonb']>;
  apiKey?: InputMaybe<Scalars['String']>;
  clientId?: InputMaybe<Scalars['String']>;
  clientIds?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantAlias?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tenantName?: InputMaybe<Scalars['String']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "bigint". All fields are combined with logical 'AND'. */
export type Bigint_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['bigint']>;
  _gt?: InputMaybe<Scalars['bigint']>;
  _gte?: InputMaybe<Scalars['bigint']>;
  _in?: InputMaybe<Array<Scalars['bigint']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['bigint']>;
  _lte?: InputMaybe<Scalars['bigint']>;
  _neq?: InputMaybe<Scalars['bigint']>;
  _nin?: InputMaybe<Array<Scalars['bigint']>>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'categories';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "categories" */
export type Categories_Aggregate = {
  __typename?: 'categories_aggregate';
  aggregate?: Maybe<Categories_Aggregate_Fields>;
  nodes: Array<Categories>;
};

/** aggregate fields of "categories" */
export type Categories_Aggregate_Fields = {
  __typename?: 'categories_aggregate_fields';
  avg?: Maybe<Categories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Categories_Max_Fields>;
  min?: Maybe<Categories_Min_Fields>;
  stddev?: Maybe<Categories_Stddev_Fields>;
  stddev_pop?: Maybe<Categories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Categories_Stddev_Samp_Fields>;
  sum?: Maybe<Categories_Sum_Fields>;
  var_pop?: Maybe<Categories_Var_Pop_Fields>;
  var_samp?: Maybe<Categories_Var_Samp_Fields>;
  variance?: Maybe<Categories_Variance_Fields>;
};


/** aggregate fields of "categories" */
export type Categories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Categories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Categories_Avg_Fields = {
  __typename?: 'categories_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type Categories_Bool_Exp = {
  _and?: InputMaybe<Array<Categories_Bool_Exp>>;
  _not?: InputMaybe<Categories_Bool_Exp>;
  _or?: InputMaybe<Array<Categories_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "categories" */
export enum Categories_Constraint {
  /** unique or primary key constraint on columns "id" */
  CategoriesPkey = 'categories_pkey'
}

/** input type for incrementing numeric columns in table "categories" */
export type Categories_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "categories" */
export type Categories_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Categories_Max_Fields = {
  __typename?: 'categories_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Categories_Min_Fields = {
  __typename?: 'categories_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "categories" */
export type Categories_Mutation_Response = {
  __typename?: 'categories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** on_conflict condition type for table "categories" */
export type Categories_On_Conflict = {
  constraint: Categories_Constraint;
  update_columns?: Array<Categories_Update_Column>;
  where?: InputMaybe<Categories_Bool_Exp>;
};

/** Ordering options when selecting data from "categories". */
export type Categories_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: categories */
export type Categories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "categories" */
export enum Categories_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "categories" */
export type Categories_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Categories_Stddev_Fields = {
  __typename?: 'categories_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Categories_Stddev_Pop_Fields = {
  __typename?: 'categories_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Categories_Stddev_Samp_Fields = {
  __typename?: 'categories_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "categories" */
export type Categories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Categories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Categories_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Categories_Sum_Fields = {
  __typename?: 'categories_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "categories" */
export enum Categories_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Categories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Categories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Categories_Set_Input>;
  /** filter the rows which have to be updated */
  where: Categories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Categories_Var_Pop_Fields = {
  __typename?: 'categories_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Categories_Var_Samp_Fields = {
  __typename?: 'categories_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Categories_Variance_Fields = {
  __typename?: 'categories_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "client_types" */
export type ClientTypes = {
  __typename?: 'clientTypes';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  type: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "client_types" */
export type ClientTypes_Aggregate = {
  __typename?: 'clientTypes_aggregate';
  aggregate?: Maybe<ClientTypes_Aggregate_Fields>;
  nodes: Array<ClientTypes>;
};

/** aggregate fields of "client_types" */
export type ClientTypes_Aggregate_Fields = {
  __typename?: 'clientTypes_aggregate_fields';
  avg?: Maybe<ClientTypes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ClientTypes_Max_Fields>;
  min?: Maybe<ClientTypes_Min_Fields>;
  stddev?: Maybe<ClientTypes_Stddev_Fields>;
  stddev_pop?: Maybe<ClientTypes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ClientTypes_Stddev_Samp_Fields>;
  sum?: Maybe<ClientTypes_Sum_Fields>;
  var_pop?: Maybe<ClientTypes_Var_Pop_Fields>;
  var_samp?: Maybe<ClientTypes_Var_Samp_Fields>;
  variance?: Maybe<ClientTypes_Variance_Fields>;
};


/** aggregate fields of "client_types" */
export type ClientTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ClientTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ClientTypes_Avg_Fields = {
  __typename?: 'clientTypes_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "client_types". All fields are combined with a logical 'AND'. */
export type ClientTypes_Bool_Exp = {
  _and?: InputMaybe<Array<ClientTypes_Bool_Exp>>;
  _not?: InputMaybe<ClientTypes_Bool_Exp>;
  _or?: InputMaybe<Array<ClientTypes_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "client_types" */
export enum ClientTypes_Constraint {
  /** unique or primary key constraint on columns "id" */
  ClientTypesPkey = 'client_types_pkey'
}

/** input type for incrementing numeric columns in table "client_types" */
export type ClientTypes_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "client_types" */
export type ClientTypes_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ClientTypes_Max_Fields = {
  __typename?: 'clientTypes_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ClientTypes_Min_Fields = {
  __typename?: 'clientTypes_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "client_types" */
export type ClientTypes_Mutation_Response = {
  __typename?: 'clientTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ClientTypes>;
};

/** on_conflict condition type for table "client_types" */
export type ClientTypes_On_Conflict = {
  constraint: ClientTypes_Constraint;
  update_columns?: Array<ClientTypes_Update_Column>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "client_types". */
export type ClientTypes_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: client_types */
export type ClientTypes_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "client_types" */
export enum ClientTypes_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "client_types" */
export type ClientTypes_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ClientTypes_Stddev_Fields = {
  __typename?: 'clientTypes_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ClientTypes_Stddev_Pop_Fields = {
  __typename?: 'clientTypes_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ClientTypes_Stddev_Samp_Fields = {
  __typename?: 'clientTypes_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "clientTypes" */
export type ClientTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ClientTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ClientTypes_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ClientTypes_Sum_Fields = {
  __typename?: 'clientTypes_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "client_types" */
export enum ClientTypes_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ClientTypes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ClientTypes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ClientTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: ClientTypes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ClientTypes_Var_Pop_Fields = {
  __typename?: 'clientTypes_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ClientTypes_Var_Samp_Fields = {
  __typename?: 'clientTypes_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ClientTypes_Variance_Fields = {
  __typename?: 'clientTypes_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "consents" */
export type Consents = {
  __typename?: 'consents';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  result: Scalars['Boolean'];
  sensitiveInformationItemId: Scalars['String'];
  /** An object relationship */
  sensitiveInformationItems?: Maybe<SensitiveInformationItems>;
  sensitiveInformationRequestServiceId?: Maybe<Scalars['String']>;
  /** An object relationship */
  sensitiveInformationRequestServices?: Maybe<SensitiveInformationRequestServices>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "consents" */
export type Consents_Aggregate = {
  __typename?: 'consents_aggregate';
  aggregate?: Maybe<Consents_Aggregate_Fields>;
  nodes: Array<Consents>;
};

export type Consents_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Consents_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Consents_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Consents_Aggregate_Bool_Exp_Count>;
};

export type Consents_Aggregate_Bool_Exp_Bool_And = {
  arguments: Consents_Select_Column_Consents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consents_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Consents_Select_Column_Consents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consents_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Consents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Consents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Consents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "consents" */
export type Consents_Aggregate_Fields = {
  __typename?: 'consents_aggregate_fields';
  avg?: Maybe<Consents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Consents_Max_Fields>;
  min?: Maybe<Consents_Min_Fields>;
  stddev?: Maybe<Consents_Stddev_Fields>;
  stddev_pop?: Maybe<Consents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Consents_Stddev_Samp_Fields>;
  sum?: Maybe<Consents_Sum_Fields>;
  var_pop?: Maybe<Consents_Var_Pop_Fields>;
  var_samp?: Maybe<Consents_Var_Samp_Fields>;
  variance?: Maybe<Consents_Variance_Fields>;
};


/** aggregate fields of "consents" */
export type Consents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Consents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "consents" */
export type Consents_Aggregate_Order_By = {
  avg?: InputMaybe<Consents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Consents_Max_Order_By>;
  min?: InputMaybe<Consents_Min_Order_By>;
  stddev?: InputMaybe<Consents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Consents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Consents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Consents_Sum_Order_By>;
  var_pop?: InputMaybe<Consents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Consents_Var_Samp_Order_By>;
  variance?: InputMaybe<Consents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "consents" */
export type Consents_Arr_Rel_Insert_Input = {
  data: Array<Consents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Consents_On_Conflict>;
};

/** aggregate avg on columns */
export type Consents_Avg_Fields = {
  __typename?: 'consents_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "consents" */
export type Consents_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "consents". All fields are combined with a logical 'AND'. */
export type Consents_Bool_Exp = {
  _and?: InputMaybe<Array<Consents_Bool_Exp>>;
  _not?: InputMaybe<Consents_Bool_Exp>;
  _or?: InputMaybe<Array<Consents_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lastUpdatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  result?: InputMaybe<Boolean_Comparison_Exp>;
  sensitiveInformationItemId?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationItems?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
  sensitiveInformationRequestServiceId?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "consents" */
export enum Consents_Constraint {
  /** unique or primary key constraint on columns "id" */
  ConsentsPkey = 'consents_pkey'
}

/** input type for incrementing numeric columns in table "consents" */
export type Consents_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "consents" */
export type Consents_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['Boolean']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  sensitiveInformationItems?: InputMaybe<SensitiveInformationItems_Obj_Rel_Insert_Input>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Consents_Max_Fields = {
  __typename?: 'consents_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  sensitiveInformationItemId?: Maybe<Scalars['String']>;
  sensitiveInformationRequestServiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "consents" */
export type Consents_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationItemId?: InputMaybe<Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Consents_Min_Fields = {
  __typename?: 'consents_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  sensitiveInformationItemId?: Maybe<Scalars['String']>;
  sensitiveInformationRequestServiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "consents" */
export type Consents_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationItemId?: InputMaybe<Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "consents" */
export type Consents_Mutation_Response = {
  __typename?: 'consents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Consents>;
};

/** on_conflict condition type for table "consents" */
export type Consents_On_Conflict = {
  constraint: Consents_Constraint;
  update_columns?: Array<Consents_Update_Column>;
  where?: InputMaybe<Consents_Bool_Exp>;
};

/** Ordering options when selecting data from "consents". */
export type Consents_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  sensitiveInformationItemId?: InputMaybe<Order_By>;
  sensitiveInformationItems?: InputMaybe<SensitiveInformationItems_Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: consents */
export type Consents_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "consents" */
export enum Consents_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  Result = 'result',
  /** column name */
  SensitiveInformationItemId = 'sensitiveInformationItemId',
  /** column name */
  SensitiveInformationRequestServiceId = 'sensitiveInformationRequestServiceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** select "consents_aggregate_bool_exp_bool_and_arguments_columns" columns of table "consents" */
export enum Consents_Select_Column_Consents_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Result = 'result'
}

/** select "consents_aggregate_bool_exp_bool_or_arguments_columns" columns of table "consents" */
export enum Consents_Select_Column_Consents_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Result = 'result'
}

/** input type for updating data in table "consents" */
export type Consents_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['Boolean']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Consents_Stddev_Fields = {
  __typename?: 'consents_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "consents" */
export type Consents_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Consents_Stddev_Pop_Fields = {
  __typename?: 'consents_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "consents" */
export type Consents_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Consents_Stddev_Samp_Fields = {
  __typename?: 'consents_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "consents" */
export type Consents_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "consents" */
export type Consents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Consents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Consents_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['Boolean']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Consents_Sum_Fields = {
  __typename?: 'consents_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "consents" */
export type Consents_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "consents" */
export enum Consents_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  Result = 'result',
  /** column name */
  SensitiveInformationItemId = 'sensitiveInformationItemId',
  /** column name */
  SensitiveInformationRequestServiceId = 'sensitiveInformationRequestServiceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type Consents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Consents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Consents_Set_Input>;
  /** filter the rows which have to be updated */
  where: Consents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Consents_Var_Pop_Fields = {
  __typename?: 'consents_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "consents" */
export type Consents_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Consents_Var_Samp_Fields = {
  __typename?: 'consents_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "consents" */
export type Consents_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Consents_Variance_Fields = {
  __typename?: 'consents_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "consents" */
export type Consents_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "csv_records" */
export type CsvRecords = {
  __typename?: 'csvRecords';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  kind: Scalars['String'];
  owner: Scalars['String'];
  receiveDate: Scalars['date'];
  record: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "csv_records" */
export type CsvRecordsRecordArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "csv_records" */
export type CsvRecords_Aggregate = {
  __typename?: 'csvRecords_aggregate';
  aggregate?: Maybe<CsvRecords_Aggregate_Fields>;
  nodes: Array<CsvRecords>;
};

/** aggregate fields of "csv_records" */
export type CsvRecords_Aggregate_Fields = {
  __typename?: 'csvRecords_aggregate_fields';
  avg?: Maybe<CsvRecords_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<CsvRecords_Max_Fields>;
  min?: Maybe<CsvRecords_Min_Fields>;
  stddev?: Maybe<CsvRecords_Stddev_Fields>;
  stddev_pop?: Maybe<CsvRecords_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<CsvRecords_Stddev_Samp_Fields>;
  sum?: Maybe<CsvRecords_Sum_Fields>;
  var_pop?: Maybe<CsvRecords_Var_Pop_Fields>;
  var_samp?: Maybe<CsvRecords_Var_Samp_Fields>;
  variance?: Maybe<CsvRecords_Variance_Fields>;
};


/** aggregate fields of "csv_records" */
export type CsvRecords_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<CsvRecords_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CsvRecords_Append_Input = {
  record?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type CsvRecords_Avg_Fields = {
  __typename?: 'csvRecords_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "csv_records". All fields are combined with a logical 'AND'. */
export type CsvRecords_Bool_Exp = {
  _and?: InputMaybe<Array<CsvRecords_Bool_Exp>>;
  _not?: InputMaybe<CsvRecords_Bool_Exp>;
  _or?: InputMaybe<Array<CsvRecords_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  kind?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  receiveDate?: InputMaybe<Date_Comparison_Exp>;
  record?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "csv_records" */
export enum CsvRecords_Constraint {
  /** unique or primary key constraint on columns "id" */
  CsvRecordsPkey = 'csv_records_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CsvRecords_Delete_At_Path_Input = {
  record?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CsvRecords_Delete_Elem_Input = {
  record?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CsvRecords_Delete_Key_Input = {
  record?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "csv_records" */
export type CsvRecords_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "csv_records" */
export type CsvRecords_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receiveDate?: InputMaybe<Scalars['date']>;
  record?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type CsvRecords_Max_Fields = {
  __typename?: 'csvRecords_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  receiveDate?: Maybe<Scalars['date']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type CsvRecords_Min_Fields = {
  __typename?: 'csvRecords_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  kind?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  receiveDate?: Maybe<Scalars['date']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "csv_records" */
export type CsvRecords_Mutation_Response = {
  __typename?: 'csvRecords_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<CsvRecords>;
};

/** on_conflict condition type for table "csv_records" */
export type CsvRecords_On_Conflict = {
  constraint: CsvRecords_Constraint;
  update_columns?: Array<CsvRecords_Update_Column>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};

/** Ordering options when selecting data from "csv_records". */
export type CsvRecords_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  kind?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  receiveDate?: InputMaybe<Order_By>;
  record?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: csv_records */
export type CsvRecords_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CsvRecords_Prepend_Input = {
  record?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "csv_records" */
export enum CsvRecords_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Owner = 'owner',
  /** column name */
  ReceiveDate = 'receiveDate',
  /** column name */
  Record = 'record',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "csv_records" */
export type CsvRecords_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receiveDate?: InputMaybe<Scalars['date']>;
  record?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type CsvRecords_Stddev_Fields = {
  __typename?: 'csvRecords_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type CsvRecords_Stddev_Pop_Fields = {
  __typename?: 'csvRecords_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type CsvRecords_Stddev_Samp_Fields = {
  __typename?: 'csvRecords_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "csvRecords" */
export type CsvRecords_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: CsvRecords_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type CsvRecords_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  kind?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receiveDate?: InputMaybe<Scalars['date']>;
  record?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type CsvRecords_Sum_Fields = {
  __typename?: 'csvRecords_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "csv_records" */
export enum CsvRecords_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Kind = 'kind',
  /** column name */
  Owner = 'owner',
  /** column name */
  ReceiveDate = 'receiveDate',
  /** column name */
  Record = 'record',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type CsvRecords_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CsvRecords_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<CsvRecords_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<CsvRecords_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<CsvRecords_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CsvRecords_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CsvRecords_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CsvRecords_Set_Input>;
  /** filter the rows which have to be updated */
  where: CsvRecords_Bool_Exp;
};

/** aggregate var_pop on columns */
export type CsvRecords_Var_Pop_Fields = {
  __typename?: 'csvRecords_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type CsvRecords_Var_Samp_Fields = {
  __typename?: 'csvRecords_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type CsvRecords_Variance_Fields = {
  __typename?: 'csvRecords_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** columns and relationships of "data_access_logs" */
export type DataAccessLogs = {
  __typename?: 'dataAccessLogs';
  accessData: Scalars['jsonb'];
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "data_access_logs" */
export type DataAccessLogsAccessDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "data_access_logs" */
export type DataAccessLogs_Aggregate = {
  __typename?: 'dataAccessLogs_aggregate';
  aggregate?: Maybe<DataAccessLogs_Aggregate_Fields>;
  nodes: Array<DataAccessLogs>;
};

/** aggregate fields of "data_access_logs" */
export type DataAccessLogs_Aggregate_Fields = {
  __typename?: 'dataAccessLogs_aggregate_fields';
  avg?: Maybe<DataAccessLogs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DataAccessLogs_Max_Fields>;
  min?: Maybe<DataAccessLogs_Min_Fields>;
  stddev?: Maybe<DataAccessLogs_Stddev_Fields>;
  stddev_pop?: Maybe<DataAccessLogs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DataAccessLogs_Stddev_Samp_Fields>;
  sum?: Maybe<DataAccessLogs_Sum_Fields>;
  var_pop?: Maybe<DataAccessLogs_Var_Pop_Fields>;
  var_samp?: Maybe<DataAccessLogs_Var_Samp_Fields>;
  variance?: Maybe<DataAccessLogs_Variance_Fields>;
};


/** aggregate fields of "data_access_logs" */
export type DataAccessLogs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DataAccessLogs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DataAccessLogs_Append_Input = {
  accessData?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type DataAccessLogs_Avg_Fields = {
  __typename?: 'dataAccessLogs_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "data_access_logs". All fields are combined with a logical 'AND'. */
export type DataAccessLogs_Bool_Exp = {
  _and?: InputMaybe<Array<DataAccessLogs_Bool_Exp>>;
  _not?: InputMaybe<DataAccessLogs_Bool_Exp>;
  _or?: InputMaybe<Array<DataAccessLogs_Bool_Exp>>;
  accessData?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "data_access_logs" */
export enum DataAccessLogs_Constraint {
  /** unique or primary key constraint on columns "id" */
  DataAccessLogsPkey = 'data_access_logs_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DataAccessLogs_Delete_At_Path_Input = {
  accessData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DataAccessLogs_Delete_Elem_Input = {
  accessData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DataAccessLogs_Delete_Key_Input = {
  accessData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "data_access_logs" */
export type DataAccessLogs_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "data_access_logs" */
export type DataAccessLogs_Insert_Input = {
  accessData?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type DataAccessLogs_Max_Fields = {
  __typename?: 'dataAccessLogs_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DataAccessLogs_Min_Fields = {
  __typename?: 'dataAccessLogs_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "data_access_logs" */
export type DataAccessLogs_Mutation_Response = {
  __typename?: 'dataAccessLogs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DataAccessLogs>;
};

/** on_conflict condition type for table "data_access_logs" */
export type DataAccessLogs_On_Conflict = {
  constraint: DataAccessLogs_Constraint;
  update_columns?: Array<DataAccessLogs_Update_Column>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};

/** Ordering options when selecting data from "data_access_logs". */
export type DataAccessLogs_Order_By = {
  accessData?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: data_access_logs */
export type DataAccessLogs_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DataAccessLogs_Prepend_Input = {
  accessData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "data_access_logs" */
export enum DataAccessLogs_Select_Column {
  /** column name */
  AccessData = 'accessData',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "data_access_logs" */
export type DataAccessLogs_Set_Input = {
  accessData?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type DataAccessLogs_Stddev_Fields = {
  __typename?: 'dataAccessLogs_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DataAccessLogs_Stddev_Pop_Fields = {
  __typename?: 'dataAccessLogs_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DataAccessLogs_Stddev_Samp_Fields = {
  __typename?: 'dataAccessLogs_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "dataAccessLogs" */
export type DataAccessLogs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DataAccessLogs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DataAccessLogs_Stream_Cursor_Value_Input = {
  accessData?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DataAccessLogs_Sum_Fields = {
  __typename?: 'dataAccessLogs_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "data_access_logs" */
export enum DataAccessLogs_Update_Column {
  /** column name */
  AccessData = 'accessData',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DataAccessLogs_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DataAccessLogs_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<DataAccessLogs_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<DataAccessLogs_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<DataAccessLogs_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DataAccessLogs_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DataAccessLogs_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataAccessLogs_Set_Input>;
  /** filter the rows which have to be updated */
  where: DataAccessLogs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DataAccessLogs_Var_Pop_Fields = {
  __typename?: 'dataAccessLogs_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DataAccessLogs_Var_Samp_Fields = {
  __typename?: 'dataAccessLogs_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DataAccessLogs_Variance_Fields = {
  __typename?: 'dataAccessLogs_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "detection_logs" */
export type DetectionLogs = {
  __typename?: 'detectionLogs';
  createdAt: Scalars['bigint'];
  detectionId: Scalars['String'];
  id: Scalars['String'];
  messageId: Scalars['String'];
  owner: Scalars['String'];
  receivedTime: Scalars['bigint'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
  within: Scalars['Boolean'];
};

/** aggregated selection of "detection_logs" */
export type DetectionLogs_Aggregate = {
  __typename?: 'detectionLogs_aggregate';
  aggregate?: Maybe<DetectionLogs_Aggregate_Fields>;
  nodes: Array<DetectionLogs>;
};

/** aggregate fields of "detection_logs" */
export type DetectionLogs_Aggregate_Fields = {
  __typename?: 'detectionLogs_aggregate_fields';
  avg?: Maybe<DetectionLogs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DetectionLogs_Max_Fields>;
  min?: Maybe<DetectionLogs_Min_Fields>;
  stddev?: Maybe<DetectionLogs_Stddev_Fields>;
  stddev_pop?: Maybe<DetectionLogs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DetectionLogs_Stddev_Samp_Fields>;
  sum?: Maybe<DetectionLogs_Sum_Fields>;
  var_pop?: Maybe<DetectionLogs_Var_Pop_Fields>;
  var_samp?: Maybe<DetectionLogs_Var_Samp_Fields>;
  variance?: Maybe<DetectionLogs_Variance_Fields>;
};


/** aggregate fields of "detection_logs" */
export type DetectionLogs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DetectionLogs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DetectionLogs_Avg_Fields = {
  __typename?: 'detectionLogs_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "detection_logs". All fields are combined with a logical 'AND'. */
export type DetectionLogs_Bool_Exp = {
  _and?: InputMaybe<Array<DetectionLogs_Bool_Exp>>;
  _not?: InputMaybe<DetectionLogs_Bool_Exp>;
  _or?: InputMaybe<Array<DetectionLogs_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  detectionId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  messageId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  receivedTime?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  within?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "detection_logs" */
export enum DetectionLogs_Constraint {
  /** unique or primary key constraint on columns "detection_id", "received_time" */
  DetectionLogsIdx = 'detection_logs_idx',
  /** unique or primary key constraint on columns "id" */
  DetectionLogsPkey = 'detection_logs_pkey'
}

/** input type for incrementing numeric columns in table "detection_logs" */
export type DetectionLogs_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "detection_logs" */
export type DetectionLogs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  within?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type DetectionLogs_Max_Fields = {
  __typename?: 'detectionLogs_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DetectionLogs_Min_Fields = {
  __typename?: 'detectionLogs_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messageId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "detection_logs" */
export type DetectionLogs_Mutation_Response = {
  __typename?: 'detectionLogs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DetectionLogs>;
};

/** on_conflict condition type for table "detection_logs" */
export type DetectionLogs_On_Conflict = {
  constraint: DetectionLogs_Constraint;
  update_columns?: Array<DetectionLogs_Update_Column>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};

/** Ordering options when selecting data from "detection_logs". */
export type DetectionLogs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  detectionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messageId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  within?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detection_logs */
export type DetectionLogs_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "detection_logs" */
export enum DetectionLogs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  Owner = 'owner',
  /** column name */
  ReceivedTime = 'receivedTime',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Within = 'within'
}

/** input type for updating data in table "detection_logs" */
export type DetectionLogs_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  within?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type DetectionLogs_Stddev_Fields = {
  __typename?: 'detectionLogs_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DetectionLogs_Stddev_Pop_Fields = {
  __typename?: 'detectionLogs_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DetectionLogs_Stddev_Samp_Fields = {
  __typename?: 'detectionLogs_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "detectionLogs" */
export type DetectionLogs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DetectionLogs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DetectionLogs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  messageId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  within?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type DetectionLogs_Sum_Fields = {
  __typename?: 'detectionLogs_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "detection_logs" */
export enum DetectionLogs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  MessageId = 'messageId',
  /** column name */
  Owner = 'owner',
  /** column name */
  ReceivedTime = 'receivedTime',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Within = 'within'
}

export type DetectionLogs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DetectionLogs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DetectionLogs_Set_Input>;
  /** filter the rows which have to be updated */
  where: DetectionLogs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DetectionLogs_Var_Pop_Fields = {
  __typename?: 'detectionLogs_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DetectionLogs_Var_Samp_Fields = {
  __typename?: 'detectionLogs_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DetectionLogs_Variance_Fields = {
  __typename?: 'detectionLogs_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "detection_sets" */
export type DetectionSets = {
  __typename?: 'detectionSets';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "detection_sets" */
export type DetectionSets_Aggregate = {
  __typename?: 'detectionSets_aggregate';
  aggregate?: Maybe<DetectionSets_Aggregate_Fields>;
  nodes: Array<DetectionSets>;
};

/** aggregate fields of "detection_sets" */
export type DetectionSets_Aggregate_Fields = {
  __typename?: 'detectionSets_aggregate_fields';
  avg?: Maybe<DetectionSets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<DetectionSets_Max_Fields>;
  min?: Maybe<DetectionSets_Min_Fields>;
  stddev?: Maybe<DetectionSets_Stddev_Fields>;
  stddev_pop?: Maybe<DetectionSets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<DetectionSets_Stddev_Samp_Fields>;
  sum?: Maybe<DetectionSets_Sum_Fields>;
  var_pop?: Maybe<DetectionSets_Var_Pop_Fields>;
  var_samp?: Maybe<DetectionSets_Var_Samp_Fields>;
  variance?: Maybe<DetectionSets_Variance_Fields>;
};


/** aggregate fields of "detection_sets" */
export type DetectionSets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<DetectionSets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type DetectionSets_Avg_Fields = {
  __typename?: 'detectionSets_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "detection_sets". All fields are combined with a logical 'AND'. */
export type DetectionSets_Bool_Exp = {
  _and?: InputMaybe<Array<DetectionSets_Bool_Exp>>;
  _not?: InputMaybe<DetectionSets_Bool_Exp>;
  _or?: InputMaybe<Array<DetectionSets_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "detection_sets" */
export enum DetectionSets_Constraint {
  /** unique or primary key constraint on columns "id" */
  DetectionSetsPkey = 'detection_sets_pkey'
}

/** input type for incrementing numeric columns in table "detection_sets" */
export type DetectionSets_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "detection_sets" */
export type DetectionSets_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type DetectionSets_Max_Fields = {
  __typename?: 'detectionSets_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type DetectionSets_Min_Fields = {
  __typename?: 'detectionSets_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "detection_sets" */
export type DetectionSets_Mutation_Response = {
  __typename?: 'detectionSets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<DetectionSets>;
};

/** on_conflict condition type for table "detection_sets" */
export type DetectionSets_On_Conflict = {
  constraint: DetectionSets_Constraint;
  update_columns?: Array<DetectionSets_Update_Column>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};

/** Ordering options when selecting data from "detection_sets". */
export type DetectionSets_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detection_sets */
export type DetectionSets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "detection_sets" */
export enum DetectionSets_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "detection_sets" */
export type DetectionSets_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type DetectionSets_Stddev_Fields = {
  __typename?: 'detectionSets_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type DetectionSets_Stddev_Pop_Fields = {
  __typename?: 'detectionSets_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type DetectionSets_Stddev_Samp_Fields = {
  __typename?: 'detectionSets_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "detectionSets" */
export type DetectionSets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: DetectionSets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type DetectionSets_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type DetectionSets_Sum_Fields = {
  __typename?: 'detectionSets_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "detection_sets" */
export enum DetectionSets_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type DetectionSets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DetectionSets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DetectionSets_Set_Input>;
  /** filter the rows which have to be updated */
  where: DetectionSets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type DetectionSets_Var_Pop_Fields = {
  __typename?: 'detectionSets_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type DetectionSets_Var_Samp_Fields = {
  __typename?: 'detectionSets_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type DetectionSets_Variance_Fields = {
  __typename?: 'detectionSets_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "detection_states" */
export type Detection_States = {
  __typename?: 'detection_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "detection_states" */
export type Detection_States_Aggregate = {
  __typename?: 'detection_states_aggregate';
  aggregate?: Maybe<Detection_States_Aggregate_Fields>;
  nodes: Array<Detection_States>;
};

/** aggregate fields of "detection_states" */
export type Detection_States_Aggregate_Fields = {
  __typename?: 'detection_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Detection_States_Max_Fields>;
  min?: Maybe<Detection_States_Min_Fields>;
};


/** aggregate fields of "detection_states" */
export type Detection_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Detection_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "detection_states". All fields are combined with a logical 'AND'. */
export type Detection_States_Bool_Exp = {
  _and?: InputMaybe<Array<Detection_States_Bool_Exp>>;
  _not?: InputMaybe<Detection_States_Bool_Exp>;
  _or?: InputMaybe<Array<Detection_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "detection_states" */
export enum Detection_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  DetectionStatesPkey = 'detection_states_pkey'
}

export enum Detection_States_Enum {
  /** disabled */
  Disabled = 'disabled',
  /** enabled */
  Enabled = 'enabled'
}

/** Boolean expression to compare columns of type "detection_states_enum". All fields are combined with logical 'AND'. */
export type Detection_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Detection_States_Enum>;
  _in?: InputMaybe<Array<Detection_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Detection_States_Enum>;
  _nin?: InputMaybe<Array<Detection_States_Enum>>;
};

/** input type for inserting data into table "detection_states" */
export type Detection_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Detection_States_Max_Fields = {
  __typename?: 'detection_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Detection_States_Min_Fields = {
  __typename?: 'detection_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "detection_states" */
export type Detection_States_Mutation_Response = {
  __typename?: 'detection_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Detection_States>;
};

/** on_conflict condition type for table "detection_states" */
export type Detection_States_On_Conflict = {
  constraint: Detection_States_Constraint;
  update_columns?: Array<Detection_States_Update_Column>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};

/** Ordering options when selecting data from "detection_states". */
export type Detection_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detection_states */
export type Detection_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "detection_states" */
export enum Detection_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "detection_states" */
export type Detection_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "detection_states" */
export type Detection_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Detection_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Detection_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "detection_states" */
export enum Detection_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Detection_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Detection_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Detection_States_Bool_Exp;
};

/** columns and relationships of "detections" */
export type Detections = {
  __typename?: 'detections';
  assetId: Scalars['String'];
  categoryId?: Maybe<Scalars['String']>;
  compareDefinition: Scalars['jsonb'];
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  detectionSetId: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  state: Detection_States_Enum;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "detections" */
export type DetectionsCompareDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "detections" */
export type Detections_Aggregate = {
  __typename?: 'detections_aggregate';
  aggregate?: Maybe<Detections_Aggregate_Fields>;
  nodes: Array<Detections>;
};

/** aggregate fields of "detections" */
export type Detections_Aggregate_Fields = {
  __typename?: 'detections_aggregate_fields';
  avg?: Maybe<Detections_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Detections_Max_Fields>;
  min?: Maybe<Detections_Min_Fields>;
  stddev?: Maybe<Detections_Stddev_Fields>;
  stddev_pop?: Maybe<Detections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Detections_Stddev_Samp_Fields>;
  sum?: Maybe<Detections_Sum_Fields>;
  var_pop?: Maybe<Detections_Var_Pop_Fields>;
  var_samp?: Maybe<Detections_Var_Samp_Fields>;
  variance?: Maybe<Detections_Variance_Fields>;
};


/** aggregate fields of "detections" */
export type Detections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Detections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Detections_Append_Input = {
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Detections_Avg_Fields = {
  __typename?: 'detections_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "detections". All fields are combined with a logical 'AND'. */
export type Detections_Bool_Exp = {
  _and?: InputMaybe<Array<Detections_Bool_Exp>>;
  _not?: InputMaybe<Detections_Bool_Exp>;
  _or?: InputMaybe<Array<Detections_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  compareDefinition?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  detectionSetId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Detection_States_Enum_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "detections" */
export enum Detections_Constraint {
  /** unique or primary key constraint on columns "id" */
  DetectionsPkey = 'detections_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Detections_Delete_At_Path_Input = {
  compareDefinition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Detections_Delete_Elem_Input = {
  compareDefinition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Detections_Delete_Key_Input = {
  compareDefinition?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "detections" */
export type Detections_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "detections" */
export type Detections_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  detectionSetId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Detection_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Detections_Max_Fields = {
  __typename?: 'detections_max_fields';
  assetId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  detectionSetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Detections_Min_Fields = {
  __typename?: 'detections_min_fields';
  assetId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  detectionSetId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "detections" */
export type Detections_Mutation_Response = {
  __typename?: 'detections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Detections>;
};

/** on_conflict condition type for table "detections" */
export type Detections_On_Conflict = {
  constraint: Detections_Constraint;
  update_columns?: Array<Detections_Update_Column>;
  where?: InputMaybe<Detections_Bool_Exp>;
};

/** Ordering options when selecting data from "detections". */
export type Detections_Order_By = {
  assetId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  compareDefinition?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  detectionSetId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: detections */
export type Detections_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Detections_Prepend_Input = {
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "detections" */
export enum Detections_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CompareDefinition = 'compareDefinition',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DetectionSetId = 'detectionSetId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "detections" */
export type Detections_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  detectionSetId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Detection_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Detections_Stddev_Fields = {
  __typename?: 'detections_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Detections_Stddev_Pop_Fields = {
  __typename?: 'detections_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Detections_Stddev_Samp_Fields = {
  __typename?: 'detections_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "detections" */
export type Detections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Detections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Detections_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  detectionSetId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Detection_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Detections_Sum_Fields = {
  __typename?: 'detections_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "detections" */
export enum Detections_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CompareDefinition = 'compareDefinition',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  DetectionSetId = 'detectionSetId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Detections_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Detections_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Detections_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Detections_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Detections_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Detections_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Detections_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Detections_Set_Input>;
  /** filter the rows which have to be updated */
  where: Detections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Detections_Var_Pop_Fields = {
  __typename?: 'detections_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Detections_Var_Samp_Fields = {
  __typename?: 'detections_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Detections_Variance_Fields = {
  __typename?: 'detections_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "evacuation_settings" */
export type EvacuationSettings = {
  __typename?: 'evacuationSettings';
  createdAt?: Maybe<Scalars['bigint']>;
  expireDays: Scalars['bigint'];
  id: Scalars['String'];
  owner: Scalars['String'];
  tableName: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "evacuation_settings" */
export type EvacuationSettings_Aggregate = {
  __typename?: 'evacuationSettings_aggregate';
  aggregate?: Maybe<EvacuationSettings_Aggregate_Fields>;
  nodes: Array<EvacuationSettings>;
};

/** aggregate fields of "evacuation_settings" */
export type EvacuationSettings_Aggregate_Fields = {
  __typename?: 'evacuationSettings_aggregate_fields';
  avg?: Maybe<EvacuationSettings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<EvacuationSettings_Max_Fields>;
  min?: Maybe<EvacuationSettings_Min_Fields>;
  stddev?: Maybe<EvacuationSettings_Stddev_Fields>;
  stddev_pop?: Maybe<EvacuationSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<EvacuationSettings_Stddev_Samp_Fields>;
  sum?: Maybe<EvacuationSettings_Sum_Fields>;
  var_pop?: Maybe<EvacuationSettings_Var_Pop_Fields>;
  var_samp?: Maybe<EvacuationSettings_Var_Samp_Fields>;
  variance?: Maybe<EvacuationSettings_Variance_Fields>;
};


/** aggregate fields of "evacuation_settings" */
export type EvacuationSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<EvacuationSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type EvacuationSettings_Avg_Fields = {
  __typename?: 'evacuationSettings_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "evacuation_settings". All fields are combined with a logical 'AND'. */
export type EvacuationSettings_Bool_Exp = {
  _and?: InputMaybe<Array<EvacuationSettings_Bool_Exp>>;
  _not?: InputMaybe<EvacuationSettings_Bool_Exp>;
  _or?: InputMaybe<Array<EvacuationSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  expireDays?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tableName?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "evacuation_settings" */
export enum EvacuationSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  EvacuationSettingsPkey = 'evacuation_settings_pkey'
}

/** input type for incrementing numeric columns in table "evacuation_settings" */
export type EvacuationSettings_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expireDays?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "evacuation_settings" */
export type EvacuationSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expireDays?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type EvacuationSettings_Max_Fields = {
  __typename?: 'evacuationSettings_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  expireDays?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tableName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type EvacuationSettings_Min_Fields = {
  __typename?: 'evacuationSettings_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  expireDays?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tableName?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "evacuation_settings" */
export type EvacuationSettings_Mutation_Response = {
  __typename?: 'evacuationSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<EvacuationSettings>;
};

/** on_conflict condition type for table "evacuation_settings" */
export type EvacuationSettings_On_Conflict = {
  constraint: EvacuationSettings_Constraint;
  update_columns?: Array<EvacuationSettings_Update_Column>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "evacuation_settings". */
export type EvacuationSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expireDays?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tableName?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: evacuation_settings */
export type EvacuationSettings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "evacuation_settings" */
export enum EvacuationSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpireDays = 'expireDays',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "evacuation_settings" */
export type EvacuationSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expireDays?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type EvacuationSettings_Stddev_Fields = {
  __typename?: 'evacuationSettings_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type EvacuationSettings_Stddev_Pop_Fields = {
  __typename?: 'evacuationSettings_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type EvacuationSettings_Stddev_Samp_Fields = {
  __typename?: 'evacuationSettings_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "evacuationSettings" */
export type EvacuationSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: EvacuationSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type EvacuationSettings_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expireDays?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tableName?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type EvacuationSettings_Sum_Fields = {
  __typename?: 'evacuationSettings_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  expireDays?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "evacuation_settings" */
export enum EvacuationSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpireDays = 'expireDays',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TableName = 'tableName',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type EvacuationSettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EvacuationSettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvacuationSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: EvacuationSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type EvacuationSettings_Var_Pop_Fields = {
  __typename?: 'evacuationSettings_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type EvacuationSettings_Var_Samp_Fields = {
  __typename?: 'evacuationSettings_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type EvacuationSettings_Variance_Fields = {
  __typename?: 'evacuationSettings_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expireDays?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "events" */
export type Events = {
  __typename?: 'events';
  action: Scalars['String'];
  assetId: Scalars['String'];
  compareDefinition: Scalars['jsonb'];
  createdAt: Scalars['bigint'];
  detectionId: Scalars['String'];
  id: Scalars['String'];
  label?: Maybe<Scalars['String']>;
  occurredDatetime: Scalars['bigint'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "events" */
export type EventsCompareDefinitionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "events" */
export type Events_Aggregate = {
  __typename?: 'events_aggregate';
  aggregate?: Maybe<Events_Aggregate_Fields>;
  nodes: Array<Events>;
};

/** aggregate fields of "events" */
export type Events_Aggregate_Fields = {
  __typename?: 'events_aggregate_fields';
  avg?: Maybe<Events_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Events_Max_Fields>;
  min?: Maybe<Events_Min_Fields>;
  stddev?: Maybe<Events_Stddev_Fields>;
  stddev_pop?: Maybe<Events_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Events_Stddev_Samp_Fields>;
  sum?: Maybe<Events_Sum_Fields>;
  var_pop?: Maybe<Events_Var_Pop_Fields>;
  var_samp?: Maybe<Events_Var_Samp_Fields>;
  variance?: Maybe<Events_Variance_Fields>;
};


/** aggregate fields of "events" */
export type Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Events_Append_Input = {
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Events_Avg_Fields = {
  __typename?: 'events_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "events". All fields are combined with a logical 'AND'. */
export type Events_Bool_Exp = {
  _and?: InputMaybe<Array<Events_Bool_Exp>>;
  _not?: InputMaybe<Events_Bool_Exp>;
  _or?: InputMaybe<Array<Events_Bool_Exp>>;
  action?: InputMaybe<String_Comparison_Exp>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  compareDefinition?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  detectionId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  occurredDatetime?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "events" */
export enum Events_Constraint {
  /** unique or primary key constraint on columns "id" */
  EventsPkey = 'events_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Events_Delete_At_Path_Input = {
  compareDefinition?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Events_Delete_Elem_Input = {
  compareDefinition?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Events_Delete_Key_Input = {
  compareDefinition?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "events" */
export type Events_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  occurredDatetime?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "events" */
export type Events_Insert_Input = {
  action?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  occurredDatetime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Events_Max_Fields = {
  __typename?: 'events_max_fields';
  action?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  occurredDatetime?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Events_Min_Fields = {
  __typename?: 'events_min_fields';
  action?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  occurredDatetime?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "events" */
export type Events_Mutation_Response = {
  __typename?: 'events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Events>;
};

/** on_conflict condition type for table "events" */
export type Events_On_Conflict = {
  constraint: Events_Constraint;
  update_columns?: Array<Events_Update_Column>;
  where?: InputMaybe<Events_Bool_Exp>;
};

/** Ordering options when selecting data from "events". */
export type Events_Order_By = {
  action?: InputMaybe<Order_By>;
  assetId?: InputMaybe<Order_By>;
  compareDefinition?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  detectionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  occurredDatetime?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: events */
export type Events_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Events_Prepend_Input = {
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "events" */
export enum Events_Select_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CompareDefinition = 'compareDefinition',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OccurredDatetime = 'occurredDatetime',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "events" */
export type Events_Set_Input = {
  action?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  occurredDatetime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Events_Stddev_Fields = {
  __typename?: 'events_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Events_Stddev_Pop_Fields = {
  __typename?: 'events_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Events_Stddev_Samp_Fields = {
  __typename?: 'events_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "events" */
export type Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Events_Stream_Cursor_Value_Input = {
  action?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  compareDefinition?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  label?: InputMaybe<Scalars['String']>;
  occurredDatetime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Events_Sum_Fields = {
  __typename?: 'events_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  occurredDatetime?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "events" */
export enum Events_Update_Column {
  /** column name */
  Action = 'action',
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CompareDefinition = 'compareDefinition',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  Label = 'label',
  /** column name */
  OccurredDatetime = 'occurredDatetime',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Events_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Events_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Events_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Events_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Events_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Events_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Events_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Events_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Events_Var_Pop_Fields = {
  __typename?: 'events_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Events_Var_Samp_Fields = {
  __typename?: 'events_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Events_Variance_Fields = {
  __typename?: 'events_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  occurredDatetime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "execution_histories" */
export type ExecutionHistories = {
  __typename?: 'executionHistories';
  createdAt: Scalars['bigint'];
  executionHistoryKey: Scalars['String'];
  id: Scalars['String'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};

/** aggregated selection of "execution_histories" */
export type ExecutionHistories_Aggregate = {
  __typename?: 'executionHistories_aggregate';
  aggregate?: Maybe<ExecutionHistories_Aggregate_Fields>;
  nodes: Array<ExecutionHistories>;
};

/** aggregate fields of "execution_histories" */
export type ExecutionHistories_Aggregate_Fields = {
  __typename?: 'executionHistories_aggregate_fields';
  avg?: Maybe<ExecutionHistories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ExecutionHistories_Max_Fields>;
  min?: Maybe<ExecutionHistories_Min_Fields>;
  stddev?: Maybe<ExecutionHistories_Stddev_Fields>;
  stddev_pop?: Maybe<ExecutionHistories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ExecutionHistories_Stddev_Samp_Fields>;
  sum?: Maybe<ExecutionHistories_Sum_Fields>;
  var_pop?: Maybe<ExecutionHistories_Var_Pop_Fields>;
  var_samp?: Maybe<ExecutionHistories_Var_Samp_Fields>;
  variance?: Maybe<ExecutionHistories_Variance_Fields>;
};


/** aggregate fields of "execution_histories" */
export type ExecutionHistories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ExecutionHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type ExecutionHistories_Avg_Fields = {
  __typename?: 'executionHistories_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "execution_histories". All fields are combined with a logical 'AND'. */
export type ExecutionHistories_Bool_Exp = {
  _and?: InputMaybe<Array<ExecutionHistories_Bool_Exp>>;
  _not?: InputMaybe<ExecutionHistories_Bool_Exp>;
  _or?: InputMaybe<Array<ExecutionHistories_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  executionHistoryKey?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "execution_histories" */
export enum ExecutionHistories_Constraint {
  /** unique or primary key constraint on columns "execution_history_key" */
  ExecutionHistoriesExecutionHistoryKeyKey = 'execution_histories_execution_history_key_key',
  /** unique or primary key constraint on columns "id" */
  ExecutionHistoriesPkey = 'execution_histories_pkey'
}

/** input type for incrementing numeric columns in table "execution_histories" */
export type ExecutionHistories_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "execution_histories" */
export type ExecutionHistories_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionHistoryKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ExecutionHistories_Max_Fields = {
  __typename?: 'executionHistories_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  executionHistoryKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type ExecutionHistories_Min_Fields = {
  __typename?: 'executionHistories_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  executionHistoryKey?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "execution_histories" */
export type ExecutionHistories_Mutation_Response = {
  __typename?: 'executionHistories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ExecutionHistories>;
};

/** on_conflict condition type for table "execution_histories" */
export type ExecutionHistories_On_Conflict = {
  constraint: ExecutionHistories_Constraint;
  update_columns?: Array<ExecutionHistories_Update_Column>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};

/** Ordering options when selecting data from "execution_histories". */
export type ExecutionHistories_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  executionHistoryKey?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: execution_histories */
export type ExecutionHistories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "execution_histories" */
export enum ExecutionHistories_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExecutionHistoryKey = 'executionHistoryKey',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "execution_histories" */
export type ExecutionHistories_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionHistoryKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ExecutionHistories_Stddev_Fields = {
  __typename?: 'executionHistories_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type ExecutionHistories_Stddev_Pop_Fields = {
  __typename?: 'executionHistories_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type ExecutionHistories_Stddev_Samp_Fields = {
  __typename?: 'executionHistories_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "executionHistories" */
export type ExecutionHistories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ExecutionHistories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ExecutionHistories_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionHistoryKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ExecutionHistories_Sum_Fields = {
  __typename?: 'executionHistories_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "execution_histories" */
export enum ExecutionHistories_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExecutionHistoryKey = 'executionHistoryKey',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ExecutionHistories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ExecutionHistories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ExecutionHistories_Set_Input>;
  /** filter the rows which have to be updated */
  where: ExecutionHistories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ExecutionHistories_Var_Pop_Fields = {
  __typename?: 'executionHistories_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type ExecutionHistories_Var_Samp_Fields = {
  __typename?: 'executionHistories_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type ExecutionHistories_Variance_Fields = {
  __typename?: 'executionHistories_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "file_states" */
export type File_States = {
  __typename?: 'file_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "file_states" */
export type File_States_Aggregate = {
  __typename?: 'file_states_aggregate';
  aggregate?: Maybe<File_States_Aggregate_Fields>;
  nodes: Array<File_States>;
};

/** aggregate fields of "file_states" */
export type File_States_Aggregate_Fields = {
  __typename?: 'file_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<File_States_Max_Fields>;
  min?: Maybe<File_States_Min_Fields>;
};


/** aggregate fields of "file_states" */
export type File_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<File_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "file_states". All fields are combined with a logical 'AND'. */
export type File_States_Bool_Exp = {
  _and?: InputMaybe<Array<File_States_Bool_Exp>>;
  _not?: InputMaybe<File_States_Bool_Exp>;
  _or?: InputMaybe<Array<File_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "file_states" */
export enum File_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  FileStatesPkey = 'file_states_pkey'
}

/** input type for inserting data into table "file_states" */
export type File_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type File_States_Max_Fields = {
  __typename?: 'file_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type File_States_Min_Fields = {
  __typename?: 'file_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "file_states" */
export type File_States_Mutation_Response = {
  __typename?: 'file_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<File_States>;
};

/** on_conflict condition type for table "file_states" */
export type File_States_On_Conflict = {
  constraint: File_States_Constraint;
  update_columns?: Array<File_States_Update_Column>;
  where?: InputMaybe<File_States_Bool_Exp>;
};

/** Ordering options when selecting data from "file_states". */
export type File_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: file_states */
export type File_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "file_states" */
export enum File_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "file_states" */
export type File_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "file_states" */
export type File_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: File_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type File_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "file_states" */
export enum File_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type File_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<File_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: File_States_Bool_Exp;
};

/** columns and relationships of "groups" */
export type Groups = {
  __typename?: 'groups';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  parentId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  usersGroups: Array<UsersGroups>;
  /** An aggregate relationship */
  usersGroups_aggregate: UsersGroups_Aggregate;
};


/** columns and relationships of "groups" */
export type GroupsUsersGroupsArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


/** columns and relationships of "groups" */
export type GroupsUsersGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};

/** aggregated selection of "groups" */
export type Groups_Aggregate = {
  __typename?: 'groups_aggregate';
  aggregate?: Maybe<Groups_Aggregate_Fields>;
  nodes: Array<Groups>;
};

/** aggregate fields of "groups" */
export type Groups_Aggregate_Fields = {
  __typename?: 'groups_aggregate_fields';
  avg?: Maybe<Groups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Groups_Max_Fields>;
  min?: Maybe<Groups_Min_Fields>;
  stddev?: Maybe<Groups_Stddev_Fields>;
  stddev_pop?: Maybe<Groups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Groups_Stddev_Samp_Fields>;
  sum?: Maybe<Groups_Sum_Fields>;
  var_pop?: Maybe<Groups_Var_Pop_Fields>;
  var_samp?: Maybe<Groups_Var_Samp_Fields>;
  variance?: Maybe<Groups_Variance_Fields>;
};


/** aggregate fields of "groups" */
export type Groups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Groups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Groups_Avg_Fields = {
  __typename?: 'groups_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "groups". All fields are combined with a logical 'AND'. */
export type Groups_Bool_Exp = {
  _and?: InputMaybe<Array<Groups_Bool_Exp>>;
  _not?: InputMaybe<Groups_Bool_Exp>;
  _or?: InputMaybe<Array<Groups_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  parentId?: InputMaybe<String_Comparison_Exp>;
  policyId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  usersGroups?: InputMaybe<UsersGroups_Bool_Exp>;
  usersGroups_aggregate?: InputMaybe<UsersGroups_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "groups" */
export enum Groups_Constraint {
  /** unique or primary key constraint on columns "id" */
  GroupsPkey = 'groups_pkey'
}

/** input type for incrementing numeric columns in table "groups" */
export type Groups_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "groups" */
export type Groups_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  usersGroups?: InputMaybe<UsersGroups_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Groups_Max_Fields = {
  __typename?: 'groups_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Groups_Min_Fields = {
  __typename?: 'groups_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parentId?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "groups" */
export type Groups_Mutation_Response = {
  __typename?: 'groups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Groups>;
};

/** input type for inserting object relation for remote table "groups" */
export type Groups_Obj_Rel_Insert_Input = {
  data: Groups_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};

/** on_conflict condition type for table "groups" */
export type Groups_On_Conflict = {
  constraint: Groups_Constraint;
  update_columns?: Array<Groups_Update_Column>;
  where?: InputMaybe<Groups_Bool_Exp>;
};

/** Ordering options when selecting data from "groups". */
export type Groups_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  parentId?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usersGroups_aggregate?: InputMaybe<UsersGroups_Aggregate_Order_By>;
};

/** primary key columns input for table: groups */
export type Groups_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "groups" */
export enum Groups_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "groups" */
export type Groups_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Groups_Stddev_Fields = {
  __typename?: 'groups_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Groups_Stddev_Pop_Fields = {
  __typename?: 'groups_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Groups_Stddev_Samp_Fields = {
  __typename?: 'groups_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "groups" */
export type Groups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Groups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Groups_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentId?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Groups_Sum_Fields = {
  __typename?: 'groups_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "groups" */
export enum Groups_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ParentId = 'parentId',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Groups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Groups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Groups_Set_Input>;
  /** filter the rows which have to be updated */
  where: Groups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Groups_Var_Pop_Fields = {
  __typename?: 'groups_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Groups_Var_Samp_Fields = {
  __typename?: 'groups_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Groups_Variance_Fields = {
  __typename?: 'groups_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "idp_types" */
export type IdpTypes = {
  __typename?: 'idpTypes';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "idp_types" */
export type IdpTypes_Aggregate = {
  __typename?: 'idpTypes_aggregate';
  aggregate?: Maybe<IdpTypes_Aggregate_Fields>;
  nodes: Array<IdpTypes>;
};

/** aggregate fields of "idp_types" */
export type IdpTypes_Aggregate_Fields = {
  __typename?: 'idpTypes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<IdpTypes_Max_Fields>;
  min?: Maybe<IdpTypes_Min_Fields>;
};


/** aggregate fields of "idp_types" */
export type IdpTypes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<IdpTypes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "idp_types". All fields are combined with a logical 'AND'. */
export type IdpTypes_Bool_Exp = {
  _and?: InputMaybe<Array<IdpTypes_Bool_Exp>>;
  _not?: InputMaybe<IdpTypes_Bool_Exp>;
  _or?: InputMaybe<Array<IdpTypes_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "idp_types" */
export enum IdpTypes_Constraint {
  /** unique or primary key constraint on columns "value" */
  IdpTypesPkey = 'idp_types_pkey'
}

export enum IdpTypes_Enum {
  /** Amazon */
  Amazon = 'Amazon',
  /** Apple */
  Apple = 'Apple',
  /** Facebook */
  Facebook = 'Facebook',
  /** Google */
  Google = 'Google',
  /** OIDC */
  Oidc = 'OIDC',
  /** SAML */
  Saml = 'SAML'
}

/** Boolean expression to compare columns of type "idpTypes_enum". All fields are combined with logical 'AND'. */
export type IdpTypes_Enum_Comparison_Exp = {
  _eq?: InputMaybe<IdpTypes_Enum>;
  _in?: InputMaybe<Array<IdpTypes_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<IdpTypes_Enum>;
  _nin?: InputMaybe<Array<IdpTypes_Enum>>;
};

/** input type for inserting data into table "idp_types" */
export type IdpTypes_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type IdpTypes_Max_Fields = {
  __typename?: 'idpTypes_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type IdpTypes_Min_Fields = {
  __typename?: 'idpTypes_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "idp_types" */
export type IdpTypes_Mutation_Response = {
  __typename?: 'idpTypes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<IdpTypes>;
};

/** on_conflict condition type for table "idp_types" */
export type IdpTypes_On_Conflict = {
  constraint: IdpTypes_Constraint;
  update_columns?: Array<IdpTypes_Update_Column>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};

/** Ordering options when selecting data from "idp_types". */
export type IdpTypes_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: idp_types */
export type IdpTypes_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "idp_types" */
export enum IdpTypes_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "idp_types" */
export type IdpTypes_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "idpTypes" */
export type IdpTypes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: IdpTypes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type IdpTypes_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "idp_types" */
export enum IdpTypes_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type IdpTypes_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<IdpTypes_Set_Input>;
  /** filter the rows which have to be updated */
  where: IdpTypes_Bool_Exp;
};

/** columns and relationships of "idps" */
export type Idps = {
  __typename?: 'idps';
  createdAt?: Maybe<Scalars['bigint']>;
  define: Scalars['jsonb'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  oidcIssuerUrl?: Maybe<Scalars['String']>;
  type: IdpTypes_Enum;
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "idps" */
export type IdpsDefineArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "idps" */
export type Idps_Aggregate = {
  __typename?: 'idps_aggregate';
  aggregate?: Maybe<Idps_Aggregate_Fields>;
  nodes: Array<Idps>;
};

/** aggregate fields of "idps" */
export type Idps_Aggregate_Fields = {
  __typename?: 'idps_aggregate_fields';
  avg?: Maybe<Idps_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Idps_Max_Fields>;
  min?: Maybe<Idps_Min_Fields>;
  stddev?: Maybe<Idps_Stddev_Fields>;
  stddev_pop?: Maybe<Idps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Idps_Stddev_Samp_Fields>;
  sum?: Maybe<Idps_Sum_Fields>;
  var_pop?: Maybe<Idps_Var_Pop_Fields>;
  var_samp?: Maybe<Idps_Var_Samp_Fields>;
  variance?: Maybe<Idps_Variance_Fields>;
};


/** aggregate fields of "idps" */
export type Idps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Idps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Idps_Append_Input = {
  define?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Idps_Avg_Fields = {
  __typename?: 'idps_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "idps". All fields are combined with a logical 'AND'. */
export type Idps_Bool_Exp = {
  _and?: InputMaybe<Array<Idps_Bool_Exp>>;
  _not?: InputMaybe<Idps_Bool_Exp>;
  _or?: InputMaybe<Array<Idps_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  define?: InputMaybe<Jsonb_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  oidcIssuerUrl?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<IdpTypes_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "idps" */
export enum Idps_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdpsPkey = 'idps_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Idps_Delete_At_Path_Input = {
  define?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Idps_Delete_Elem_Input = {
  define?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Idps_Delete_Key_Input = {
  define?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "idps" */
export type Idps_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "idps" */
export type Idps_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oidcIssuerUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<IdpTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Idps_Max_Fields = {
  __typename?: 'idps_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  oidcIssuerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Idps_Min_Fields = {
  __typename?: 'idps_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  oidcIssuerUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "idps" */
export type Idps_Mutation_Response = {
  __typename?: 'idps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Idps>;
};

/** input type for inserting object relation for remote table "idps" */
export type Idps_Obj_Rel_Insert_Input = {
  data: Idps_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Idps_On_Conflict>;
};

/** on_conflict condition type for table "idps" */
export type Idps_On_Conflict = {
  constraint: Idps_Constraint;
  update_columns?: Array<Idps_Update_Column>;
  where?: InputMaybe<Idps_Bool_Exp>;
};

/** Ordering options when selecting data from "idps". */
export type Idps_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  define?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  oidcIssuerUrl?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: idps */
export type Idps_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Idps_Prepend_Input = {
  define?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "idps" */
export enum Idps_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Define = 'define',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OidcIssuerUrl = 'oidcIssuerUrl',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "idps" */
export type Idps_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oidcIssuerUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<IdpTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Idps_Stddev_Fields = {
  __typename?: 'idps_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Idps_Stddev_Pop_Fields = {
  __typename?: 'idps_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Idps_Stddev_Samp_Fields = {
  __typename?: 'idps_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "idps" */
export type Idps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Idps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Idps_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  oidcIssuerUrl?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<IdpTypes_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Idps_Sum_Fields = {
  __typename?: 'idps_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "idps" */
export enum Idps_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Define = 'define',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OidcIssuerUrl = 'oidcIssuerUrl',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Idps_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Idps_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Idps_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Idps_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Idps_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Idps_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Idps_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Idps_Set_Input>;
  /** filter the rows which have to be updated */
  where: Idps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Idps_Var_Pop_Fields = {
  __typename?: 'idps_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Idps_Var_Samp_Fields = {
  __typename?: 'idps_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Idps_Variance_Fields = {
  __typename?: 'idps_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_settings" */
export type JobSettings = {
  __typename?: 'jobSettings';
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  jobSiteId: Scalars['String'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};

/** aggregated selection of "job_settings" */
export type JobSettings_Aggregate = {
  __typename?: 'jobSettings_aggregate';
  aggregate?: Maybe<JobSettings_Aggregate_Fields>;
  nodes: Array<JobSettings>;
};

/** aggregate fields of "job_settings" */
export type JobSettings_Aggregate_Fields = {
  __typename?: 'jobSettings_aggregate_fields';
  avg?: Maybe<JobSettings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JobSettings_Max_Fields>;
  min?: Maybe<JobSettings_Min_Fields>;
  stddev?: Maybe<JobSettings_Stddev_Fields>;
  stddev_pop?: Maybe<JobSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JobSettings_Stddev_Samp_Fields>;
  sum?: Maybe<JobSettings_Sum_Fields>;
  var_pop?: Maybe<JobSettings_Var_Pop_Fields>;
  var_samp?: Maybe<JobSettings_Var_Samp_Fields>;
  variance?: Maybe<JobSettings_Variance_Fields>;
};


/** aggregate fields of "job_settings" */
export type JobSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobSettings_Avg_Fields = {
  __typename?: 'jobSettings_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_settings". All fields are combined with a logical 'AND'. */
export type JobSettings_Bool_Exp = {
  _and?: InputMaybe<Array<JobSettings_Bool_Exp>>;
  _not?: InputMaybe<JobSettings_Bool_Exp>;
  _or?: InputMaybe<Array<JobSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  jobSiteId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_settings" */
export enum JobSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobSettingsPkey = 'job_settings_pkey'
}

/** input type for incrementing numeric columns in table "job_settings" */
export type JobSettings_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_settings" */
export type JobSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSiteId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobSettings_Max_Fields = {
  __typename?: 'jobSettings_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  jobSiteId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JobSettings_Min_Fields = {
  __typename?: 'jobSettings_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  jobSiteId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "job_settings" */
export type JobSettings_Mutation_Response = {
  __typename?: 'jobSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobSettings>;
};

/** on_conflict condition type for table "job_settings" */
export type JobSettings_On_Conflict = {
  constraint: JobSettings_Constraint;
  update_columns?: Array<JobSettings_Update_Column>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "job_settings". */
export type JobSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobSiteId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_settings */
export type JobSettings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "job_settings" */
export enum JobSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobSiteId = 'jobSiteId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "job_settings" */
export type JobSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSiteId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type JobSettings_Stddev_Fields = {
  __typename?: 'jobSettings_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JobSettings_Stddev_Pop_Fields = {
  __typename?: 'jobSettings_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JobSettings_Stddev_Samp_Fields = {
  __typename?: 'jobSettings_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobSettings" */
export type JobSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobSettings_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSiteId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobSettings_Sum_Fields = {
  __typename?: 'jobSettings_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "job_settings" */
export enum JobSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobSiteId = 'jobSiteId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JobSettings_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobSettings_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JobSettings_Var_Pop_Fields = {
  __typename?: 'jobSettings_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JobSettings_Var_Samp_Fields = {
  __typename?: 'jobSettings_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobSettings_Variance_Fields = {
  __typename?: 'jobSettings_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_site_attributes" */
export type JobSiteAttributes = {
  __typename?: 'jobSiteAttributes';
  assetId: Scalars['String'];
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  jobSettingId: Scalars['String'];
  key: Scalars['String'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};

/** aggregated selection of "job_site_attributes" */
export type JobSiteAttributes_Aggregate = {
  __typename?: 'jobSiteAttributes_aggregate';
  aggregate?: Maybe<JobSiteAttributes_Aggregate_Fields>;
  nodes: Array<JobSiteAttributes>;
};

/** aggregate fields of "job_site_attributes" */
export type JobSiteAttributes_Aggregate_Fields = {
  __typename?: 'jobSiteAttributes_aggregate_fields';
  avg?: Maybe<JobSiteAttributes_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JobSiteAttributes_Max_Fields>;
  min?: Maybe<JobSiteAttributes_Min_Fields>;
  stddev?: Maybe<JobSiteAttributes_Stddev_Fields>;
  stddev_pop?: Maybe<JobSiteAttributes_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JobSiteAttributes_Stddev_Samp_Fields>;
  sum?: Maybe<JobSiteAttributes_Sum_Fields>;
  var_pop?: Maybe<JobSiteAttributes_Var_Pop_Fields>;
  var_samp?: Maybe<JobSiteAttributes_Var_Samp_Fields>;
  variance?: Maybe<JobSiteAttributes_Variance_Fields>;
};


/** aggregate fields of "job_site_attributes" */
export type JobSiteAttributes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobSiteAttributes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type JobSiteAttributes_Avg_Fields = {
  __typename?: 'jobSiteAttributes_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_site_attributes". All fields are combined with a logical 'AND'. */
export type JobSiteAttributes_Bool_Exp = {
  _and?: InputMaybe<Array<JobSiteAttributes_Bool_Exp>>;
  _not?: InputMaybe<JobSiteAttributes_Bool_Exp>;
  _or?: InputMaybe<Array<JobSiteAttributes_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  jobSettingId?: InputMaybe<String_Comparison_Exp>;
  key?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_site_attributes" */
export enum JobSiteAttributes_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobSiteAttributesPkey = 'job_site_attributes_pkey'
}

/** input type for incrementing numeric columns in table "job_site_attributes" */
export type JobSiteAttributes_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_site_attributes" */
export type JobSiteAttributes_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobSiteAttributes_Max_Fields = {
  __typename?: 'jobSiteAttributes_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  jobSettingId?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JobSiteAttributes_Min_Fields = {
  __typename?: 'jobSiteAttributes_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  jobSettingId?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "job_site_attributes" */
export type JobSiteAttributes_Mutation_Response = {
  __typename?: 'jobSiteAttributes_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobSiteAttributes>;
};

/** on_conflict condition type for table "job_site_attributes" */
export type JobSiteAttributes_On_Conflict = {
  constraint: JobSiteAttributes_Constraint;
  update_columns?: Array<JobSiteAttributes_Update_Column>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};

/** Ordering options when selecting data from "job_site_attributes". */
export type JobSiteAttributes_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobSettingId?: InputMaybe<Order_By>;
  key?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_site_attributes */
export type JobSiteAttributes_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "job_site_attributes" */
export enum JobSiteAttributes_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobSettingId = 'jobSettingId',
  /** column name */
  Key = 'key',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "job_site_attributes" */
export type JobSiteAttributes_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type JobSiteAttributes_Stddev_Fields = {
  __typename?: 'jobSiteAttributes_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JobSiteAttributes_Stddev_Pop_Fields = {
  __typename?: 'jobSiteAttributes_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JobSiteAttributes_Stddev_Samp_Fields = {
  __typename?: 'jobSiteAttributes_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobSiteAttributes" */
export type JobSiteAttributes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobSiteAttributes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobSiteAttributes_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobSiteAttributes_Sum_Fields = {
  __typename?: 'jobSiteAttributes_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "job_site_attributes" */
export enum JobSiteAttributes_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  JobSettingId = 'jobSettingId',
  /** column name */
  Key = 'key',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JobSiteAttributes_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobSiteAttributes_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobSiteAttributes_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobSiteAttributes_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JobSiteAttributes_Var_Pop_Fields = {
  __typename?: 'jobSiteAttributes_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JobSiteAttributes_Var_Samp_Fields = {
  __typename?: 'jobSiteAttributes_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobSiteAttributes_Variance_Fields = {
  __typename?: 'jobSiteAttributes_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "job_sites" */
export type JobSites = {
  __typename?: 'jobSites';
  convert: Scalars['jsonb'];
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  owner: Scalars['String'];
  requestData: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "job_sites" */
export type JobSitesConvertArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "job_sites" */
export type JobSitesRequestDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "job_sites" */
export type JobSites_Aggregate = {
  __typename?: 'jobSites_aggregate';
  aggregate?: Maybe<JobSites_Aggregate_Fields>;
  nodes: Array<JobSites>;
};

/** aggregate fields of "job_sites" */
export type JobSites_Aggregate_Fields = {
  __typename?: 'jobSites_aggregate_fields';
  avg?: Maybe<JobSites_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<JobSites_Max_Fields>;
  min?: Maybe<JobSites_Min_Fields>;
  stddev?: Maybe<JobSites_Stddev_Fields>;
  stddev_pop?: Maybe<JobSites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<JobSites_Stddev_Samp_Fields>;
  sum?: Maybe<JobSites_Sum_Fields>;
  var_pop?: Maybe<JobSites_Var_Pop_Fields>;
  var_samp?: Maybe<JobSites_Var_Samp_Fields>;
  variance?: Maybe<JobSites_Variance_Fields>;
};


/** aggregate fields of "job_sites" */
export type JobSites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<JobSites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type JobSites_Append_Input = {
  convert?: InputMaybe<Scalars['jsonb']>;
  requestData?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type JobSites_Avg_Fields = {
  __typename?: 'jobSites_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "job_sites". All fields are combined with a logical 'AND'. */
export type JobSites_Bool_Exp = {
  _and?: InputMaybe<Array<JobSites_Bool_Exp>>;
  _not?: InputMaybe<JobSites_Bool_Exp>;
  _or?: InputMaybe<Array<JobSites_Bool_Exp>>;
  convert?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  requestData?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_sites" */
export enum JobSites_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobSitesPkey = 'job_sites_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type JobSites_Delete_At_Path_Input = {
  convert?: InputMaybe<Array<Scalars['String']>>;
  requestData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type JobSites_Delete_Elem_Input = {
  convert?: InputMaybe<Scalars['Int']>;
  requestData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type JobSites_Delete_Key_Input = {
  convert?: InputMaybe<Scalars['String']>;
  requestData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "job_sites" */
export type JobSites_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "job_sites" */
export type JobSites_Insert_Input = {
  convert?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestData?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type JobSites_Max_Fields = {
  __typename?: 'jobSites_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type JobSites_Min_Fields = {
  __typename?: 'jobSites_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "job_sites" */
export type JobSites_Mutation_Response = {
  __typename?: 'jobSites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<JobSites>;
};

/** on_conflict condition type for table "job_sites" */
export type JobSites_On_Conflict = {
  constraint: JobSites_Constraint;
  update_columns?: Array<JobSites_Update_Column>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};

/** Ordering options when selecting data from "job_sites". */
export type JobSites_Order_By = {
  convert?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestData?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_sites */
export type JobSites_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type JobSites_Prepend_Input = {
  convert?: InputMaybe<Scalars['jsonb']>;
  requestData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "job_sites" */
export enum JobSites_Select_Column {
  /** column name */
  Convert = 'convert',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestData = 'requestData',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "job_sites" */
export type JobSites_Set_Input = {
  convert?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestData?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type JobSites_Stddev_Fields = {
  __typename?: 'jobSites_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type JobSites_Stddev_Pop_Fields = {
  __typename?: 'jobSites_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type JobSites_Stddev_Samp_Fields = {
  __typename?: 'jobSites_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "jobSites" */
export type JobSites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: JobSites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type JobSites_Stream_Cursor_Value_Input = {
  convert?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestData?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type JobSites_Sum_Fields = {
  __typename?: 'jobSites_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "job_sites" */
export enum JobSites_Update_Column {
  /** column name */
  Convert = 'convert',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestData = 'requestData',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type JobSites_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<JobSites_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<JobSites_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<JobSites_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<JobSites_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<JobSites_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<JobSites_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobSites_Set_Input>;
  /** filter the rows which have to be updated */
  where: JobSites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type JobSites_Var_Pop_Fields = {
  __typename?: 'jobSites_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type JobSites_Var_Samp_Fields = {
  __typename?: 'jobSites_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type JobSites_Variance_Fields = {
  __typename?: 'jobSites_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "login_logs" */
export type Login_Logs = {
  __typename?: 'login_logs';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  sourceIpAddress?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userAgent?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

/** aggregated selection of "login_logs" */
export type Login_Logs_Aggregate = {
  __typename?: 'login_logs_aggregate';
  aggregate?: Maybe<Login_Logs_Aggregate_Fields>;
  nodes: Array<Login_Logs>;
};

/** aggregate fields of "login_logs" */
export type Login_Logs_Aggregate_Fields = {
  __typename?: 'login_logs_aggregate_fields';
  avg?: Maybe<Login_Logs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Login_Logs_Max_Fields>;
  min?: Maybe<Login_Logs_Min_Fields>;
  stddev?: Maybe<Login_Logs_Stddev_Fields>;
  stddev_pop?: Maybe<Login_Logs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Login_Logs_Stddev_Samp_Fields>;
  sum?: Maybe<Login_Logs_Sum_Fields>;
  var_pop?: Maybe<Login_Logs_Var_Pop_Fields>;
  var_samp?: Maybe<Login_Logs_Var_Samp_Fields>;
  variance?: Maybe<Login_Logs_Variance_Fields>;
};


/** aggregate fields of "login_logs" */
export type Login_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Login_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Login_Logs_Avg_Fields = {
  __typename?: 'login_logs_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "login_logs". All fields are combined with a logical 'AND'. */
export type Login_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Login_Logs_Bool_Exp>>;
  _not?: InputMaybe<Login_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Login_Logs_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  eventTime?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  sourceIpAddress?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userAgent?: InputMaybe<String_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "login_logs" */
export enum Login_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  LoginLogsPkey = 'login_logs_pkey'
}

/** input type for incrementing numeric columns in table "login_logs" */
export type Login_Logs_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "login_logs" */
export type Login_Logs_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceIpAddress?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Login_Logs_Max_Fields = {
  __typename?: 'login_logs_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourceIpAddress?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Login_Logs_Min_Fields = {
  __typename?: 'login_logs_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  sourceIpAddress?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userAgent?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "login_logs" */
export type Login_Logs_Mutation_Response = {
  __typename?: 'login_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Login_Logs>;
};

/** on_conflict condition type for table "login_logs" */
export type Login_Logs_On_Conflict = {
  constraint: Login_Logs_Constraint;
  update_columns?: Array<Login_Logs_Update_Column>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "login_logs". */
export type Login_Logs_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sourceIpAddress?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userAgent?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: login_logs */
export type Login_Logs_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "login_logs" */
export enum Login_Logs_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  Id = 'id',
  /** column name */
  SourceIpAddress = 'sourceIpAddress',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "login_logs" */
export type Login_Logs_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceIpAddress?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Login_Logs_Stddev_Fields = {
  __typename?: 'login_logs_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Login_Logs_Stddev_Pop_Fields = {
  __typename?: 'login_logs_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Login_Logs_Stddev_Samp_Fields = {
  __typename?: 'login_logs_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "login_logs" */
export type Login_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Login_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Login_Logs_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  sourceIpAddress?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userAgent?: InputMaybe<Scalars['String']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Login_Logs_Sum_Fields = {
  __typename?: 'login_logs_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "login_logs" */
export enum Login_Logs_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  Id = 'id',
  /** column name */
  SourceIpAddress = 'sourceIpAddress',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserAgent = 'userAgent',
  /** column name */
  UserId = 'userId'
}

export type Login_Logs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Login_Logs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Login_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Login_Logs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Login_Logs_Var_Pop_Fields = {
  __typename?: 'login_logs_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Login_Logs_Var_Samp_Fields = {
  __typename?: 'login_logs_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Login_Logs_Variance_Fields = {
  __typename?: 'login_logs_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "message_formats" */
export type MessageFormats = {
  __typename?: 'messageFormats';
  categoryId?: Maybe<Scalars['String']>;
  code: Scalars['String'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  publish: Scalars['Boolean'];
  settings: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "message_formats" */
export type MessageFormatsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "message_formats" */
export type MessageFormats_Aggregate = {
  __typename?: 'messageFormats_aggregate';
  aggregate?: Maybe<MessageFormats_Aggregate_Fields>;
  nodes: Array<MessageFormats>;
};

/** aggregate fields of "message_formats" */
export type MessageFormats_Aggregate_Fields = {
  __typename?: 'messageFormats_aggregate_fields';
  avg?: Maybe<MessageFormats_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MessageFormats_Max_Fields>;
  min?: Maybe<MessageFormats_Min_Fields>;
  stddev?: Maybe<MessageFormats_Stddev_Fields>;
  stddev_pop?: Maybe<MessageFormats_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MessageFormats_Stddev_Samp_Fields>;
  sum?: Maybe<MessageFormats_Sum_Fields>;
  var_pop?: Maybe<MessageFormats_Var_Pop_Fields>;
  var_samp?: Maybe<MessageFormats_Var_Samp_Fields>;
  variance?: Maybe<MessageFormats_Variance_Fields>;
};


/** aggregate fields of "message_formats" */
export type MessageFormats_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MessageFormats_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MessageFormats_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type MessageFormats_Avg_Fields = {
  __typename?: 'messageFormats_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "message_formats". All fields are combined with a logical 'AND'. */
export type MessageFormats_Bool_Exp = {
  _and?: InputMaybe<Array<MessageFormats_Bool_Exp>>;
  _not?: InputMaybe<MessageFormats_Bool_Exp>;
  _or?: InputMaybe<Array<MessageFormats_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  publish?: InputMaybe<Boolean_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "message_formats" */
export enum MessageFormats_Constraint {
  /** unique or primary key constraint on columns "code" */
  MessageFormatsCodeKey = 'message_formats_code_key',
  /** unique or primary key constraint on columns "id" */
  MessageFormatsPkey = 'message_formats_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MessageFormats_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MessageFormats_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MessageFormats_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "message_formats" */
export type MessageFormats_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "message_formats" */
export type MessageFormats_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type MessageFormats_Max_Fields = {
  __typename?: 'messageFormats_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MessageFormats_Min_Fields = {
  __typename?: 'messageFormats_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "message_formats" */
export type MessageFormats_Mutation_Response = {
  __typename?: 'messageFormats_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MessageFormats>;
};

/** on_conflict condition type for table "message_formats" */
export type MessageFormats_On_Conflict = {
  constraint: MessageFormats_Constraint;
  update_columns?: Array<MessageFormats_Update_Column>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};

/** Ordering options when selecting data from "message_formats". */
export type MessageFormats_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  publish?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: message_formats */
export type MessageFormats_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MessageFormats_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "message_formats" */
export enum MessageFormats_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Publish = 'publish',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "message_formats" */
export type MessageFormats_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type MessageFormats_Stddev_Fields = {
  __typename?: 'messageFormats_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MessageFormats_Stddev_Pop_Fields = {
  __typename?: 'messageFormats_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MessageFormats_Stddev_Samp_Fields = {
  __typename?: 'messageFormats_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "messageFormats" */
export type MessageFormats_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MessageFormats_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MessageFormats_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  publish?: InputMaybe<Scalars['Boolean']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MessageFormats_Sum_Fields = {
  __typename?: 'messageFormats_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "message_formats" */
export enum MessageFormats_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Publish = 'publish',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type MessageFormats_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MessageFormats_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MessageFormats_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MessageFormats_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MessageFormats_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MessageFormats_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MessageFormats_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MessageFormats_Set_Input>;
  /** filter the rows which have to be updated */
  where: MessageFormats_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MessageFormats_Var_Pop_Fields = {
  __typename?: 'messageFormats_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MessageFormats_Var_Samp_Fields = {
  __typename?: 'messageFormats_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MessageFormats_Variance_Fields = {
  __typename?: 'messageFormats_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "messages" */
export type Messages = {
  __typename?: 'messages';
  assetCode?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  assetTypeId?: Maybe<Scalars['String']>;
  /** An object relationship */
  assets?: Maybe<Assets>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  dataType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  location: Scalars['jsonb'];
  messageTime?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  properties: Scalars['jsonb'];
  providerId?: Maybe<Scalars['String']>;
  quadkey?: Maybe<Scalars['String']>;
  receivedTime: Scalars['bigint'];
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "messages" */
export type MessagesLocationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "messages" */
export type MessagesPropertiesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "messages" */
export type Messages_Aggregate = {
  __typename?: 'messages_aggregate';
  aggregate?: Maybe<Messages_Aggregate_Fields>;
  nodes: Array<Messages>;
};

export type Messages_Aggregate_Bool_Exp = {
  count?: InputMaybe<Messages_Aggregate_Bool_Exp_Count>;
};

export type Messages_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Messages_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "messages" */
export type Messages_Aggregate_Fields = {
  __typename?: 'messages_aggregate_fields';
  avg?: Maybe<Messages_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Messages_Max_Fields>;
  min?: Maybe<Messages_Min_Fields>;
  stddev?: Maybe<Messages_Stddev_Fields>;
  stddev_pop?: Maybe<Messages_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Messages_Stddev_Samp_Fields>;
  sum?: Maybe<Messages_Sum_Fields>;
  var_pop?: Maybe<Messages_Var_Pop_Fields>;
  var_samp?: Maybe<Messages_Var_Samp_Fields>;
  variance?: Maybe<Messages_Variance_Fields>;
};


/** aggregate fields of "messages" */
export type Messages_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Messages_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "messages" */
export type Messages_Aggregate_Order_By = {
  avg?: InputMaybe<Messages_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Messages_Max_Order_By>;
  min?: InputMaybe<Messages_Min_Order_By>;
  stddev?: InputMaybe<Messages_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Messages_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Messages_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Messages_Sum_Order_By>;
  var_pop?: InputMaybe<Messages_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Messages_Var_Samp_Order_By>;
  variance?: InputMaybe<Messages_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Messages_Append_Input = {
  location?: InputMaybe<Scalars['jsonb']>;
  properties?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "messages" */
export type Messages_Arr_Rel_Insert_Input = {
  data: Array<Messages_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};

/** aggregate avg on columns */
export type Messages_Avg_Fields = {
  __typename?: 'messages_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "messages" */
export type Messages_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "messages". All fields are combined with a logical 'AND'. */
export type Messages_Bool_Exp = {
  _and?: InputMaybe<Array<Messages_Bool_Exp>>;
  _not?: InputMaybe<Messages_Bool_Exp>;
  _or?: InputMaybe<Array<Messages_Bool_Exp>>;
  assetCode?: InputMaybe<String_Comparison_Exp>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assetTypeId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  dataType?: InputMaybe<String_Comparison_Exp>;
  groupId?: InputMaybe<String_Comparison_Exp>;
  hash?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  location?: InputMaybe<Jsonb_Comparison_Exp>;
  messageTime?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  properties?: InputMaybe<Jsonb_Comparison_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  quadkey?: InputMaybe<String_Comparison_Exp>;
  receivedTime?: InputMaybe<Bigint_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "messages" */
export enum Messages_Constraint {
  /** unique or primary key constraint on columns "hash" */
  MessagesHashKey = 'messages_hash_key',
  /** unique or primary key constraint on columns "id" */
  MessagesPkey = 'messages_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Messages_Delete_At_Path_Input = {
  location?: InputMaybe<Array<Scalars['String']>>;
  properties?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Messages_Delete_Elem_Input = {
  location?: InputMaybe<Scalars['Int']>;
  properties?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Messages_Delete_Key_Input = {
  location?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "messages" */
export type Messages_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  messageTime?: InputMaybe<Scalars['bigint']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "messages" */
export type Messages_Insert_Input = {
  assetCode?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  assetTypeId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  dataType?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  messageTime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  providerId?: InputMaybe<Scalars['String']>;
  quadkey?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Messages_Max_Fields = {
  __typename?: 'messages_max_fields';
  assetCode?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  assetTypeId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  dataType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messageTime?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  quadkey?: Maybe<Scalars['String']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "messages" */
export type Messages_Max_Order_By = {
  assetCode?: InputMaybe<Order_By>;
  assetId?: InputMaybe<Order_By>;
  assetTypeId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataType?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  quadkey?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Messages_Min_Fields = {
  __typename?: 'messages_min_fields';
  assetCode?: Maybe<Scalars['String']>;
  assetId?: Maybe<Scalars['String']>;
  assetTypeId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  dataType?: Maybe<Scalars['String']>;
  groupId?: Maybe<Scalars['String']>;
  hash?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  messageTime?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  quadkey?: Maybe<Scalars['String']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "messages" */
export type Messages_Min_Order_By = {
  assetCode?: InputMaybe<Order_By>;
  assetId?: InputMaybe<Order_By>;
  assetTypeId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataType?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  quadkey?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "messages" */
export type Messages_Mutation_Response = {
  __typename?: 'messages_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Messages>;
};

/** on_conflict condition type for table "messages" */
export type Messages_On_Conflict = {
  constraint: Messages_Constraint;
  update_columns?: Array<Messages_Update_Column>;
  where?: InputMaybe<Messages_Bool_Exp>;
};

/** Ordering options when selecting data from "messages". */
export type Messages_Order_By = {
  assetCode?: InputMaybe<Order_By>;
  assetId?: InputMaybe<Order_By>;
  assetTypeId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dataType?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  hash?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  location?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  properties?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  quadkey?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: messages */
export type Messages_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Messages_Prepend_Input = {
  location?: InputMaybe<Scalars['jsonb']>;
  properties?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "messages" */
export enum Messages_Select_Column {
  /** column name */
  AssetCode = 'assetCode',
  /** column name */
  AssetId = 'assetId',
  /** column name */
  AssetTypeId = 'assetTypeId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DataType = 'dataType',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MessageTime = 'messageTime',
  /** column name */
  Owner = 'owner',
  /** column name */
  Properties = 'properties',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Quadkey = 'quadkey',
  /** column name */
  ReceivedTime = 'receivedTime',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "messages" */
export type Messages_Set_Input = {
  assetCode?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  assetTypeId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  dataType?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  messageTime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  providerId?: InputMaybe<Scalars['String']>;
  quadkey?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Messages_Stddev_Fields = {
  __typename?: 'messages_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "messages" */
export type Messages_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Messages_Stddev_Pop_Fields = {
  __typename?: 'messages_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "messages" */
export type Messages_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Messages_Stddev_Samp_Fields = {
  __typename?: 'messages_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "messages" */
export type Messages_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "messages" */
export type Messages_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Messages_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Messages_Stream_Cursor_Value_Input = {
  assetCode?: InputMaybe<Scalars['String']>;
  assetId?: InputMaybe<Scalars['String']>;
  assetTypeId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  dataType?: InputMaybe<Scalars['String']>;
  groupId?: InputMaybe<Scalars['String']>;
  hash?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<Scalars['jsonb']>;
  messageTime?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  properties?: InputMaybe<Scalars['jsonb']>;
  providerId?: InputMaybe<Scalars['String']>;
  quadkey?: InputMaybe<Scalars['String']>;
  receivedTime?: InputMaybe<Scalars['bigint']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Messages_Sum_Fields = {
  __typename?: 'messages_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  messageTime?: Maybe<Scalars['bigint']>;
  receivedTime?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "messages" */
export type Messages_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "messages" */
export enum Messages_Update_Column {
  /** column name */
  AssetCode = 'assetCode',
  /** column name */
  AssetId = 'assetId',
  /** column name */
  AssetTypeId = 'assetTypeId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DataType = 'dataType',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Hash = 'hash',
  /** column name */
  Id = 'id',
  /** column name */
  Location = 'location',
  /** column name */
  MessageTime = 'messageTime',
  /** column name */
  Owner = 'owner',
  /** column name */
  Properties = 'properties',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  Quadkey = 'quadkey',
  /** column name */
  ReceivedTime = 'receivedTime',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Messages_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Messages_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Messages_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Messages_Set_Input>;
  /** filter the rows which have to be updated */
  where: Messages_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Messages_Var_Pop_Fields = {
  __typename?: 'messages_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "messages" */
export type Messages_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Messages_Var_Samp_Fields = {
  __typename?: 'messages_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "messages" */
export type Messages_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Messages_Variance_Fields = {
  __typename?: 'messages_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  messageTime?: Maybe<Scalars['Float']>;
  receivedTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "messages" */
export type Messages_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  messageTime?: InputMaybe<Order_By>;
  receivedTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "multiple_detections" */
export type MultipleDetections = {
  __typename?: 'multipleDetections';
  createdAt: Scalars['bigint'];
  detectionId: Scalars['String'];
  id: Scalars['String'];
  ignoreDetectionIds: Scalars['jsonb'];
  label: Scalars['String'];
  orderDetectionIds: Scalars['jsonb'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "multiple_detections" */
export type MultipleDetectionsIgnoreDetectionIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "multiple_detections" */
export type MultipleDetectionsOrderDetectionIdsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "multiple_detections" */
export type MultipleDetections_Aggregate = {
  __typename?: 'multipleDetections_aggregate';
  aggregate?: Maybe<MultipleDetections_Aggregate_Fields>;
  nodes: Array<MultipleDetections>;
};

/** aggregate fields of "multiple_detections" */
export type MultipleDetections_Aggregate_Fields = {
  __typename?: 'multipleDetections_aggregate_fields';
  avg?: Maybe<MultipleDetections_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<MultipleDetections_Max_Fields>;
  min?: Maybe<MultipleDetections_Min_Fields>;
  stddev?: Maybe<MultipleDetections_Stddev_Fields>;
  stddev_pop?: Maybe<MultipleDetections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<MultipleDetections_Stddev_Samp_Fields>;
  sum?: Maybe<MultipleDetections_Sum_Fields>;
  var_pop?: Maybe<MultipleDetections_Var_Pop_Fields>;
  var_samp?: Maybe<MultipleDetections_Var_Samp_Fields>;
  variance?: Maybe<MultipleDetections_Variance_Fields>;
};


/** aggregate fields of "multiple_detections" */
export type MultipleDetections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<MultipleDetections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type MultipleDetections_Append_Input = {
  ignoreDetectionIds?: InputMaybe<Scalars['jsonb']>;
  orderDetectionIds?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type MultipleDetections_Avg_Fields = {
  __typename?: 'multipleDetections_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "multiple_detections". All fields are combined with a logical 'AND'. */
export type MultipleDetections_Bool_Exp = {
  _and?: InputMaybe<Array<MultipleDetections_Bool_Exp>>;
  _not?: InputMaybe<MultipleDetections_Bool_Exp>;
  _or?: InputMaybe<Array<MultipleDetections_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  detectionId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  ignoreDetectionIds?: InputMaybe<Jsonb_Comparison_Exp>;
  label?: InputMaybe<String_Comparison_Exp>;
  orderDetectionIds?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "multiple_detections" */
export enum MultipleDetections_Constraint {
  /** unique or primary key constraint on columns "id" */
  MultipleDetectionsPkey = 'multiple_detections_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type MultipleDetections_Delete_At_Path_Input = {
  ignoreDetectionIds?: InputMaybe<Array<Scalars['String']>>;
  orderDetectionIds?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type MultipleDetections_Delete_Elem_Input = {
  ignoreDetectionIds?: InputMaybe<Scalars['Int']>;
  orderDetectionIds?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type MultipleDetections_Delete_Key_Input = {
  ignoreDetectionIds?: InputMaybe<Scalars['String']>;
  orderDetectionIds?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "multiple_detections" */
export type MultipleDetections_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "multiple_detections" */
export type MultipleDetections_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ignoreDetectionIds?: InputMaybe<Scalars['jsonb']>;
  label?: InputMaybe<Scalars['String']>;
  orderDetectionIds?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type MultipleDetections_Max_Fields = {
  __typename?: 'multipleDetections_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type MultipleDetections_Min_Fields = {
  __typename?: 'multipleDetections_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  detectionId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  label?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "multiple_detections" */
export type MultipleDetections_Mutation_Response = {
  __typename?: 'multipleDetections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<MultipleDetections>;
};

/** on_conflict condition type for table "multiple_detections" */
export type MultipleDetections_On_Conflict = {
  constraint: MultipleDetections_Constraint;
  update_columns?: Array<MultipleDetections_Update_Column>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};

/** Ordering options when selecting data from "multiple_detections". */
export type MultipleDetections_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  detectionId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  ignoreDetectionIds?: InputMaybe<Order_By>;
  label?: InputMaybe<Order_By>;
  orderDetectionIds?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: multiple_detections */
export type MultipleDetections_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type MultipleDetections_Prepend_Input = {
  ignoreDetectionIds?: InputMaybe<Scalars['jsonb']>;
  orderDetectionIds?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "multiple_detections" */
export enum MultipleDetections_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreDetectionIds = 'ignoreDetectionIds',
  /** column name */
  Label = 'label',
  /** column name */
  OrderDetectionIds = 'orderDetectionIds',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "multiple_detections" */
export type MultipleDetections_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ignoreDetectionIds?: InputMaybe<Scalars['jsonb']>;
  label?: InputMaybe<Scalars['String']>;
  orderDetectionIds?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type MultipleDetections_Stddev_Fields = {
  __typename?: 'multipleDetections_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type MultipleDetections_Stddev_Pop_Fields = {
  __typename?: 'multipleDetections_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type MultipleDetections_Stddev_Samp_Fields = {
  __typename?: 'multipleDetections_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "multipleDetections" */
export type MultipleDetections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: MultipleDetections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type MultipleDetections_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  detectionId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  ignoreDetectionIds?: InputMaybe<Scalars['jsonb']>;
  label?: InputMaybe<Scalars['String']>;
  orderDetectionIds?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type MultipleDetections_Sum_Fields = {
  __typename?: 'multipleDetections_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "multiple_detections" */
export enum MultipleDetections_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DetectionId = 'detectionId',
  /** column name */
  Id = 'id',
  /** column name */
  IgnoreDetectionIds = 'ignoreDetectionIds',
  /** column name */
  Label = 'label',
  /** column name */
  OrderDetectionIds = 'orderDetectionIds',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type MultipleDetections_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<MultipleDetections_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<MultipleDetections_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<MultipleDetections_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<MultipleDetections_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<MultipleDetections_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<MultipleDetections_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<MultipleDetections_Set_Input>;
  /** filter the rows which have to be updated */
  where: MultipleDetections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type MultipleDetections_Var_Pop_Fields = {
  __typename?: 'multipleDetections_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type MultipleDetections_Var_Samp_Fields = {
  __typename?: 'multipleDetections_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type MultipleDetections_Variance_Fields = {
  __typename?: 'multipleDetections_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  /** insert a single row into the table: "access_logs" */
  createAccessLog?: Maybe<AccessLogs>;
  /** insert data into the table: "access_logs" */
  createAccessLogs?: Maybe<AccessLogs_Mutation_Response>;
  /** insert a single row into the table: "assets" */
  createAsset?: Maybe<Assets>;
  /** insert a single row into the table: "assets_assets" */
  createAssetAsset?: Maybe<AssetsAssets>;
  /** insert a single row into the table: "asset_images" */
  createAssetImage?: Maybe<AssetImages>;
  /** insert data into the table: "asset_images" */
  createAssetImages?: Maybe<AssetImages_Mutation_Response>;
  /** insert data into the table: "asset_properties" */
  createAssetProperties?: Maybe<AssetProperties_Mutation_Response>;
  /** insert a single row into the table: "asset_properties" */
  createAssetProperty?: Maybe<AssetProperties>;
  /** insert a single row into the table: "asset_states" */
  createAssetState?: Maybe<Asset_States>;
  /** insert data into the table: "asset_states" */
  createAssetStates?: Maybe<Asset_States_Mutation_Response>;
  /** insert a single row into the table: "asset_tags" */
  createAssetTag?: Maybe<AssetTags>;
  /** insert data into the table: "asset_tags" */
  createAssetTags?: Maybe<AssetTags_Mutation_Response>;
  /** insert a single row into the table: "asset_types" */
  createAssetType?: Maybe<AssetTypes>;
  /** insert data into the table: "asset_types" */
  createAssetTypes?: Maybe<AssetTypes_Mutation_Response>;
  /** insert data into the table: "assets" */
  createAssets?: Maybe<Assets_Mutation_Response>;
  /** insert data into the table: "assets_assets" */
  createAssetsAssets?: Maybe<AssetsAssets_Mutation_Response>;
  /** insert a single row into the table: "authorization_info" */
  createAuthorizationInfo?: Maybe<AuthorizationInfo>;
  /** insert data into the table: "authorization_info" */
  createAuthorizationInfos?: Maybe<AuthorizationInfo_Mutation_Response>;
  /** insert data into the table: "categories" */
  createCategories?: Maybe<Categories_Mutation_Response>;
  /** insert a single row into the table: "categories" */
  createCategory?: Maybe<Categories>;
  /** insert a single row into the table: "client_types" */
  createClientType?: Maybe<ClientTypes>;
  /** insert data into the table: "client_types" */
  createClientTypes?: Maybe<ClientTypes_Mutation_Response>;
  /** insert a single row into the table: "consents" */
  createConsent?: Maybe<Consents>;
  /** insert data into the table: "consents" */
  createConsents?: Maybe<Consents_Mutation_Response>;
  /** insert a single row into the table: "csv_records" */
  createCsvRecord?: Maybe<CsvRecords>;
  /** insert data into the table: "csv_records" */
  createCsvRecords?: Maybe<CsvRecords_Mutation_Response>;
  /** insert a single row into the table: "data_access_logs" */
  createDataAccessLog?: Maybe<DataAccessLogs>;
  /** insert data into the table: "data_access_logs" */
  createDataAccessLogs?: Maybe<DataAccessLogs_Mutation_Response>;
  /** insert a single row into the table: "detections" */
  createDetection?: Maybe<Detections>;
  /** insert a single row into the table: "detection_logs" */
  createDetectionLog?: Maybe<DetectionLogs>;
  /** insert data into the table: "detection_logs" */
  createDetectionLogs?: Maybe<DetectionLogs_Mutation_Response>;
  /** insert a single row into the table: "detection_sets" */
  createDetectionSet?: Maybe<DetectionSets>;
  /** insert data into the table: "detection_sets" */
  createDetectionSets?: Maybe<DetectionSets_Mutation_Response>;
  /** insert a single row into the table: "detection_states" */
  createDetectionState?: Maybe<Detection_States>;
  /** insert data into the table: "detection_states" */
  createDetectionStates?: Maybe<Detection_States_Mutation_Response>;
  /** insert data into the table: "detections" */
  createDetections?: Maybe<Detections_Mutation_Response>;
  /** insert a single row into the table: "evacuation_settings" */
  createEvacuationSetting?: Maybe<EvacuationSettings>;
  /** insert data into the table: "evacuation_settings" */
  createEvacuationSettings?: Maybe<EvacuationSettings_Mutation_Response>;
  /** insert a single row into the table: "events" */
  createEvent?: Maybe<Events>;
  /** insert data into the table: "events" */
  createEvents?: Maybe<Events_Mutation_Response>;
  /** insert data into the table: "execution_histories" */
  createExecutionHistories?: Maybe<ExecutionHistories_Mutation_Response>;
  /** insert a single row into the table: "execution_histories" */
  createExecutionHistory?: Maybe<ExecutionHistories>;
  /** insert a single row into the table: "file_states" */
  createFileState?: Maybe<File_States>;
  /** insert data into the table: "file_states" */
  createFileStates?: Maybe<File_States_Mutation_Response>;
  /** insert a single row into the table: "groups" */
  createGroup?: Maybe<Groups>;
  /** insert data into the table: "groups" */
  createGroups?: Maybe<Groups_Mutation_Response>;
  /** insert a single row into the table: "idps" */
  createIdp?: Maybe<Idps>;
  /** insert a single row into the table: "idp_types" */
  createIdpType?: Maybe<IdpTypes>;
  /** insert data into the table: "idp_types" */
  createIdpTypes?: Maybe<IdpTypes_Mutation_Response>;
  /** insert data into the table: "idps" */
  createIdps?: Maybe<Idps_Mutation_Response>;
  /** insert a single row into the table: "job_settings" */
  createJobSetting?: Maybe<JobSettings>;
  /** insert data into the table: "job_settings" */
  createJobSettings?: Maybe<JobSettings_Mutation_Response>;
  /** insert a single row into the table: "job_sites" */
  createJobSite?: Maybe<JobSites>;
  /** insert a single row into the table: "job_site_attributes" */
  createJobSiteAttribute?: Maybe<JobSiteAttributes>;
  /** insert data into the table: "job_site_attributes" */
  createJobSiteAttributes?: Maybe<JobSiteAttributes_Mutation_Response>;
  /** insert data into the table: "job_sites" */
  createJobSites?: Maybe<JobSites_Mutation_Response>;
  /** insert a single row into the table: "login_logs" */
  createLoginLog?: Maybe<Login_Logs>;
  /** insert data into the table: "login_logs" */
  createLoginLogs?: Maybe<Login_Logs_Mutation_Response>;
  /** insert a single row into the table: "messages" */
  createMessage?: Maybe<Messages>;
  /** insert a single row into the table: "message_formats" */
  createMessageFormat?: Maybe<MessageFormats>;
  /** insert data into the table: "message_formats" */
  createMessageFormats?: Maybe<MessageFormats_Mutation_Response>;
  /** insert data into the table: "messages" */
  createMessages?: Maybe<Messages_Mutation_Response>;
  /** insert a single row into the table: "multiple_detections" */
  createMultipleDetection?: Maybe<MultipleDetections>;
  /** insert data into the table: "multiple_detections" */
  createMultipleDetections?: Maybe<MultipleDetections_Mutation_Response>;
  /** insert a single row into the table: "notification_conditions" */
  createNotificationCondition?: Maybe<NotificationConditions>;
  /** insert a single row into the table: "notification_condition_details" */
  createNotificationConditionDetail?: Maybe<NotificationConditionDetails>;
  /** insert data into the table: "notification_condition_details" */
  createNotificationConditionDetails?: Maybe<NotificationConditionDetails_Mutation_Response>;
  /** insert data into the table: "notification_conditions" */
  createNotificationConditions?: Maybe<NotificationConditions_Mutation_Response>;
  /** insert a single row into the table: "notification_events" */
  createNotificationEvent?: Maybe<NotificationEvents>;
  /** insert data into the table: "notification_events" */
  createNotificationEvents?: Maybe<NotificationEvents_Mutation_Response>;
  /** insert data into the table: "notification_histories" */
  createNotificationHistories?: Maybe<NotificationHistories_Mutation_Response>;
  /** insert a single row into the table: "notification_histories" */
  createNotificationHistory?: Maybe<NotificationHistories>;
  /** insert a single row into the table: "notification_history_states" */
  createNotificationHistoryState?: Maybe<Notification_History_States>;
  /** insert data into the table: "notification_history_states" */
  createNotificationHistoryStates?: Maybe<Notification_History_States_Mutation_Response>;
  /** insert a single row into the table: "notification_services" */
  createNotificationService?: Maybe<NotificationServices>;
  /** insert data into the table: "notification_services" */
  createNotificationServices?: Maybe<NotificationServices_Mutation_Response>;
  /** insert a single row into the table: "notification_settings" */
  createNotificationSetting?: Maybe<NotificationSettings>;
  /** insert data into the table: "notification_settings" */
  createNotificationSettings?: Maybe<NotificationSettings_Mutation_Response>;
  /** insert a single row into the table: "notification_targets" */
  createNotificationTarget?: Maybe<NotificationTargets>;
  /** insert a single row into the table: "notification_target_states" */
  createNotificationTargetState?: Maybe<Notification_Target_States>;
  /** insert data into the table: "notification_target_states" */
  createNotificationTargetStates?: Maybe<Notification_Target_States_Mutation_Response>;
  /** insert data into the table: "notification_targets" */
  createNotificationTargets?: Maybe<NotificationTargets_Mutation_Response>;
  /** insert a single row into the table: "notification_templates" */
  createNotificationTemplate?: Maybe<NotificationTemplates>;
  /** insert data into the table: "notification_templates" */
  createNotificationTemplates?: Maybe<NotificationTemplates_Mutation_Response>;
  /** insert a single row into the table: "notification_users" */
  createNotificationUser?: Maybe<NotificationUsers>;
  /** insert a single row into the table: "notification_user_states" */
  createNotificationUserState?: Maybe<Notification_User_States>;
  /** insert data into the table: "notification_user_states" */
  createNotificationUserStates?: Maybe<Notification_User_States_Mutation_Response>;
  /** insert a single row into the table: "notification_user_temp" */
  createNotificationUserTemp?: Maybe<NotificationUserTemp>;
  /** insert data into the table: "notification_user_temp" */
  createNotificationUserTemps?: Maybe<NotificationUserTemp_Mutation_Response>;
  /** insert data into the table: "notification_users" */
  createNotificationUsers?: Maybe<NotificationUsers_Mutation_Response>;
  /** insert data into the table: "policies" */
  createPolicies?: Maybe<Policies_Mutation_Response>;
  /** insert a single row into the table: "policies" */
  createPolicy?: Maybe<Policies>;
  /** insert a single row into the table: "policy_defines" */
  createPolicyDefine?: Maybe<PolicyDefines>;
  /** insert a single row into the table: "policy_define_types" */
  createPolicyDefineType?: Maybe<Policy_Define_Types>;
  /** insert data into the table: "policy_define_types" */
  createPolicyDefineTypes?: Maybe<Policy_Define_Types_Mutation_Response>;
  /** insert data into the table: "policy_defines" */
  createPolicyDefines?: Maybe<PolicyDefines_Mutation_Response>;
  /** insert a single row into the table: "policy_templates" */
  createPolicyTemplate?: Maybe<PolicyTemplates>;
  /** insert data into the table: "policy_templates" */
  createPolicyTemplates?: Maybe<PolicyTemplates_Mutation_Response>;
  /** insert a single row into the table: "providers" */
  createProvider?: Maybe<Providers>;
  /** insert a single row into the table: "providers_assets" */
  createProviderAsset?: Maybe<ProvidersAssets>;
  /** insert data into the table: "providers" */
  createProviders?: Maybe<Providers_Mutation_Response>;
  /** insert data into the table: "providers_assets" */
  createProvidersAssets?: Maybe<ProvidersAssets_Mutation_Response>;
  /** insert a single row into the table: "relay_api_services" */
  createRelayApiService?: Maybe<RelayApiServices>;
  /** insert data into the table: "relay_api_services" */
  createRelayApiServices?: Maybe<RelayApiServices_Mutation_Response>;
  /** insert a single row into the table: "relay_services" */
  createRelayService?: Maybe<RelayServices>;
  /** insert data into the table: "relay_services" */
  createRelayServices?: Maybe<RelayServices_Mutation_Response>;
  /** insert a single row into the table: "request_settings" */
  createRequestSetting?: Maybe<RequestSettings>;
  /** insert data into the table: "request_settings" */
  createRequestSettings?: Maybe<RequestSettings_Mutation_Response>;
  /** insert a single row into the table: "request_templates" */
  createRequestTemplate?: Maybe<RequestTemplates>;
  /** insert a single row into the table: "request_template_types" */
  createRequestTemplateType?: Maybe<Request_Template_Types>;
  /** insert data into the table: "request_template_types" */
  createRequestTemplateTypes?: Maybe<Request_Template_Types_Mutation_Response>;
  /** insert data into the table: "request_templates" */
  createRequestTemplates?: Maybe<RequestTemplates_Mutation_Response>;
  /** insert a single row into the table: "rest2graphql_settings" */
  createRest2graphqlSetting?: Maybe<Rest2graphqlSettings>;
  /** insert data into the table: "rest2graphql_settings" */
  createRest2graphqlSettings?: Maybe<Rest2graphqlSettings_Mutation_Response>;
  /** insert a single row into the table: "schedules" */
  createSchedule?: Maybe<Schedules>;
  /** insert data into the table: "schedules" */
  createSchedules?: Maybe<Schedules_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information" */
  createSensitiveInformation?: Maybe<SensitiveInformation>;
  /** insert data into the table: "sensitive_information_categories" */
  createSensitiveInformationCategories?: Maybe<SensitiveInformationCategories_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information_categories" */
  createSensitiveInformationCategory?: Maybe<SensitiveInformationCategories>;
  /** insert data into the table: "sensitive_information_histories" */
  createSensitiveInformationHistories?: Maybe<SensitiveInformationHistories_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information_histories" */
  createSensitiveInformationHistory?: Maybe<SensitiveInformationHistories>;
  /** insert a single row into the table: "sensitive_information_items" */
  createSensitiveInformationItem?: Maybe<SensitiveInformationItems>;
  /** insert data into the table: "sensitive_information_items" */
  createSensitiveInformationItems?: Maybe<SensitiveInformationItems_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information_request_services" */
  createSensitiveInformationRequestService?: Maybe<SensitiveInformationRequestServices>;
  /** insert data into the table: "sensitive_information_request_services" */
  createSensitiveInformationRequestServices?: Maybe<SensitiveInformationRequestServices_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information_store_service_connections" */
  createSensitiveInformationStoreServiceConnection?: Maybe<SensitiveInformationStoreServiceConnections>;
  /** insert data into the table: "sensitive_information_store_service_connections" */
  createSensitiveInformationStoreServiceConnections?: Maybe<SensitiveInformationStoreServiceConnections_Mutation_Response>;
  /** insert data into the table: "sensitive_information" */
  createSensitiveInformations?: Maybe<SensitiveInformation_Mutation_Response>;
  /** insert a single row into the table: "services" */
  createService?: Maybe<Services>;
  /** insert data into the table: "services" */
  createServices?: Maybe<Services_Mutation_Response>;
  /** insert a single row into the table: "sensitive_information_items" */
  createStoreSensitiveInformationItem?: Maybe<StoreSensitiveInformationItems>;
  /** insert data into the table: "sensitive_information_items" */
  createStoreSensitiveInformationItems?: Maybe<StoreSensitiveInformationItems_Mutation_Response>;
  /** insert a single row into the table: "tenants" */
  createTenant?: Maybe<Tenants>;
  /** insert a single row into the table: "tenants_idps" */
  createTenantIdp?: Maybe<TenantsIdps>;
  /**  ## テナント公開情報 */
  createTenantPublicInfo?: Maybe<MutationTenantPublicInfoOutput>;
  /** insert data into the table: "tenant_public_info" */
  createTenantPublicInfos?: Maybe<TenantPublicInfo_Mutation_Response>;
  /** insert a single row into the table: "tenant_services" */
  createTenantService?: Maybe<TenantServices>;
  /** insert data into the table: "tenant_services" */
  createTenantServices?: Maybe<TenantServices_Mutation_Response>;
  /** insert data into the table: "tenants" */
  createTenants?: Maybe<Tenants_Mutation_Response>;
  /** insert data into the table: "tenants_idps" */
  createTenantsIdps?: Maybe<TenantsIdps_Mutation_Response>;
  /** insert a single row into the table: "upload_files" */
  createUploadFile?: Maybe<UploadFiles>;
  /** insert data into the table: "upload_files" */
  createUploadFiles?: Maybe<UploadFiles_Mutation_Response>;
  /** insert a single row into the table: "users" */
  createUser?: Maybe<Users>;
  /** insert a single row into the table: "users_groups" */
  createUserGroup?: Maybe<UsersGroups>;
  /** insert a single row into the table: "users_idps" */
  createUserIdp?: Maybe<UsersIdps>;
  /** insert data into the table: "user_policies" */
  createUserPolicies?: Maybe<UserPolicies_Mutation_Response>;
  /** insert a single row into the table: "user_policies" */
  createUserPolicy?: Maybe<UserPolicies>;
  /** insert a single row into the table: "user_roles" */
  createUserRole?: Maybe<User_Roles>;
  /** insert data into the table: "user_roles" */
  createUserRoles?: Maybe<User_Roles_Mutation_Response>;
  /** insert a single row into the table: "user_states" */
  createUserState?: Maybe<User_States>;
  /** insert data into the table: "user_states" */
  createUserStates?: Maybe<User_States_Mutation_Response>;
  /** insert data into the table: "users" */
  createUsers?: Maybe<Users_Mutation_Response>;
  /** insert a single row into the table: "users_assets" */
  createUsersAsset?: Maybe<UsersAssets>;
  /** insert data into the table: "users_assets" */
  createUsersAssets?: Maybe<UsersAssets_Mutation_Response>;
  /** insert a single row into the table: "users_external_users" */
  createUsersExternalUser?: Maybe<UsersExternalUsers>;
  /** insert data into the table: "users_external_users" */
  createUsersExternalUsers?: Maybe<UsersExternalUsers_Mutation_Response>;
  /** insert data into the table: "users_groups" */
  createUsersGroups?: Maybe<UsersGroups_Mutation_Response>;
  /** insert data into the table: "users_idps" */
  createUsersIdps?: Maybe<UsersIdps_Mutation_Response>;
  /** insert a single row into the table: "users_users" */
  createUsersUser?: Maybe<UsersUsers>;
  /** insert data into the table: "users_users" */
  createUsersUsers?: Maybe<UsersUsers_Mutation_Response>;
  /** delete data from the table: "access_logs" */
  deleteAccessLogs?: Maybe<AccessLogs_Mutation_Response>;
  /** delete data from the table: "asset_images" */
  deleteAssetImages?: Maybe<AssetImages_Mutation_Response>;
  /** delete data from the table: "asset_properties" */
  deleteAssetProperties?: Maybe<AssetProperties_Mutation_Response>;
  /** delete data from the table: "asset_states" */
  deleteAssetStates?: Maybe<Asset_States_Mutation_Response>;
  /** delete data from the table: "asset_tags" */
  deleteAssetTags?: Maybe<AssetTags_Mutation_Response>;
  /** delete data from the table: "asset_types" */
  deleteAssetTypes?: Maybe<AssetTypes_Mutation_Response>;
  /** delete data from the table: "assets" */
  deleteAssets?: Maybe<Assets_Mutation_Response>;
  /** delete data from the table: "assets_assets" */
  deleteAssetsAssets?: Maybe<AssetsAssets_Mutation_Response>;
  /** delete data from the table: "authorization_info" */
  deleteAuthorizationInfo?: Maybe<AuthorizationInfo_Mutation_Response>;
  /** delete single row from the table: "access_logs" */
  deleteByPkAccessLog?: Maybe<AccessLogs>;
  /** delete single row from the table: "assets" */
  deleteByPkAsset?: Maybe<Assets>;
  /** delete single row from the table: "assets_assets" */
  deleteByPkAssetAsset?: Maybe<AssetsAssets>;
  /** delete single row from the table: "asset_images" */
  deleteByPkAssetImage?: Maybe<AssetImages>;
  /** delete single row from the table: "asset_properties" */
  deleteByPkAssetProperty?: Maybe<AssetProperties>;
  /** delete single row from the table: "asset_states" */
  deleteByPkAssetState?: Maybe<Asset_States>;
  /** delete single row from the table: "asset_tags" */
  deleteByPkAssetTag?: Maybe<AssetTags>;
  /** delete single row from the table: "asset_types" */
  deleteByPkAssetType?: Maybe<AssetTypes>;
  /** delete single row from the table: "authorization_info" */
  deleteByPkAuthorizationInfo?: Maybe<AuthorizationInfo>;
  /** delete single row from the table: "categories" */
  deleteByPkCategory?: Maybe<Categories>;
  /** delete single row from the table: "client_types" */
  deleteByPkClientType?: Maybe<ClientTypes>;
  /** delete single row from the table: "consents" */
  deleteByPkConsent?: Maybe<Consents>;
  /** delete single row from the table: "csv_records" */
  deleteByPkCsvRecord?: Maybe<CsvRecords>;
  /** delete single row from the table: "data_access_logs" */
  deleteByPkDataAccessLog?: Maybe<DataAccessLogs>;
  /** delete single row from the table: "detections" */
  deleteByPkDetection?: Maybe<Detections>;
  /** delete single row from the table: "detection_logs" */
  deleteByPkDetectionLog?: Maybe<DetectionLogs>;
  /** delete single row from the table: "detection_sets" */
  deleteByPkDetectionSet?: Maybe<DetectionSets>;
  /** delete single row from the table: "detection_states" */
  deleteByPkDetectionState?: Maybe<Detection_States>;
  /** delete single row from the table: "evacuation_settings" */
  deleteByPkEvacuationSetting?: Maybe<EvacuationSettings>;
  /** delete single row from the table: "events" */
  deleteByPkEvent?: Maybe<Events>;
  /** delete single row from the table: "execution_histories" */
  deleteByPkExecutionHistory?: Maybe<ExecutionHistories>;
  /** delete single row from the table: "file_states" */
  deleteByPkFileState?: Maybe<File_States>;
  /** delete single row from the table: "groups" */
  deleteByPkGroup?: Maybe<Groups>;
  /** delete single row from the table: "idps" */
  deleteByPkIdp?: Maybe<Idps>;
  /** delete single row from the table: "idp_types" */
  deleteByPkIdpType?: Maybe<IdpTypes>;
  /** delete single row from the table: "job_settings" */
  deleteByPkJobSetting?: Maybe<JobSettings>;
  /** delete single row from the table: "job_sites" */
  deleteByPkJobSite?: Maybe<JobSites>;
  /** delete single row from the table: "job_site_attributes" */
  deleteByPkJobSiteAttribute?: Maybe<JobSiteAttributes>;
  /** delete single row from the table: "login_logs" */
  deleteByPkLoginLog?: Maybe<Login_Logs>;
  /** delete single row from the table: "messages" */
  deleteByPkMessage?: Maybe<Messages>;
  /** delete single row from the table: "message_formats" */
  deleteByPkMessageFormat?: Maybe<MessageFormats>;
  /** delete single row from the table: "multiple_detections" */
  deleteByPkMultipleDetection?: Maybe<MultipleDetections>;
  /** delete single row from the table: "notification_conditions" */
  deleteByPkNotificationCondition?: Maybe<NotificationConditions>;
  /** delete single row from the table: "notification_condition_details" */
  deleteByPkNotificationConditionDetail?: Maybe<NotificationConditionDetails>;
  /** delete single row from the table: "notification_events" */
  deleteByPkNotificationEvent?: Maybe<NotificationEvents>;
  /** delete single row from the table: "notification_histories" */
  deleteByPkNotificationHistory?: Maybe<NotificationHistories>;
  /** delete single row from the table: "notification_history_states" */
  deleteByPkNotificationHistoryState?: Maybe<Notification_History_States>;
  /** delete single row from the table: "notification_services" */
  deleteByPkNotificationService?: Maybe<NotificationServices>;
  /** delete single row from the table: "notification_settings" */
  deleteByPkNotificationSetting?: Maybe<NotificationSettings>;
  /** delete single row from the table: "notification_targets" */
  deleteByPkNotificationTarget?: Maybe<NotificationTargets>;
  /** delete single row from the table: "notification_target_states" */
  deleteByPkNotificationTargetState?: Maybe<Notification_Target_States>;
  /** delete single row from the table: "notification_templates" */
  deleteByPkNotificationTemplate?: Maybe<NotificationTemplates>;
  /** delete single row from the table: "notification_users" */
  deleteByPkNotificationUser?: Maybe<NotificationUsers>;
  /** delete single row from the table: "notification_user_states" */
  deleteByPkNotificationUserState?: Maybe<Notification_User_States>;
  /** delete single row from the table: "notification_user_temp" */
  deleteByPkNotificationUserTemp?: Maybe<NotificationUserTemp>;
  /** delete single row from the table: "policies" */
  deleteByPkPolicy?: Maybe<Policies>;
  /** delete single row from the table: "policy_defines" */
  deleteByPkPolicyDefine?: Maybe<PolicyDefines>;
  /** delete single row from the table: "policy_define_types" */
  deleteByPkPolicyDefineType?: Maybe<Policy_Define_Types>;
  /** delete single row from the table: "policy_templates" */
  deleteByPkPolicyTemplate?: Maybe<PolicyTemplates>;
  /** delete single row from the table: "providers" */
  deleteByPkProvider?: Maybe<Providers>;
  /** delete single row from the table: "providers_assets" */
  deleteByPkProviderAsset?: Maybe<ProvidersAssets>;
  /** delete single row from the table: "relay_api_services" */
  deleteByPkRelayApiService?: Maybe<RelayApiServices>;
  /** delete single row from the table: "relay_services" */
  deleteByPkRelayService?: Maybe<RelayServices>;
  /** delete single row from the table: "request_settings" */
  deleteByPkRequestSetting?: Maybe<RequestSettings>;
  /** delete single row from the table: "request_templates" */
  deleteByPkRequestTemplate?: Maybe<RequestTemplates>;
  /** delete single row from the table: "request_template_types" */
  deleteByPkRequestTemplateType?: Maybe<Request_Template_Types>;
  /** delete single row from the table: "rest2graphql_settings" */
  deleteByPkRest2graphqlSetting?: Maybe<Rest2graphqlSettings>;
  /** delete single row from the table: "schedules" */
  deleteByPkSchedule?: Maybe<Schedules>;
  /** delete single row from the table: "sensitive_information" */
  deleteByPkSensitiveInformation?: Maybe<SensitiveInformation>;
  /** delete single row from the table: "sensitive_information_categories" */
  deleteByPkSensitiveInformationCategory?: Maybe<SensitiveInformationCategories>;
  /** delete single row from the table: "sensitive_information_histories" */
  deleteByPkSensitiveInformationHistory?: Maybe<SensitiveInformationHistories>;
  /** delete single row from the table: "sensitive_information_items" */
  deleteByPkSensitiveInformationItem?: Maybe<SensitiveInformationItems>;
  /** delete single row from the table: "sensitive_information_request_services" */
  deleteByPkSensitiveInformationRequestService?: Maybe<SensitiveInformationRequestServices>;
  /** delete single row from the table: "sensitive_information_store_service_connections" */
  deleteByPkSensitiveInformationStoreServiceConnection?: Maybe<SensitiveInformationStoreServiceConnections>;
  /** delete single row from the table: "services" */
  deleteByPkService?: Maybe<Services>;
  /** delete single row from the table: "sensitive_information_items" */
  deleteByPkStoreSensitiveInformationItem?: Maybe<StoreSensitiveInformationItems>;
  /** delete single row from the table: "tenants" */
  deleteByPkTenant?: Maybe<Tenants>;
  /** delete single row from the table: "tenants_idps" */
  deleteByPkTenantIdp?: Maybe<TenantsIdps>;
  /** delete single row from the table: "tenant_services" */
  deleteByPkTenantService?: Maybe<TenantServices>;
  /** delete single row from the table: "upload_files" */
  deleteByPkUploadFile?: Maybe<UploadFiles>;
  /** delete single row from the table: "users" */
  deleteByPkUser?: Maybe<Users>;
  /** delete single row from the table: "users_groups" */
  deleteByPkUserGroup?: Maybe<UsersGroups>;
  /** delete single row from the table: "users_idps" */
  deleteByPkUserIdp?: Maybe<UsersIdps>;
  /** delete single row from the table: "user_policies" */
  deleteByPkUserPolicy?: Maybe<UserPolicies>;
  /** delete single row from the table: "user_roles" */
  deleteByPkUserRole?: Maybe<User_Roles>;
  /** delete single row from the table: "user_states" */
  deleteByPkUserState?: Maybe<User_States>;
  /** delete single row from the table: "users_external_users" */
  deleteByPkUsersExternalUser?: Maybe<UsersExternalUsers>;
  /** delete single row from the table: "users_users" */
  deleteByPkUsersUser?: Maybe<UsersUsers>;
  /** delete data from the table: "categories" */
  deleteCategories?: Maybe<Categories_Mutation_Response>;
  /** delete data from the table: "client_types" */
  deleteClientTypes?: Maybe<ClientTypes_Mutation_Response>;
  /** delete data from the table: "consents" */
  deleteConsents?: Maybe<Consents_Mutation_Response>;
  /** delete data from the table: "csv_records" */
  deleteCsvRecords?: Maybe<CsvRecords_Mutation_Response>;
  /** delete data from the table: "data_access_logs" */
  deleteDataAccessLogs?: Maybe<DataAccessLogs_Mutation_Response>;
  /** delete data from the table: "detection_logs" */
  deleteDetectionLogs?: Maybe<DetectionLogs_Mutation_Response>;
  /** delete data from the table: "detection_sets" */
  deleteDetectionSets?: Maybe<DetectionSets_Mutation_Response>;
  /** delete data from the table: "detection_states" */
  deleteDetectionStates?: Maybe<Detection_States_Mutation_Response>;
  /** delete data from the table: "detections" */
  deleteDetections?: Maybe<Detections_Mutation_Response>;
  /** delete data from the table: "evacuation_settings" */
  deleteEvacuationSettings?: Maybe<EvacuationSettings_Mutation_Response>;
  /** delete data from the table: "events" */
  deleteEvents?: Maybe<Events_Mutation_Response>;
  /** delete data from the table: "execution_histories" */
  deleteExecutionHistories?: Maybe<ExecutionHistories_Mutation_Response>;
  /** delete data from the table: "file_states" */
  deleteFileStates?: Maybe<File_States_Mutation_Response>;
  /** delete data from the table: "groups" */
  deleteGroups?: Maybe<Groups_Mutation_Response>;
  /** delete data from the table: "idp_types" */
  deleteIdpTypes?: Maybe<IdpTypes_Mutation_Response>;
  /** delete data from the table: "idps" */
  deleteIdps?: Maybe<Idps_Mutation_Response>;
  /** delete data from the table: "job_settings" */
  deleteJobSettings?: Maybe<JobSettings_Mutation_Response>;
  /** delete data from the table: "job_site_attributes" */
  deleteJobSiteAttributes?: Maybe<JobSiteAttributes_Mutation_Response>;
  /** delete data from the table: "job_sites" */
  deleteJobSites?: Maybe<JobSites_Mutation_Response>;
  /** delete data from the table: "login_logs" */
  deleteLoginLogs?: Maybe<Login_Logs_Mutation_Response>;
  /** delete data from the table: "message_formats" */
  deleteMessageFormats?: Maybe<MessageFormats_Mutation_Response>;
  /** delete data from the table: "messages" */
  deleteMessages?: Maybe<Messages_Mutation_Response>;
  /** delete data from the table: "multiple_detections" */
  deleteMultipleDetections?: Maybe<MultipleDetections_Mutation_Response>;
  /** delete data from the table: "notification_condition_details" */
  deleteNotificationConditionDetails?: Maybe<NotificationConditionDetails_Mutation_Response>;
  /** delete data from the table: "notification_conditions" */
  deleteNotificationConditions?: Maybe<NotificationConditions_Mutation_Response>;
  /** delete data from the table: "notification_events" */
  deleteNotificationEvents?: Maybe<NotificationEvents_Mutation_Response>;
  /** delete data from the table: "notification_histories" */
  deleteNotificationHistories?: Maybe<NotificationHistories_Mutation_Response>;
  /** delete data from the table: "notification_history_states" */
  deleteNotificationHistoryStates?: Maybe<Notification_History_States_Mutation_Response>;
  /** delete data from the table: "notification_services" */
  deleteNotificationServices?: Maybe<NotificationServices_Mutation_Response>;
  /** delete data from the table: "notification_settings" */
  deleteNotificationSettings?: Maybe<NotificationSettings_Mutation_Response>;
  /** delete data from the table: "notification_target_states" */
  deleteNotificationTargetStates?: Maybe<Notification_Target_States_Mutation_Response>;
  /** delete data from the table: "notification_targets" */
  deleteNotificationTargets?: Maybe<NotificationTargets_Mutation_Response>;
  /** delete data from the table: "notification_templates" */
  deleteNotificationTemplates?: Maybe<NotificationTemplates_Mutation_Response>;
  /** delete data from the table: "notification_user_states" */
  deleteNotificationUserStates?: Maybe<Notification_User_States_Mutation_Response>;
  /** delete data from the table: "notification_user_temp" */
  deleteNotificationUserTemp?: Maybe<NotificationUserTemp_Mutation_Response>;
  /** delete data from the table: "notification_users" */
  deleteNotificationUsers?: Maybe<NotificationUsers_Mutation_Response>;
  /** delete data from the table: "policies" */
  deletePolicies?: Maybe<Policies_Mutation_Response>;
  /** delete data from the table: "policy_define_types" */
  deletePolicyDefineTypes?: Maybe<Policy_Define_Types_Mutation_Response>;
  /** delete data from the table: "policy_defines" */
  deletePolicyDefines?: Maybe<PolicyDefines_Mutation_Response>;
  /** delete data from the table: "policy_templates" */
  deletePolicyTemplates?: Maybe<PolicyTemplates_Mutation_Response>;
  /** delete data from the table: "providers" */
  deleteProviders?: Maybe<Providers_Mutation_Response>;
  /** delete data from the table: "providers_assets" */
  deleteProvidersAssets?: Maybe<ProvidersAssets_Mutation_Response>;
  /** delete data from the table: "relay_api_services" */
  deleteRelayApiServices?: Maybe<RelayApiServices_Mutation_Response>;
  /** delete data from the table: "relay_services" */
  deleteRelayServices?: Maybe<RelayServices_Mutation_Response>;
  /** delete data from the table: "request_settings" */
  deleteRequestSettings?: Maybe<RequestSettings_Mutation_Response>;
  /** delete data from the table: "request_template_types" */
  deleteRequestTemplateTypes?: Maybe<Request_Template_Types_Mutation_Response>;
  /** delete data from the table: "request_templates" */
  deleteRequestTemplates?: Maybe<RequestTemplates_Mutation_Response>;
  /** delete data from the table: "rest2graphql_settings" */
  deleteRest2graphqlSettings?: Maybe<Rest2graphqlSettings_Mutation_Response>;
  /** delete data from the table: "schedules" */
  deleteSchedules?: Maybe<Schedules_Mutation_Response>;
  /** delete data from the table: "sensitive_information" */
  deleteSensitiveInformation?: Maybe<SensitiveInformation_Mutation_Response>;
  /** delete data from the table: "sensitive_information_categories" */
  deleteSensitiveInformationCategories?: Maybe<SensitiveInformationCategories_Mutation_Response>;
  /** delete data from the table: "sensitive_information_histories" */
  deleteSensitiveInformationHistories?: Maybe<SensitiveInformationHistories_Mutation_Response>;
  /** delete data from the table: "sensitive_information_items" */
  deleteSensitiveInformationItems?: Maybe<SensitiveInformationItems_Mutation_Response>;
  /** delete data from the table: "sensitive_information_request_services" */
  deleteSensitiveInformationRequestServices?: Maybe<SensitiveInformationRequestServices_Mutation_Response>;
  /** delete data from the table: "sensitive_information_store_service_connections" */
  deleteSensitiveInformationStoreServiceConnections?: Maybe<SensitiveInformationStoreServiceConnections_Mutation_Response>;
  /** delete data from the table: "services" */
  deleteServices?: Maybe<Services_Mutation_Response>;
  /** delete data from the table: "sensitive_information_items" */
  deleteStoreSensitiveInformationItems?: Maybe<StoreSensitiveInformationItems_Mutation_Response>;
  /** delete data from the table: "tenant_services" */
  deleteTenantServices?: Maybe<TenantServices_Mutation_Response>;
  /** delete data from the table: "tenants" */
  deleteTenants?: Maybe<Tenants_Mutation_Response>;
  /** delete data from the table: "tenants_idps" */
  deleteTenantsIdps?: Maybe<TenantsIdps_Mutation_Response>;
  /** delete data from the table: "upload_files" */
  deleteUploadFiles?: Maybe<UploadFiles_Mutation_Response>;
  /** delete data from the table: "user_policies" */
  deleteUserPolicies?: Maybe<UserPolicies_Mutation_Response>;
  /** delete data from the table: "user_roles" */
  deleteUserRoles?: Maybe<User_Roles_Mutation_Response>;
  /** delete data from the table: "user_states" */
  deleteUserStates?: Maybe<User_States_Mutation_Response>;
  deleteUsers?: Maybe<MutationUserOutput>;
  /** delete data from the table: "users_assets" */
  deleteUsersAssets?: Maybe<UsersAssets_Mutation_Response>;
  /** delete data from the table: "users_external_users" */
  deleteUsersExternalUsers?: Maybe<UsersExternalUsers_Mutation_Response>;
  /** delete data from the table: "users_groups" */
  deleteUsersGroups?: Maybe<UsersGroups_Mutation_Response>;
  /** delete data from the table: "users_idps" */
  deleteUsersIdps?: Maybe<UsersIdps_Mutation_Response>;
  /** delete data from the table: "users_users" */
  deleteUsersUsers?: Maybe<UsersUsers_Mutation_Response>;
  /** update data of the table: "access_logs" */
  updateAccessLogs?: Maybe<AccessLogs_Mutation_Response>;
  /** update data of the table: "asset_images" */
  updateAssetImages?: Maybe<AssetImages_Mutation_Response>;
  /** update data of the table: "asset_properties" */
  updateAssetProperties?: Maybe<AssetProperties_Mutation_Response>;
  /** update data of the table: "asset_states" */
  updateAssetStates?: Maybe<Asset_States_Mutation_Response>;
  /** update data of the table: "asset_tags" */
  updateAssetTags?: Maybe<AssetTags_Mutation_Response>;
  /** update data of the table: "asset_types" */
  updateAssetTypes?: Maybe<AssetTypes_Mutation_Response>;
  /** update data of the table: "assets" */
  updateAssets?: Maybe<Assets_Mutation_Response>;
  /** update data of the table: "assets_assets" */
  updateAssetsAssets?: Maybe<AssetsAssets_Mutation_Response>;
  /** update data of the table: "authorization_info" */
  updateAuthorizationInfo?: Maybe<AuthorizationInfo_Mutation_Response>;
  /** update single row of the table: "access_logs" */
  updateByPkAccessLog?: Maybe<AccessLogs>;
  /** update single row of the table: "assets" */
  updateByPkAsset?: Maybe<Assets>;
  /** update single row of the table: "assets_assets" */
  updateByPkAssetAsset?: Maybe<AssetsAssets>;
  /** update single row of the table: "asset_images" */
  updateByPkAssetImage?: Maybe<AssetImages>;
  /** update single row of the table: "asset_properties" */
  updateByPkAssetProperty?: Maybe<AssetProperties>;
  /** update single row of the table: "asset_states" */
  updateByPkAssetState?: Maybe<Asset_States>;
  /** update single row of the table: "asset_tags" */
  updateByPkAssetTag?: Maybe<AssetTags>;
  /** update single row of the table: "asset_types" */
  updateByPkAssetType?: Maybe<AssetTypes>;
  /** update single row of the table: "authorization_info" */
  updateByPkAuthorizationInfo?: Maybe<AuthorizationInfo>;
  /** update single row of the table: "categories" */
  updateByPkCategory?: Maybe<Categories>;
  /** update single row of the table: "client_types" */
  updateByPkClientType?: Maybe<ClientTypes>;
  /** update single row of the table: "consents" */
  updateByPkConsent?: Maybe<Consents>;
  /** update single row of the table: "csv_records" */
  updateByPkCsvRecord?: Maybe<CsvRecords>;
  /** update single row of the table: "data_access_logs" */
  updateByPkDataAccessLog?: Maybe<DataAccessLogs>;
  /** update single row of the table: "detections" */
  updateByPkDetection?: Maybe<Detections>;
  /** update single row of the table: "detection_logs" */
  updateByPkDetectionLog?: Maybe<DetectionLogs>;
  /** update single row of the table: "detection_sets" */
  updateByPkDetectionSet?: Maybe<DetectionSets>;
  /** update single row of the table: "detection_states" */
  updateByPkDetectionState?: Maybe<Detection_States>;
  /** update single row of the table: "evacuation_settings" */
  updateByPkEvacuationSetting?: Maybe<EvacuationSettings>;
  /** update single row of the table: "events" */
  updateByPkEvent?: Maybe<Events>;
  /** update single row of the table: "execution_histories" */
  updateByPkExecutionHistory?: Maybe<ExecutionHistories>;
  /** update single row of the table: "file_states" */
  updateByPkFileState?: Maybe<File_States>;
  /** update single row of the table: "groups" */
  updateByPkGroup?: Maybe<Groups>;
  /** update single row of the table: "idps" */
  updateByPkIdp?: Maybe<Idps>;
  /** update single row of the table: "idp_types" */
  updateByPkIdpType?: Maybe<IdpTypes>;
  /** update single row of the table: "job_settings" */
  updateByPkJobSetting?: Maybe<JobSettings>;
  /** update single row of the table: "job_sites" */
  updateByPkJobSite?: Maybe<JobSites>;
  /** update single row of the table: "job_site_attributes" */
  updateByPkJobSiteAttribute?: Maybe<JobSiteAttributes>;
  /** update single row of the table: "login_logs" */
  updateByPkLoginLog?: Maybe<Login_Logs>;
  /** update single row of the table: "messages" */
  updateByPkMessage?: Maybe<Messages>;
  /** update single row of the table: "message_formats" */
  updateByPkMessageFormat?: Maybe<MessageFormats>;
  /** update single row of the table: "multiple_detections" */
  updateByPkMultipleDetection?: Maybe<MultipleDetections>;
  /** update single row of the table: "notification_conditions" */
  updateByPkNotificationCondition?: Maybe<NotificationConditions>;
  /** update single row of the table: "notification_condition_details" */
  updateByPkNotificationConditionDetail?: Maybe<NotificationConditionDetails>;
  /** update single row of the table: "notification_events" */
  updateByPkNotificationEvent?: Maybe<NotificationEvents>;
  /** update single row of the table: "notification_histories" */
  updateByPkNotificationHistory?: Maybe<NotificationHistories>;
  /** update single row of the table: "notification_history_states" */
  updateByPkNotificationHistoryState?: Maybe<Notification_History_States>;
  /** update single row of the table: "notification_services" */
  updateByPkNotificationService?: Maybe<NotificationServices>;
  /** update single row of the table: "notification_settings" */
  updateByPkNotificationSetting?: Maybe<NotificationSettings>;
  /** update single row of the table: "notification_targets" */
  updateByPkNotificationTarget?: Maybe<NotificationTargets>;
  /** update single row of the table: "notification_target_states" */
  updateByPkNotificationTargetState?: Maybe<Notification_Target_States>;
  /** update single row of the table: "notification_templates" */
  updateByPkNotificationTemplate?: Maybe<NotificationTemplates>;
  /** update single row of the table: "notification_users" */
  updateByPkNotificationUser?: Maybe<NotificationUsers>;
  /** update single row of the table: "notification_user_states" */
  updateByPkNotificationUserState?: Maybe<Notification_User_States>;
  /** update single row of the table: "notification_user_temp" */
  updateByPkNotificationUserTemp?: Maybe<NotificationUserTemp>;
  /** update single row of the table: "policies" */
  updateByPkPolicy?: Maybe<Policies>;
  /** update single row of the table: "policy_defines" */
  updateByPkPolicyDefine?: Maybe<PolicyDefines>;
  /** update single row of the table: "policy_define_types" */
  updateByPkPolicyDefineType?: Maybe<Policy_Define_Types>;
  /** update single row of the table: "policy_templates" */
  updateByPkPolicyTemplate?: Maybe<PolicyTemplates>;
  /** update single row of the table: "providers" */
  updateByPkProvider?: Maybe<Providers>;
  /** update single row of the table: "providers_assets" */
  updateByPkProviderAsset?: Maybe<ProvidersAssets>;
  /** update single row of the table: "relay_api_services" */
  updateByPkRelayApiService?: Maybe<RelayApiServices>;
  /** update single row of the table: "relay_services" */
  updateByPkRelayService?: Maybe<RelayServices>;
  /** update single row of the table: "request_settings" */
  updateByPkRequestSetting?: Maybe<RequestSettings>;
  /** update single row of the table: "request_templates" */
  updateByPkRequestTemplate?: Maybe<RequestTemplates>;
  /** update single row of the table: "request_template_types" */
  updateByPkRequestTemplateType?: Maybe<Request_Template_Types>;
  /** update single row of the table: "rest2graphql_settings" */
  updateByPkRest2graphqlSetting?: Maybe<Rest2graphqlSettings>;
  /** update single row of the table: "schedules" */
  updateByPkSchedule?: Maybe<Schedules>;
  /** update single row of the table: "sensitive_information" */
  updateByPkSensitiveInformation?: Maybe<SensitiveInformation>;
  /** update single row of the table: "sensitive_information_categories" */
  updateByPkSensitiveInformationCategory?: Maybe<SensitiveInformationCategories>;
  /** update single row of the table: "sensitive_information_histories" */
  updateByPkSensitiveInformationHistory?: Maybe<SensitiveInformationHistories>;
  /** update single row of the table: "sensitive_information_items" */
  updateByPkSensitiveInformationItem?: Maybe<SensitiveInformationItems>;
  /** update single row of the table: "sensitive_information_request_services" */
  updateByPkSensitiveInformationRequestService?: Maybe<SensitiveInformationRequestServices>;
  /** update single row of the table: "sensitive_information_store_service_connections" */
  updateByPkSensitiveInformationStoreServiceConnection?: Maybe<SensitiveInformationStoreServiceConnections>;
  /** update single row of the table: "services" */
  updateByPkService?: Maybe<Services>;
  /** update single row of the table: "sensitive_information_items" */
  updateByPkStoreSensitiveInformationItem?: Maybe<StoreSensitiveInformationItems>;
  /** update single row of the table: "tenants" */
  updateByPkTenant?: Maybe<Tenants>;
  /** update single row of the table: "tenants_idps" */
  updateByPkTenantIdp?: Maybe<TenantsIdps>;
  /** update single row of the table: "tenant_services" */
  updateByPkTenantService?: Maybe<TenantServices>;
  /** update single row of the table: "upload_files" */
  updateByPkUploadFile?: Maybe<UploadFiles>;
  /** update single row of the table: "users" */
  updateByPkUser?: Maybe<Users>;
  /** update single row of the table: "users_groups" */
  updateByPkUserGroup?: Maybe<UsersGroups>;
  /** update single row of the table: "users_idps" */
  updateByPkUserIdp?: Maybe<UsersIdps>;
  /** update single row of the table: "user_policies" */
  updateByPkUserPolicy?: Maybe<UserPolicies>;
  /** update single row of the table: "user_roles" */
  updateByPkUserRole?: Maybe<User_Roles>;
  /** update single row of the table: "user_states" */
  updateByPkUserState?: Maybe<User_States>;
  /** update single row of the table: "users_external_users" */
  updateByPkUsersExternalUser?: Maybe<UsersExternalUsers>;
  /** update single row of the table: "users_users" */
  updateByPkUsersUser?: Maybe<UsersUsers>;
  /** update single row of the table: "users_assets" */
  updateByUsersAsset?: Maybe<UsersAssets>;
  /** update data of the table: "categories" */
  updateCategories?: Maybe<Categories_Mutation_Response>;
  /** update data of the table: "client_types" */
  updateClientTypes?: Maybe<ClientTypes_Mutation_Response>;
  /** update data of the table: "consents" */
  updateConsents?: Maybe<Consents_Mutation_Response>;
  /** update data of the table: "csv_records" */
  updateCsvRecords?: Maybe<CsvRecords_Mutation_Response>;
  /** update data of the table: "data_access_logs" */
  updateDataAccessLogs?: Maybe<DataAccessLogs_Mutation_Response>;
  /** update data of the table: "detection_logs" */
  updateDetectionLogs?: Maybe<DetectionLogs_Mutation_Response>;
  /** update data of the table: "detection_sets" */
  updateDetectionSets?: Maybe<DetectionSets_Mutation_Response>;
  /** update data of the table: "detection_states" */
  updateDetectionStates?: Maybe<Detection_States_Mutation_Response>;
  /** update data of the table: "detections" */
  updateDetections?: Maybe<Detections_Mutation_Response>;
  /** update data of the table: "evacuation_settings" */
  updateEvacuationSettings?: Maybe<EvacuationSettings_Mutation_Response>;
  /** update data of the table: "events" */
  updateEvents?: Maybe<Events_Mutation_Response>;
  /** update data of the table: "execution_histories" */
  updateExecutionHistories?: Maybe<ExecutionHistories_Mutation_Response>;
  /** update data of the table: "file_states" */
  updateFileStates?: Maybe<File_States_Mutation_Response>;
  /** update data of the table: "groups" */
  updateGroups?: Maybe<Groups_Mutation_Response>;
  /** update data of the table: "idp_types" */
  updateIdpTypes?: Maybe<IdpTypes_Mutation_Response>;
  /** update data of the table: "idps" */
  updateIdps?: Maybe<Idps_Mutation_Response>;
  /** update data of the table: "job_settings" */
  updateJobSettings?: Maybe<JobSettings_Mutation_Response>;
  /** update data of the table: "job_site_attributes" */
  updateJobSiteAttributes?: Maybe<JobSiteAttributes_Mutation_Response>;
  /** update data of the table: "job_sites" */
  updateJobSites?: Maybe<JobSites_Mutation_Response>;
  /** update data of the table: "login_logs" */
  updateLoginLogs?: Maybe<Login_Logs_Mutation_Response>;
  /** update data of the table: "message_formats" */
  updateMessageFormats?: Maybe<MessageFormats_Mutation_Response>;
  /** update data of the table: "messages" */
  updateMessages?: Maybe<Messages_Mutation_Response>;
  /** update data of the table: "multiple_detections" */
  updateMultipleDetections?: Maybe<MultipleDetections_Mutation_Response>;
  /** update data of the table: "notification_condition_details" */
  updateNotificationConditionDetails?: Maybe<NotificationConditionDetails_Mutation_Response>;
  /** update data of the table: "notification_conditions" */
  updateNotificationConditions?: Maybe<NotificationConditions_Mutation_Response>;
  /** update data of the table: "notification_events" */
  updateNotificationEvents?: Maybe<NotificationEvents_Mutation_Response>;
  /** update data of the table: "notification_histories" */
  updateNotificationHistories?: Maybe<NotificationHistories_Mutation_Response>;
  /** update data of the table: "notification_history_states" */
  updateNotificationHistoryStates?: Maybe<Notification_History_States_Mutation_Response>;
  /** update data of the table: "notification_services" */
  updateNotificationServices?: Maybe<NotificationServices_Mutation_Response>;
  /** update data of the table: "notification_settings" */
  updateNotificationSettings?: Maybe<NotificationSettings_Mutation_Response>;
  /** update data of the table: "notification_target_states" */
  updateNotificationTargetStates?: Maybe<Notification_Target_States_Mutation_Response>;
  /** update data of the table: "notification_targets" */
  updateNotificationTargets?: Maybe<NotificationTargets_Mutation_Response>;
  /** update data of the table: "notification_templates" */
  updateNotificationTemplates?: Maybe<NotificationTemplates_Mutation_Response>;
  /** update data of the table: "notification_user_states" */
  updateNotificationUserStates?: Maybe<Notification_User_States_Mutation_Response>;
  /** update data of the table: "notification_user_temp" */
  updateNotificationUserTemp?: Maybe<NotificationUserTemp_Mutation_Response>;
  /** update data of the table: "notification_users" */
  updateNotificationUsers?: Maybe<NotificationUsers_Mutation_Response>;
  updatePolicies?: Maybe<MutationPolicyOutput>;
  /** update data of the table: "policy_define_types" */
  updatePolicyDefineTypes?: Maybe<Policy_Define_Types_Mutation_Response>;
  /** update data of the table: "policy_defines" */
  updatePolicyDefines?: Maybe<PolicyDefines_Mutation_Response>;
  /** update data of the table: "policy_templates" */
  updatePolicyTemplates?: Maybe<PolicyTemplates_Mutation_Response>;
  /** update data of the table: "providers" */
  updateProviders?: Maybe<Providers_Mutation_Response>;
  /** update data of the table: "providers_assets" */
  updateProvidersAssets?: Maybe<ProvidersAssets_Mutation_Response>;
  /** update data of the table: "relay_api_services" */
  updateRelayApiServices?: Maybe<RelayApiServices_Mutation_Response>;
  /** update data of the table: "relay_services" */
  updateRelayServices?: Maybe<RelayServices_Mutation_Response>;
  /** update data of the table: "request_settings" */
  updateRequestSettings?: Maybe<RequestSettings_Mutation_Response>;
  /** update data of the table: "request_template_types" */
  updateRequestTemplateTypes?: Maybe<Request_Template_Types_Mutation_Response>;
  /** update data of the table: "request_templates" */
  updateRequestTemplates?: Maybe<RequestTemplates_Mutation_Response>;
  /** update data of the table: "rest2graphql_settings" */
  updateRest2graphqlSettings?: Maybe<Rest2graphqlSettings_Mutation_Response>;
  /** update data of the table: "schedules" */
  updateSchedules?: Maybe<Schedules_Mutation_Response>;
  /** update data of the table: "sensitive_information" */
  updateSensitiveInformation?: Maybe<SensitiveInformation_Mutation_Response>;
  /** update data of the table: "sensitive_information_categories" */
  updateSensitiveInformationCategories?: Maybe<SensitiveInformationCategories_Mutation_Response>;
  /** update data of the table: "sensitive_information_histories" */
  updateSensitiveInformationHistories?: Maybe<SensitiveInformationHistories_Mutation_Response>;
  /** update data of the table: "sensitive_information_items" */
  updateSensitiveInformationItems?: Maybe<SensitiveInformationItems_Mutation_Response>;
  /** update data of the table: "sensitive_information_request_services" */
  updateSensitiveInformationRequestServices?: Maybe<SensitiveInformationRequestServices_Mutation_Response>;
  /** update data of the table: "sensitive_information_store_service_connections" */
  updateSensitiveInformationStoreServiceConnections?: Maybe<SensitiveInformationStoreServiceConnections_Mutation_Response>;
  /** update data of the table: "services" */
  updateServices?: Maybe<Services_Mutation_Response>;
  /** update data of the table: "sensitive_information_items" */
  updateStoreSensitiveInformationItems?: Maybe<StoreSensitiveInformationItems_Mutation_Response>;
  updateTenantPublicInfo?: Maybe<MutationTenantPublicInfoOutput>;
  /** update data of the table: "tenant_services" */
  updateTenantServices?: Maybe<TenantServices_Mutation_Response>;
  /** update data of the table: "tenants" */
  updateTenants?: Maybe<Tenants_Mutation_Response>;
  /** update data of the table: "tenants_idps" */
  updateTenantsIdps?: Maybe<TenantsIdps_Mutation_Response>;
  /** update data of the table: "upload_files" */
  updateUploadFiles?: Maybe<UploadFiles_Mutation_Response>;
  /** update data of the table: "user_policies" */
  updateUserPolicies?: Maybe<UserPolicies_Mutation_Response>;
  /** update data of the table: "user_roles" */
  updateUserRoles?: Maybe<User_Roles_Mutation_Response>;
  /** update data of the table: "user_states" */
  updateUserStates?: Maybe<User_States_Mutation_Response>;
  updateUsers?: Maybe<MutationUserOutput>;
  /** update data of the table: "users_assets" */
  updateUsersAssets?: Maybe<UsersAssets_Mutation_Response>;
  /** update data of the table: "users_external_users" */
  updateUsersExternalUsers?: Maybe<UsersExternalUsers_Mutation_Response>;
  /**  ## ユーザーグループ */
  updateUsersGroups?: Maybe<MutationUserGroupOutput>;
  /** update data of the table: "users_idps" */
  updateUsersIdps?: Maybe<UsersIdps_Mutation_Response>;
  /** update data of the table: "users_users" */
  updateUsersUsers?: Maybe<UsersUsers_Mutation_Response>;
  /** update multiples rows of table: "access_logs" */
  update_accessLogs_many?: Maybe<Array<Maybe<AccessLogs_Mutation_Response>>>;
  /** update multiples rows of table: "asset_images" */
  update_assetImages_many?: Maybe<Array<Maybe<AssetImages_Mutation_Response>>>;
  /** update multiples rows of table: "asset_properties" */
  update_assetProperties_many?: Maybe<Array<Maybe<AssetProperties_Mutation_Response>>>;
  /** update multiples rows of table: "asset_tags" */
  update_assetTags_many?: Maybe<Array<Maybe<AssetTags_Mutation_Response>>>;
  /** update multiples rows of table: "asset_types" */
  update_assetTypes_many?: Maybe<Array<Maybe<AssetTypes_Mutation_Response>>>;
  /** update multiples rows of table: "asset_states" */
  update_asset_states_many?: Maybe<Array<Maybe<Asset_States_Mutation_Response>>>;
  /** update multiples rows of table: "assets_assets" */
  update_assetsAssets_many?: Maybe<Array<Maybe<AssetsAssets_Mutation_Response>>>;
  /** update multiples rows of table: "assets" */
  update_assets_many?: Maybe<Array<Maybe<Assets_Mutation_Response>>>;
  /** update multiples rows of table: "authorization_info" */
  update_authorizationInfo_many?: Maybe<Array<Maybe<AuthorizationInfo_Mutation_Response>>>;
  /** update multiples rows of table: "categories" */
  update_categories_many?: Maybe<Array<Maybe<Categories_Mutation_Response>>>;
  /** update multiples rows of table: "client_types" */
  update_clientTypes_many?: Maybe<Array<Maybe<ClientTypes_Mutation_Response>>>;
  /** update multiples rows of table: "consents" */
  update_consents_many?: Maybe<Array<Maybe<Consents_Mutation_Response>>>;
  /** update multiples rows of table: "csv_records" */
  update_csvRecords_many?: Maybe<Array<Maybe<CsvRecords_Mutation_Response>>>;
  /** update multiples rows of table: "data_access_logs" */
  update_dataAccessLogs_many?: Maybe<Array<Maybe<DataAccessLogs_Mutation_Response>>>;
  /** update multiples rows of table: "detection_logs" */
  update_detectionLogs_many?: Maybe<Array<Maybe<DetectionLogs_Mutation_Response>>>;
  /** update multiples rows of table: "detection_sets" */
  update_detectionSets_many?: Maybe<Array<Maybe<DetectionSets_Mutation_Response>>>;
  /** update multiples rows of table: "detection_states" */
  update_detection_states_many?: Maybe<Array<Maybe<Detection_States_Mutation_Response>>>;
  /** update multiples rows of table: "detections" */
  update_detections_many?: Maybe<Array<Maybe<Detections_Mutation_Response>>>;
  /** update multiples rows of table: "evacuation_settings" */
  update_evacuationSettings_many?: Maybe<Array<Maybe<EvacuationSettings_Mutation_Response>>>;
  /** update multiples rows of table: "events" */
  update_events_many?: Maybe<Array<Maybe<Events_Mutation_Response>>>;
  /** update multiples rows of table: "execution_histories" */
  update_executionHistories_many?: Maybe<Array<Maybe<ExecutionHistories_Mutation_Response>>>;
  /** update multiples rows of table: "file_states" */
  update_file_states_many?: Maybe<Array<Maybe<File_States_Mutation_Response>>>;
  /** update multiples rows of table: "groups" */
  update_groups_many?: Maybe<Array<Maybe<Groups_Mutation_Response>>>;
  /** update multiples rows of table: "idp_types" */
  update_idpTypes_many?: Maybe<Array<Maybe<IdpTypes_Mutation_Response>>>;
  /** update multiples rows of table: "idps" */
  update_idps_many?: Maybe<Array<Maybe<Idps_Mutation_Response>>>;
  /** update multiples rows of table: "job_settings" */
  update_jobSettings_many?: Maybe<Array<Maybe<JobSettings_Mutation_Response>>>;
  /** update multiples rows of table: "job_site_attributes" */
  update_jobSiteAttributes_many?: Maybe<Array<Maybe<JobSiteAttributes_Mutation_Response>>>;
  /** update multiples rows of table: "job_sites" */
  update_jobSites_many?: Maybe<Array<Maybe<JobSites_Mutation_Response>>>;
  /** update multiples rows of table: "login_logs" */
  update_login_logs_many?: Maybe<Array<Maybe<Login_Logs_Mutation_Response>>>;
  /** update multiples rows of table: "message_formats" */
  update_messageFormats_many?: Maybe<Array<Maybe<MessageFormats_Mutation_Response>>>;
  /** update multiples rows of table: "messages" */
  update_messages_many?: Maybe<Array<Maybe<Messages_Mutation_Response>>>;
  /** update multiples rows of table: "multiple_detections" */
  update_multipleDetections_many?: Maybe<Array<Maybe<MultipleDetections_Mutation_Response>>>;
  /** update multiples rows of table: "notification_condition_details" */
  update_notificationConditionDetails_many?: Maybe<Array<Maybe<NotificationConditionDetails_Mutation_Response>>>;
  /** update multiples rows of table: "notification_conditions" */
  update_notificationConditions_many?: Maybe<Array<Maybe<NotificationConditions_Mutation_Response>>>;
  /** update multiples rows of table: "notification_events" */
  update_notificationEvents_many?: Maybe<Array<Maybe<NotificationEvents_Mutation_Response>>>;
  /** update multiples rows of table: "notification_histories" */
  update_notificationHistories_many?: Maybe<Array<Maybe<NotificationHistories_Mutation_Response>>>;
  /** update multiples rows of table: "notification_services" */
  update_notificationServices_many?: Maybe<Array<Maybe<NotificationServices_Mutation_Response>>>;
  /** update multiples rows of table: "notification_settings" */
  update_notificationSettings_many?: Maybe<Array<Maybe<NotificationSettings_Mutation_Response>>>;
  /** update multiples rows of table: "notification_targets" */
  update_notificationTargets_many?: Maybe<Array<Maybe<NotificationTargets_Mutation_Response>>>;
  /** update multiples rows of table: "notification_templates" */
  update_notificationTemplates_many?: Maybe<Array<Maybe<NotificationTemplates_Mutation_Response>>>;
  /** update multiples rows of table: "notification_user_temp" */
  update_notificationUserTemp_many?: Maybe<Array<Maybe<NotificationUserTemp_Mutation_Response>>>;
  /** update multiples rows of table: "notification_users" */
  update_notificationUsers_many?: Maybe<Array<Maybe<NotificationUsers_Mutation_Response>>>;
  /** update multiples rows of table: "notification_history_states" */
  update_notification_history_states_many?: Maybe<Array<Maybe<Notification_History_States_Mutation_Response>>>;
  /** update multiples rows of table: "notification_target_states" */
  update_notification_target_states_many?: Maybe<Array<Maybe<Notification_Target_States_Mutation_Response>>>;
  /** update multiples rows of table: "notification_user_states" */
  update_notification_user_states_many?: Maybe<Array<Maybe<Notification_User_States_Mutation_Response>>>;
  /** update multiples rows of table: "policies" */
  update_policies_many?: Maybe<Array<Maybe<Policies_Mutation_Response>>>;
  /** update multiples rows of table: "policy_defines" */
  update_policyDefines_many?: Maybe<Array<Maybe<PolicyDefines_Mutation_Response>>>;
  /** update multiples rows of table: "policy_templates" */
  update_policyTemplates_many?: Maybe<Array<Maybe<PolicyTemplates_Mutation_Response>>>;
  /** update multiples rows of table: "policy_define_types" */
  update_policy_define_types_many?: Maybe<Array<Maybe<Policy_Define_Types_Mutation_Response>>>;
  /** update multiples rows of table: "providers_assets" */
  update_providersAssets_many?: Maybe<Array<Maybe<ProvidersAssets_Mutation_Response>>>;
  /** update multiples rows of table: "providers" */
  update_providers_many?: Maybe<Array<Maybe<Providers_Mutation_Response>>>;
  /** update multiples rows of table: "relay_api_services" */
  update_relayApiServices_many?: Maybe<Array<Maybe<RelayApiServices_Mutation_Response>>>;
  /** update multiples rows of table: "relay_services" */
  update_relayServices_many?: Maybe<Array<Maybe<RelayServices_Mutation_Response>>>;
  /** update multiples rows of table: "request_settings" */
  update_requestSettings_many?: Maybe<Array<Maybe<RequestSettings_Mutation_Response>>>;
  /** update multiples rows of table: "request_templates" */
  update_requestTemplates_many?: Maybe<Array<Maybe<RequestTemplates_Mutation_Response>>>;
  /** update multiples rows of table: "request_template_types" */
  update_request_template_types_many?: Maybe<Array<Maybe<Request_Template_Types_Mutation_Response>>>;
  /** update multiples rows of table: "rest2graphql_settings" */
  update_rest2graphqlSettings_many?: Maybe<Array<Maybe<Rest2graphqlSettings_Mutation_Response>>>;
  /** update multiples rows of table: "schedules" */
  update_schedules_many?: Maybe<Array<Maybe<Schedules_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_categories" */
  update_sensitiveInformationCategories_many?: Maybe<Array<Maybe<SensitiveInformationCategories_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_histories" */
  update_sensitiveInformationHistories_many?: Maybe<Array<Maybe<SensitiveInformationHistories_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_items" */
  update_sensitiveInformationItems_many?: Maybe<Array<Maybe<SensitiveInformationItems_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_request_services" */
  update_sensitiveInformationRequestServices_many?: Maybe<Array<Maybe<SensitiveInformationRequestServices_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_store_service_connections" */
  update_sensitiveInformationStoreServiceConnections_many?: Maybe<Array<Maybe<SensitiveInformationStoreServiceConnections_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information" */
  update_sensitiveInformation_many?: Maybe<Array<Maybe<SensitiveInformation_Mutation_Response>>>;
  /** update multiples rows of table: "services" */
  update_services_many?: Maybe<Array<Maybe<Services_Mutation_Response>>>;
  /** update multiples rows of table: "sensitive_information_items" */
  update_storeSensitiveInformationItems_many?: Maybe<Array<Maybe<StoreSensitiveInformationItems_Mutation_Response>>>;
  /** update multiples rows of table: "tenant_public_info" */
  update_tenantPublicInfo_many?: Maybe<Array<Maybe<TenantPublicInfo_Mutation_Response>>>;
  /** update multiples rows of table: "tenant_services" */
  update_tenantServices_many?: Maybe<Array<Maybe<TenantServices_Mutation_Response>>>;
  /** update multiples rows of table: "tenants_idps" */
  update_tenantsIdps_many?: Maybe<Array<Maybe<TenantsIdps_Mutation_Response>>>;
  /** update multiples rows of table: "tenants" */
  update_tenants_many?: Maybe<Array<Maybe<Tenants_Mutation_Response>>>;
  /** update multiples rows of table: "upload_files" */
  update_uploadFiles_many?: Maybe<Array<Maybe<UploadFiles_Mutation_Response>>>;
  /** update multiples rows of table: "user_policies" */
  update_userPolicies_many?: Maybe<Array<Maybe<UserPolicies_Mutation_Response>>>;
  /** update multiples rows of table: "user_roles" */
  update_user_roles_many?: Maybe<Array<Maybe<User_Roles_Mutation_Response>>>;
  /** update multiples rows of table: "user_states" */
  update_user_states_many?: Maybe<Array<Maybe<User_States_Mutation_Response>>>;
  /** update multiples rows of table: "users_assets" */
  update_usersAssets_many?: Maybe<Array<Maybe<UsersAssets_Mutation_Response>>>;
  /** update multiples rows of table: "users_external_users" */
  update_usersExternalUsers_many?: Maybe<Array<Maybe<UsersExternalUsers_Mutation_Response>>>;
  /** update multiples rows of table: "users_groups" */
  update_usersGroups_many?: Maybe<Array<Maybe<UsersGroups_Mutation_Response>>>;
  /** update multiples rows of table: "users_idps" */
  update_usersIdps_many?: Maybe<Array<Maybe<UsersIdps_Mutation_Response>>>;
  /** update multiples rows of table: "users_users" */
  update_usersUsers_many?: Maybe<Array<Maybe<UsersUsers_Mutation_Response>>>;
  /** update multiples rows of table: "users" */
  update_users_many?: Maybe<Array<Maybe<Users_Mutation_Response>>>;
  /** delete single row from the table: "users_assets" */
  usersAsset?: Maybe<UsersAssets>;
};


/** mutation root */
export type Mutation_RootCreateAccessLogArgs = {
  object: AccessLogs_Insert_Input;
  on_conflict?: InputMaybe<AccessLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAccessLogsArgs = {
  objects: Array<AccessLogs_Insert_Input>;
  on_conflict?: InputMaybe<AccessLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetArgs = {
  object: Assets_Insert_Input;
  on_conflict?: InputMaybe<Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetAssetArgs = {
  object: AssetsAssets_Insert_Input;
  on_conflict?: InputMaybe<AssetsAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetImageArgs = {
  object: AssetImages_Insert_Input;
  on_conflict?: InputMaybe<AssetImages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetImagesArgs = {
  objects: Array<AssetImages_Insert_Input>;
  on_conflict?: InputMaybe<AssetImages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetPropertiesArgs = {
  objects: Array<AssetProperties_Insert_Input>;
  on_conflict?: InputMaybe<AssetProperties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetPropertyArgs = {
  object: AssetProperties_Insert_Input;
  on_conflict?: InputMaybe<AssetProperties_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetStateArgs = {
  object: Asset_States_Insert_Input;
  on_conflict?: InputMaybe<Asset_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetStatesArgs = {
  objects: Array<Asset_States_Insert_Input>;
  on_conflict?: InputMaybe<Asset_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetTagArgs = {
  object: AssetTags_Insert_Input;
  on_conflict?: InputMaybe<AssetTags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetTagsArgs = {
  objects: Array<AssetTags_Insert_Input>;
  on_conflict?: InputMaybe<AssetTags_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetTypeArgs = {
  object: AssetTypes_Insert_Input;
  on_conflict?: InputMaybe<AssetTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetTypesArgs = {
  objects: Array<AssetTypes_Insert_Input>;
  on_conflict?: InputMaybe<AssetTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetsArgs = {
  objects: Array<Assets_Insert_Input>;
  on_conflict?: InputMaybe<Assets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAssetsAssetsArgs = {
  objects: Array<AssetsAssets_Insert_Input>;
  on_conflict?: InputMaybe<AssetsAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAuthorizationInfoArgs = {
  object: AuthorizationInfo_Insert_Input;
  on_conflict?: InputMaybe<AuthorizationInfo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateAuthorizationInfosArgs = {
  objects: Array<AuthorizationInfo_Insert_Input>;
  on_conflict?: InputMaybe<AuthorizationInfo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateCategoriesArgs = {
  objects: Array<Categories_Insert_Input>;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateCategoryArgs = {
  object: Categories_Insert_Input;
  on_conflict?: InputMaybe<Categories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateClientTypeArgs = {
  object: ClientTypes_Insert_Input;
  on_conflict?: InputMaybe<ClientTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateClientTypesArgs = {
  objects: Array<ClientTypes_Insert_Input>;
  on_conflict?: InputMaybe<ClientTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateConsentArgs = {
  object: Consents_Insert_Input;
  on_conflict?: InputMaybe<Consents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateConsentsArgs = {
  objects: Array<Consents_Insert_Input>;
  on_conflict?: InputMaybe<Consents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateCsvRecordArgs = {
  object: CsvRecords_Insert_Input;
  on_conflict?: InputMaybe<CsvRecords_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateCsvRecordsArgs = {
  objects: Array<CsvRecords_Insert_Input>;
  on_conflict?: InputMaybe<CsvRecords_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDataAccessLogArgs = {
  object: DataAccessLogs_Insert_Input;
  on_conflict?: InputMaybe<DataAccessLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDataAccessLogsArgs = {
  objects: Array<DataAccessLogs_Insert_Input>;
  on_conflict?: InputMaybe<DataAccessLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionArgs = {
  object: Detections_Insert_Input;
  on_conflict?: InputMaybe<Detections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionLogArgs = {
  object: DetectionLogs_Insert_Input;
  on_conflict?: InputMaybe<DetectionLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionLogsArgs = {
  objects: Array<DetectionLogs_Insert_Input>;
  on_conflict?: InputMaybe<DetectionLogs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionSetArgs = {
  object: DetectionSets_Insert_Input;
  on_conflict?: InputMaybe<DetectionSets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionSetsArgs = {
  objects: Array<DetectionSets_Insert_Input>;
  on_conflict?: InputMaybe<DetectionSets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionStateArgs = {
  object: Detection_States_Insert_Input;
  on_conflict?: InputMaybe<Detection_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionStatesArgs = {
  objects: Array<Detection_States_Insert_Input>;
  on_conflict?: InputMaybe<Detection_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateDetectionsArgs = {
  objects: Array<Detections_Insert_Input>;
  on_conflict?: InputMaybe<Detections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateEvacuationSettingArgs = {
  object: EvacuationSettings_Insert_Input;
  on_conflict?: InputMaybe<EvacuationSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateEvacuationSettingsArgs = {
  objects: Array<EvacuationSettings_Insert_Input>;
  on_conflict?: InputMaybe<EvacuationSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateEventArgs = {
  object: Events_Insert_Input;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateEventsArgs = {
  objects: Array<Events_Insert_Input>;
  on_conflict?: InputMaybe<Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateExecutionHistoriesArgs = {
  objects: Array<ExecutionHistories_Insert_Input>;
  on_conflict?: InputMaybe<ExecutionHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateExecutionHistoryArgs = {
  object: ExecutionHistories_Insert_Input;
  on_conflict?: InputMaybe<ExecutionHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateFileStateArgs = {
  object: File_States_Insert_Input;
  on_conflict?: InputMaybe<File_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateFileStatesArgs = {
  objects: Array<File_States_Insert_Input>;
  on_conflict?: InputMaybe<File_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateGroupArgs = {
  object: Groups_Insert_Input;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateGroupsArgs = {
  objects: Array<Groups_Insert_Input>;
  on_conflict?: InputMaybe<Groups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateIdpArgs = {
  object: Idps_Insert_Input;
  on_conflict?: InputMaybe<Idps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateIdpTypeArgs = {
  object: IdpTypes_Insert_Input;
  on_conflict?: InputMaybe<IdpTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateIdpTypesArgs = {
  objects: Array<IdpTypes_Insert_Input>;
  on_conflict?: InputMaybe<IdpTypes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateIdpsArgs = {
  objects: Array<Idps_Insert_Input>;
  on_conflict?: InputMaybe<Idps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSettingArgs = {
  object: JobSettings_Insert_Input;
  on_conflict?: InputMaybe<JobSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSettingsArgs = {
  objects: Array<JobSettings_Insert_Input>;
  on_conflict?: InputMaybe<JobSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSiteArgs = {
  object: JobSites_Insert_Input;
  on_conflict?: InputMaybe<JobSites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSiteAttributeArgs = {
  object: JobSiteAttributes_Insert_Input;
  on_conflict?: InputMaybe<JobSiteAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSiteAttributesArgs = {
  objects: Array<JobSiteAttributes_Insert_Input>;
  on_conflict?: InputMaybe<JobSiteAttributes_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateJobSitesArgs = {
  objects: Array<JobSites_Insert_Input>;
  on_conflict?: InputMaybe<JobSites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateLoginLogArgs = {
  object: Login_Logs_Insert_Input;
  on_conflict?: InputMaybe<Login_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateLoginLogsArgs = {
  objects: Array<Login_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Login_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMessageArgs = {
  object: Messages_Insert_Input;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMessageFormatArgs = {
  object: MessageFormats_Insert_Input;
  on_conflict?: InputMaybe<MessageFormats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMessageFormatsArgs = {
  objects: Array<MessageFormats_Insert_Input>;
  on_conflict?: InputMaybe<MessageFormats_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMessagesArgs = {
  objects: Array<Messages_Insert_Input>;
  on_conflict?: InputMaybe<Messages_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMultipleDetectionArgs = {
  object: MultipleDetections_Insert_Input;
  on_conflict?: InputMaybe<MultipleDetections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateMultipleDetectionsArgs = {
  objects: Array<MultipleDetections_Insert_Input>;
  on_conflict?: InputMaybe<MultipleDetections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationConditionArgs = {
  object: NotificationConditions_Insert_Input;
  on_conflict?: InputMaybe<NotificationConditions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationConditionDetailArgs = {
  object: NotificationConditionDetails_Insert_Input;
  on_conflict?: InputMaybe<NotificationConditionDetails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationConditionDetailsArgs = {
  objects: Array<NotificationConditionDetails_Insert_Input>;
  on_conflict?: InputMaybe<NotificationConditionDetails_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationConditionsArgs = {
  objects: Array<NotificationConditions_Insert_Input>;
  on_conflict?: InputMaybe<NotificationConditions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationEventArgs = {
  object: NotificationEvents_Insert_Input;
  on_conflict?: InputMaybe<NotificationEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationEventsArgs = {
  objects: Array<NotificationEvents_Insert_Input>;
  on_conflict?: InputMaybe<NotificationEvents_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationHistoriesArgs = {
  objects: Array<NotificationHistories_Insert_Input>;
  on_conflict?: InputMaybe<NotificationHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationHistoryArgs = {
  object: NotificationHistories_Insert_Input;
  on_conflict?: InputMaybe<NotificationHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationHistoryStateArgs = {
  object: Notification_History_States_Insert_Input;
  on_conflict?: InputMaybe<Notification_History_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationHistoryStatesArgs = {
  objects: Array<Notification_History_States_Insert_Input>;
  on_conflict?: InputMaybe<Notification_History_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationServiceArgs = {
  object: NotificationServices_Insert_Input;
  on_conflict?: InputMaybe<NotificationServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationServicesArgs = {
  objects: Array<NotificationServices_Insert_Input>;
  on_conflict?: InputMaybe<NotificationServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationSettingArgs = {
  object: NotificationSettings_Insert_Input;
  on_conflict?: InputMaybe<NotificationSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationSettingsArgs = {
  objects: Array<NotificationSettings_Insert_Input>;
  on_conflict?: InputMaybe<NotificationSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTargetArgs = {
  object: NotificationTargets_Insert_Input;
  on_conflict?: InputMaybe<NotificationTargets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTargetStateArgs = {
  object: Notification_Target_States_Insert_Input;
  on_conflict?: InputMaybe<Notification_Target_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTargetStatesArgs = {
  objects: Array<Notification_Target_States_Insert_Input>;
  on_conflict?: InputMaybe<Notification_Target_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTargetsArgs = {
  objects: Array<NotificationTargets_Insert_Input>;
  on_conflict?: InputMaybe<NotificationTargets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTemplateArgs = {
  object: NotificationTemplates_Insert_Input;
  on_conflict?: InputMaybe<NotificationTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationTemplatesArgs = {
  objects: Array<NotificationTemplates_Insert_Input>;
  on_conflict?: InputMaybe<NotificationTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUserArgs = {
  object: NotificationUsers_Insert_Input;
  on_conflict?: InputMaybe<NotificationUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUserStateArgs = {
  object: Notification_User_States_Insert_Input;
  on_conflict?: InputMaybe<Notification_User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUserStatesArgs = {
  objects: Array<Notification_User_States_Insert_Input>;
  on_conflict?: InputMaybe<Notification_User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUserTempArgs = {
  object: NotificationUserTemp_Insert_Input;
  on_conflict?: InputMaybe<NotificationUserTemp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUserTempsArgs = {
  objects: Array<NotificationUserTemp_Insert_Input>;
  on_conflict?: InputMaybe<NotificationUserTemp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateNotificationUsersArgs = {
  objects: Array<NotificationUsers_Insert_Input>;
  on_conflict?: InputMaybe<NotificationUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePoliciesArgs = {
  objects: Array<Policies_Insert_Input>;
  on_conflict?: InputMaybe<Policies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyArgs = {
  object: Policies_Insert_Input;
  on_conflict?: InputMaybe<Policies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyDefineArgs = {
  object: PolicyDefines_Insert_Input;
  on_conflict?: InputMaybe<PolicyDefines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyDefineTypeArgs = {
  object: Policy_Define_Types_Insert_Input;
  on_conflict?: InputMaybe<Policy_Define_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyDefineTypesArgs = {
  objects: Array<Policy_Define_Types_Insert_Input>;
  on_conflict?: InputMaybe<Policy_Define_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyDefinesArgs = {
  objects: Array<PolicyDefines_Insert_Input>;
  on_conflict?: InputMaybe<PolicyDefines_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyTemplateArgs = {
  object: PolicyTemplates_Insert_Input;
  on_conflict?: InputMaybe<PolicyTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreatePolicyTemplatesArgs = {
  objects: Array<PolicyTemplates_Insert_Input>;
  on_conflict?: InputMaybe<PolicyTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateProviderArgs = {
  object: Providers_Insert_Input;
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateProviderAssetArgs = {
  object: ProvidersAssets_Insert_Input;
  on_conflict?: InputMaybe<ProvidersAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateProvidersArgs = {
  objects: Array<Providers_Insert_Input>;
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateProvidersAssetsArgs = {
  objects: Array<ProvidersAssets_Insert_Input>;
  on_conflict?: InputMaybe<ProvidersAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRelayApiServiceArgs = {
  object: RelayApiServices_Insert_Input;
  on_conflict?: InputMaybe<RelayApiServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRelayApiServicesArgs = {
  objects: Array<RelayApiServices_Insert_Input>;
  on_conflict?: InputMaybe<RelayApiServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRelayServiceArgs = {
  object: RelayServices_Insert_Input;
  on_conflict?: InputMaybe<RelayServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRelayServicesArgs = {
  objects: Array<RelayServices_Insert_Input>;
  on_conflict?: InputMaybe<RelayServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestSettingArgs = {
  object: RequestSettings_Insert_Input;
  on_conflict?: InputMaybe<RequestSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestSettingsArgs = {
  objects: Array<RequestSettings_Insert_Input>;
  on_conflict?: InputMaybe<RequestSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestTemplateArgs = {
  object: RequestTemplates_Insert_Input;
  on_conflict?: InputMaybe<RequestTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestTemplateTypeArgs = {
  object: Request_Template_Types_Insert_Input;
  on_conflict?: InputMaybe<Request_Template_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestTemplateTypesArgs = {
  objects: Array<Request_Template_Types_Insert_Input>;
  on_conflict?: InputMaybe<Request_Template_Types_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRequestTemplatesArgs = {
  objects: Array<RequestTemplates_Insert_Input>;
  on_conflict?: InputMaybe<RequestTemplates_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRest2graphqlSettingArgs = {
  object: Rest2graphqlSettings_Insert_Input;
  on_conflict?: InputMaybe<Rest2graphqlSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateRest2graphqlSettingsArgs = {
  objects: Array<Rest2graphqlSettings_Insert_Input>;
  on_conflict?: InputMaybe<Rest2graphqlSettings_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateScheduleArgs = {
  object: Schedules_Insert_Input;
  on_conflict?: InputMaybe<Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSchedulesArgs = {
  objects: Array<Schedules_Insert_Input>;
  on_conflict?: InputMaybe<Schedules_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationArgs = {
  object: SensitiveInformation_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationCategoriesArgs = {
  objects: Array<SensitiveInformationCategories_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformationCategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationCategoryArgs = {
  object: SensitiveInformationCategories_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformationCategories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationHistoriesArgs = {
  objects: Array<SensitiveInformationHistories_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformationHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationHistoryArgs = {
  object: SensitiveInformationHistories_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformationHistories_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationItemArgs = {
  object: SensitiveInformationItems_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformationItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationItemsArgs = {
  objects: Array<SensitiveInformationItems_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformationItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationRequestServiceArgs = {
  object: SensitiveInformationRequestServices_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformationRequestServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationRequestServicesArgs = {
  objects: Array<SensitiveInformationRequestServices_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformationRequestServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationStoreServiceConnectionArgs = {
  object: SensitiveInformationStoreServiceConnections_Insert_Input;
  on_conflict?: InputMaybe<SensitiveInformationStoreServiceConnections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationStoreServiceConnectionsArgs = {
  objects: Array<SensitiveInformationStoreServiceConnections_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformationStoreServiceConnections_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateSensitiveInformationsArgs = {
  objects: Array<SensitiveInformation_Insert_Input>;
  on_conflict?: InputMaybe<SensitiveInformation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateServiceArgs = {
  object: Services_Insert_Input;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateServicesArgs = {
  objects: Array<Services_Insert_Input>;
  on_conflict?: InputMaybe<Services_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateStoreSensitiveInformationItemArgs = {
  object: StoreSensitiveInformationItems_Insert_Input;
  on_conflict?: InputMaybe<StoreSensitiveInformationItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateStoreSensitiveInformationItemsArgs = {
  objects: Array<StoreSensitiveInformationItems_Insert_Input>;
  on_conflict?: InputMaybe<StoreSensitiveInformationItems_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantArgs = {
  object: Tenants_Insert_Input;
  on_conflict?: InputMaybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantIdpArgs = {
  object: TenantsIdps_Insert_Input;
  on_conflict?: InputMaybe<TenantsIdps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantPublicInfoArgs = {
  object: CreateTenantPublicInfoInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/** mutation root */
export type Mutation_RootCreateTenantPublicInfosArgs = {
  objects: Array<TenantPublicInfo_Insert_Input>;
  on_conflict?: InputMaybe<TenantPublicInfo_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantServiceArgs = {
  object: TenantServices_Insert_Input;
  on_conflict?: InputMaybe<TenantServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantServicesArgs = {
  objects: Array<TenantServices_Insert_Input>;
  on_conflict?: InputMaybe<TenantServices_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantsArgs = {
  objects: Array<Tenants_Insert_Input>;
  on_conflict?: InputMaybe<Tenants_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateTenantsIdpsArgs = {
  objects: Array<TenantsIdps_Insert_Input>;
  on_conflict?: InputMaybe<TenantsIdps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUploadFileArgs = {
  object: UploadFiles_Insert_Input;
  on_conflict?: InputMaybe<UploadFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUploadFilesArgs = {
  objects: Array<UploadFiles_Insert_Input>;
  on_conflict?: InputMaybe<UploadFiles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  object: CreateUserInput;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserGroupArgs = {
  object: UsersGroups_Insert_Input;
  on_conflict?: InputMaybe<UsersGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserIdpArgs = {
  object: UsersIdps_Insert_Input;
  on_conflict?: InputMaybe<UsersIdps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserPoliciesArgs = {
  objects: Array<UserPolicies_Insert_Input>;
  on_conflict?: InputMaybe<UserPolicies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserPolicyArgs = {
  object: UserPolicies_Insert_Input;
  on_conflict?: InputMaybe<UserPolicies_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserRoleArgs = {
  object: User_Roles_Insert_Input;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserRolesArgs = {
  objects: Array<User_Roles_Insert_Input>;
  on_conflict?: InputMaybe<User_Roles_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserStateArgs = {
  object: User_States_Insert_Input;
  on_conflict?: InputMaybe<User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUserStatesArgs = {
  objects: Array<User_States_Insert_Input>;
  on_conflict?: InputMaybe<User_States_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersArgs = {
  objects: Array<Users_Insert_Input>;
  on_conflict?: InputMaybe<Users_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersAssetArgs = {
  object: UsersAssets_Insert_Input;
  on_conflict?: InputMaybe<UsersAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersAssetsArgs = {
  objects: Array<UsersAssets_Insert_Input>;
  on_conflict?: InputMaybe<UsersAssets_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersExternalUserArgs = {
  object: UsersExternalUsers_Insert_Input;
  on_conflict?: InputMaybe<UsersExternalUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersExternalUsersArgs = {
  objects: Array<UsersExternalUsers_Insert_Input>;
  on_conflict?: InputMaybe<UsersExternalUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersGroupsArgs = {
  objects: Array<UsersGroups_Insert_Input>;
  on_conflict?: InputMaybe<UsersGroups_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersIdpsArgs = {
  objects: Array<UsersIdps_Insert_Input>;
  on_conflict?: InputMaybe<UsersIdps_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersUserArgs = {
  object: UsersUsers_Insert_Input;
  on_conflict?: InputMaybe<UsersUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootCreateUsersUsersArgs = {
  objects: Array<UsersUsers_Insert_Input>;
  on_conflict?: InputMaybe<UsersUsers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootDeleteAccessLogsArgs = {
  where: AccessLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetImagesArgs = {
  where: AssetImages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetPropertiesArgs = {
  where: AssetProperties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetStatesArgs = {
  where: Asset_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetTagsArgs = {
  where: AssetTags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetTypesArgs = {
  where: AssetTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetsArgs = {
  where: Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAssetsAssetsArgs = {
  where: AssetsAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteAuthorizationInfoArgs = {
  where: AuthorizationInfo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteByPkAccessLogArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetAssetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetImageArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetPropertyArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetTagArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAssetTypeArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkAuthorizationInfoArgs = {
  tenantAlias: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkCategoryArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkClientTypeArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkConsentArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkCsvRecordArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkDataAccessLogArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkDetectionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkDetectionLogArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkDetectionSetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkDetectionStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkEvacuationSettingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkEventArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkExecutionHistoryArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkFileStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkGroupArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkIdpArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkIdpTypeArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkJobSettingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkJobSiteArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkJobSiteAttributeArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkLoginLogArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkMessageArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkMessageFormatArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkMultipleDetectionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationConditionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationConditionDetailArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationEventArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationHistoryArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationHistoryStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationSettingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationTargetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationTargetStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationTemplateArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationUserArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationUserStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkNotificationUserTempArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkPolicyArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkPolicyDefineArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkPolicyDefineTypeArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkPolicyTemplateArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkProviderArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkProviderAssetArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRelayApiServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRelayServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRequestSettingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRequestTemplateArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRequestTemplateTypeArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkRest2graphqlSettingArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkScheduleArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationCategoryArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationHistoryArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationItemArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationRequestServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkSensitiveInformationStoreServiceConnectionArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkStoreSensitiveInformationItemArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkTenantArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkTenantIdpArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkTenantServiceArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUploadFileArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserGroupArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserIdpArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserPolicyArgs = {
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserRoleArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUserStateArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUsersExternalUserArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteByPkUsersUserArgs = {
  id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteCategoriesArgs = {
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteClientTypesArgs = {
  where: ClientTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteConsentsArgs = {
  where: Consents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteCsvRecordsArgs = {
  where: CsvRecords_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDataAccessLogsArgs = {
  where: DataAccessLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDetectionLogsArgs = {
  where: DetectionLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDetectionSetsArgs = {
  where: DetectionSets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDetectionStatesArgs = {
  where: Detection_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteDetectionsArgs = {
  where: Detections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEvacuationSettingsArgs = {
  where: EvacuationSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteEventsArgs = {
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteExecutionHistoriesArgs = {
  where: ExecutionHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteFileStatesArgs = {
  where: File_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteGroupsArgs = {
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdpTypesArgs = {
  where: IdpTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteIdpsArgs = {
  where: Idps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobSettingsArgs = {
  where: JobSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobSiteAttributesArgs = {
  where: JobSiteAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteJobSitesArgs = {
  where: JobSites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteLoginLogsArgs = {
  where: Login_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteMessageFormatsArgs = {
  where: MessageFormats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteMessagesArgs = {
  where: Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteMultipleDetectionsArgs = {
  where: MultipleDetections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationConditionDetailsArgs = {
  where: NotificationConditionDetails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationConditionsArgs = {
  where: NotificationConditions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationEventsArgs = {
  where: NotificationEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationHistoriesArgs = {
  where: NotificationHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationHistoryStatesArgs = {
  where: Notification_History_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationServicesArgs = {
  where: NotificationServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationSettingsArgs = {
  where: NotificationSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationTargetStatesArgs = {
  where: Notification_Target_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationTargetsArgs = {
  where: NotificationTargets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationTemplatesArgs = {
  where: NotificationTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationUserStatesArgs = {
  where: Notification_User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationUserTempArgs = {
  where: NotificationUserTemp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteNotificationUsersArgs = {
  where: NotificationUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePoliciesArgs = {
  where: Policies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyDefineTypesArgs = {
  where: Policy_Define_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyDefinesArgs = {
  where: PolicyDefines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeletePolicyTemplatesArgs = {
  where: PolicyTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProvidersArgs = {
  where: Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteProvidersAssetsArgs = {
  where: ProvidersAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRelayApiServicesArgs = {
  where: RelayApiServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRelayServicesArgs = {
  where: RelayServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRequestSettingsArgs = {
  where: RequestSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRequestTemplateTypesArgs = {
  where: Request_Template_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRequestTemplatesArgs = {
  where: RequestTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteRest2graphqlSettingsArgs = {
  where: Rest2graphqlSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSchedulesArgs = {
  where: Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationArgs = {
  where: SensitiveInformation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationCategoriesArgs = {
  where: SensitiveInformationCategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationHistoriesArgs = {
  where: SensitiveInformationHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationItemsArgs = {
  where: SensitiveInformationItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationRequestServicesArgs = {
  where: SensitiveInformationRequestServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteSensitiveInformationStoreServiceConnectionsArgs = {
  where: SensitiveInformationStoreServiceConnections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteServicesArgs = {
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteStoreSensitiveInformationItemsArgs = {
  where: StoreSensitiveInformationItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTenantServicesArgs = {
  where: TenantServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTenantsArgs = {
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteTenantsIdpsArgs = {
  where: TenantsIdps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUploadFilesArgs = {
  where: UploadFiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserPoliciesArgs = {
  where: UserPolicies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserRolesArgs = {
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUserStatesArgs = {
  where: User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/** mutation root */
export type Mutation_RootDeleteUsersAssetsArgs = {
  where: UsersAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersExternalUsersArgs = {
  where: UsersExternalUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersGroupsArgs = {
  where: UsersGroups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersIdpsArgs = {
  where: UsersIdps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDeleteUsersUsersArgs = {
  where: UsersUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAccessLogsArgs = {
  _append?: InputMaybe<AccessLogs_Append_Input>;
  _delete_at_path?: InputMaybe<AccessLogs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AccessLogs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AccessLogs_Delete_Key_Input>;
  _inc?: InputMaybe<AccessLogs_Inc_Input>;
  _prepend?: InputMaybe<AccessLogs_Prepend_Input>;
  _set?: InputMaybe<AccessLogs_Set_Input>;
  where: AccessLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetImagesArgs = {
  _inc?: InputMaybe<AssetImages_Inc_Input>;
  _set?: InputMaybe<AssetImages_Set_Input>;
  where: AssetImages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetPropertiesArgs = {
  _append?: InputMaybe<AssetProperties_Append_Input>;
  _delete_at_path?: InputMaybe<AssetProperties_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AssetProperties_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AssetProperties_Delete_Key_Input>;
  _inc?: InputMaybe<AssetProperties_Inc_Input>;
  _prepend?: InputMaybe<AssetProperties_Prepend_Input>;
  _set?: InputMaybe<AssetProperties_Set_Input>;
  where: AssetProperties_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetStatesArgs = {
  _set?: InputMaybe<Asset_States_Set_Input>;
  where: Asset_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetTagsArgs = {
  _inc?: InputMaybe<AssetTags_Inc_Input>;
  _set?: InputMaybe<AssetTags_Set_Input>;
  where: AssetTags_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetTypesArgs = {
  _append?: InputMaybe<AssetTypes_Append_Input>;
  _delete_at_path?: InputMaybe<AssetTypes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AssetTypes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AssetTypes_Delete_Key_Input>;
  _inc?: InputMaybe<AssetTypes_Inc_Input>;
  _prepend?: InputMaybe<AssetTypes_Prepend_Input>;
  _set?: InputMaybe<AssetTypes_Set_Input>;
  where: AssetTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetsArgs = {
  _append?: InputMaybe<Assets_Append_Input>;
  _delete_at_path?: InputMaybe<Assets_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assets_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assets_Delete_Key_Input>;
  _inc?: InputMaybe<Assets_Inc_Input>;
  _prepend?: InputMaybe<Assets_Prepend_Input>;
  _set?: InputMaybe<Assets_Set_Input>;
  where: Assets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAssetsAssetsArgs = {
  _inc?: InputMaybe<AssetsAssets_Inc_Input>;
  _set?: InputMaybe<AssetsAssets_Set_Input>;
  where: AssetsAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateAuthorizationInfoArgs = {
  _append?: InputMaybe<AuthorizationInfo_Append_Input>;
  _delete_at_path?: InputMaybe<AuthorizationInfo_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthorizationInfo_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthorizationInfo_Delete_Key_Input>;
  _inc?: InputMaybe<AuthorizationInfo_Inc_Input>;
  _prepend?: InputMaybe<AuthorizationInfo_Prepend_Input>;
  _set?: InputMaybe<AuthorizationInfo_Set_Input>;
  where: AuthorizationInfo_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateByPkAccessLogArgs = {
  _append?: InputMaybe<AccessLogs_Append_Input>;
  _delete_at_path?: InputMaybe<AccessLogs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AccessLogs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AccessLogs_Delete_Key_Input>;
  _inc?: InputMaybe<AccessLogs_Inc_Input>;
  _prepend?: InputMaybe<AccessLogs_Prepend_Input>;
  _set?: InputMaybe<AccessLogs_Set_Input>;
  pk_columns: AccessLogs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetArgs = {
  _append?: InputMaybe<Assets_Append_Input>;
  _delete_at_path?: InputMaybe<Assets_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Assets_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Assets_Delete_Key_Input>;
  _inc?: InputMaybe<Assets_Inc_Input>;
  _prepend?: InputMaybe<Assets_Prepend_Input>;
  _set?: InputMaybe<Assets_Set_Input>;
  pk_columns: Assets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetAssetArgs = {
  _inc?: InputMaybe<AssetsAssets_Inc_Input>;
  _set?: InputMaybe<AssetsAssets_Set_Input>;
  pk_columns: AssetsAssets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetImageArgs = {
  _inc?: InputMaybe<AssetImages_Inc_Input>;
  _set?: InputMaybe<AssetImages_Set_Input>;
  pk_columns: AssetImages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetPropertyArgs = {
  _append?: InputMaybe<AssetProperties_Append_Input>;
  _delete_at_path?: InputMaybe<AssetProperties_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AssetProperties_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AssetProperties_Delete_Key_Input>;
  _inc?: InputMaybe<AssetProperties_Inc_Input>;
  _prepend?: InputMaybe<AssetProperties_Prepend_Input>;
  _set?: InputMaybe<AssetProperties_Set_Input>;
  pk_columns: AssetProperties_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetStateArgs = {
  _set?: InputMaybe<Asset_States_Set_Input>;
  pk_columns: Asset_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetTagArgs = {
  _inc?: InputMaybe<AssetTags_Inc_Input>;
  _set?: InputMaybe<AssetTags_Set_Input>;
  pk_columns: AssetTags_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAssetTypeArgs = {
  _append?: InputMaybe<AssetTypes_Append_Input>;
  _delete_at_path?: InputMaybe<AssetTypes_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AssetTypes_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AssetTypes_Delete_Key_Input>;
  _inc?: InputMaybe<AssetTypes_Inc_Input>;
  _prepend?: InputMaybe<AssetTypes_Prepend_Input>;
  _set?: InputMaybe<AssetTypes_Set_Input>;
  pk_columns: AssetTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkAuthorizationInfoArgs = {
  _append?: InputMaybe<AuthorizationInfo_Append_Input>;
  _delete_at_path?: InputMaybe<AuthorizationInfo_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<AuthorizationInfo_Delete_Elem_Input>;
  _delete_key?: InputMaybe<AuthorizationInfo_Delete_Key_Input>;
  _inc?: InputMaybe<AuthorizationInfo_Inc_Input>;
  _prepend?: InputMaybe<AuthorizationInfo_Prepend_Input>;
  _set?: InputMaybe<AuthorizationInfo_Set_Input>;
  pk_columns: AuthorizationInfo_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkCategoryArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  pk_columns: Categories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkClientTypeArgs = {
  _inc?: InputMaybe<ClientTypes_Inc_Input>;
  _set?: InputMaybe<ClientTypes_Set_Input>;
  pk_columns: ClientTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkConsentArgs = {
  _inc?: InputMaybe<Consents_Inc_Input>;
  _set?: InputMaybe<Consents_Set_Input>;
  pk_columns: Consents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkCsvRecordArgs = {
  _append?: InputMaybe<CsvRecords_Append_Input>;
  _delete_at_path?: InputMaybe<CsvRecords_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CsvRecords_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CsvRecords_Delete_Key_Input>;
  _inc?: InputMaybe<CsvRecords_Inc_Input>;
  _prepend?: InputMaybe<CsvRecords_Prepend_Input>;
  _set?: InputMaybe<CsvRecords_Set_Input>;
  pk_columns: CsvRecords_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkDataAccessLogArgs = {
  _append?: InputMaybe<DataAccessLogs_Append_Input>;
  _delete_at_path?: InputMaybe<DataAccessLogs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<DataAccessLogs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<DataAccessLogs_Delete_Key_Input>;
  _inc?: InputMaybe<DataAccessLogs_Inc_Input>;
  _prepend?: InputMaybe<DataAccessLogs_Prepend_Input>;
  _set?: InputMaybe<DataAccessLogs_Set_Input>;
  pk_columns: DataAccessLogs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkDetectionArgs = {
  _append?: InputMaybe<Detections_Append_Input>;
  _delete_at_path?: InputMaybe<Detections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Detections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Detections_Delete_Key_Input>;
  _inc?: InputMaybe<Detections_Inc_Input>;
  _prepend?: InputMaybe<Detections_Prepend_Input>;
  _set?: InputMaybe<Detections_Set_Input>;
  pk_columns: Detections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkDetectionLogArgs = {
  _inc?: InputMaybe<DetectionLogs_Inc_Input>;
  _set?: InputMaybe<DetectionLogs_Set_Input>;
  pk_columns: DetectionLogs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkDetectionSetArgs = {
  _inc?: InputMaybe<DetectionSets_Inc_Input>;
  _set?: InputMaybe<DetectionSets_Set_Input>;
  pk_columns: DetectionSets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkDetectionStateArgs = {
  _set?: InputMaybe<Detection_States_Set_Input>;
  pk_columns: Detection_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkEvacuationSettingArgs = {
  _inc?: InputMaybe<EvacuationSettings_Inc_Input>;
  _set?: InputMaybe<EvacuationSettings_Set_Input>;
  pk_columns: EvacuationSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkEventArgs = {
  _append?: InputMaybe<Events_Append_Input>;
  _delete_at_path?: InputMaybe<Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Events_Delete_Key_Input>;
  _inc?: InputMaybe<Events_Inc_Input>;
  _prepend?: InputMaybe<Events_Prepend_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  pk_columns: Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkExecutionHistoryArgs = {
  _inc?: InputMaybe<ExecutionHistories_Inc_Input>;
  _set?: InputMaybe<ExecutionHistories_Set_Input>;
  pk_columns: ExecutionHistories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkFileStateArgs = {
  _set?: InputMaybe<File_States_Set_Input>;
  pk_columns: File_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkGroupArgs = {
  _inc?: InputMaybe<Groups_Inc_Input>;
  _set?: InputMaybe<Groups_Set_Input>;
  pk_columns: Groups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkIdpArgs = {
  _append?: InputMaybe<Idps_Append_Input>;
  _delete_at_path?: InputMaybe<Idps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Idps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Idps_Delete_Key_Input>;
  _inc?: InputMaybe<Idps_Inc_Input>;
  _prepend?: InputMaybe<Idps_Prepend_Input>;
  _set?: InputMaybe<Idps_Set_Input>;
  pk_columns: Idps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkIdpTypeArgs = {
  _set?: InputMaybe<IdpTypes_Set_Input>;
  pk_columns: IdpTypes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkJobSettingArgs = {
  _inc?: InputMaybe<JobSettings_Inc_Input>;
  _set?: InputMaybe<JobSettings_Set_Input>;
  pk_columns: JobSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkJobSiteArgs = {
  _append?: InputMaybe<JobSites_Append_Input>;
  _delete_at_path?: InputMaybe<JobSites_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobSites_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobSites_Delete_Key_Input>;
  _inc?: InputMaybe<JobSites_Inc_Input>;
  _prepend?: InputMaybe<JobSites_Prepend_Input>;
  _set?: InputMaybe<JobSites_Set_Input>;
  pk_columns: JobSites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkJobSiteAttributeArgs = {
  _inc?: InputMaybe<JobSiteAttributes_Inc_Input>;
  _set?: InputMaybe<JobSiteAttributes_Set_Input>;
  pk_columns: JobSiteAttributes_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkLoginLogArgs = {
  _inc?: InputMaybe<Login_Logs_Inc_Input>;
  _set?: InputMaybe<Login_Logs_Set_Input>;
  pk_columns: Login_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkMessageArgs = {
  _append?: InputMaybe<Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Messages_Inc_Input>;
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  _set?: InputMaybe<Messages_Set_Input>;
  pk_columns: Messages_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkMessageFormatArgs = {
  _append?: InputMaybe<MessageFormats_Append_Input>;
  _delete_at_path?: InputMaybe<MessageFormats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<MessageFormats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<MessageFormats_Delete_Key_Input>;
  _inc?: InputMaybe<MessageFormats_Inc_Input>;
  _prepend?: InputMaybe<MessageFormats_Prepend_Input>;
  _set?: InputMaybe<MessageFormats_Set_Input>;
  pk_columns: MessageFormats_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkMultipleDetectionArgs = {
  _append?: InputMaybe<MultipleDetections_Append_Input>;
  _delete_at_path?: InputMaybe<MultipleDetections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<MultipleDetections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<MultipleDetections_Delete_Key_Input>;
  _inc?: InputMaybe<MultipleDetections_Inc_Input>;
  _prepend?: InputMaybe<MultipleDetections_Prepend_Input>;
  _set?: InputMaybe<MultipleDetections_Set_Input>;
  pk_columns: MultipleDetections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationConditionArgs = {
  _inc?: InputMaybe<NotificationConditions_Inc_Input>;
  _set?: InputMaybe<NotificationConditions_Set_Input>;
  pk_columns: NotificationConditions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationConditionDetailArgs = {
  _append?: InputMaybe<NotificationConditionDetails_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationConditionDetails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationConditionDetails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationConditionDetails_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationConditionDetails_Inc_Input>;
  _prepend?: InputMaybe<NotificationConditionDetails_Prepend_Input>;
  _set?: InputMaybe<NotificationConditionDetails_Set_Input>;
  pk_columns: NotificationConditionDetails_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationEventArgs = {
  _inc?: InputMaybe<NotificationEvents_Inc_Input>;
  _set?: InputMaybe<NotificationEvents_Set_Input>;
  pk_columns: NotificationEvents_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationHistoryArgs = {
  _append?: InputMaybe<NotificationHistories_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationHistories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationHistories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationHistories_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationHistories_Inc_Input>;
  _prepend?: InputMaybe<NotificationHistories_Prepend_Input>;
  _set?: InputMaybe<NotificationHistories_Set_Input>;
  pk_columns: NotificationHistories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationHistoryStateArgs = {
  _set?: InputMaybe<Notification_History_States_Set_Input>;
  pk_columns: Notification_History_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationServiceArgs = {
  _append?: InputMaybe<NotificationServices_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationServices_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationServices_Inc_Input>;
  _prepend?: InputMaybe<NotificationServices_Prepend_Input>;
  _set?: InputMaybe<NotificationServices_Set_Input>;
  pk_columns: NotificationServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationSettingArgs = {
  _append?: InputMaybe<NotificationSettings_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationSettings_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationSettings_Inc_Input>;
  _prepend?: InputMaybe<NotificationSettings_Prepend_Input>;
  _set?: InputMaybe<NotificationSettings_Set_Input>;
  pk_columns: NotificationSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationTargetArgs = {
  _inc?: InputMaybe<NotificationTargets_Inc_Input>;
  _set?: InputMaybe<NotificationTargets_Set_Input>;
  pk_columns: NotificationTargets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationTargetStateArgs = {
  _set?: InputMaybe<Notification_Target_States_Set_Input>;
  pk_columns: Notification_Target_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationTemplateArgs = {
  _append?: InputMaybe<NotificationTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationTemplates_Inc_Input>;
  _prepend?: InputMaybe<NotificationTemplates_Prepend_Input>;
  _set?: InputMaybe<NotificationTemplates_Set_Input>;
  pk_columns: NotificationTemplates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationUserArgs = {
  _inc?: InputMaybe<NotificationUsers_Inc_Input>;
  _set?: InputMaybe<NotificationUsers_Set_Input>;
  pk_columns: NotificationUsers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationUserStateArgs = {
  _set?: InputMaybe<Notification_User_States_Set_Input>;
  pk_columns: Notification_User_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkNotificationUserTempArgs = {
  _inc?: InputMaybe<NotificationUserTemp_Inc_Input>;
  _set?: InputMaybe<NotificationUserTemp_Set_Input>;
  pk_columns: NotificationUserTemp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkPolicyArgs = {
  _append?: InputMaybe<Policies_Append_Input>;
  _delete_at_path?: InputMaybe<Policies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Policies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Policies_Delete_Key_Input>;
  _inc?: InputMaybe<Policies_Inc_Input>;
  _prepend?: InputMaybe<Policies_Prepend_Input>;
  _set?: InputMaybe<Policies_Set_Input>;
  pk_columns: Policies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkPolicyDefineArgs = {
  _append?: InputMaybe<PolicyDefines_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyDefines_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyDefines_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyDefines_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyDefines_Inc_Input>;
  _prepend?: InputMaybe<PolicyDefines_Prepend_Input>;
  _set?: InputMaybe<PolicyDefines_Set_Input>;
  pk_columns: PolicyDefines_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkPolicyDefineTypeArgs = {
  _set?: InputMaybe<Policy_Define_Types_Set_Input>;
  pk_columns: Policy_Define_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkPolicyTemplateArgs = {
  _append?: InputMaybe<PolicyTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyTemplates_Inc_Input>;
  _prepend?: InputMaybe<PolicyTemplates_Prepend_Input>;
  _set?: InputMaybe<PolicyTemplates_Set_Input>;
  pk_columns: PolicyTemplates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkProviderArgs = {
  _inc?: InputMaybe<Providers_Inc_Input>;
  _set?: InputMaybe<Providers_Set_Input>;
  pk_columns: Providers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkProviderAssetArgs = {
  _inc?: InputMaybe<ProvidersAssets_Inc_Input>;
  _set?: InputMaybe<ProvidersAssets_Set_Input>;
  pk_columns: ProvidersAssets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRelayApiServiceArgs = {
  _append?: InputMaybe<RelayApiServices_Append_Input>;
  _delete_at_path?: InputMaybe<RelayApiServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RelayApiServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RelayApiServices_Delete_Key_Input>;
  _inc?: InputMaybe<RelayApiServices_Inc_Input>;
  _prepend?: InputMaybe<RelayApiServices_Prepend_Input>;
  _set?: InputMaybe<RelayApiServices_Set_Input>;
  pk_columns: RelayApiServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRelayServiceArgs = {
  _append?: InputMaybe<RelayServices_Append_Input>;
  _delete_at_path?: InputMaybe<RelayServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RelayServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RelayServices_Delete_Key_Input>;
  _inc?: InputMaybe<RelayServices_Inc_Input>;
  _prepend?: InputMaybe<RelayServices_Prepend_Input>;
  _set?: InputMaybe<RelayServices_Set_Input>;
  pk_columns: RelayServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRequestSettingArgs = {
  _append?: InputMaybe<RequestSettings_Append_Input>;
  _delete_at_path?: InputMaybe<RequestSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RequestSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RequestSettings_Delete_Key_Input>;
  _inc?: InputMaybe<RequestSettings_Inc_Input>;
  _prepend?: InputMaybe<RequestSettings_Prepend_Input>;
  _set?: InputMaybe<RequestSettings_Set_Input>;
  pk_columns: RequestSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRequestTemplateArgs = {
  _append?: InputMaybe<RequestTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<RequestTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RequestTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RequestTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<RequestTemplates_Inc_Input>;
  _prepend?: InputMaybe<RequestTemplates_Prepend_Input>;
  _set?: InputMaybe<RequestTemplates_Set_Input>;
  pk_columns: RequestTemplates_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRequestTemplateTypeArgs = {
  _set?: InputMaybe<Request_Template_Types_Set_Input>;
  pk_columns: Request_Template_Types_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkRest2graphqlSettingArgs = {
  _append?: InputMaybe<Rest2graphqlSettings_Append_Input>;
  _delete_at_path?: InputMaybe<Rest2graphqlSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rest2graphqlSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rest2graphqlSettings_Delete_Key_Input>;
  _inc?: InputMaybe<Rest2graphqlSettings_Inc_Input>;
  _prepend?: InputMaybe<Rest2graphqlSettings_Prepend_Input>;
  _set?: InputMaybe<Rest2graphqlSettings_Set_Input>;
  pk_columns: Rest2graphqlSettings_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkScheduleArgs = {
  _inc?: InputMaybe<Schedules_Inc_Input>;
  _set?: InputMaybe<Schedules_Set_Input>;
  pk_columns: Schedules_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationArgs = {
  _inc?: InputMaybe<SensitiveInformation_Inc_Input>;
  _set?: InputMaybe<SensitiveInformation_Set_Input>;
  pk_columns: SensitiveInformation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationCategoryArgs = {
  _inc?: InputMaybe<SensitiveInformationCategories_Inc_Input>;
  _set?: InputMaybe<SensitiveInformationCategories_Set_Input>;
  pk_columns: SensitiveInformationCategories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationHistoryArgs = {
  _append?: InputMaybe<SensitiveInformationHistories_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationHistories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationHistories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationHistories_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationHistories_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationHistories_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationHistories_Set_Input>;
  pk_columns: SensitiveInformationHistories_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationItemArgs = {
  _inc?: InputMaybe<SensitiveInformationItems_Inc_Input>;
  _set?: InputMaybe<SensitiveInformationItems_Set_Input>;
  pk_columns: SensitiveInformationItems_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationRequestServiceArgs = {
  _append?: InputMaybe<SensitiveInformationRequestServices_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationRequestServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationRequestServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationRequestServices_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationRequestServices_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationRequestServices_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationRequestServices_Set_Input>;
  pk_columns: SensitiveInformationRequestServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkSensitiveInformationStoreServiceConnectionArgs = {
  _append?: InputMaybe<SensitiveInformationStoreServiceConnections_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationStoreServiceConnections_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationStoreServiceConnections_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationStoreServiceConnections_Set_Input>;
  pk_columns: SensitiveInformationStoreServiceConnections_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkServiceArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  pk_columns: Services_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkStoreSensitiveInformationItemArgs = {
  _inc?: InputMaybe<StoreSensitiveInformationItems_Inc_Input>;
  _set?: InputMaybe<StoreSensitiveInformationItems_Set_Input>;
  pk_columns: StoreSensitiveInformationItems_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkTenantArgs = {
  _append?: InputMaybe<Tenants_Append_Input>;
  _delete_at_path?: InputMaybe<Tenants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenants_Delete_Key_Input>;
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _prepend?: InputMaybe<Tenants_Prepend_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  pk_columns: Tenants_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkTenantIdpArgs = {
  _inc?: InputMaybe<TenantsIdps_Inc_Input>;
  _set?: InputMaybe<TenantsIdps_Set_Input>;
  pk_columns: TenantsIdps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkTenantServiceArgs = {
  _inc?: InputMaybe<TenantServices_Inc_Input>;
  _set?: InputMaybe<TenantServices_Set_Input>;
  pk_columns: TenantServices_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUploadFileArgs = {
  _append?: InputMaybe<UploadFiles_Append_Input>;
  _delete_at_path?: InputMaybe<UploadFiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<UploadFiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<UploadFiles_Delete_Key_Input>;
  _inc?: InputMaybe<UploadFiles_Inc_Input>;
  _prepend?: InputMaybe<UploadFiles_Prepend_Input>;
  _set?: InputMaybe<UploadFiles_Set_Input>;
  pk_columns: UploadFiles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserArgs = {
  _append?: InputMaybe<Users_Append_Input>;
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  _inc?: InputMaybe<Users_Inc_Input>;
  _prepend?: InputMaybe<Users_Prepend_Input>;
  _set?: InputMaybe<Users_Set_Input>;
  pk_columns: Users_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserGroupArgs = {
  _inc?: InputMaybe<UsersGroups_Inc_Input>;
  _set?: InputMaybe<UsersGroups_Set_Input>;
  pk_columns: UsersGroups_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserIdpArgs = {
  _inc?: InputMaybe<UsersIdps_Inc_Input>;
  _set?: InputMaybe<UsersIdps_Set_Input>;
  pk_columns: UsersIdps_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserPolicyArgs = {
  _append?: InputMaybe<UserPolicies_Append_Input>;
  _delete_at_path?: InputMaybe<UserPolicies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<UserPolicies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<UserPolicies_Delete_Key_Input>;
  _inc?: InputMaybe<UserPolicies_Inc_Input>;
  _prepend?: InputMaybe<UserPolicies_Prepend_Input>;
  _set?: InputMaybe<UserPolicies_Set_Input>;
  pk_columns: UserPolicies_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserRoleArgs = {
  _set?: InputMaybe<User_Roles_Set_Input>;
  pk_columns: User_Roles_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUserStateArgs = {
  _set?: InputMaybe<User_States_Set_Input>;
  pk_columns: User_States_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUsersExternalUserArgs = {
  _inc?: InputMaybe<UsersExternalUsers_Inc_Input>;
  _set?: InputMaybe<UsersExternalUsers_Set_Input>;
  pk_columns: UsersExternalUsers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByPkUsersUserArgs = {
  _inc?: InputMaybe<UsersUsers_Inc_Input>;
  _set?: InputMaybe<UsersUsers_Set_Input>;
  pk_columns: UsersUsers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateByUsersAssetArgs = {
  _inc?: InputMaybe<UsersAssets_Inc_Input>;
  _set?: InputMaybe<UsersAssets_Set_Input>;
  pk_columns: UsersAssets_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdateCategoriesArgs = {
  _inc?: InputMaybe<Categories_Inc_Input>;
  _set?: InputMaybe<Categories_Set_Input>;
  where: Categories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateClientTypesArgs = {
  _inc?: InputMaybe<ClientTypes_Inc_Input>;
  _set?: InputMaybe<ClientTypes_Set_Input>;
  where: ClientTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateConsentsArgs = {
  _inc?: InputMaybe<Consents_Inc_Input>;
  _set?: InputMaybe<Consents_Set_Input>;
  where: Consents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateCsvRecordsArgs = {
  _append?: InputMaybe<CsvRecords_Append_Input>;
  _delete_at_path?: InputMaybe<CsvRecords_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<CsvRecords_Delete_Elem_Input>;
  _delete_key?: InputMaybe<CsvRecords_Delete_Key_Input>;
  _inc?: InputMaybe<CsvRecords_Inc_Input>;
  _prepend?: InputMaybe<CsvRecords_Prepend_Input>;
  _set?: InputMaybe<CsvRecords_Set_Input>;
  where: CsvRecords_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDataAccessLogsArgs = {
  _append?: InputMaybe<DataAccessLogs_Append_Input>;
  _delete_at_path?: InputMaybe<DataAccessLogs_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<DataAccessLogs_Delete_Elem_Input>;
  _delete_key?: InputMaybe<DataAccessLogs_Delete_Key_Input>;
  _inc?: InputMaybe<DataAccessLogs_Inc_Input>;
  _prepend?: InputMaybe<DataAccessLogs_Prepend_Input>;
  _set?: InputMaybe<DataAccessLogs_Set_Input>;
  where: DataAccessLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDetectionLogsArgs = {
  _inc?: InputMaybe<DetectionLogs_Inc_Input>;
  _set?: InputMaybe<DetectionLogs_Set_Input>;
  where: DetectionLogs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDetectionSetsArgs = {
  _inc?: InputMaybe<DetectionSets_Inc_Input>;
  _set?: InputMaybe<DetectionSets_Set_Input>;
  where: DetectionSets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDetectionStatesArgs = {
  _set?: InputMaybe<Detection_States_Set_Input>;
  where: Detection_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateDetectionsArgs = {
  _append?: InputMaybe<Detections_Append_Input>;
  _delete_at_path?: InputMaybe<Detections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Detections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Detections_Delete_Key_Input>;
  _inc?: InputMaybe<Detections_Inc_Input>;
  _prepend?: InputMaybe<Detections_Prepend_Input>;
  _set?: InputMaybe<Detections_Set_Input>;
  where: Detections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEvacuationSettingsArgs = {
  _inc?: InputMaybe<EvacuationSettings_Inc_Input>;
  _set?: InputMaybe<EvacuationSettings_Set_Input>;
  where: EvacuationSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateEventsArgs = {
  _append?: InputMaybe<Events_Append_Input>;
  _delete_at_path?: InputMaybe<Events_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Events_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Events_Delete_Key_Input>;
  _inc?: InputMaybe<Events_Inc_Input>;
  _prepend?: InputMaybe<Events_Prepend_Input>;
  _set?: InputMaybe<Events_Set_Input>;
  where: Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateExecutionHistoriesArgs = {
  _inc?: InputMaybe<ExecutionHistories_Inc_Input>;
  _set?: InputMaybe<ExecutionHistories_Set_Input>;
  where: ExecutionHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateFileStatesArgs = {
  _set?: InputMaybe<File_States_Set_Input>;
  where: File_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateGroupsArgs = {
  _inc?: InputMaybe<Groups_Inc_Input>;
  _set?: InputMaybe<Groups_Set_Input>;
  where: Groups_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdpTypesArgs = {
  _set?: InputMaybe<IdpTypes_Set_Input>;
  where: IdpTypes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateIdpsArgs = {
  _append?: InputMaybe<Idps_Append_Input>;
  _delete_at_path?: InputMaybe<Idps_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Idps_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Idps_Delete_Key_Input>;
  _inc?: InputMaybe<Idps_Inc_Input>;
  _prepend?: InputMaybe<Idps_Prepend_Input>;
  _set?: InputMaybe<Idps_Set_Input>;
  where: Idps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobSettingsArgs = {
  _inc?: InputMaybe<JobSettings_Inc_Input>;
  _set?: InputMaybe<JobSettings_Set_Input>;
  where: JobSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobSiteAttributesArgs = {
  _inc?: InputMaybe<JobSiteAttributes_Inc_Input>;
  _set?: InputMaybe<JobSiteAttributes_Set_Input>;
  where: JobSiteAttributes_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateJobSitesArgs = {
  _append?: InputMaybe<JobSites_Append_Input>;
  _delete_at_path?: InputMaybe<JobSites_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<JobSites_Delete_Elem_Input>;
  _delete_key?: InputMaybe<JobSites_Delete_Key_Input>;
  _inc?: InputMaybe<JobSites_Inc_Input>;
  _prepend?: InputMaybe<JobSites_Prepend_Input>;
  _set?: InputMaybe<JobSites_Set_Input>;
  where: JobSites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateLoginLogsArgs = {
  _inc?: InputMaybe<Login_Logs_Inc_Input>;
  _set?: InputMaybe<Login_Logs_Set_Input>;
  where: Login_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateMessageFormatsArgs = {
  _append?: InputMaybe<MessageFormats_Append_Input>;
  _delete_at_path?: InputMaybe<MessageFormats_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<MessageFormats_Delete_Elem_Input>;
  _delete_key?: InputMaybe<MessageFormats_Delete_Key_Input>;
  _inc?: InputMaybe<MessageFormats_Inc_Input>;
  _prepend?: InputMaybe<MessageFormats_Prepend_Input>;
  _set?: InputMaybe<MessageFormats_Set_Input>;
  where: MessageFormats_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateMessagesArgs = {
  _append?: InputMaybe<Messages_Append_Input>;
  _delete_at_path?: InputMaybe<Messages_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Messages_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Messages_Delete_Key_Input>;
  _inc?: InputMaybe<Messages_Inc_Input>;
  _prepend?: InputMaybe<Messages_Prepend_Input>;
  _set?: InputMaybe<Messages_Set_Input>;
  where: Messages_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateMultipleDetectionsArgs = {
  _append?: InputMaybe<MultipleDetections_Append_Input>;
  _delete_at_path?: InputMaybe<MultipleDetections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<MultipleDetections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<MultipleDetections_Delete_Key_Input>;
  _inc?: InputMaybe<MultipleDetections_Inc_Input>;
  _prepend?: InputMaybe<MultipleDetections_Prepend_Input>;
  _set?: InputMaybe<MultipleDetections_Set_Input>;
  where: MultipleDetections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationConditionDetailsArgs = {
  _append?: InputMaybe<NotificationConditionDetails_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationConditionDetails_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationConditionDetails_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationConditionDetails_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationConditionDetails_Inc_Input>;
  _prepend?: InputMaybe<NotificationConditionDetails_Prepend_Input>;
  _set?: InputMaybe<NotificationConditionDetails_Set_Input>;
  where: NotificationConditionDetails_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationConditionsArgs = {
  _inc?: InputMaybe<NotificationConditions_Inc_Input>;
  _set?: InputMaybe<NotificationConditions_Set_Input>;
  where: NotificationConditions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationEventsArgs = {
  _inc?: InputMaybe<NotificationEvents_Inc_Input>;
  _set?: InputMaybe<NotificationEvents_Set_Input>;
  where: NotificationEvents_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationHistoriesArgs = {
  _append?: InputMaybe<NotificationHistories_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationHistories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationHistories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationHistories_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationHistories_Inc_Input>;
  _prepend?: InputMaybe<NotificationHistories_Prepend_Input>;
  _set?: InputMaybe<NotificationHistories_Set_Input>;
  where: NotificationHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationHistoryStatesArgs = {
  _set?: InputMaybe<Notification_History_States_Set_Input>;
  where: Notification_History_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationServicesArgs = {
  _append?: InputMaybe<NotificationServices_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationServices_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationServices_Inc_Input>;
  _prepend?: InputMaybe<NotificationServices_Prepend_Input>;
  _set?: InputMaybe<NotificationServices_Set_Input>;
  where: NotificationServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationSettingsArgs = {
  _append?: InputMaybe<NotificationSettings_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationSettings_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationSettings_Inc_Input>;
  _prepend?: InputMaybe<NotificationSettings_Prepend_Input>;
  _set?: InputMaybe<NotificationSettings_Set_Input>;
  where: NotificationSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationTargetStatesArgs = {
  _set?: InputMaybe<Notification_Target_States_Set_Input>;
  where: Notification_Target_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationTargetsArgs = {
  _inc?: InputMaybe<NotificationTargets_Inc_Input>;
  _set?: InputMaybe<NotificationTargets_Set_Input>;
  where: NotificationTargets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationTemplatesArgs = {
  _append?: InputMaybe<NotificationTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<NotificationTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<NotificationTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<NotificationTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<NotificationTemplates_Inc_Input>;
  _prepend?: InputMaybe<NotificationTemplates_Prepend_Input>;
  _set?: InputMaybe<NotificationTemplates_Set_Input>;
  where: NotificationTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationUserStatesArgs = {
  _set?: InputMaybe<Notification_User_States_Set_Input>;
  where: Notification_User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationUserTempArgs = {
  _inc?: InputMaybe<NotificationUserTemp_Inc_Input>;
  _set?: InputMaybe<NotificationUserTemp_Set_Input>;
  where: NotificationUserTemp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateNotificationUsersArgs = {
  _inc?: InputMaybe<NotificationUsers_Inc_Input>;
  _set?: InputMaybe<NotificationUsers_Set_Input>;
  where: NotificationUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePoliciesArgs = {
  id: Scalars['String'];
  object: UpdatePoliciesInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/** mutation root */
export type Mutation_RootUpdatePolicyDefineTypesArgs = {
  _set?: InputMaybe<Policy_Define_Types_Set_Input>;
  where: Policy_Define_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyDefinesArgs = {
  _append?: InputMaybe<PolicyDefines_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyDefines_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyDefines_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyDefines_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyDefines_Inc_Input>;
  _prepend?: InputMaybe<PolicyDefines_Prepend_Input>;
  _set?: InputMaybe<PolicyDefines_Set_Input>;
  where: PolicyDefines_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdatePolicyTemplatesArgs = {
  _append?: InputMaybe<PolicyTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<PolicyTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<PolicyTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<PolicyTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<PolicyTemplates_Inc_Input>;
  _prepend?: InputMaybe<PolicyTemplates_Prepend_Input>;
  _set?: InputMaybe<PolicyTemplates_Set_Input>;
  where: PolicyTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProvidersArgs = {
  _inc?: InputMaybe<Providers_Inc_Input>;
  _set?: InputMaybe<Providers_Set_Input>;
  where: Providers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateProvidersAssetsArgs = {
  _inc?: InputMaybe<ProvidersAssets_Inc_Input>;
  _set?: InputMaybe<ProvidersAssets_Set_Input>;
  where: ProvidersAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRelayApiServicesArgs = {
  _append?: InputMaybe<RelayApiServices_Append_Input>;
  _delete_at_path?: InputMaybe<RelayApiServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RelayApiServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RelayApiServices_Delete_Key_Input>;
  _inc?: InputMaybe<RelayApiServices_Inc_Input>;
  _prepend?: InputMaybe<RelayApiServices_Prepend_Input>;
  _set?: InputMaybe<RelayApiServices_Set_Input>;
  where: RelayApiServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRelayServicesArgs = {
  _append?: InputMaybe<RelayServices_Append_Input>;
  _delete_at_path?: InputMaybe<RelayServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RelayServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RelayServices_Delete_Key_Input>;
  _inc?: InputMaybe<RelayServices_Inc_Input>;
  _prepend?: InputMaybe<RelayServices_Prepend_Input>;
  _set?: InputMaybe<RelayServices_Set_Input>;
  where: RelayServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRequestSettingsArgs = {
  _append?: InputMaybe<RequestSettings_Append_Input>;
  _delete_at_path?: InputMaybe<RequestSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RequestSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RequestSettings_Delete_Key_Input>;
  _inc?: InputMaybe<RequestSettings_Inc_Input>;
  _prepend?: InputMaybe<RequestSettings_Prepend_Input>;
  _set?: InputMaybe<RequestSettings_Set_Input>;
  where: RequestSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRequestTemplateTypesArgs = {
  _set?: InputMaybe<Request_Template_Types_Set_Input>;
  where: Request_Template_Types_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRequestTemplatesArgs = {
  _append?: InputMaybe<RequestTemplates_Append_Input>;
  _delete_at_path?: InputMaybe<RequestTemplates_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<RequestTemplates_Delete_Elem_Input>;
  _delete_key?: InputMaybe<RequestTemplates_Delete_Key_Input>;
  _inc?: InputMaybe<RequestTemplates_Inc_Input>;
  _prepend?: InputMaybe<RequestTemplates_Prepend_Input>;
  _set?: InputMaybe<RequestTemplates_Set_Input>;
  where: RequestTemplates_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateRest2graphqlSettingsArgs = {
  _append?: InputMaybe<Rest2graphqlSettings_Append_Input>;
  _delete_at_path?: InputMaybe<Rest2graphqlSettings_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Rest2graphqlSettings_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Rest2graphqlSettings_Delete_Key_Input>;
  _inc?: InputMaybe<Rest2graphqlSettings_Inc_Input>;
  _prepend?: InputMaybe<Rest2graphqlSettings_Prepend_Input>;
  _set?: InputMaybe<Rest2graphqlSettings_Set_Input>;
  where: Rest2graphqlSettings_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSchedulesArgs = {
  _inc?: InputMaybe<Schedules_Inc_Input>;
  _set?: InputMaybe<Schedules_Set_Input>;
  where: Schedules_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationArgs = {
  _inc?: InputMaybe<SensitiveInformation_Inc_Input>;
  _set?: InputMaybe<SensitiveInformation_Set_Input>;
  where: SensitiveInformation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationCategoriesArgs = {
  _inc?: InputMaybe<SensitiveInformationCategories_Inc_Input>;
  _set?: InputMaybe<SensitiveInformationCategories_Set_Input>;
  where: SensitiveInformationCategories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationHistoriesArgs = {
  _append?: InputMaybe<SensitiveInformationHistories_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationHistories_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationHistories_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationHistories_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationHistories_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationHistories_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationHistories_Set_Input>;
  where: SensitiveInformationHistories_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationItemsArgs = {
  _inc?: InputMaybe<SensitiveInformationItems_Inc_Input>;
  _set?: InputMaybe<SensitiveInformationItems_Set_Input>;
  where: SensitiveInformationItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationRequestServicesArgs = {
  _append?: InputMaybe<SensitiveInformationRequestServices_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationRequestServices_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationRequestServices_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationRequestServices_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationRequestServices_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationRequestServices_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationRequestServices_Set_Input>;
  where: SensitiveInformationRequestServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateSensitiveInformationStoreServiceConnectionsArgs = {
  _append?: InputMaybe<SensitiveInformationStoreServiceConnections_Append_Input>;
  _delete_at_path?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Elem_Input>;
  _delete_key?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Key_Input>;
  _inc?: InputMaybe<SensitiveInformationStoreServiceConnections_Inc_Input>;
  _prepend?: InputMaybe<SensitiveInformationStoreServiceConnections_Prepend_Input>;
  _set?: InputMaybe<SensitiveInformationStoreServiceConnections_Set_Input>;
  where: SensitiveInformationStoreServiceConnections_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateServicesArgs = {
  _inc?: InputMaybe<Services_Inc_Input>;
  _set?: InputMaybe<Services_Set_Input>;
  where: Services_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateStoreSensitiveInformationItemsArgs = {
  _inc?: InputMaybe<StoreSensitiveInformationItems_Inc_Input>;
  _set?: InputMaybe<StoreSensitiveInformationItems_Set_Input>;
  where: StoreSensitiveInformationItems_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTenantPublicInfoArgs = {
  _set: UpdateTenantPublicInfoInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<TenantPublicInfoWhereInput>;
};


/** mutation root */
export type Mutation_RootUpdateTenantServicesArgs = {
  _inc?: InputMaybe<TenantServices_Inc_Input>;
  _set?: InputMaybe<TenantServices_Set_Input>;
  where: TenantServices_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTenantsArgs = {
  _append?: InputMaybe<Tenants_Append_Input>;
  _delete_at_path?: InputMaybe<Tenants_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Tenants_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Tenants_Delete_Key_Input>;
  _inc?: InputMaybe<Tenants_Inc_Input>;
  _prepend?: InputMaybe<Tenants_Prepend_Input>;
  _set?: InputMaybe<Tenants_Set_Input>;
  where: Tenants_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateTenantsIdpsArgs = {
  _inc?: InputMaybe<TenantsIdps_Inc_Input>;
  _set?: InputMaybe<TenantsIdps_Set_Input>;
  where: TenantsIdps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUploadFilesArgs = {
  _append?: InputMaybe<UploadFiles_Append_Input>;
  _delete_at_path?: InputMaybe<UploadFiles_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<UploadFiles_Delete_Elem_Input>;
  _delete_key?: InputMaybe<UploadFiles_Delete_Key_Input>;
  _inc?: InputMaybe<UploadFiles_Inc_Input>;
  _prepend?: InputMaybe<UploadFiles_Prepend_Input>;
  _set?: InputMaybe<UploadFiles_Set_Input>;
  where: UploadFiles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserPoliciesArgs = {
  _append?: InputMaybe<UserPolicies_Append_Input>;
  _delete_at_path?: InputMaybe<UserPolicies_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<UserPolicies_Delete_Elem_Input>;
  _delete_key?: InputMaybe<UserPolicies_Delete_Key_Input>;
  _inc?: InputMaybe<UserPolicies_Inc_Input>;
  _prepend?: InputMaybe<UserPolicies_Prepend_Input>;
  _set?: InputMaybe<UserPolicies_Set_Input>;
  where: UserPolicies_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserRolesArgs = {
  _set?: InputMaybe<User_Roles_Set_Input>;
  where: User_Roles_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUserStatesArgs = {
  _set?: InputMaybe<User_States_Set_Input>;
  where: User_States_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  id: Scalars['String'];
  object: UpdateUsersInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


/** mutation root */
export type Mutation_RootUpdateUsersAssetsArgs = {
  _inc?: InputMaybe<UsersAssets_Inc_Input>;
  _set?: InputMaybe<UsersAssets_Set_Input>;
  where: UsersAssets_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUsersExternalUsersArgs = {
  _inc?: InputMaybe<UsersExternalUsers_Inc_Input>;
  _set?: InputMaybe<UsersExternalUsers_Set_Input>;
  where: UsersExternalUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUsersGroupsArgs = {
  groupId: Scalars['String'];
  object: UpdateUsersGroupsInput;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  userId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootUpdateUsersIdpsArgs = {
  _inc?: InputMaybe<UsersIdps_Inc_Input>;
  _set?: InputMaybe<UsersIdps_Set_Input>;
  where: UsersIdps_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdateUsersUsersArgs = {
  _inc?: InputMaybe<UsersUsers_Inc_Input>;
  _set?: InputMaybe<UsersUsers_Set_Input>;
  where: UsersUsers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_AccessLogs_ManyArgs = {
  updates: Array<AccessLogs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetImages_ManyArgs = {
  updates: Array<AssetImages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetProperties_ManyArgs = {
  updates: Array<AssetProperties_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetTags_ManyArgs = {
  updates: Array<AssetTags_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetTypes_ManyArgs = {
  updates: Array<AssetTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Asset_States_ManyArgs = {
  updates: Array<Asset_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AssetsAssets_ManyArgs = {
  updates: Array<AssetsAssets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Assets_ManyArgs = {
  updates: Array<Assets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AuthorizationInfo_ManyArgs = {
  updates: Array<AuthorizationInfo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Categories_ManyArgs = {
  updates: Array<Categories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ClientTypes_ManyArgs = {
  updates: Array<ClientTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Consents_ManyArgs = {
  updates: Array<Consents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CsvRecords_ManyArgs = {
  updates: Array<CsvRecords_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DataAccessLogs_ManyArgs = {
  updates: Array<DataAccessLogs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DetectionLogs_ManyArgs = {
  updates: Array<DetectionLogs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_DetectionSets_ManyArgs = {
  updates: Array<DetectionSets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Detection_States_ManyArgs = {
  updates: Array<Detection_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Detections_ManyArgs = {
  updates: Array<Detections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_EvacuationSettings_ManyArgs = {
  updates: Array<EvacuationSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Events_ManyArgs = {
  updates: Array<Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ExecutionHistories_ManyArgs = {
  updates: Array<ExecutionHistories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_File_States_ManyArgs = {
  updates: Array<File_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Groups_ManyArgs = {
  updates: Array<Groups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdpTypes_ManyArgs = {
  updates: Array<IdpTypes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Idps_ManyArgs = {
  updates: Array<Idps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobSettings_ManyArgs = {
  updates: Array<JobSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobSiteAttributes_ManyArgs = {
  updates: Array<JobSiteAttributes_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_JobSites_ManyArgs = {
  updates: Array<JobSites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Login_Logs_ManyArgs = {
  updates: Array<Login_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MessageFormats_ManyArgs = {
  updates: Array<MessageFormats_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Messages_ManyArgs = {
  updates: Array<Messages_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_MultipleDetections_ManyArgs = {
  updates: Array<MultipleDetections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationConditionDetails_ManyArgs = {
  updates: Array<NotificationConditionDetails_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationConditions_ManyArgs = {
  updates: Array<NotificationConditions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationEvents_ManyArgs = {
  updates: Array<NotificationEvents_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationHistories_ManyArgs = {
  updates: Array<NotificationHistories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationServices_ManyArgs = {
  updates: Array<NotificationServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationSettings_ManyArgs = {
  updates: Array<NotificationSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationTargets_ManyArgs = {
  updates: Array<NotificationTargets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationTemplates_ManyArgs = {
  updates: Array<NotificationTemplates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationUserTemp_ManyArgs = {
  updates: Array<NotificationUserTemp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_NotificationUsers_ManyArgs = {
  updates: Array<NotificationUsers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_History_States_ManyArgs = {
  updates: Array<Notification_History_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_Target_States_ManyArgs = {
  updates: Array<Notification_Target_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Notification_User_States_ManyArgs = {
  updates: Array<Notification_User_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Policies_ManyArgs = {
  updates: Array<Policies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PolicyDefines_ManyArgs = {
  updates: Array<PolicyDefines_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_PolicyTemplates_ManyArgs = {
  updates: Array<PolicyTemplates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Policy_Define_Types_ManyArgs = {
  updates: Array<Policy_Define_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProvidersAssets_ManyArgs = {
  updates: Array<ProvidersAssets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Providers_ManyArgs = {
  updates: Array<Providers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RelayApiServices_ManyArgs = {
  updates: Array<RelayApiServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RelayServices_ManyArgs = {
  updates: Array<RelayServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RequestSettings_ManyArgs = {
  updates: Array<RequestSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RequestTemplates_ManyArgs = {
  updates: Array<RequestTemplates_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Request_Template_Types_ManyArgs = {
  updates: Array<Request_Template_Types_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Rest2graphqlSettings_ManyArgs = {
  updates: Array<Rest2graphqlSettings_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Schedules_ManyArgs = {
  updates: Array<Schedules_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformationCategories_ManyArgs = {
  updates: Array<SensitiveInformationCategories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformationHistories_ManyArgs = {
  updates: Array<SensitiveInformationHistories_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformationItems_ManyArgs = {
  updates: Array<SensitiveInformationItems_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformationRequestServices_ManyArgs = {
  updates: Array<SensitiveInformationRequestServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformationStoreServiceConnections_ManyArgs = {
  updates: Array<SensitiveInformationStoreServiceConnections_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SensitiveInformation_ManyArgs = {
  updates: Array<SensitiveInformation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Services_ManyArgs = {
  updates: Array<Services_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_StoreSensitiveInformationItems_ManyArgs = {
  updates: Array<StoreSensitiveInformationItems_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantPublicInfo_ManyArgs = {
  updates: Array<TenantPublicInfo_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantServices_ManyArgs = {
  updates: Array<TenantServices_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_TenantsIdps_ManyArgs = {
  updates: Array<TenantsIdps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tenants_ManyArgs = {
  updates: Array<Tenants_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UploadFiles_ManyArgs = {
  updates: Array<UploadFiles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UserPolicies_ManyArgs = {
  updates: Array<UserPolicies_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Roles_ManyArgs = {
  updates: Array<User_Roles_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_States_ManyArgs = {
  updates: Array<User_States_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersAssets_ManyArgs = {
  updates: Array<UsersAssets_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersExternalUsers_ManyArgs = {
  updates: Array<UsersExternalUsers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersGroups_ManyArgs = {
  updates: Array<UsersGroups_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersIdps_ManyArgs = {
  updates: Array<UsersIdps_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_UsersUsers_ManyArgs = {
  updates: Array<UsersUsers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Users_ManyArgs = {
  updates: Array<Users_Updates>;
};


/** mutation root */
export type Mutation_RootUsersAssetArgs = {
  id: Scalars['String'];
};

/** columns and relationships of "notification_condition_details" */
export type NotificationConditionDetails = {
  __typename?: 'notificationConditionDetails';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationConditionId: Scalars['String'];
  /** An object relationship */
  notificationConditions?: Maybe<NotificationConditions>;
  owner?: Maybe<Scalars['String']>;
  settings: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_condition_details" */
export type NotificationConditionDetailsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_condition_details" */
export type NotificationConditionDetails_Aggregate = {
  __typename?: 'notificationConditionDetails_aggregate';
  aggregate?: Maybe<NotificationConditionDetails_Aggregate_Fields>;
  nodes: Array<NotificationConditionDetails>;
};

export type NotificationConditionDetails_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationConditionDetails_Aggregate_Bool_Exp_Count>;
};

export type NotificationConditionDetails_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_condition_details" */
export type NotificationConditionDetails_Aggregate_Fields = {
  __typename?: 'notificationConditionDetails_aggregate_fields';
  avg?: Maybe<NotificationConditionDetails_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationConditionDetails_Max_Fields>;
  min?: Maybe<NotificationConditionDetails_Min_Fields>;
  stddev?: Maybe<NotificationConditionDetails_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationConditionDetails_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationConditionDetails_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationConditionDetails_Sum_Fields>;
  var_pop?: Maybe<NotificationConditionDetails_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationConditionDetails_Var_Samp_Fields>;
  variance?: Maybe<NotificationConditionDetails_Variance_Fields>;
};


/** aggregate fields of "notification_condition_details" */
export type NotificationConditionDetails_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_condition_details" */
export type NotificationConditionDetails_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationConditionDetails_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationConditionDetails_Max_Order_By>;
  min?: InputMaybe<NotificationConditionDetails_Min_Order_By>;
  stddev?: InputMaybe<NotificationConditionDetails_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationConditionDetails_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationConditionDetails_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationConditionDetails_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationConditionDetails_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationConditionDetails_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationConditionDetails_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationConditionDetails_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "notification_condition_details" */
export type NotificationConditionDetails_Arr_Rel_Insert_Input = {
  data: Array<NotificationConditionDetails_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationConditionDetails_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationConditionDetails_Avg_Fields = {
  __typename?: 'notificationConditionDetails_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_condition_details". All fields are combined with a logical 'AND'. */
export type NotificationConditionDetails_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationConditionDetails_Bool_Exp>>;
  _not?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationConditionDetails_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationConditionId?: InputMaybe<String_Comparison_Exp>;
  notificationConditions?: InputMaybe<NotificationConditions_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_condition_details" */
export enum NotificationConditionDetails_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationConditionDetailsPkey = 'notification_condition_details_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationConditionDetails_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationConditionDetails_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationConditionDetails_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_condition_details" */
export type NotificationConditionDetails_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_condition_details" */
export type NotificationConditionDetails_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  notificationConditions?: InputMaybe<NotificationConditions_Obj_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationConditionDetails_Max_Fields = {
  __typename?: 'notificationConditionDetails_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationConditionDetails_Min_Fields = {
  __typename?: 'notificationConditionDetails_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_condition_details" */
export type NotificationConditionDetails_Mutation_Response = {
  __typename?: 'notificationConditionDetails_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationConditionDetails>;
};

/** on_conflict condition type for table "notification_condition_details" */
export type NotificationConditionDetails_On_Conflict = {
  constraint: NotificationConditionDetails_Constraint;
  update_columns?: Array<NotificationConditionDetails_Update_Column>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_condition_details". */
export type NotificationConditionDetails_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  notificationConditions?: InputMaybe<NotificationConditions_Order_By>;
  owner?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_condition_details */
export type NotificationConditionDetails_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationConditionDetails_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_condition_details" */
export enum NotificationConditionDetails_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  Owner = 'owner',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_condition_details" */
export type NotificationConditionDetails_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationConditionDetails_Stddev_Fields = {
  __typename?: 'notificationConditionDetails_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationConditionDetails_Stddev_Pop_Fields = {
  __typename?: 'notificationConditionDetails_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationConditionDetails_Stddev_Samp_Fields = {
  __typename?: 'notificationConditionDetails_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationConditionDetails" */
export type NotificationConditionDetails_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationConditionDetails_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationConditionDetails_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationConditionDetails_Sum_Fields = {
  __typename?: 'notificationConditionDetails_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_condition_details" */
export enum NotificationConditionDetails_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  Owner = 'owner',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationConditionDetails_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationConditionDetails_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationConditionDetails_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationConditionDetails_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationConditionDetails_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationConditionDetails_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationConditionDetails_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationConditionDetails_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationConditionDetails_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationConditionDetails_Var_Pop_Fields = {
  __typename?: 'notificationConditionDetails_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationConditionDetails_Var_Samp_Fields = {
  __typename?: 'notificationConditionDetails_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationConditionDetails_Variance_Fields = {
  __typename?: 'notificationConditionDetails_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_condition_details" */
export type NotificationConditionDetails_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_conditions" */
export type NotificationConditions = {
  __typename?: 'notificationConditions';
  assetId: Scalars['String'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  notificationConditionDetails: Array<NotificationConditionDetails>;
  /** An aggregate relationship */
  notificationConditionDetails_aggregate: NotificationConditionDetails_Aggregate;
  /** An array relationship */
  notificationConditionsEvents: Array<NotificationEvents>;
  /** An aggregate relationship */
  notificationConditionsEvents_aggregate: NotificationEvents_Aggregate;
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_conditions" */
export type NotificationConditionsNotificationConditionDetailsArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


/** columns and relationships of "notification_conditions" */
export type NotificationConditionsNotificationConditionDetails_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


/** columns and relationships of "notification_conditions" */
export type NotificationConditionsNotificationConditionsEventsArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


/** columns and relationships of "notification_conditions" */
export type NotificationConditionsNotificationConditionsEvents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};

export type NotificationConditionsAggregateNativeModel = {
  __typename?: 'notificationConditionsAggregateNativeModel';
  conditionId: Scalars['String'];
  conditionName: Scalars['String'];
  eventTime?: Maybe<Scalars['bigint']>;
  notificationCount: Scalars['bigint'];
  notificationTime?: Maybe<Scalars['bigint']>;
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "notificationConditionsAggregateNativeModel". All fields are combined with a logical 'AND'. */
export type NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  conditionId?: InputMaybe<String_Comparison_Exp>;
  conditionName?: InputMaybe<String_Comparison_Exp>;
  eventTime?: InputMaybe<Bigint_Comparison_Exp>;
  notificationCount?: InputMaybe<Bigint_Comparison_Exp>;
  notificationTime?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tenantName?: InputMaybe<String_Comparison_Exp>;
};

export enum NotificationConditionsAggregateNativeModel_Enum_Name {
  /** column name */
  ConditionId = 'conditionId',
  /** column name */
  ConditionName = 'conditionName',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  NotificationCount = 'notificationCount',
  /** column name */
  NotificationTime = 'notificationTime',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantName = 'tenantName'
}

/** Ordering options when selecting data from "notificationConditionsAggregateNativeModel". */
export type NotificationConditionsAggregateNativeModel_Order_By = {
  conditionId?: InputMaybe<Order_By>;
  conditionName?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  notificationCount?: InputMaybe<Order_By>;
  notificationTime?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tenantName?: InputMaybe<Order_By>;
};

/** notificationConditionsAggregateNativeNative Query Arguments */
export type NotificationConditionsAggregateNative_Arguments = {
  /** 抽出期間FROM */
  periodFrom: Scalars['bigint'];
  /** 抽出期間TO */
  periodTo: Scalars['bigint'];
  /** テナントID */
  tenantId?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_conditions" */
export type NotificationConditions_Aggregate = {
  __typename?: 'notificationConditions_aggregate';
  aggregate?: Maybe<NotificationConditions_Aggregate_Fields>;
  nodes: Array<NotificationConditions>;
};

/** aggregate fields of "notification_conditions" */
export type NotificationConditions_Aggregate_Fields = {
  __typename?: 'notificationConditions_aggregate_fields';
  avg?: Maybe<NotificationConditions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationConditions_Max_Fields>;
  min?: Maybe<NotificationConditions_Min_Fields>;
  stddev?: Maybe<NotificationConditions_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationConditions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationConditions_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationConditions_Sum_Fields>;
  var_pop?: Maybe<NotificationConditions_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationConditions_Var_Samp_Fields>;
  variance?: Maybe<NotificationConditions_Variance_Fields>;
};


/** aggregate fields of "notification_conditions" */
export type NotificationConditions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationConditions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NotificationConditions_Avg_Fields = {
  __typename?: 'notificationConditions_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_conditions". All fields are combined with a logical 'AND'. */
export type NotificationConditions_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationConditions_Bool_Exp>>;
  _not?: InputMaybe<NotificationConditions_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationConditions_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationConditionDetails?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
  notificationConditionDetails_aggregate?: InputMaybe<NotificationConditionDetails_Aggregate_Bool_Exp>;
  notificationConditionsEvents?: InputMaybe<NotificationEvents_Bool_Exp>;
  notificationConditionsEvents_aggregate?: InputMaybe<NotificationEvents_Aggregate_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_conditions" */
export enum NotificationConditions_Constraint {
  /** unique or primary key constraint on columns "asset_id" */
  NotificationConditionsAssetIdIdx = 'notification_conditions_asset_id_idx',
  /** unique or primary key constraint on columns "id" */
  NotificationConditionsPkey = 'notification_conditions_pkey'
}

/** input type for incrementing numeric columns in table "notification_conditions" */
export type NotificationConditions_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_conditions" */
export type NotificationConditions_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationConditionDetails?: InputMaybe<NotificationConditionDetails_Arr_Rel_Insert_Input>;
  notificationConditionsEvents?: InputMaybe<NotificationEvents_Arr_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationConditions_Max_Fields = {
  __typename?: 'notificationConditions_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type NotificationConditions_Min_Fields = {
  __typename?: 'notificationConditions_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "notification_conditions" */
export type NotificationConditions_Mutation_Response = {
  __typename?: 'notificationConditions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationConditions>;
};

/** input type for inserting object relation for remote table "notification_conditions" */
export type NotificationConditions_Obj_Rel_Insert_Input = {
  data: NotificationConditions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationConditions_On_Conflict>;
};

/** on_conflict condition type for table "notification_conditions" */
export type NotificationConditions_On_Conflict = {
  constraint: NotificationConditions_Constraint;
  update_columns?: Array<NotificationConditions_Update_Column>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_conditions". */
export type NotificationConditions_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationConditionDetails_aggregate?: InputMaybe<NotificationConditionDetails_Aggregate_Order_By>;
  notificationConditionsEvents_aggregate?: InputMaybe<NotificationEvents_Aggregate_Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_conditions */
export type NotificationConditions_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "notification_conditions" */
export enum NotificationConditions_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_conditions" */
export type NotificationConditions_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationConditions_Stddev_Fields = {
  __typename?: 'notificationConditions_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationConditions_Stddev_Pop_Fields = {
  __typename?: 'notificationConditions_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationConditions_Stddev_Samp_Fields = {
  __typename?: 'notificationConditions_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notificationConditions" */
export type NotificationConditions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationConditions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationConditions_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationConditions_Sum_Fields = {
  __typename?: 'notificationConditions_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notification_conditions" */
export enum NotificationConditions_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationConditions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationConditions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationConditions_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationConditions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationConditions_Var_Pop_Fields = {
  __typename?: 'notificationConditions_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationConditions_Var_Samp_Fields = {
  __typename?: 'notificationConditions_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationConditions_Variance_Fields = {
  __typename?: 'notificationConditions_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type NotificationCountAggregateNativeModel = {
  __typename?: 'notificationCountAggregateNativeModel';
  dateTotal: Scalars['bigint'];
  periodTotal: Scalars['bigint'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "notificationCountAggregateNativeModel". All fields are combined with a logical 'AND'. */
export type NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  dateTotal?: InputMaybe<Bigint_Comparison_Exp>;
  periodTotal?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tenantName?: InputMaybe<String_Comparison_Exp>;
};

export enum NotificationCountAggregateNativeModel_Enum_Name {
  /** column name */
  DateTotal = 'dateTotal',
  /** column name */
  PeriodTotal = 'periodTotal',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantName = 'tenantName'
}

/** Ordering options when selecting data from "notificationCountAggregateNativeModel". */
export type NotificationCountAggregateNativeModel_Order_By = {
  dateTotal?: InputMaybe<Order_By>;
  periodTotal?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tenantName?: InputMaybe<Order_By>;
};

/** notificationCountAggregateNativeNative Query Arguments */
export type NotificationCountAggregateNative_Arguments = {
  /** 抽出期間FROM */
  periodFrom: Scalars['bigint'];
  /** 抽出期間TO */
  periodTo: Scalars['bigint'];
  /** テナントID */
  tenantId?: InputMaybe<Scalars['String']>;
  /** 集計対象日(抽出期間内) */
  tergetDate: Scalars['bigint'];
};

/** columns and relationships of "notification_events" */
export type NotificationEvents = {
  __typename?: 'notificationEvents';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationConditionId: Scalars['String'];
  /** An object relationship */
  notificationConditions?: Maybe<NotificationConditions>;
  /** An array relationship */
  notificationEventsHistories: Array<NotificationHistories>;
  /** An aggregate relationship */
  notificationEventsHistories_aggregate: NotificationHistories_Aggregate;
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_events" */
export type NotificationEventsNotificationEventsHistoriesArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


/** columns and relationships of "notification_events" */
export type NotificationEventsNotificationEventsHistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};

/** aggregated selection of "notification_events" */
export type NotificationEvents_Aggregate = {
  __typename?: 'notificationEvents_aggregate';
  aggregate?: Maybe<NotificationEvents_Aggregate_Fields>;
  nodes: Array<NotificationEvents>;
};

export type NotificationEvents_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationEvents_Aggregate_Bool_Exp_Count>;
};

export type NotificationEvents_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationEvents_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_events" */
export type NotificationEvents_Aggregate_Fields = {
  __typename?: 'notificationEvents_aggregate_fields';
  avg?: Maybe<NotificationEvents_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationEvents_Max_Fields>;
  min?: Maybe<NotificationEvents_Min_Fields>;
  stddev?: Maybe<NotificationEvents_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationEvents_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationEvents_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationEvents_Sum_Fields>;
  var_pop?: Maybe<NotificationEvents_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationEvents_Var_Samp_Fields>;
  variance?: Maybe<NotificationEvents_Variance_Fields>;
};


/** aggregate fields of "notification_events" */
export type NotificationEvents_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_events" */
export type NotificationEvents_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationEvents_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationEvents_Max_Order_By>;
  min?: InputMaybe<NotificationEvents_Min_Order_By>;
  stddev?: InputMaybe<NotificationEvents_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationEvents_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationEvents_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationEvents_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationEvents_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationEvents_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationEvents_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_events" */
export type NotificationEvents_Arr_Rel_Insert_Input = {
  data: Array<NotificationEvents_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationEvents_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationEvents_Avg_Fields = {
  __typename?: 'notificationEvents_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_events" */
export type NotificationEvents_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_events". All fields are combined with a logical 'AND'. */
export type NotificationEvents_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationEvents_Bool_Exp>>;
  _not?: InputMaybe<NotificationEvents_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationEvents_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  eventTime?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationConditionId?: InputMaybe<String_Comparison_Exp>;
  notificationConditions?: InputMaybe<NotificationConditions_Bool_Exp>;
  notificationEventsHistories?: InputMaybe<NotificationHistories_Bool_Exp>;
  notificationEventsHistories_aggregate?: InputMaybe<NotificationHistories_Aggregate_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_events" */
export enum NotificationEvents_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationEventsPkey = 'notification_events_pkey'
}

/** input type for incrementing numeric columns in table "notification_events" */
export type NotificationEvents_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_events" */
export type NotificationEvents_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  notificationConditions?: InputMaybe<NotificationConditions_Obj_Rel_Insert_Input>;
  notificationEventsHistories?: InputMaybe<NotificationHistories_Arr_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationEvents_Max_Fields = {
  __typename?: 'notificationEvents_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "notification_events" */
export type NotificationEvents_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationEvents_Min_Fields = {
  __typename?: 'notificationEvents_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "notification_events" */
export type NotificationEvents_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_events" */
export type NotificationEvents_Mutation_Response = {
  __typename?: 'notificationEvents_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationEvents>;
};

/** input type for inserting object relation for remote table "notification_events" */
export type NotificationEvents_Obj_Rel_Insert_Input = {
  data: NotificationEvents_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationEvents_On_Conflict>;
};

/** on_conflict condition type for table "notification_events" */
export type NotificationEvents_On_Conflict = {
  constraint: NotificationEvents_Constraint;
  update_columns?: Array<NotificationEvents_Update_Column>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_events". */
export type NotificationEvents_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  notificationConditions?: InputMaybe<NotificationConditions_Order_By>;
  notificationEventsHistories_aggregate?: InputMaybe<NotificationHistories_Aggregate_Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_events */
export type NotificationEvents_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "notification_events" */
export enum NotificationEvents_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_events" */
export type NotificationEvents_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationEvents_Stddev_Fields = {
  __typename?: 'notificationEvents_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_events" */
export type NotificationEvents_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationEvents_Stddev_Pop_Fields = {
  __typename?: 'notificationEvents_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_events" */
export type NotificationEvents_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationEvents_Stddev_Samp_Fields = {
  __typename?: 'notificationEvents_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_events" */
export type NotificationEvents_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationEvents" */
export type NotificationEvents_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationEvents_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationEvents_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  eventTime?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationEvents_Sum_Fields = {
  __typename?: 'notificationEvents_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  eventTime?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_events" */
export type NotificationEvents_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_events" */
export enum NotificationEvents_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  EventTime = 'eventTime',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationEvents_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationEvents_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationEvents_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationEvents_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationEvents_Var_Pop_Fields = {
  __typename?: 'notificationEvents_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_events" */
export type NotificationEvents_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationEvents_Var_Samp_Fields = {
  __typename?: 'notificationEvents_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_events" */
export type NotificationEvents_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationEvents_Variance_Fields = {
  __typename?: 'notificationEvents_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  eventTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_events" */
export type NotificationEvents_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  eventTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_histories" */
export type NotificationHistories = {
  __typename?: 'notificationHistories';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  message: Scalars['jsonb'];
  notificationEventId: Scalars['String'];
  /** An object relationship */
  notificationEvents?: Maybe<NotificationEvents>;
  notificationUserId: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  sentTime?: Maybe<Scalars['bigint']>;
  startTime: Scalars['bigint'];
  state: Notification_History_States_Enum;
  takenTime?: Maybe<Scalars['Int']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_histories" */
export type NotificationHistoriesMessageArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_histories" */
export type NotificationHistories_Aggregate = {
  __typename?: 'notificationHistories_aggregate';
  aggregate?: Maybe<NotificationHistories_Aggregate_Fields>;
  nodes: Array<NotificationHistories>;
};

export type NotificationHistories_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationHistories_Aggregate_Bool_Exp_Count>;
};

export type NotificationHistories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationHistories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_histories" */
export type NotificationHistories_Aggregate_Fields = {
  __typename?: 'notificationHistories_aggregate_fields';
  avg?: Maybe<NotificationHistories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationHistories_Max_Fields>;
  min?: Maybe<NotificationHistories_Min_Fields>;
  stddev?: Maybe<NotificationHistories_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationHistories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationHistories_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationHistories_Sum_Fields>;
  var_pop?: Maybe<NotificationHistories_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationHistories_Var_Samp_Fields>;
  variance?: Maybe<NotificationHistories_Variance_Fields>;
};


/** aggregate fields of "notification_histories" */
export type NotificationHistories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_histories" */
export type NotificationHistories_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationHistories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationHistories_Max_Order_By>;
  min?: InputMaybe<NotificationHistories_Min_Order_By>;
  stddev?: InputMaybe<NotificationHistories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationHistories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationHistories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationHistories_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationHistories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationHistories_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationHistories_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationHistories_Append_Input = {
  message?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "notification_histories" */
export type NotificationHistories_Arr_Rel_Insert_Input = {
  data: Array<NotificationHistories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationHistories_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationHistories_Avg_Fields = {
  __typename?: 'notificationHistories_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_histories" */
export type NotificationHistories_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_histories". All fields are combined with a logical 'AND'. */
export type NotificationHistories_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationHistories_Bool_Exp>>;
  _not?: InputMaybe<NotificationHistories_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationHistories_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<Jsonb_Comparison_Exp>;
  notificationEventId?: InputMaybe<String_Comparison_Exp>;
  notificationEvents?: InputMaybe<NotificationEvents_Bool_Exp>;
  notificationUserId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  sentTime?: InputMaybe<Bigint_Comparison_Exp>;
  startTime?: InputMaybe<Bigint_Comparison_Exp>;
  state?: InputMaybe<Notification_History_States_Enum_Comparison_Exp>;
  takenTime?: InputMaybe<Int_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_histories" */
export enum NotificationHistories_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationHistoriesPkey = 'notification_histories_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationHistories_Delete_At_Path_Input = {
  message?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationHistories_Delete_Elem_Input = {
  message?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationHistories_Delete_Key_Input = {
  message?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_histories" */
export type NotificationHistories_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  sentTime?: InputMaybe<Scalars['bigint']>;
  startTime?: InputMaybe<Scalars['bigint']>;
  takenTime?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_histories" */
export type NotificationHistories_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['jsonb']>;
  notificationEventId?: InputMaybe<Scalars['String']>;
  notificationEvents?: InputMaybe<NotificationEvents_Obj_Rel_Insert_Input>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sentTime?: InputMaybe<Scalars['bigint']>;
  startTime?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Notification_History_States_Enum>;
  takenTime?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationHistories_Max_Fields = {
  __typename?: 'notificationHistories_max_fields';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationEventId?: Maybe<Scalars['String']>;
  notificationUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  sentTime?: Maybe<Scalars['bigint']>;
  startTime?: Maybe<Scalars['bigint']>;
  takenTime?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "notification_histories" */
export type NotificationHistories_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationEventId?: InputMaybe<Order_By>;
  notificationUserId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationHistories_Min_Fields = {
  __typename?: 'notificationHistories_min_fields';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationEventId?: Maybe<Scalars['String']>;
  notificationUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  sentTime?: Maybe<Scalars['bigint']>;
  startTime?: Maybe<Scalars['bigint']>;
  takenTime?: Maybe<Scalars['Int']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "notification_histories" */
export type NotificationHistories_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationEventId?: InputMaybe<Order_By>;
  notificationUserId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_histories" */
export type NotificationHistories_Mutation_Response = {
  __typename?: 'notificationHistories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationHistories>;
};

/** on_conflict condition type for table "notification_histories" */
export type NotificationHistories_On_Conflict = {
  constraint: NotificationHistories_Constraint;
  update_columns?: Array<NotificationHistories_Update_Column>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_histories". */
export type NotificationHistories_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  notificationEventId?: InputMaybe<Order_By>;
  notificationEvents?: InputMaybe<NotificationEvents_Order_By>;
  notificationUserId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_histories */
export type NotificationHistories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationHistories_Prepend_Input = {
  message?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_histories" */
export enum NotificationHistories_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NotificationEventId = 'notificationEventId',
  /** column name */
  NotificationUserId = 'notificationUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  SentTime = 'sentTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  TakenTime = 'takenTime',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_histories" */
export type NotificationHistories_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['jsonb']>;
  notificationEventId?: InputMaybe<Scalars['String']>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sentTime?: InputMaybe<Scalars['bigint']>;
  startTime?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Notification_History_States_Enum>;
  takenTime?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationHistories_Stddev_Fields = {
  __typename?: 'notificationHistories_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_histories" */
export type NotificationHistories_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationHistories_Stddev_Pop_Fields = {
  __typename?: 'notificationHistories_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_histories" */
export type NotificationHistories_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationHistories_Stddev_Samp_Fields = {
  __typename?: 'notificationHistories_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_histories" */
export type NotificationHistories_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationHistories" */
export type NotificationHistories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationHistories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationHistories_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['jsonb']>;
  notificationEventId?: InputMaybe<Scalars['String']>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sentTime?: InputMaybe<Scalars['bigint']>;
  startTime?: InputMaybe<Scalars['bigint']>;
  state?: InputMaybe<Notification_History_States_Enum>;
  takenTime?: InputMaybe<Scalars['Int']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationHistories_Sum_Fields = {
  __typename?: 'notificationHistories_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  sentTime?: Maybe<Scalars['bigint']>;
  startTime?: Maybe<Scalars['bigint']>;
  takenTime?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_histories" */
export type NotificationHistories_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_histories" */
export enum NotificationHistories_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NotificationEventId = 'notificationEventId',
  /** column name */
  NotificationUserId = 'notificationUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  SentTime = 'sentTime',
  /** column name */
  StartTime = 'startTime',
  /** column name */
  State = 'state',
  /** column name */
  TakenTime = 'takenTime',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationHistories_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationHistories_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationHistories_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationHistories_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationHistories_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationHistories_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationHistories_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationHistories_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationHistories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationHistories_Var_Pop_Fields = {
  __typename?: 'notificationHistories_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_histories" */
export type NotificationHistories_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationHistories_Var_Samp_Fields = {
  __typename?: 'notificationHistories_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_histories" */
export type NotificationHistories_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationHistories_Variance_Fields = {
  __typename?: 'notificationHistories_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  sentTime?: Maybe<Scalars['Float']>;
  startTime?: Maybe<Scalars['Float']>;
  takenTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_histories" */
export type NotificationHistories_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  sentTime?: InputMaybe<Order_By>;
  startTime?: InputMaybe<Order_By>;
  takenTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_services" */
export type NotificationServices = {
  __typename?: 'notificationServices';
  apiUrls: Scalars['jsonb'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  /** An array relationship */
  notificationSettings: Array<NotificationSettings>;
  /** An aggregate relationship */
  notificationSettings_aggregate: NotificationSettings_Aggregate;
  owner?: Maybe<Scalars['String']>;
  preRegistrationTemplate: Scalars['jsonb'];
  registrationTemplate: Scalars['jsonb'];
  unregistrationTemplate: Scalars['jsonb'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesApiUrlsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesNotificationSettingsArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesNotificationSettings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesPreRegistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesRegistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_services" */
export type NotificationServicesUnregistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_services" */
export type NotificationServices_Aggregate = {
  __typename?: 'notificationServices_aggregate';
  aggregate?: Maybe<NotificationServices_Aggregate_Fields>;
  nodes: Array<NotificationServices>;
};

/** aggregate fields of "notification_services" */
export type NotificationServices_Aggregate_Fields = {
  __typename?: 'notificationServices_aggregate_fields';
  avg?: Maybe<NotificationServices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationServices_Max_Fields>;
  min?: Maybe<NotificationServices_Min_Fields>;
  stddev?: Maybe<NotificationServices_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationServices_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationServices_Sum_Fields>;
  var_pop?: Maybe<NotificationServices_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationServices_Var_Samp_Fields>;
  variance?: Maybe<NotificationServices_Variance_Fields>;
};


/** aggregate fields of "notification_services" */
export type NotificationServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationServices_Append_Input = {
  apiUrls?: InputMaybe<Scalars['jsonb']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type NotificationServices_Avg_Fields = {
  __typename?: 'notificationServices_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_services". All fields are combined with a logical 'AND'. */
export type NotificationServices_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationServices_Bool_Exp>>;
  _not?: InputMaybe<NotificationServices_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationServices_Bool_Exp>>;
  apiUrls?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationSettings?: InputMaybe<NotificationSettings_Bool_Exp>;
  notificationSettings_aggregate?: InputMaybe<NotificationSettings_Aggregate_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  preRegistrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  registrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  unregistrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_services" */
export enum NotificationServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationServicesPkey = 'notification_services_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationServices_Delete_At_Path_Input = {
  apiUrls?: InputMaybe<Array<Scalars['String']>>;
  preRegistrationTemplate?: InputMaybe<Array<Scalars['String']>>;
  registrationTemplate?: InputMaybe<Array<Scalars['String']>>;
  unregistrationTemplate?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationServices_Delete_Elem_Input = {
  apiUrls?: InputMaybe<Scalars['Int']>;
  preRegistrationTemplate?: InputMaybe<Scalars['Int']>;
  registrationTemplate?: InputMaybe<Scalars['Int']>;
  unregistrationTemplate?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationServices_Delete_Key_Input = {
  apiUrls?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['String']>;
  registrationTemplate?: InputMaybe<Scalars['String']>;
  unregistrationTemplate?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_services" */
export type NotificationServices_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_services" */
export type NotificationServices_Insert_Input = {
  apiUrls?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<NotificationSettings_Arr_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationServices_Max_Fields = {
  __typename?: 'notificationServices_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type NotificationServices_Min_Fields = {
  __typename?: 'notificationServices_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "notification_services" */
export type NotificationServices_Mutation_Response = {
  __typename?: 'notificationServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationServices>;
};

/** input type for inserting object relation for remote table "notification_services" */
export type NotificationServices_Obj_Rel_Insert_Input = {
  data: NotificationServices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationServices_On_Conflict>;
};

/** on_conflict condition type for table "notification_services" */
export type NotificationServices_On_Conflict = {
  constraint: NotificationServices_Constraint;
  update_columns?: Array<NotificationServices_Update_Column>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_services". */
export type NotificationServices_Order_By = {
  apiUrls?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationSettings_aggregate?: InputMaybe<NotificationSettings_Aggregate_Order_By>;
  owner?: InputMaybe<Order_By>;
  preRegistrationTemplate?: InputMaybe<Order_By>;
  registrationTemplate?: InputMaybe<Order_By>;
  unregistrationTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_services */
export type NotificationServices_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationServices_Prepend_Input = {
  apiUrls?: InputMaybe<Scalars['jsonb']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_services" */
export enum NotificationServices_Select_Column {
  /** column name */
  ApiUrls = 'apiUrls',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  PreRegistrationTemplate = 'preRegistrationTemplate',
  /** column name */
  RegistrationTemplate = 'registrationTemplate',
  /** column name */
  UnregistrationTemplate = 'unregistrationTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_services" */
export type NotificationServices_Set_Input = {
  apiUrls?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationServices_Stddev_Fields = {
  __typename?: 'notificationServices_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationServices_Stddev_Pop_Fields = {
  __typename?: 'notificationServices_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationServices_Stddev_Samp_Fields = {
  __typename?: 'notificationServices_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notificationServices" */
export type NotificationServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationServices_Stream_Cursor_Value_Input = {
  apiUrls?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationServices_Sum_Fields = {
  __typename?: 'notificationServices_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notification_services" */
export enum NotificationServices_Update_Column {
  /** column name */
  ApiUrls = 'apiUrls',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  PreRegistrationTemplate = 'preRegistrationTemplate',
  /** column name */
  RegistrationTemplate = 'registrationTemplate',
  /** column name */
  UnregistrationTemplate = 'unregistrationTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationServices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationServices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationServices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationServices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationServices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationServices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationServices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationServices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationServices_Var_Pop_Fields = {
  __typename?: 'notificationServices_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationServices_Var_Samp_Fields = {
  __typename?: 'notificationServices_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationServices_Variance_Fields = {
  __typename?: 'notificationServices_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_settings" */
export type NotificationSettings = {
  __typename?: 'notificationSettings';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationServiceId: Scalars['String'];
  /** An object relationship */
  notificationServices?: Maybe<NotificationServices>;
  /** An array relationship */
  notificationUserTemp: Array<NotificationUserTemp>;
  /** An aggregate relationship */
  notificationUserTemp_aggregate: NotificationUserTemp_Aggregate;
  /** An array relationship */
  notificationUsers: Array<NotificationUsers>;
  /** An aggregate relationship */
  notificationUsers_aggregate: NotificationUsers_Aggregate;
  owner?: Maybe<Scalars['String']>;
  preRegistrationTemplate: Scalars['jsonb'];
  registrationTemplate: Scalars['jsonb'];
  settings: Scalars['jsonb'];
  tenantId: Scalars['String'];
  unregistrationTemplate: Scalars['jsonb'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsNotificationUserTempArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsNotificationUserTemp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsNotificationUsersArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsNotificationUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsPreRegistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsRegistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "notification_settings" */
export type NotificationSettingsUnregistrationTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_settings" */
export type NotificationSettings_Aggregate = {
  __typename?: 'notificationSettings_aggregate';
  aggregate?: Maybe<NotificationSettings_Aggregate_Fields>;
  nodes: Array<NotificationSettings>;
};

export type NotificationSettings_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationSettings_Aggregate_Bool_Exp_Count>;
};

export type NotificationSettings_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationSettings_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_settings" */
export type NotificationSettings_Aggregate_Fields = {
  __typename?: 'notificationSettings_aggregate_fields';
  avg?: Maybe<NotificationSettings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationSettings_Max_Fields>;
  min?: Maybe<NotificationSettings_Min_Fields>;
  stddev?: Maybe<NotificationSettings_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationSettings_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationSettings_Sum_Fields>;
  var_pop?: Maybe<NotificationSettings_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationSettings_Var_Samp_Fields>;
  variance?: Maybe<NotificationSettings_Variance_Fields>;
};


/** aggregate fields of "notification_settings" */
export type NotificationSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_settings" */
export type NotificationSettings_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationSettings_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationSettings_Max_Order_By>;
  min?: InputMaybe<NotificationSettings_Min_Order_By>;
  stddev?: InputMaybe<NotificationSettings_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationSettings_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationSettings_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationSettings_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationSettings_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationSettings_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationSettings_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationSettings_Append_Input = {
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "notification_settings" */
export type NotificationSettings_Arr_Rel_Insert_Input = {
  data: Array<NotificationSettings_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationSettings_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationSettings_Avg_Fields = {
  __typename?: 'notificationSettings_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_settings" */
export type NotificationSettings_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_settings". All fields are combined with a logical 'AND'. */
export type NotificationSettings_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationSettings_Bool_Exp>>;
  _not?: InputMaybe<NotificationSettings_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationServiceId?: InputMaybe<String_Comparison_Exp>;
  notificationServices?: InputMaybe<NotificationServices_Bool_Exp>;
  notificationUserTemp?: InputMaybe<NotificationUserTemp_Bool_Exp>;
  notificationUserTemp_aggregate?: InputMaybe<NotificationUserTemp_Aggregate_Bool_Exp>;
  notificationUsers?: InputMaybe<NotificationUsers_Bool_Exp>;
  notificationUsers_aggregate?: InputMaybe<NotificationUsers_Aggregate_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  preRegistrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  registrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  unregistrationTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_settings" */
export enum NotificationSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationSettingsPkey = 'notification_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationSettings_Delete_At_Path_Input = {
  preRegistrationTemplate?: InputMaybe<Array<Scalars['String']>>;
  registrationTemplate?: InputMaybe<Array<Scalars['String']>>;
  settings?: InputMaybe<Array<Scalars['String']>>;
  unregistrationTemplate?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationSettings_Delete_Elem_Input = {
  preRegistrationTemplate?: InputMaybe<Scalars['Int']>;
  registrationTemplate?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Scalars['Int']>;
  unregistrationTemplate?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationSettings_Delete_Key_Input = {
  preRegistrationTemplate?: InputMaybe<Scalars['String']>;
  registrationTemplate?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['String']>;
  unregistrationTemplate?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_settings" */
export type NotificationSettings_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_settings" */
export type NotificationSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationServiceId?: InputMaybe<Scalars['String']>;
  notificationServices?: InputMaybe<NotificationServices_Obj_Rel_Insert_Input>;
  notificationUserTemp?: InputMaybe<NotificationUserTemp_Arr_Rel_Insert_Input>;
  notificationUsers?: InputMaybe<NotificationUsers_Arr_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationSettings_Max_Fields = {
  __typename?: 'notificationSettings_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationServiceId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "notification_settings" */
export type NotificationSettings_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationServiceId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationSettings_Min_Fields = {
  __typename?: 'notificationSettings_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationServiceId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "notification_settings" */
export type NotificationSettings_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationServiceId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_settings" */
export type NotificationSettings_Mutation_Response = {
  __typename?: 'notificationSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationSettings>;
};

/** input type for inserting object relation for remote table "notification_settings" */
export type NotificationSettings_Obj_Rel_Insert_Input = {
  data: NotificationSettings_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationSettings_On_Conflict>;
};

/** on_conflict condition type for table "notification_settings" */
export type NotificationSettings_On_Conflict = {
  constraint: NotificationSettings_Constraint;
  update_columns?: Array<NotificationSettings_Update_Column>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_settings". */
export type NotificationSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationServiceId?: InputMaybe<Order_By>;
  notificationServices?: InputMaybe<NotificationServices_Order_By>;
  notificationUserTemp_aggregate?: InputMaybe<NotificationUserTemp_Aggregate_Order_By>;
  notificationUsers_aggregate?: InputMaybe<NotificationUsers_Aggregate_Order_By>;
  owner?: InputMaybe<Order_By>;
  preRegistrationTemplate?: InputMaybe<Order_By>;
  registrationTemplate?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  unregistrationTemplate?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_settings */
export type NotificationSettings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationSettings_Prepend_Input = {
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_settings" */
export enum NotificationSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationServiceId = 'notificationServiceId',
  /** column name */
  Owner = 'owner',
  /** column name */
  PreRegistrationTemplate = 'preRegistrationTemplate',
  /** column name */
  RegistrationTemplate = 'registrationTemplate',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UnregistrationTemplate = 'unregistrationTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_settings" */
export type NotificationSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationServiceId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationSettings_Stddev_Fields = {
  __typename?: 'notificationSettings_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_settings" */
export type NotificationSettings_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationSettings_Stddev_Pop_Fields = {
  __typename?: 'notificationSettings_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_settings" */
export type NotificationSettings_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationSettings_Stddev_Samp_Fields = {
  __typename?: 'notificationSettings_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_settings" */
export type NotificationSettings_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationSettings" */
export type NotificationSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationSettings_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationServiceId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  preRegistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  registrationTemplate?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  unregistrationTemplate?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationSettings_Sum_Fields = {
  __typename?: 'notificationSettings_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_settings" */
export type NotificationSettings_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_settings" */
export enum NotificationSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationServiceId = 'notificationServiceId',
  /** column name */
  Owner = 'owner',
  /** column name */
  PreRegistrationTemplate = 'preRegistrationTemplate',
  /** column name */
  RegistrationTemplate = 'registrationTemplate',
  /** column name */
  Settings = 'settings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UnregistrationTemplate = 'unregistrationTemplate',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationSettings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationSettings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationSettings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationSettings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationSettings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationSettings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationSettings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationSettings_Var_Pop_Fields = {
  __typename?: 'notificationSettings_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_settings" */
export type NotificationSettings_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationSettings_Var_Samp_Fields = {
  __typename?: 'notificationSettings_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_settings" */
export type NotificationSettings_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationSettings_Variance_Fields = {
  __typename?: 'notificationSettings_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_settings" */
export type NotificationSettings_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

export type NotificationStateAggregateNativeModel = {
  __typename?: 'notificationStateAggregateNativeModel';
  completedTotal: Scalars['bigint'];
  dateTotal: Scalars['bigint'];
  errorTotal: Scalars['bigint'];
  periodTotal: Scalars['bigint'];
  processingTimeAvg: Scalars['numeric'];
  processingTimeMax: Scalars['bigint'];
  processingTimeMin: Scalars['bigint'];
  tenantId: Scalars['String'];
  tenantName: Scalars['String'];
};

/** Boolean expression to filter rows from the logical model for "notificationStateAggregateNativeModel". All fields are combined with a logical 'AND'. */
export type NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  _not?: InputMaybe<NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp>>;
  completedTotal?: InputMaybe<Bigint_Comparison_Exp>;
  dateTotal?: InputMaybe<Bigint_Comparison_Exp>;
  errorTotal?: InputMaybe<Bigint_Comparison_Exp>;
  periodTotal?: InputMaybe<Bigint_Comparison_Exp>;
  processingTimeAvg?: InputMaybe<Numeric_Comparison_Exp>;
  processingTimeMax?: InputMaybe<Bigint_Comparison_Exp>;
  processingTimeMin?: InputMaybe<Bigint_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tenantName?: InputMaybe<String_Comparison_Exp>;
};

export enum NotificationStateAggregateNativeModel_Enum_Name {
  /** column name */
  CompletedTotal = 'completedTotal',
  /** column name */
  DateTotal = 'dateTotal',
  /** column name */
  ErrorTotal = 'errorTotal',
  /** column name */
  PeriodTotal = 'periodTotal',
  /** column name */
  ProcessingTimeAvg = 'processingTimeAvg',
  /** column name */
  ProcessingTimeMax = 'processingTimeMax',
  /** column name */
  ProcessingTimeMin = 'processingTimeMin',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TenantName = 'tenantName'
}

/** Ordering options when selecting data from "notificationStateAggregateNativeModel". */
export type NotificationStateAggregateNativeModel_Order_By = {
  completedTotal?: InputMaybe<Order_By>;
  dateTotal?: InputMaybe<Order_By>;
  errorTotal?: InputMaybe<Order_By>;
  periodTotal?: InputMaybe<Order_By>;
  processingTimeAvg?: InputMaybe<Order_By>;
  processingTimeMax?: InputMaybe<Order_By>;
  processingTimeMin?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tenantName?: InputMaybe<Order_By>;
};

/** notificationStateAggregateNativeNative Query Arguments */
export type NotificationStateAggregateNative_Arguments = {
  /** 抽出期間FROM */
  periodFrom: Scalars['bigint'];
  /** 抽出期間TO */
  periodTo: Scalars['bigint'];
  /** テナントID */
  tenantId?: InputMaybe<Scalars['String']>;
  /** 集計対象日(抽出期間内) */
  tergetDate: Scalars['bigint'];
};

/** columns and relationships of "notification_targets" */
export type NotificationTargets = {
  __typename?: 'notificationTargets';
  createdAt?: Maybe<Scalars['bigint']>;
  from?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationConditionId: Scalars['String'];
  notificationUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  state: Notification_Target_States_Enum;
  tenantId: Scalars['String'];
  to?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "notification_targets" */
export type NotificationTargets_Aggregate = {
  __typename?: 'notificationTargets_aggregate';
  aggregate?: Maybe<NotificationTargets_Aggregate_Fields>;
  nodes: Array<NotificationTargets>;
};

/** aggregate fields of "notification_targets" */
export type NotificationTargets_Aggregate_Fields = {
  __typename?: 'notificationTargets_aggregate_fields';
  avg?: Maybe<NotificationTargets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationTargets_Max_Fields>;
  min?: Maybe<NotificationTargets_Min_Fields>;
  stddev?: Maybe<NotificationTargets_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationTargets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationTargets_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationTargets_Sum_Fields>;
  var_pop?: Maybe<NotificationTargets_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationTargets_Var_Samp_Fields>;
  variance?: Maybe<NotificationTargets_Variance_Fields>;
};


/** aggregate fields of "notification_targets" */
export type NotificationTargets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationTargets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type NotificationTargets_Avg_Fields = {
  __typename?: 'notificationTargets_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_targets". All fields are combined with a logical 'AND'. */
export type NotificationTargets_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationTargets_Bool_Exp>>;
  _not?: InputMaybe<NotificationTargets_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationTargets_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  from?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationConditionId?: InputMaybe<String_Comparison_Exp>;
  notificationUserId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Notification_Target_States_Enum_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  to?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_targets" */
export enum NotificationTargets_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTargetsPkey = 'notification_targets_pkey'
}

/** input type for incrementing numeric columns in table "notification_targets" */
export type NotificationTargets_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  from?: InputMaybe<Scalars['bigint']>;
  to?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_targets" */
export type NotificationTargets_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  from?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_Target_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationTargets_Max_Fields = {
  __typename?: 'notificationTargets_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  from?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  notificationUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type NotificationTargets_Min_Fields = {
  __typename?: 'notificationTargets_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  from?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationConditionId?: Maybe<Scalars['String']>;
  notificationUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  to?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_targets" */
export type NotificationTargets_Mutation_Response = {
  __typename?: 'notificationTargets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationTargets>;
};

/** on_conflict condition type for table "notification_targets" */
export type NotificationTargets_On_Conflict = {
  constraint: NotificationTargets_Constraint;
  update_columns?: Array<NotificationTargets_Update_Column>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_targets". */
export type NotificationTargets_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationConditionId?: InputMaybe<Order_By>;
  notificationUserId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  to?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_targets */
export type NotificationTargets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "notification_targets" */
export enum NotificationTargets_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  NotificationUserId = 'notificationUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "notification_targets" */
export type NotificationTargets_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  from?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_Target_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type NotificationTargets_Stddev_Fields = {
  __typename?: 'notificationTargets_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationTargets_Stddev_Pop_Fields = {
  __typename?: 'notificationTargets_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationTargets_Stddev_Samp_Fields = {
  __typename?: 'notificationTargets_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notificationTargets" */
export type NotificationTargets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationTargets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationTargets_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  from?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationConditionId?: InputMaybe<Scalars['String']>;
  notificationUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_Target_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type NotificationTargets_Sum_Fields = {
  __typename?: 'notificationTargets_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  from?: Maybe<Scalars['bigint']>;
  to?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notification_targets" */
export enum NotificationTargets_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  From = 'from',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationConditionId = 'notificationConditionId',
  /** column name */
  NotificationUserId = 'notificationUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  To = 'to',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type NotificationTargets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationTargets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationTargets_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationTargets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationTargets_Var_Pop_Fields = {
  __typename?: 'notificationTargets_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationTargets_Var_Samp_Fields = {
  __typename?: 'notificationTargets_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationTargets_Variance_Fields = {
  __typename?: 'notificationTargets_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  from?: Maybe<Scalars['Float']>;
  to?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_templates" */
export type NotificationTemplates = {
  __typename?: 'notificationTemplates';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  notificationConditionDetailId: Scalars['String'];
  notificationSettingId: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  template: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "notification_templates" */
export type NotificationTemplatesTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "notification_templates" */
export type NotificationTemplates_Aggregate = {
  __typename?: 'notificationTemplates_aggregate';
  aggregate?: Maybe<NotificationTemplates_Aggregate_Fields>;
  nodes: Array<NotificationTemplates>;
};

/** aggregate fields of "notification_templates" */
export type NotificationTemplates_Aggregate_Fields = {
  __typename?: 'notificationTemplates_aggregate_fields';
  avg?: Maybe<NotificationTemplates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationTemplates_Max_Fields>;
  min?: Maybe<NotificationTemplates_Min_Fields>;
  stddev?: Maybe<NotificationTemplates_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationTemplates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationTemplates_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationTemplates_Sum_Fields>;
  var_pop?: Maybe<NotificationTemplates_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationTemplates_Var_Samp_Fields>;
  variance?: Maybe<NotificationTemplates_Variance_Fields>;
};


/** aggregate fields of "notification_templates" */
export type NotificationTemplates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type NotificationTemplates_Append_Input = {
  template?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type NotificationTemplates_Avg_Fields = {
  __typename?: 'notificationTemplates_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "notification_templates". All fields are combined with a logical 'AND'. */
export type NotificationTemplates_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationTemplates_Bool_Exp>>;
  _not?: InputMaybe<NotificationTemplates_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationTemplates_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notificationConditionDetailId?: InputMaybe<String_Comparison_Exp>;
  notificationSettingId?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  template?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_templates" */
export enum NotificationTemplates_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationTemplatesPkey = 'notification_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type NotificationTemplates_Delete_At_Path_Input = {
  template?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type NotificationTemplates_Delete_Elem_Input = {
  template?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type NotificationTemplates_Delete_Key_Input = {
  template?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "notification_templates" */
export type NotificationTemplates_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_templates" */
export type NotificationTemplates_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationConditionDetailId?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type NotificationTemplates_Max_Fields = {
  __typename?: 'notificationTemplates_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationConditionDetailId?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type NotificationTemplates_Min_Fields = {
  __typename?: 'notificationTemplates_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notificationConditionDetailId?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "notification_templates" */
export type NotificationTemplates_Mutation_Response = {
  __typename?: 'notificationTemplates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationTemplates>;
};

/** on_conflict condition type for table "notification_templates" */
export type NotificationTemplates_On_Conflict = {
  constraint: NotificationTemplates_Constraint;
  update_columns?: Array<NotificationTemplates_Update_Column>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_templates". */
export type NotificationTemplates_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notificationConditionDetailId?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  template?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_templates */
export type NotificationTemplates_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type NotificationTemplates_Prepend_Input = {
  template?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "notification_templates" */
export enum NotificationTemplates_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationConditionDetailId = 'notificationConditionDetailId',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  Template = 'template',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "notification_templates" */
export type NotificationTemplates_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationConditionDetailId?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type NotificationTemplates_Stddev_Fields = {
  __typename?: 'notificationTemplates_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type NotificationTemplates_Stddev_Pop_Fields = {
  __typename?: 'notificationTemplates_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type NotificationTemplates_Stddev_Samp_Fields = {
  __typename?: 'notificationTemplates_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "notificationTemplates" */
export type NotificationTemplates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationTemplates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationTemplates_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notificationConditionDetailId?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  template?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type NotificationTemplates_Sum_Fields = {
  __typename?: 'notificationTemplates_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "notification_templates" */
export enum NotificationTemplates_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NotificationConditionDetailId = 'notificationConditionDetailId',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  Template = 'template',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type NotificationTemplates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<NotificationTemplates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<NotificationTemplates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<NotificationTemplates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<NotificationTemplates_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationTemplates_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<NotificationTemplates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationTemplates_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationTemplates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationTemplates_Var_Pop_Fields = {
  __typename?: 'notificationTemplates_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type NotificationTemplates_Var_Samp_Fields = {
  __typename?: 'notificationTemplates_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type NotificationTemplates_Variance_Fields = {
  __typename?: 'notificationTemplates_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "notification_user_temp" */
export type NotificationUserTemp = {
  __typename?: 'notificationUserTemp';
  activateCode: Scalars['String'];
  address?: Maybe<Scalars['String']>;
  confirmCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  expire?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationSettingId: Scalars['String'];
  /** An object relationship */
  notificationSettings?: Maybe<NotificationSettings>;
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "notification_user_temp" */
export type NotificationUserTemp_Aggregate = {
  __typename?: 'notificationUserTemp_aggregate';
  aggregate?: Maybe<NotificationUserTemp_Aggregate_Fields>;
  nodes: Array<NotificationUserTemp>;
};

export type NotificationUserTemp_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationUserTemp_Aggregate_Bool_Exp_Count>;
};

export type NotificationUserTemp_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationUserTemp_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_user_temp" */
export type NotificationUserTemp_Aggregate_Fields = {
  __typename?: 'notificationUserTemp_aggregate_fields';
  avg?: Maybe<NotificationUserTemp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationUserTemp_Max_Fields>;
  min?: Maybe<NotificationUserTemp_Min_Fields>;
  stddev?: Maybe<NotificationUserTemp_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationUserTemp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationUserTemp_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationUserTemp_Sum_Fields>;
  var_pop?: Maybe<NotificationUserTemp_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationUserTemp_Var_Samp_Fields>;
  variance?: Maybe<NotificationUserTemp_Variance_Fields>;
};


/** aggregate fields of "notification_user_temp" */
export type NotificationUserTemp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_user_temp" */
export type NotificationUserTemp_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationUserTemp_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationUserTemp_Max_Order_By>;
  min?: InputMaybe<NotificationUserTemp_Min_Order_By>;
  stddev?: InputMaybe<NotificationUserTemp_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationUserTemp_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationUserTemp_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationUserTemp_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationUserTemp_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationUserTemp_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationUserTemp_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_user_temp" */
export type NotificationUserTemp_Arr_Rel_Insert_Input = {
  data: Array<NotificationUserTemp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationUserTemp_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationUserTemp_Avg_Fields = {
  __typename?: 'notificationUserTemp_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_user_temp". All fields are combined with a logical 'AND'. */
export type NotificationUserTemp_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationUserTemp_Bool_Exp>>;
  _not?: InputMaybe<NotificationUserTemp_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationUserTemp_Bool_Exp>>;
  activateCode?: InputMaybe<String_Comparison_Exp>;
  address?: InputMaybe<String_Comparison_Exp>;
  confirmCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  expire?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationSettingId?: InputMaybe<String_Comparison_Exp>;
  notificationSettings?: InputMaybe<NotificationSettings_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_user_temp" */
export enum NotificationUserTemp_Constraint {
  /** unique or primary key constraint on columns "activate_code" */
  NotificationUserTempActivateCodeKey = 'notification_user_temp_activate_code_key',
  /** unique or primary key constraint on columns "id" */
  NotificationUserTempPkey = 'notification_user_temp_pkey'
}

/** input type for incrementing numeric columns in table "notification_user_temp" */
export type NotificationUserTemp_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expire?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_user_temp" */
export type NotificationUserTemp_Insert_Input = {
  activateCode?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  confirmCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  expire?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<NotificationSettings_Obj_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationUserTemp_Max_Fields = {
  __typename?: 'notificationUserTemp_max_fields';
  activateCode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  confirmCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  expire?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Max_Order_By = {
  activateCode?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  confirmCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationUserTemp_Min_Fields = {
  __typename?: 'notificationUserTemp_min_fields';
  activateCode?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  confirmCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  expire?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Min_Order_By = {
  activateCode?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  confirmCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_user_temp" */
export type NotificationUserTemp_Mutation_Response = {
  __typename?: 'notificationUserTemp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationUserTemp>;
};

/** on_conflict condition type for table "notification_user_temp" */
export type NotificationUserTemp_On_Conflict = {
  constraint: NotificationUserTemp_Constraint;
  update_columns?: Array<NotificationUserTemp_Update_Column>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_user_temp". */
export type NotificationUserTemp_Order_By = {
  activateCode?: InputMaybe<Order_By>;
  address?: InputMaybe<Order_By>;
  confirmCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  notificationSettings?: InputMaybe<NotificationSettings_Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_user_temp */
export type NotificationUserTemp_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "notification_user_temp" */
export enum NotificationUserTemp_Select_Column {
  /** column name */
  ActivateCode = 'activateCode',
  /** column name */
  Address = 'address',
  /** column name */
  ConfirmCode = 'confirmCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Expire = 'expire',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "notification_user_temp" */
export type NotificationUserTemp_Set_Input = {
  activateCode?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  confirmCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  expire?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type NotificationUserTemp_Stddev_Fields = {
  __typename?: 'notificationUserTemp_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationUserTemp_Stddev_Pop_Fields = {
  __typename?: 'notificationUserTemp_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationUserTemp_Stddev_Samp_Fields = {
  __typename?: 'notificationUserTemp_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationUserTemp" */
export type NotificationUserTemp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationUserTemp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationUserTemp_Stream_Cursor_Value_Input = {
  activateCode?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Scalars['String']>;
  confirmCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  expire?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type NotificationUserTemp_Sum_Fields = {
  __typename?: 'notificationUserTemp_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  expire?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_user_temp" */
export enum NotificationUserTemp_Update_Column {
  /** column name */
  ActivateCode = 'activateCode',
  /** column name */
  Address = 'address',
  /** column name */
  ConfirmCode = 'confirmCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Expire = 'expire',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type NotificationUserTemp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationUserTemp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationUserTemp_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationUserTemp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationUserTemp_Var_Pop_Fields = {
  __typename?: 'notificationUserTemp_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationUserTemp_Var_Samp_Fields = {
  __typename?: 'notificationUserTemp_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationUserTemp_Variance_Fields = {
  __typename?: 'notificationUserTemp_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expire?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_user_temp" */
export type NotificationUserTemp_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  expire?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_users" */
export type NotificationUsers = {
  __typename?: 'notificationUsers';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  notificationSettingId: Scalars['String'];
  /** An object relationship */
  notificationSettings?: Maybe<NotificationSettings>;
  owner?: Maybe<Scalars['String']>;
  state: Notification_User_States_Enum;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregated selection of "notification_users" */
export type NotificationUsers_Aggregate = {
  __typename?: 'notificationUsers_aggregate';
  aggregate?: Maybe<NotificationUsers_Aggregate_Fields>;
  nodes: Array<NotificationUsers>;
};

export type NotificationUsers_Aggregate_Bool_Exp = {
  count?: InputMaybe<NotificationUsers_Aggregate_Bool_Exp_Count>;
};

export type NotificationUsers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<NotificationUsers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "notification_users" */
export type NotificationUsers_Aggregate_Fields = {
  __typename?: 'notificationUsers_aggregate_fields';
  avg?: Maybe<NotificationUsers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<NotificationUsers_Max_Fields>;
  min?: Maybe<NotificationUsers_Min_Fields>;
  stddev?: Maybe<NotificationUsers_Stddev_Fields>;
  stddev_pop?: Maybe<NotificationUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<NotificationUsers_Stddev_Samp_Fields>;
  sum?: Maybe<NotificationUsers_Sum_Fields>;
  var_pop?: Maybe<NotificationUsers_Var_Pop_Fields>;
  var_samp?: Maybe<NotificationUsers_Var_Samp_Fields>;
  variance?: Maybe<NotificationUsers_Variance_Fields>;
};


/** aggregate fields of "notification_users" */
export type NotificationUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "notification_users" */
export type NotificationUsers_Aggregate_Order_By = {
  avg?: InputMaybe<NotificationUsers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<NotificationUsers_Max_Order_By>;
  min?: InputMaybe<NotificationUsers_Min_Order_By>;
  stddev?: InputMaybe<NotificationUsers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<NotificationUsers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<NotificationUsers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<NotificationUsers_Sum_Order_By>;
  var_pop?: InputMaybe<NotificationUsers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<NotificationUsers_Var_Samp_Order_By>;
  variance?: InputMaybe<NotificationUsers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "notification_users" */
export type NotificationUsers_Arr_Rel_Insert_Input = {
  data: Array<NotificationUsers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<NotificationUsers_On_Conflict>;
};

/** aggregate avg on columns */
export type NotificationUsers_Avg_Fields = {
  __typename?: 'notificationUsers_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "notification_users" */
export type NotificationUsers_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "notification_users". All fields are combined with a logical 'AND'. */
export type NotificationUsers_Bool_Exp = {
  _and?: InputMaybe<Array<NotificationUsers_Bool_Exp>>;
  _not?: InputMaybe<NotificationUsers_Bool_Exp>;
  _or?: InputMaybe<Array<NotificationUsers_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  notificationSettingId?: InputMaybe<String_Comparison_Exp>;
  notificationSettings?: InputMaybe<NotificationSettings_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<Notification_User_States_Enum_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_users" */
export enum NotificationUsers_Constraint {
  /** unique or primary key constraint on columns "id" */
  NotificationUsersPkey = 'notification_users_pkey'
}

/** input type for incrementing numeric columns in table "notification_users" */
export type NotificationUsers_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "notification_users" */
export type NotificationUsers_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  notificationSettings?: InputMaybe<NotificationSettings_Obj_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type NotificationUsers_Max_Fields = {
  __typename?: 'notificationUsers_max_fields';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "notification_users" */
export type NotificationUsers_Max_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type NotificationUsers_Min_Fields = {
  __typename?: 'notificationUsers_min_fields';
  address?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  notificationSettingId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "notification_users" */
export type NotificationUsers_Min_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "notification_users" */
export type NotificationUsers_Mutation_Response = {
  __typename?: 'notificationUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<NotificationUsers>;
};

/** on_conflict condition type for table "notification_users" */
export type NotificationUsers_On_Conflict = {
  constraint: NotificationUsers_Constraint;
  update_columns?: Array<NotificationUsers_Update_Column>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_users". */
export type NotificationUsers_Order_By = {
  address?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  notificationSettingId?: InputMaybe<Order_By>;
  notificationSettings?: InputMaybe<NotificationSettings_Order_By>;
  owner?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_users */
export type NotificationUsers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "notification_users" */
export enum NotificationUsers_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "notification_users" */
export type NotificationUsers_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type NotificationUsers_Stddev_Fields = {
  __typename?: 'notificationUsers_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "notification_users" */
export type NotificationUsers_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type NotificationUsers_Stddev_Pop_Fields = {
  __typename?: 'notificationUsers_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "notification_users" */
export type NotificationUsers_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type NotificationUsers_Stddev_Samp_Fields = {
  __typename?: 'notificationUsers_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "notification_users" */
export type NotificationUsers_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "notificationUsers" */
export type NotificationUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: NotificationUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type NotificationUsers_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  notificationSettingId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Notification_User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type NotificationUsers_Sum_Fields = {
  __typename?: 'notificationUsers_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "notification_users" */
export type NotificationUsers_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "notification_users" */
export enum NotificationUsers_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  NotificationSettingId = 'notificationSettingId',
  /** column name */
  Owner = 'owner',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type NotificationUsers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<NotificationUsers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<NotificationUsers_Set_Input>;
  /** filter the rows which have to be updated */
  where: NotificationUsers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type NotificationUsers_Var_Pop_Fields = {
  __typename?: 'notificationUsers_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "notification_users" */
export type NotificationUsers_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type NotificationUsers_Var_Samp_Fields = {
  __typename?: 'notificationUsers_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "notification_users" */
export type NotificationUsers_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type NotificationUsers_Variance_Fields = {
  __typename?: 'notificationUsers_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "notification_users" */
export type NotificationUsers_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "notification_history_states" */
export type Notification_History_States = {
  __typename?: 'notification_history_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_history_states" */
export type Notification_History_States_Aggregate = {
  __typename?: 'notification_history_states_aggregate';
  aggregate?: Maybe<Notification_History_States_Aggregate_Fields>;
  nodes: Array<Notification_History_States>;
};

/** aggregate fields of "notification_history_states" */
export type Notification_History_States_Aggregate_Fields = {
  __typename?: 'notification_history_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_History_States_Max_Fields>;
  min?: Maybe<Notification_History_States_Min_Fields>;
};


/** aggregate fields of "notification_history_states" */
export type Notification_History_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_History_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_history_states". All fields are combined with a logical 'AND'. */
export type Notification_History_States_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_History_States_Bool_Exp>>;
  _not?: InputMaybe<Notification_History_States_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_History_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_history_states" */
export enum Notification_History_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  NotificationHistoryStatesPkey = 'notification_history_states_pkey'
}

export enum Notification_History_States_Enum {
  /** 通知完了 */
  Completed = 'COMPLETED',
  /** 通知エラー */
  Error = 'ERROR',
  /** 未通知（通知処理中） */
  Processing = 'PROCESSING'
}

/** Boolean expression to compare columns of type "notification_history_states_enum". All fields are combined with logical 'AND'. */
export type Notification_History_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_History_States_Enum>;
  _in?: InputMaybe<Array<Notification_History_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_History_States_Enum>;
  _nin?: InputMaybe<Array<Notification_History_States_Enum>>;
};

/** input type for inserting data into table "notification_history_states" */
export type Notification_History_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_History_States_Max_Fields = {
  __typename?: 'notification_history_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_History_States_Min_Fields = {
  __typename?: 'notification_history_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_history_states" */
export type Notification_History_States_Mutation_Response = {
  __typename?: 'notification_history_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_History_States>;
};

/** on_conflict condition type for table "notification_history_states" */
export type Notification_History_States_On_Conflict = {
  constraint: Notification_History_States_Constraint;
  update_columns?: Array<Notification_History_States_Update_Column>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_history_states". */
export type Notification_History_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_history_states */
export type Notification_History_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "notification_history_states" */
export enum Notification_History_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_history_states" */
export type Notification_History_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_history_states" */
export type Notification_History_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_History_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_History_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_history_states" */
export enum Notification_History_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Notification_History_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_History_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_History_States_Bool_Exp;
};

/** columns and relationships of "notification_target_states" */
export type Notification_Target_States = {
  __typename?: 'notification_target_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_target_states" */
export type Notification_Target_States_Aggregate = {
  __typename?: 'notification_target_states_aggregate';
  aggregate?: Maybe<Notification_Target_States_Aggregate_Fields>;
  nodes: Array<Notification_Target_States>;
};

/** aggregate fields of "notification_target_states" */
export type Notification_Target_States_Aggregate_Fields = {
  __typename?: 'notification_target_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_Target_States_Max_Fields>;
  min?: Maybe<Notification_Target_States_Min_Fields>;
};


/** aggregate fields of "notification_target_states" */
export type Notification_Target_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_Target_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_target_states". All fields are combined with a logical 'AND'. */
export type Notification_Target_States_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_Target_States_Bool_Exp>>;
  _not?: InputMaybe<Notification_Target_States_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_Target_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_target_states" */
export enum Notification_Target_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  NotificationTargetStatesPkey = 'notification_target_states_pkey'
}

export enum Notification_Target_States_Enum {
  /** disabled */
  Disabled = 'disabled',
  /** enabled */
  Enabled = 'enabled'
}

/** Boolean expression to compare columns of type "notification_target_states_enum". All fields are combined with logical 'AND'. */
export type Notification_Target_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_Target_States_Enum>;
  _in?: InputMaybe<Array<Notification_Target_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_Target_States_Enum>;
  _nin?: InputMaybe<Array<Notification_Target_States_Enum>>;
};

/** input type for inserting data into table "notification_target_states" */
export type Notification_Target_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_Target_States_Max_Fields = {
  __typename?: 'notification_target_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_Target_States_Min_Fields = {
  __typename?: 'notification_target_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_target_states" */
export type Notification_Target_States_Mutation_Response = {
  __typename?: 'notification_target_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_Target_States>;
};

/** on_conflict condition type for table "notification_target_states" */
export type Notification_Target_States_On_Conflict = {
  constraint: Notification_Target_States_Constraint;
  update_columns?: Array<Notification_Target_States_Update_Column>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_target_states". */
export type Notification_Target_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_target_states */
export type Notification_Target_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "notification_target_states" */
export enum Notification_Target_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_target_states" */
export type Notification_Target_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_target_states" */
export type Notification_Target_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_Target_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_Target_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_target_states" */
export enum Notification_Target_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Notification_Target_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_Target_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_Target_States_Bool_Exp;
};

/** columns and relationships of "notification_user_states" */
export type Notification_User_States = {
  __typename?: 'notification_user_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "notification_user_states" */
export type Notification_User_States_Aggregate = {
  __typename?: 'notification_user_states_aggregate';
  aggregate?: Maybe<Notification_User_States_Aggregate_Fields>;
  nodes: Array<Notification_User_States>;
};

/** aggregate fields of "notification_user_states" */
export type Notification_User_States_Aggregate_Fields = {
  __typename?: 'notification_user_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Notification_User_States_Max_Fields>;
  min?: Maybe<Notification_User_States_Min_Fields>;
};


/** aggregate fields of "notification_user_states" */
export type Notification_User_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Notification_User_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "notification_user_states". All fields are combined with a logical 'AND'. */
export type Notification_User_States_Bool_Exp = {
  _and?: InputMaybe<Array<Notification_User_States_Bool_Exp>>;
  _not?: InputMaybe<Notification_User_States_Bool_Exp>;
  _or?: InputMaybe<Array<Notification_User_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "notification_user_states" */
export enum Notification_User_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  NotificationUserStatesPkey = 'notification_user_states_pkey'
}

export enum Notification_User_States_Enum {
  /** 削除済 */
  Deleted = 'deleted',
  /** 登録済 */
  Enabled = 'enabled'
}

/** Boolean expression to compare columns of type "notification_user_states_enum". All fields are combined with logical 'AND'. */
export type Notification_User_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Notification_User_States_Enum>;
  _in?: InputMaybe<Array<Notification_User_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Notification_User_States_Enum>;
  _nin?: InputMaybe<Array<Notification_User_States_Enum>>;
};

/** input type for inserting data into table "notification_user_states" */
export type Notification_User_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Notification_User_States_Max_Fields = {
  __typename?: 'notification_user_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Notification_User_States_Min_Fields = {
  __typename?: 'notification_user_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "notification_user_states" */
export type Notification_User_States_Mutation_Response = {
  __typename?: 'notification_user_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Notification_User_States>;
};

/** on_conflict condition type for table "notification_user_states" */
export type Notification_User_States_On_Conflict = {
  constraint: Notification_User_States_Constraint;
  update_columns?: Array<Notification_User_States_Update_Column>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};

/** Ordering options when selecting data from "notification_user_states". */
export type Notification_User_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: notification_user_states */
export type Notification_User_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "notification_user_states" */
export enum Notification_User_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "notification_user_states" */
export type Notification_User_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "notification_user_states" */
export type Notification_User_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Notification_User_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Notification_User_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "notification_user_states" */
export enum Notification_User_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Notification_User_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Notification_User_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: Notification_User_States_Bool_Exp;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** columns and relationships of "policies" */
export type Policies = {
  __typename?: 'policies';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  permission?: Maybe<Scalars['jsonb']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "policies" */
export type PoliciesPermissionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "policies" */
export type Policies_Aggregate = {
  __typename?: 'policies_aggregate';
  aggregate?: Maybe<Policies_Aggregate_Fields>;
  nodes: Array<Policies>;
};

/** aggregate fields of "policies" */
export type Policies_Aggregate_Fields = {
  __typename?: 'policies_aggregate_fields';
  avg?: Maybe<Policies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Policies_Max_Fields>;
  min?: Maybe<Policies_Min_Fields>;
  stddev?: Maybe<Policies_Stddev_Fields>;
  stddev_pop?: Maybe<Policies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Policies_Stddev_Samp_Fields>;
  sum?: Maybe<Policies_Sum_Fields>;
  var_pop?: Maybe<Policies_Var_Pop_Fields>;
  var_samp?: Maybe<Policies_Var_Samp_Fields>;
  variance?: Maybe<Policies_Variance_Fields>;
};


/** aggregate fields of "policies" */
export type Policies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Policies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Policies_Append_Input = {
  policies?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Policies_Avg_Fields = {
  __typename?: 'policies_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "policies". All fields are combined with a logical 'AND'. */
export type Policies_Bool_Exp = {
  _and?: InputMaybe<Array<Policies_Bool_Exp>>;
  _not?: InputMaybe<Policies_Bool_Exp>;
  _or?: InputMaybe<Array<Policies_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  policies?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "policies" */
export enum Policies_Constraint {
  /** unique or primary key constraint on columns "id" */
  PoliciesPkey = 'policies_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Policies_Delete_At_Path_Input = {
  policies?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Policies_Delete_Elem_Input = {
  policies?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Policies_Delete_Key_Input = {
  policies?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "policies" */
export type Policies_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "policies" */
export type Policies_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Policies_Max_Fields = {
  __typename?: 'policies_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Policies_Min_Fields = {
  __typename?: 'policies_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "policies" */
export type Policies_Mutation_Response = {
  __typename?: 'policies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Policies>;
};

/** on_conflict condition type for table "policies" */
export type Policies_On_Conflict = {
  constraint: Policies_Constraint;
  update_columns?: Array<Policies_Update_Column>;
  where?: InputMaybe<Policies_Bool_Exp>;
};

/** Ordering options when selecting data from "policies". */
export type Policies_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  policies?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policies */
export type Policies_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Policies_Prepend_Input = {
  policies?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "policies" */
export enum Policies_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Policies = 'policies',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "policies" */
export type Policies_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  permission?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Policies_Stddev_Fields = {
  __typename?: 'policies_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Policies_Stddev_Pop_Fields = {
  __typename?: 'policies_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Policies_Stddev_Samp_Fields = {
  __typename?: 'policies_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policies" */
export type Policies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Policies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Policies_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  policies?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Policies_Sum_Fields = {
  __typename?: 'policies_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "policies" */
export enum Policies_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Policies = 'policies',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Policies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Policies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Policies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Policies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Policies_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Policies_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Policies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policies_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Policies_Var_Pop_Fields = {
  __typename?: 'policies_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Policies_Var_Samp_Fields = {
  __typename?: 'policies_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Policies_Variance_Fields = {
  __typename?: 'policies_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "policy_defines" */
export type PolicyDefines = {
  __typename?: 'policyDefines';
  alignmentOrder: Scalars['bigint'];
  apiName: Scalars['String'];
  apiType: Policy_Define_Types_Enum;
  createdAt?: Maybe<Scalars['bigint']>;
  define: Scalars['jsonb'];
  id: Scalars['String'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "policy_defines" */
export type PolicyDefinesDefineArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "policy_defines" */
export type PolicyDefines_Aggregate = {
  __typename?: 'policyDefines_aggregate';
  aggregate?: Maybe<PolicyDefines_Aggregate_Fields>;
  nodes: Array<PolicyDefines>;
};

/** aggregate fields of "policy_defines" */
export type PolicyDefines_Aggregate_Fields = {
  __typename?: 'policyDefines_aggregate_fields';
  avg?: Maybe<PolicyDefines_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyDefines_Max_Fields>;
  min?: Maybe<PolicyDefines_Min_Fields>;
  stddev?: Maybe<PolicyDefines_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyDefines_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyDefines_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyDefines_Sum_Fields>;
  var_pop?: Maybe<PolicyDefines_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyDefines_Var_Samp_Fields>;
  variance?: Maybe<PolicyDefines_Variance_Fields>;
};


/** aggregate fields of "policy_defines" */
export type PolicyDefines_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyDefines_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyDefines_Append_Input = {
  define?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PolicyDefines_Avg_Fields = {
  __typename?: 'policyDefines_avg_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "policy_defines". All fields are combined with a logical 'AND'. */
export type PolicyDefines_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyDefines_Bool_Exp>>;
  _not?: InputMaybe<PolicyDefines_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyDefines_Bool_Exp>>;
  alignmentOrder?: InputMaybe<Bigint_Comparison_Exp>;
  apiName?: InputMaybe<String_Comparison_Exp>;
  apiType?: InputMaybe<Policy_Define_Types_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  define?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_defines" */
export enum PolicyDefines_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyDefinesPkey = 'policy_defines_pkey',
  /** unique or primary key constraint on columns "api_type", "tenant_id", "api_name" */
  UniqueTypeName = 'unique_type_name'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyDefines_Delete_At_Path_Input = {
  define?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyDefines_Delete_Elem_Input = {
  define?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyDefines_Delete_Key_Input = {
  define?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "policy_defines" */
export type PolicyDefines_Inc_Input = {
  alignmentOrder?: InputMaybe<Scalars['bigint']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "policy_defines" */
export type PolicyDefines_Insert_Input = {
  alignmentOrder?: InputMaybe<Scalars['bigint']>;
  apiName?: InputMaybe<Scalars['String']>;
  apiType?: InputMaybe<Policy_Define_Types_Enum>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PolicyDefines_Max_Fields = {
  __typename?: 'policyDefines_max_fields';
  alignmentOrder?: Maybe<Scalars['bigint']>;
  apiName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PolicyDefines_Min_Fields = {
  __typename?: 'policyDefines_min_fields';
  alignmentOrder?: Maybe<Scalars['bigint']>;
  apiName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "policy_defines" */
export type PolicyDefines_Mutation_Response = {
  __typename?: 'policyDefines_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyDefines>;
};

/** on_conflict condition type for table "policy_defines" */
export type PolicyDefines_On_Conflict = {
  constraint: PolicyDefines_Constraint;
  update_columns?: Array<PolicyDefines_Update_Column>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_defines". */
export type PolicyDefines_Order_By = {
  alignmentOrder?: InputMaybe<Order_By>;
  apiName?: InputMaybe<Order_By>;
  apiType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  define?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_defines */
export type PolicyDefines_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyDefines_Prepend_Input = {
  define?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "policy_defines" */
export enum PolicyDefines_Select_Column {
  /** column name */
  AlignmentOrder = 'alignmentOrder',
  /** column name */
  ApiName = 'apiName',
  /** column name */
  ApiType = 'apiType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Define = 'define',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "policy_defines" */
export type PolicyDefines_Set_Input = {
  alignmentOrder?: InputMaybe<Scalars['bigint']>;
  apiName?: InputMaybe<Scalars['String']>;
  apiType?: InputMaybe<Policy_Define_Types_Enum>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PolicyDefines_Stddev_Fields = {
  __typename?: 'policyDefines_stddev_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyDefines_Stddev_Pop_Fields = {
  __typename?: 'policyDefines_stddev_pop_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyDefines_Stddev_Samp_Fields = {
  __typename?: 'policyDefines_stddev_samp_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyDefines" */
export type PolicyDefines_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyDefines_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyDefines_Stream_Cursor_Value_Input = {
  alignmentOrder?: InputMaybe<Scalars['bigint']>;
  apiName?: InputMaybe<Scalars['String']>;
  apiType?: InputMaybe<Policy_Define_Types_Enum>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  define?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PolicyDefines_Sum_Fields = {
  __typename?: 'policyDefines_sum_fields';
  alignmentOrder?: Maybe<Scalars['bigint']>;
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "policy_defines" */
export enum PolicyDefines_Update_Column {
  /** column name */
  AlignmentOrder = 'alignmentOrder',
  /** column name */
  ApiName = 'apiName',
  /** column name */
  ApiType = 'apiType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Define = 'define',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyDefines_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyDefines_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyDefines_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyDefines_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyDefines_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyDefines_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyDefines_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyDefines_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyDefines_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyDefines_Var_Pop_Fields = {
  __typename?: 'policyDefines_var_pop_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyDefines_Var_Samp_Fields = {
  __typename?: 'policyDefines_var_samp_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyDefines_Variance_Fields = {
  __typename?: 'policyDefines_variance_fields';
  alignmentOrder?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "policy_templates" */
export type PolicyTemplates = {
  __typename?: 'policyTemplates';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  policy: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "policy_templates" */
export type PolicyTemplatesPolicyArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "policy_templates" */
export type PolicyTemplates_Aggregate = {
  __typename?: 'policyTemplates_aggregate';
  aggregate?: Maybe<PolicyTemplates_Aggregate_Fields>;
  nodes: Array<PolicyTemplates>;
};

/** aggregate fields of "policy_templates" */
export type PolicyTemplates_Aggregate_Fields = {
  __typename?: 'policyTemplates_aggregate_fields';
  avg?: Maybe<PolicyTemplates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<PolicyTemplates_Max_Fields>;
  min?: Maybe<PolicyTemplates_Min_Fields>;
  stddev?: Maybe<PolicyTemplates_Stddev_Fields>;
  stddev_pop?: Maybe<PolicyTemplates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<PolicyTemplates_Stddev_Samp_Fields>;
  sum?: Maybe<PolicyTemplates_Sum_Fields>;
  var_pop?: Maybe<PolicyTemplates_Var_Pop_Fields>;
  var_samp?: Maybe<PolicyTemplates_Var_Samp_Fields>;
  variance?: Maybe<PolicyTemplates_Variance_Fields>;
};


/** aggregate fields of "policy_templates" */
export type PolicyTemplates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<PolicyTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PolicyTemplates_Append_Input = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type PolicyTemplates_Avg_Fields = {
  __typename?: 'policyTemplates_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "policy_templates". All fields are combined with a logical 'AND'. */
export type PolicyTemplates_Bool_Exp = {
  _and?: InputMaybe<Array<PolicyTemplates_Bool_Exp>>;
  _not?: InputMaybe<PolicyTemplates_Bool_Exp>;
  _or?: InputMaybe<Array<PolicyTemplates_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  policy?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_templates" */
export enum PolicyTemplates_Constraint {
  /** unique or primary key constraint on columns "id" */
  PolicyTemplatesPkey = 'policy_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PolicyTemplates_Delete_At_Path_Input = {
  policy?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PolicyTemplates_Delete_Elem_Input = {
  policy?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PolicyTemplates_Delete_Key_Input = {
  policy?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "policy_templates" */
export type PolicyTemplates_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "policy_templates" */
export type PolicyTemplates_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type PolicyTemplates_Max_Fields = {
  __typename?: 'policyTemplates_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type PolicyTemplates_Min_Fields = {
  __typename?: 'policyTemplates_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "policy_templates" */
export type PolicyTemplates_Mutation_Response = {
  __typename?: 'policyTemplates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<PolicyTemplates>;
};

/** on_conflict condition type for table "policy_templates" */
export type PolicyTemplates_On_Conflict = {
  constraint: PolicyTemplates_Constraint;
  update_columns?: Array<PolicyTemplates_Update_Column>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_templates". */
export type PolicyTemplates_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  policy?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_templates */
export type PolicyTemplates_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PolicyTemplates_Prepend_Input = {
  policy?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "policy_templates" */
export enum PolicyTemplates_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Policy = 'policy',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "policy_templates" */
export type PolicyTemplates_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type PolicyTemplates_Stddev_Fields = {
  __typename?: 'policyTemplates_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type PolicyTemplates_Stddev_Pop_Fields = {
  __typename?: 'policyTemplates_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type PolicyTemplates_Stddev_Samp_Fields = {
  __typename?: 'policyTemplates_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "policyTemplates" */
export type PolicyTemplates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: PolicyTemplates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type PolicyTemplates_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  policy?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type PolicyTemplates_Sum_Fields = {
  __typename?: 'policyTemplates_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "policy_templates" */
export enum PolicyTemplates_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Policy = 'policy',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type PolicyTemplates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PolicyTemplates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<PolicyTemplates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<PolicyTemplates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<PolicyTemplates_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PolicyTemplates_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PolicyTemplates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PolicyTemplates_Set_Input>;
  /** filter the rows which have to be updated */
  where: PolicyTemplates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type PolicyTemplates_Var_Pop_Fields = {
  __typename?: 'policyTemplates_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type PolicyTemplates_Var_Samp_Fields = {
  __typename?: 'policyTemplates_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type PolicyTemplates_Variance_Fields = {
  __typename?: 'policyTemplates_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "policy_define_types" */
export type Policy_Define_Types = {
  __typename?: 'policy_define_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "policy_define_types" */
export type Policy_Define_Types_Aggregate = {
  __typename?: 'policy_define_types_aggregate';
  aggregate?: Maybe<Policy_Define_Types_Aggregate_Fields>;
  nodes: Array<Policy_Define_Types>;
};

/** aggregate fields of "policy_define_types" */
export type Policy_Define_Types_Aggregate_Fields = {
  __typename?: 'policy_define_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Policy_Define_Types_Max_Fields>;
  min?: Maybe<Policy_Define_Types_Min_Fields>;
};


/** aggregate fields of "policy_define_types" */
export type Policy_Define_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Policy_Define_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "policy_define_types". All fields are combined with a logical 'AND'. */
export type Policy_Define_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Policy_Define_Types_Bool_Exp>>;
  _not?: InputMaybe<Policy_Define_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Policy_Define_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "policy_define_types" */
export enum Policy_Define_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  PolicyDefineTypesPkey = 'policy_define_types_pkey'
}

export enum Policy_Define_Types_Enum {
  /** graphql */
  Graphql = 'graphql'
}

/** Boolean expression to compare columns of type "policy_define_types_enum". All fields are combined with logical 'AND'. */
export type Policy_Define_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Policy_Define_Types_Enum>;
  _in?: InputMaybe<Array<Policy_Define_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Policy_Define_Types_Enum>;
  _nin?: InputMaybe<Array<Policy_Define_Types_Enum>>;
};

/** input type for inserting data into table "policy_define_types" */
export type Policy_Define_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Policy_Define_Types_Max_Fields = {
  __typename?: 'policy_define_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Policy_Define_Types_Min_Fields = {
  __typename?: 'policy_define_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "policy_define_types" */
export type Policy_Define_Types_Mutation_Response = {
  __typename?: 'policy_define_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Policy_Define_Types>;
};

/** on_conflict condition type for table "policy_define_types" */
export type Policy_Define_Types_On_Conflict = {
  constraint: Policy_Define_Types_Constraint;
  update_columns?: Array<Policy_Define_Types_Update_Column>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "policy_define_types". */
export type Policy_Define_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: policy_define_types */
export type Policy_Define_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "policy_define_types" */
export enum Policy_Define_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "policy_define_types" */
export type Policy_Define_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "policy_define_types" */
export type Policy_Define_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Policy_Define_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Policy_Define_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "policy_define_types" */
export enum Policy_Define_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Policy_Define_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Policy_Define_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Policy_Define_Types_Bool_Exp;
};

/** columns and relationships of "providers" */
export type Providers = {
  __typename?: 'providers';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  /** An array relationship */
  providersAssets: Array<ProvidersAssets>;
  /** An aggregate relationship */
  providersAssets_aggregate: ProvidersAssets_Aggregate;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "providers" */
export type ProvidersProvidersAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


/** columns and relationships of "providers" */
export type ProvidersProvidersAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};

/** columns and relationships of "providers_assets" */
export type ProvidersAssets = {
  __typename?: 'providersAssets';
  assetId: Scalars['String'];
  /** An object relationship */
  assets?: Maybe<Assets>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  /** An object relationship */
  providers?: Maybe<Providers>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "providers_assets" */
export type ProvidersAssets_Aggregate = {
  __typename?: 'providersAssets_aggregate';
  aggregate?: Maybe<ProvidersAssets_Aggregate_Fields>;
  nodes: Array<ProvidersAssets>;
};

export type ProvidersAssets_Aggregate_Bool_Exp = {
  count?: InputMaybe<ProvidersAssets_Aggregate_Bool_Exp_Count>;
};

export type ProvidersAssets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<ProvidersAssets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "providers_assets" */
export type ProvidersAssets_Aggregate_Fields = {
  __typename?: 'providersAssets_aggregate_fields';
  avg?: Maybe<ProvidersAssets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<ProvidersAssets_Max_Fields>;
  min?: Maybe<ProvidersAssets_Min_Fields>;
  stddev?: Maybe<ProvidersAssets_Stddev_Fields>;
  stddev_pop?: Maybe<ProvidersAssets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<ProvidersAssets_Stddev_Samp_Fields>;
  sum?: Maybe<ProvidersAssets_Sum_Fields>;
  var_pop?: Maybe<ProvidersAssets_Var_Pop_Fields>;
  var_samp?: Maybe<ProvidersAssets_Var_Samp_Fields>;
  variance?: Maybe<ProvidersAssets_Variance_Fields>;
};


/** aggregate fields of "providers_assets" */
export type ProvidersAssets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "providers_assets" */
export type ProvidersAssets_Aggregate_Order_By = {
  avg?: InputMaybe<ProvidersAssets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<ProvidersAssets_Max_Order_By>;
  min?: InputMaybe<ProvidersAssets_Min_Order_By>;
  stddev?: InputMaybe<ProvidersAssets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<ProvidersAssets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<ProvidersAssets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<ProvidersAssets_Sum_Order_By>;
  var_pop?: InputMaybe<ProvidersAssets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<ProvidersAssets_Var_Samp_Order_By>;
  variance?: InputMaybe<ProvidersAssets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "providers_assets" */
export type ProvidersAssets_Arr_Rel_Insert_Input = {
  data: Array<ProvidersAssets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<ProvidersAssets_On_Conflict>;
};

/** aggregate avg on columns */
export type ProvidersAssets_Avg_Fields = {
  __typename?: 'providersAssets_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "providers_assets" */
export type ProvidersAssets_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "providers_assets". All fields are combined with a logical 'AND'. */
export type ProvidersAssets_Bool_Exp = {
  _and?: InputMaybe<Array<ProvidersAssets_Bool_Exp>>;
  _not?: InputMaybe<ProvidersAssets_Bool_Exp>;
  _or?: InputMaybe<Array<ProvidersAssets_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  providerId?: InputMaybe<String_Comparison_Exp>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "providers_assets" */
export enum ProvidersAssets_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProvidersAssetsPkey = 'providers_assets_pkey'
}

/** input type for incrementing numeric columns in table "providers_assets" */
export type ProvidersAssets_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "providers_assets" */
export type ProvidersAssets_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Providers_Obj_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type ProvidersAssets_Max_Fields = {
  __typename?: 'providersAssets_max_fields';
  assetId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "providers_assets" */
export type ProvidersAssets_Max_Order_By = {
  assetId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type ProvidersAssets_Min_Fields = {
  __typename?: 'providersAssets_min_fields';
  assetId?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  providerId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "providers_assets" */
export type ProvidersAssets_Min_Order_By = {
  assetId?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "providers_assets" */
export type ProvidersAssets_Mutation_Response = {
  __typename?: 'providersAssets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<ProvidersAssets>;
};

/** on_conflict condition type for table "providers_assets" */
export type ProvidersAssets_On_Conflict = {
  constraint: ProvidersAssets_Constraint;
  update_columns?: Array<ProvidersAssets_Update_Column>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};

/** Ordering options when selecting data from "providers_assets". */
export type ProvidersAssets_Order_By = {
  assetId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providerId?: InputMaybe<Order_By>;
  providers?: InputMaybe<Providers_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providers_assets */
export type ProvidersAssets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "providers_assets" */
export enum ProvidersAssets_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "providers_assets" */
export type ProvidersAssets_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type ProvidersAssets_Stddev_Fields = {
  __typename?: 'providersAssets_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "providers_assets" */
export type ProvidersAssets_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type ProvidersAssets_Stddev_Pop_Fields = {
  __typename?: 'providersAssets_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "providers_assets" */
export type ProvidersAssets_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type ProvidersAssets_Stddev_Samp_Fields = {
  __typename?: 'providersAssets_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "providers_assets" */
export type ProvidersAssets_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "providersAssets" */
export type ProvidersAssets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: ProvidersAssets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type ProvidersAssets_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providerId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type ProvidersAssets_Sum_Fields = {
  __typename?: 'providersAssets_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "providers_assets" */
export type ProvidersAssets_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "providers_assets" */
export enum ProvidersAssets_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ProviderId = 'providerId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type ProvidersAssets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ProvidersAssets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProvidersAssets_Set_Input>;
  /** filter the rows which have to be updated */
  where: ProvidersAssets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type ProvidersAssets_Var_Pop_Fields = {
  __typename?: 'providersAssets_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "providers_assets" */
export type ProvidersAssets_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type ProvidersAssets_Var_Samp_Fields = {
  __typename?: 'providersAssets_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "providers_assets" */
export type ProvidersAssets_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type ProvidersAssets_Variance_Fields = {
  __typename?: 'providersAssets_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "providers_assets" */
export type ProvidersAssets_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregated selection of "providers" */
export type Providers_Aggregate = {
  __typename?: 'providers_aggregate';
  aggregate?: Maybe<Providers_Aggregate_Fields>;
  nodes: Array<Providers>;
};

export type Providers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Providers_Aggregate_Bool_Exp_Count>;
};

export type Providers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Providers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "providers" */
export type Providers_Aggregate_Fields = {
  __typename?: 'providers_aggregate_fields';
  avg?: Maybe<Providers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Providers_Max_Fields>;
  min?: Maybe<Providers_Min_Fields>;
  stddev?: Maybe<Providers_Stddev_Fields>;
  stddev_pop?: Maybe<Providers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Providers_Stddev_Samp_Fields>;
  sum?: Maybe<Providers_Sum_Fields>;
  var_pop?: Maybe<Providers_Var_Pop_Fields>;
  var_samp?: Maybe<Providers_Var_Samp_Fields>;
  variance?: Maybe<Providers_Variance_Fields>;
};


/** aggregate fields of "providers" */
export type Providers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Providers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "providers" */
export type Providers_Aggregate_Order_By = {
  avg?: InputMaybe<Providers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Providers_Max_Order_By>;
  min?: InputMaybe<Providers_Min_Order_By>;
  stddev?: InputMaybe<Providers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Providers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Providers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Providers_Sum_Order_By>;
  var_pop?: InputMaybe<Providers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Providers_Var_Samp_Order_By>;
  variance?: InputMaybe<Providers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "providers" */
export type Providers_Arr_Rel_Insert_Input = {
  data: Array<Providers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};

/** aggregate avg on columns */
export type Providers_Avg_Fields = {
  __typename?: 'providers_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "providers" */
export type Providers_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "providers". All fields are combined with a logical 'AND'. */
export type Providers_Bool_Exp = {
  _and?: InputMaybe<Array<Providers_Bool_Exp>>;
  _not?: InputMaybe<Providers_Bool_Exp>;
  _or?: InputMaybe<Array<Providers_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  providersAssets?: InputMaybe<ProvidersAssets_Bool_Exp>;
  providersAssets_aggregate?: InputMaybe<ProvidersAssets_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "providers" */
export enum Providers_Constraint {
  /** unique or primary key constraint on columns "name" */
  ProvidersNameKey = 'providers_name_key',
  /** unique or primary key constraint on columns "id" */
  ProvidersPkey = 'providers_pkey'
}

/** input type for incrementing numeric columns in table "providers" */
export type Providers_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "providers" */
export type Providers_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providersAssets?: InputMaybe<ProvidersAssets_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Providers_Max_Fields = {
  __typename?: 'providers_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "providers" */
export type Providers_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Providers_Min_Fields = {
  __typename?: 'providers_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "providers" */
export type Providers_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "providers" */
export type Providers_Mutation_Response = {
  __typename?: 'providers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Providers>;
};

/** input type for inserting object relation for remote table "providers" */
export type Providers_Obj_Rel_Insert_Input = {
  data: Providers_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Providers_On_Conflict>;
};

/** on_conflict condition type for table "providers" */
export type Providers_On_Conflict = {
  constraint: Providers_Constraint;
  update_columns?: Array<Providers_Update_Column>;
  where?: InputMaybe<Providers_Bool_Exp>;
};

/** Ordering options when selecting data from "providers". */
export type Providers_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providersAssets_aggregate?: InputMaybe<ProvidersAssets_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: providers */
export type Providers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "providers" */
export enum Providers_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "providers" */
export type Providers_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Providers_Stddev_Fields = {
  __typename?: 'providers_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "providers" */
export type Providers_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Providers_Stddev_Pop_Fields = {
  __typename?: 'providers_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "providers" */
export type Providers_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Providers_Stddev_Samp_Fields = {
  __typename?: 'providers_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "providers" */
export type Providers_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "providers" */
export type Providers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Providers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Providers_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Providers_Sum_Fields = {
  __typename?: 'providers_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "providers" */
export type Providers_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "providers" */
export enum Providers_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Providers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Providers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Providers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Providers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Providers_Var_Pop_Fields = {
  __typename?: 'providers_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "providers" */
export type Providers_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Providers_Var_Samp_Fields = {
  __typename?: 'providers_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "providers" */
export type Providers_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Providers_Variance_Fields = {
  __typename?: 'providers_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "providers" */
export type Providers_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "access_logs" using primary key columns */
  accessLogByPk?: Maybe<AccessLogs>;
  /** fetch data from the table: "access_logs" */
  accessLogs: Array<AccessLogs>;
  /** fetch aggregated fields from the table: "access_logs" */
  accessLogsAggregate: AccessLogs_Aggregate;
  /** fetch data from the table: "assets_assets" using primary key columns */
  assetAssetByPk?: Maybe<AssetsAssets>;
  /** fetch data from the table: "assets" using primary key columns */
  assetByPk?: Maybe<Assets>;
  /** fetch data from the table: "asset_images" using primary key columns */
  assetImageByPk?: Maybe<AssetImages>;
  /** An array relationship */
  assetImages: Array<AssetImages>;
  /** fetch aggregated fields from the table: "asset_images" */
  assetImagesAggregate: AssetImages_Aggregate;
  /** An array relationship */
  assetProperties: Array<AssetProperties>;
  /** fetch aggregated fields from the table: "asset_properties" */
  assetPropertiesAggregate: AssetProperties_Aggregate;
  /** fetch data from the table: "asset_properties" using primary key columns */
  assetPropertyByPk?: Maybe<AssetProperties>;
  /** fetch data from the table: "asset_states" using primary key columns */
  assetStateByPk?: Maybe<Asset_States>;
  /** fetch data from the table: "asset_states" */
  assetStates: Array<Asset_States>;
  /** fetch aggregated fields from the table: "asset_states" */
  assetStatesAggregate: Asset_States_Aggregate;
  /** fetch data from the table: "asset_tags" using primary key columns */
  assetTagByPk?: Maybe<AssetTags>;
  /** An array relationship */
  assetTags: Array<AssetTags>;
  /** fetch aggregated fields from the table: "asset_tags" */
  assetTagsAggregate: AssetTags_Aggregate;
  /** fetch data from the table: "asset_types" using primary key columns */
  assetTypeByPk?: Maybe<AssetTypes>;
  /** fetch data from the table: "asset_types" */
  assetTypes: Array<AssetTypes>;
  /** fetch aggregated fields from the table: "asset_types" */
  assetTypesAggregate: AssetTypes_Aggregate;
  /** An array relationship */
  assets: Array<Assets>;
  /** fetch aggregated fields from the table: "assets" */
  assetsAggregate: Assets_Aggregate;
  /** fetch data from the table: "assets_assets" */
  assetsAssets: Array<AssetsAssets>;
  /** fetch aggregated fields from the table: "assets_assets" */
  assetsAssetsAggregate: AssetsAssets_Aggregate;
  /** fetch data from the table: "authorization_info" */
  authorizationInfo: Array<AuthorizationInfo>;
  /** fetch aggregated fields from the table: "authorization_info" */
  authorizationInfoAggregate: AuthorizationInfo_Aggregate;
  /** fetch data from the table: "authorization_info" using primary key columns */
  authorizationInfoByPk?: Maybe<AuthorizationInfo>;
  /** fetch data from the table: "authorization_tenant_service_info" */
  authorizationTenantServiceInfo: Array<AuthorizationTenantServiceInfo>;
  /** fetch aggregated fields from the table: "authorization_tenant_service_info" */
  authorizationTenantServiceInfoAggregate: AuthorizationTenantServiceInfo_Aggregate;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categoriesAggregate: Categories_Aggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categoryByPk?: Maybe<Categories>;
  /** fetch data from the table: "client_types" using primary key columns */
  clientTypeByPk?: Maybe<ClientTypes>;
  /** fetch data from the table: "client_types" */
  clientTypes: Array<ClientTypes>;
  /** fetch aggregated fields from the table: "client_types" */
  clientTypesAggregate: ClientTypes_Aggregate;
  /** fetch data from the table: "consents" using primary key columns */
  consentByPk?: Maybe<Consents>;
  /** An array relationship */
  consents: Array<Consents>;
  /** fetch aggregated fields from the table: "consents" */
  consentsAggregate: Consents_Aggregate;
  /** fetch data from the table: "csv_records" */
  csvRecords: Array<CsvRecords>;
  /** fetch aggregated fields from the table: "csv_records" */
  csvRecordsAggregate: CsvRecords_Aggregate;
  /** fetch data from the table: "csv_records" using primary key columns */
  csvRecordsByPk?: Maybe<CsvRecords>;
  /** fetch data from the table: "data_access_logs" using primary key columns */
  dataAccessLogByPk?: Maybe<DataAccessLogs>;
  /** fetch data from the table: "data_access_logs" */
  dataAccessLogs: Array<DataAccessLogs>;
  /** fetch aggregated fields from the table: "data_access_logs" */
  dataAccessLogsAggregate: DataAccessLogs_Aggregate;
  /** fetch data from the table: "detections" using primary key columns */
  detectionByPk?: Maybe<Detections>;
  /** fetch data from the table: "detection_logs" using primary key columns */
  detectionLogByPk?: Maybe<DetectionLogs>;
  /** fetch data from the table: "detection_logs" */
  detectionLogs: Array<DetectionLogs>;
  /** fetch aggregated fields from the table: "detection_logs" */
  detectionLogsAggregate: DetectionLogs_Aggregate;
  /** fetch data from the table: "detection_sets" using primary key columns */
  detectionSetByPk?: Maybe<DetectionSets>;
  /** fetch data from the table: "detection_sets" */
  detectionSets: Array<DetectionSets>;
  /** fetch aggregated fields from the table: "detection_sets" */
  detectionSetsAggregate: DetectionSets_Aggregate;
  /** fetch data from the table: "detection_states" using primary key columns */
  detectionStateByPk?: Maybe<Detection_States>;
  /** fetch data from the table: "detection_states" */
  detectionStates: Array<Detection_States>;
  /** fetch aggregated fields from the table: "detection_states" */
  detectionStatesAggregate: Detection_States_Aggregate;
  /** fetch data from the table: "detections" */
  detections: Array<Detections>;
  /** fetch aggregated fields from the table: "detections" */
  detectionsAggregate: Detections_Aggregate;
  /** fetch data from the table: "evacuation_settings" using primary key columns */
  evacuationSettingByPk?: Maybe<EvacuationSettings>;
  /** fetch data from the table: "evacuation_settings" */
  evacuationSettings: Array<EvacuationSettings>;
  /** fetch aggregated fields from the table: "evacuation_settings" */
  evacuationSettingsAggregate: EvacuationSettings_Aggregate;
  /** fetch data from the table: "events" using primary key columns */
  eventByPk?: Maybe<Events>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch aggregated fields from the table: "events" */
  eventsAggregate: Events_Aggregate;
  /** fetch data from the table: "execution_histories" */
  executionHistories: Array<ExecutionHistories>;
  /** fetch aggregated fields from the table: "execution_histories" */
  executionHistoriesAggregate: ExecutionHistories_Aggregate;
  /** fetch data from the table: "execution_histories" using primary key columns */
  executionHistoryByPk?: Maybe<ExecutionHistories>;
  /** fetch data from the table: "file_states" using primary key columns */
  fileStateByPk?: Maybe<File_States>;
  /** fetch data from the table: "file_states" */
  fileStates: Array<File_States>;
  /** fetch aggregated fields from the table: "file_states" */
  fileStatesAggregate: File_States_Aggregate;
  /** fetch data from the table: "groups" using primary key columns */
  groupByPk?: Maybe<Groups>;
  /** fetch data from the table: "groups" */
  groups: Array<Groups>;
  /** fetch aggregated fields from the table: "groups" */
  groupsAggregate: Groups_Aggregate;
  /** fetch data from the table: "idps" using primary key columns */
  idpByPk?: Maybe<Idps>;
  /** fetch data from the table: "idp_types" using primary key columns */
  idpTypeByPk?: Maybe<IdpTypes>;
  /** fetch data from the table: "idp_types" */
  idpTypes: Array<IdpTypes>;
  /** fetch aggregated fields from the table: "idp_types" */
  idpTypesAggregate: IdpTypes_Aggregate;
  /** fetch data from the table: "idps" */
  idps: Array<Idps>;
  /** fetch aggregated fields from the table: "idps" */
  idpsAggregate: Idps_Aggregate;
  /** fetch data from the table: "job_settings" using primary key columns */
  jobSettingByPk?: Maybe<JobSettings>;
  /** fetch data from the table: "job_settings" */
  jobSettings: Array<JobSettings>;
  /** fetch aggregated fields from the table: "job_settings" */
  jobSettingsAggregate: JobSettings_Aggregate;
  /** fetch data from the table: "job_site_attributes" using primary key columns */
  jobSiteAttributeByPk?: Maybe<JobSiteAttributes>;
  /** fetch data from the table: "job_site_attributes" */
  jobSiteAttributes: Array<JobSiteAttributes>;
  /** fetch aggregated fields from the table: "job_site_attributes" */
  jobSiteAttributesAggregate: JobSiteAttributes_Aggregate;
  /** fetch data from the table: "job_sites" using primary key columns */
  jobSiteByPk?: Maybe<JobSites>;
  /** fetch data from the table: "job_sites" */
  jobSites: Array<JobSites>;
  /** fetch aggregated fields from the table: "job_sites" */
  jobSitesAggregate: JobSites_Aggregate;
  /** fetch data from the table: "login_logs" using primary key columns */
  loginLogByPk?: Maybe<Login_Logs>;
  /** fetch data from the table: "login_logs" */
  loginLogs: Array<Login_Logs>;
  /** fetch aggregated fields from the table: "login_logs" */
  loginLogsAggregate: Login_Logs_Aggregate;
  /** fetch data from the table: "messages" using primary key columns */
  messageByPk?: Maybe<Messages>;
  /** fetch data from the table: "message_formats" using primary key columns */
  messageFormatByPk?: Maybe<MessageFormats>;
  /** fetch data from the table: "message_formats" */
  messageFormats: Array<MessageFormats>;
  /** fetch aggregated fields from the table: "message_formats" */
  messageFormatsAggregate: MessageFormats_Aggregate;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch aggregated fields from the table: "messages" */
  messagesAggregate: Messages_Aggregate;
  /** fetch data from the table: "multiple_detections" using primary key columns */
  multipleDetectionByPk?: Maybe<MultipleDetections>;
  /** fetch data from the table: "multiple_detections" */
  multipleDetections: Array<MultipleDetections>;
  /** fetch aggregated fields from the table: "multiple_detections" */
  multipleDetectionsAggregate: MultipleDetections_Aggregate;
  /** fetch data from the table: "notification_conditions" using primary key columns */
  notificationConditionByPk?: Maybe<NotificationConditions>;
  /** fetch data from the table: "notification_condition_details" using primary key columns */
  notificationConditionDetailByPk?: Maybe<NotificationConditionDetails>;
  /** An array relationship */
  notificationConditionDetails: Array<NotificationConditionDetails>;
  /** fetch aggregated fields from the table: "notification_condition_details" */
  notificationConditionDetailsAggregate: NotificationConditionDetails_Aggregate;
  /** fetch data from the table: "notification_conditions" */
  notificationConditions: Array<NotificationConditions>;
  /** fetch aggregated fields from the table: "notification_conditions" */
  notificationConditionsAggregate: NotificationConditions_Aggregate;
  notificationConditionsAggregateNative: Array<NotificationConditionsAggregateNativeModel>;
  notificationCountAggregateNative: Array<NotificationCountAggregateNativeModel>;
  /** fetch data from the table: "notification_events" using primary key columns */
  notificationEventByPk?: Maybe<NotificationEvents>;
  /** fetch data from the table: "notification_events" */
  notificationEvents: Array<NotificationEvents>;
  /** fetch aggregated fields from the table: "notification_events" */
  notificationEventsAggregate: NotificationEvents_Aggregate;
  /** fetch data from the table: "notification_histories" */
  notificationHistories: Array<NotificationHistories>;
  /** fetch aggregated fields from the table: "notification_histories" */
  notificationHistoriesAggregate: NotificationHistories_Aggregate;
  /** fetch data from the table: "notification_histories" using primary key columns */
  notificationHistoryByPk?: Maybe<NotificationHistories>;
  /** fetch data from the table: "notification_history_states" using primary key columns */
  notificationHistoryStateByPk?: Maybe<Notification_History_States>;
  /** fetch data from the table: "notification_history_states" */
  notificationHistoryStates: Array<Notification_History_States>;
  /** fetch aggregated fields from the table: "notification_history_states" */
  notificationHistoryStatesAggregate: Notification_History_States_Aggregate;
  /** fetch data from the table: "notification_services" using primary key columns */
  notificationServiceByPk?: Maybe<NotificationServices>;
  /** fetch data from the table: "notification_services" */
  notificationServices: Array<NotificationServices>;
  /** fetch aggregated fields from the table: "notification_services" */
  notificationServicesAggregate: NotificationServices_Aggregate;
  /** fetch data from the table: "notification_settings" using primary key columns */
  notificationSettingByPk?: Maybe<NotificationSettings>;
  /** An array relationship */
  notificationSettings: Array<NotificationSettings>;
  /** fetch aggregated fields from the table: "notification_settings" */
  notificationSettingsAggregate: NotificationSettings_Aggregate;
  notificationStateAggregateNative: Array<NotificationStateAggregateNativeModel>;
  /** fetch data from the table: "notification_targets" using primary key columns */
  notificationTargetByPk?: Maybe<NotificationTargets>;
  /** fetch data from the table: "notification_target_states" using primary key columns */
  notificationTargetStateByPk?: Maybe<Notification_Target_States>;
  /** fetch data from the table: "notification_target_states" */
  notificationTargetStates: Array<Notification_Target_States>;
  /** fetch aggregated fields from the table: "notification_target_states" */
  notificationTargetStatesAggregate: Notification_Target_States_Aggregate;
  /** fetch data from the table: "notification_targets" */
  notificationTargets: Array<NotificationTargets>;
  /** fetch aggregated fields from the table: "notification_targets" */
  notificationTargetsAggregate: NotificationTargets_Aggregate;
  /** fetch data from the table: "notification_templates" using primary key columns */
  notificationTemplateByPk?: Maybe<NotificationTemplates>;
  /** fetch data from the table: "notification_templates" */
  notificationTemplates: Array<NotificationTemplates>;
  /** fetch aggregated fields from the table: "notification_templates" */
  notificationTemplatesAggregate: NotificationTemplates_Aggregate;
  /** fetch data from the table: "notification_users" using primary key columns */
  notificationUserByPk?: Maybe<NotificationUsers>;
  /** fetch data from the table: "notification_user_states" using primary key columns */
  notificationUserStateByPk?: Maybe<Notification_User_States>;
  /** fetch data from the table: "notification_user_states" */
  notificationUserStates: Array<Notification_User_States>;
  /** fetch aggregated fields from the table: "notification_user_states" */
  notificationUserStatesAggregate: Notification_User_States_Aggregate;
  /** An array relationship */
  notificationUserTemp: Array<NotificationUserTemp>;
  /** fetch aggregated fields from the table: "notification_user_temp" */
  notificationUserTempAggregate: NotificationUserTemp_Aggregate;
  /** fetch data from the table: "notification_user_temp" using primary key columns */
  notificationUserTempByPk?: Maybe<NotificationUserTemp>;
  /** An array relationship */
  notificationUsers: Array<NotificationUsers>;
  /** fetch aggregated fields from the table: "notification_users" */
  notificationUsersAggregate: NotificationUsers_Aggregate;
  /** fetch data from the table: "policies" */
  policies: Array<Policies>;
  /** fetch aggregated fields from the table: "policies" */
  policiesAggregate: Policies_Aggregate;
  /**  ## ポリシー */
  policy?: Maybe<Policy>;
  /** fetch data from the table: "policies" using primary key columns */
  policyByPk?: Maybe<Policies>;
  /** fetch data from the table: "policy_defines" using primary key columns */
  policyDefineByPk?: Maybe<PolicyDefines>;
  /** fetch data from the table: "policy_define_types" using primary key columns */
  policyDefineTypeByPk?: Maybe<Policy_Define_Types>;
  /** fetch data from the table: "policy_define_types" */
  policyDefineTypes: Array<Policy_Define_Types>;
  /** fetch aggregated fields from the table: "policy_define_types" */
  policyDefineTypesAggregate: Policy_Define_Types_Aggregate;
  /** fetch data from the table: "policy_defines" */
  policyDefines: Array<PolicyDefines>;
  /** fetch aggregated fields from the table: "policy_defines" */
  policyDefinesAggregate: PolicyDefines_Aggregate;
  /** fetch data from the table: "policy_templates" using primary key columns */
  policyTemplateByPk?: Maybe<PolicyTemplates>;
  /** fetch data from the table: "policy_templates" */
  policyTemplates: Array<PolicyTemplates>;
  /** fetch aggregated fields from the table: "policy_templates" */
  policyTemplatesAggregate: PolicyTemplates_Aggregate;
  /** fetch data from the table: "providers_assets" using primary key columns */
  providerAssetByPk?: Maybe<ProvidersAssets>;
  /** fetch data from the table: "providers" using primary key columns */
  providerByPk?: Maybe<Providers>;
  /** An array relationship */
  providers: Array<Providers>;
  /** fetch aggregated fields from the table: "providers" */
  providersAggregate: Providers_Aggregate;
  /** An array relationship */
  providersAssets: Array<ProvidersAssets>;
  /** fetch aggregated fields from the table: "providers_assets" */
  providersAssetsAggregate: ProvidersAssets_Aggregate;
  /** fetch data from the table: "relay_api_services" using primary key columns */
  relayApiServiceByPk?: Maybe<RelayApiServices>;
  /** An array relationship */
  relayApiServices: Array<RelayApiServices>;
  /** fetch aggregated fields from the table: "relay_api_services" */
  relayApiServicesAggregate: RelayApiServices_Aggregate;
  /** fetch data from the table: "relay_services" using primary key columns */
  relayServiceByPk?: Maybe<RelayServices>;
  /** fetch data from the table: "relay_services" */
  relayServices: Array<RelayServices>;
  /** fetch aggregated fields from the table: "relay_services" */
  relayServicesAggregate: RelayServices_Aggregate;
  /** fetch data from the table: "request_settings" using primary key columns */
  requestSettingByPk?: Maybe<RequestSettings>;
  /** fetch data from the table: "request_settings" */
  requestSettings: Array<RequestSettings>;
  /** fetch aggregated fields from the table: "request_settings" */
  requestSettingsAggregate: RequestSettings_Aggregate;
  /** fetch data from the table: "request_templates" using primary key columns */
  requestTemplateByPk?: Maybe<RequestTemplates>;
  /** fetch data from the table: "request_template_types" using primary key columns */
  requestTemplateTypeByPk?: Maybe<Request_Template_Types>;
  /** fetch data from the table: "request_template_types" */
  requestTemplateTypes: Array<Request_Template_Types>;
  /** fetch aggregated fields from the table: "request_template_types" */
  requestTemplateTypesAggregate: Request_Template_Types_Aggregate;
  /** fetch data from the table: "request_templates" */
  requestTemplates: Array<RequestTemplates>;
  /** fetch aggregated fields from the table: "request_templates" */
  requestTemplatesAggregate: RequestTemplates_Aggregate;
  /** fetch data from the table: "requests" */
  requests: Array<Requests>;
  /** fetch aggregated fields from the table: "requests" */
  requestsAggregate: Requests_Aggregate;
  /** fetch data from the table: "rest2graphql_settings" */
  rest2graphqlSettings: Array<Rest2graphqlSettings>;
  /** fetch aggregated fields from the table: "rest2graphql_settings" */
  rest2graphqlSettingsAggregate: Rest2graphqlSettings_Aggregate;
  /** fetch data from the table: "rest2graphql_settings" using primary key columns */
  rest2graphqlSettingsByPk?: Maybe<Rest2graphqlSettings>;
  /** fetch data from the table: "schedules" using primary key columns */
  scheduleByPk?: Maybe<Schedules>;
  /** fetch data from the table: "schedules" */
  schedules: Array<Schedules>;
  /** fetch aggregated fields from the table: "schedules" */
  schedulesAggregate: Schedules_Aggregate;
  /** fetch data from the table: "sensitive_information" */
  sensitiveInformation: Array<SensitiveInformation>;
  /** fetch aggregated fields from the table: "sensitive_information" */
  sensitiveInformationAggregate: SensitiveInformation_Aggregate;
  /** fetch data from the table: "sensitive_information" using primary key columns */
  sensitiveInformationByPk?: Maybe<SensitiveInformation>;
  /** fetch data from the table: "sensitive_information_categories" */
  sensitiveInformationCategories: Array<SensitiveInformationCategories>;
  /** fetch aggregated fields from the table: "sensitive_information_categories" */
  sensitiveInformationCategoriesAggregate: SensitiveInformationCategories_Aggregate;
  /** fetch data from the table: "sensitive_information_categories" using primary key columns */
  sensitiveInformationCategoryByPk?: Maybe<SensitiveInformationCategories>;
  /** An array relationship */
  sensitiveInformationHistories: Array<SensitiveInformationHistories>;
  /** fetch aggregated fields from the table: "sensitive_information_histories" */
  sensitiveInformationHistoriesAggregate: SensitiveInformationHistories_Aggregate;
  /** fetch data from the table: "sensitive_information_histories" using primary key columns */
  sensitiveInformationHistoryByPk?: Maybe<SensitiveInformationHistories>;
  /** fetch data from the table: "sensitive_information_items" using primary key columns */
  sensitiveInformationItemByPk?: Maybe<SensitiveInformationItems>;
  /** An array relationship */
  sensitiveInformationItems: Array<SensitiveInformationItems>;
  /** fetch aggregated fields from the table: "sensitive_information_items" */
  sensitiveInformationItemsAggregate: SensitiveInformationItems_Aggregate;
  /** fetch data from the table: "sensitive_information_request_services" using primary key columns */
  sensitiveInformationRequestServiceByPk?: Maybe<SensitiveInformationRequestServices>;
  /** fetch data from the table: "sensitive_information_request_services" */
  sensitiveInformationRequestServices: Array<SensitiveInformationRequestServices>;
  /** fetch aggregated fields from the table: "sensitive_information_request_services" */
  sensitiveInformationRequestServicesAggregate: SensitiveInformationRequestServices_Aggregate;
  /** fetch data from the table: "sensitive_information_store_service_connections" using primary key columns */
  sensitiveInformationStoreServiceConnectionByPk?: Maybe<SensitiveInformationStoreServiceConnections>;
  /** fetch data from the table: "sensitive_information_store_service_connections" */
  sensitiveInformationStoreServiceConnections: Array<SensitiveInformationStoreServiceConnections>;
  /** fetch aggregated fields from the table: "sensitive_information_store_service_connections" */
  sensitiveInformationStoreServicesConnectionAggregate: SensitiveInformationStoreServiceConnections_Aggregate;
  /** fetch data from the table: "services" */
  services: Array<Services>;
  /** fetch aggregated fields from the table: "services" */
  servicesAggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  servicesByPk?: Maybe<Services>;
  /** fetch data from the table: "sensitive_information_items" using primary key columns */
  storeSensitiveInformationItemByPk?: Maybe<StoreSensitiveInformationItems>;
  /** fetch data from the table: "sensitive_information_items" */
  storeSensitiveInformationItems: Array<StoreSensitiveInformationItems>;
  /** fetch aggregated fields from the table: "sensitive_information_items" */
  storeSensitiveInformationItemsAggregate: StoreSensitiveInformationItems_Aggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantByPk?: Maybe<Tenants>;
  /** fetch data from the table: "tenants_idps" using primary key columns */
  tenantIdpByPk?: Maybe<TenantsIdps>;
  /**  ## テナント公開情報 */
  tenantPublicInfo: Array<Maybe<TenantPublicInfoByAppSync>>;
  /** fetch aggregated fields from the table: "tenant_public_info" */
  tenantPublicInfoAggregate: TenantPublicInfo_Aggregate;
  /** fetch data from the table: "tenant_public_info" using primary key columns */
  tenantPublicInfoByPk?: Maybe<TenantPublicInfo>;
  /** fetch data from the table: "tenant_services" using primary key columns */
  tenantServiceByPk?: Maybe<TenantServices>;
  /** fetch data from the table: "tenant_services" */
  tenantServices: Array<TenantServices>;
  /** fetch aggregated fields from the table: "tenant_services" */
  tenantServicesAggregate: TenantServices_Aggregate;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenantsAggregate: Tenants_Aggregate;
  /** An array relationship */
  tenantsIdps: Array<TenantsIdps>;
  /** fetch aggregated fields from the table: "tenants_idps" */
  tenantsIdpsAggregate: TenantsIdps_Aggregate;
  /** fetch data from the table: "upload_files" using primary key columns */
  uploadFileByPk?: Maybe<UploadFiles>;
  /** fetch data from the table: "upload_files" */
  uploadFiles: Array<UploadFiles>;
  /** fetch aggregated fields from the table: "upload_files" */
  uploadFilesAggregate: UploadFiles_Aggregate;
  /** fetch data from the table: "users" using primary key columns */
  userByPk?: Maybe<Users>;
  /** fetch data from the table: "users_idps" using primary key columns */
  userExternalIdpByPk?: Maybe<UsersIdps>;
  /** fetch data from the table: "users_groups" using primary key columns */
  userGroupByPk?: Maybe<UsersGroups>;
  /** fetch data from the table: "user_policies" */
  userPolicies: Array<UserPolicies>;
  /** fetch aggregated fields from the table: "user_policies" */
  userPoliciesAggregate: UserPolicies_Aggregate;
  /** fetch data from the table: "user_policies" using primary key columns */
  userPolicyByPk?: Maybe<UserPolicies>;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRoleByPk?: Maybe<User_Roles>;
  /** fetch data from the table: "user_roles" */
  userRoles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  userRolesAggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_states" using primary key columns */
  userStateByPk?: Maybe<User_States>;
  /** fetch data from the table: "user_states" */
  userStates: Array<User_States>;
  /** fetch aggregated fields from the table: "user_states" */
  userStatesAggregate: User_States_Aggregate;
  users: Array<User>;
  usersAggregate: UsersAggregateOutput;
  /** fetch data from the table: "users_assets" using primary key columns */
  usersAssetByPk?: Maybe<UsersAssets>;
  /** An array relationship */
  usersAssets: Array<UsersAssets>;
  /** fetch aggregated fields from the table: "users_assets" */
  usersAssetsAggregate: UsersAssets_Aggregate;
  /** fetch data from the table: "users_external_users" using primary key columns */
  usersExternalUserByPk?: Maybe<UsersExternalUsers>;
  /** fetch data from the table: "users_external_users" */
  usersExternalUsers: Array<UsersExternalUsers>;
  /** fetch aggregated fields from the table: "users_external_users" */
  usersExternalUsersAggregate: UsersExternalUsers_Aggregate;
  /** An array relationship */
  usersGroups: Array<UsersGroups>;
  /** fetch aggregated fields from the table: "users_groups" */
  usersGroupsAggregate: UsersGroups_Aggregate;
  /** fetch data from the table: "users_idps" */
  usersIdps: Array<UsersIdps>;
  /** fetch aggregated fields from the table: "users_idps" */
  usersIdpsAggregate: UsersIdps_Aggregate;
  /** fetch data from the table: "users_users" using primary key columns */
  usersUserByPk?: Maybe<UsersUsers>;
  /** An array relationship */
  usersUsers: Array<UsersUsers>;
  /** fetch aggregated fields from the table: "users_users" */
  usersUsersAggregate: UsersUsers_Aggregate;
};


export type Query_RootAccessLogByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAccessLogsArgs = {
  distinct_on?: InputMaybe<Array<AccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccessLogs_Order_By>>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};


export type Query_RootAccessLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccessLogs_Order_By>>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};


export type Query_RootAssetAssetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetImageByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetImagesArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


export type Query_RootAssetImagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


export type Query_RootAssetPropertiesArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


export type Query_RootAssetPropertiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


export type Query_RootAssetPropertyByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootAssetStatesArgs = {
  distinct_on?: InputMaybe<Array<Asset_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_States_Order_By>>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};


export type Query_RootAssetStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_States_Order_By>>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};


export type Query_RootAssetTagByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetTagsArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


export type Query_RootAssetTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


export type Query_RootAssetTypeByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootAssetTypesArgs = {
  distinct_on?: InputMaybe<Array<AssetTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTypes_Order_By>>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};


export type Query_RootAssetTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTypes_Order_By>>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};


export type Query_RootAssetsArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


export type Query_RootAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


export type Query_RootAssetsAssetsArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


export type Query_RootAssetsAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


export type Query_RootAuthorizationInfoArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationInfo_Order_By>>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};


export type Query_RootAuthorizationInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationInfo_Order_By>>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};


export type Query_RootAuthorizationInfoByPkArgs = {
  tenantAlias: Scalars['String'];
};


export type Query_RootAuthorizationTenantServiceInfoArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationTenantServiceInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationTenantServiceInfo_Order_By>>;
  where?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
};


export type Query_RootAuthorizationTenantServiceInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationTenantServiceInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationTenantServiceInfo_Order_By>>;
  where?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
};


export type Query_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Query_RootCategoryByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootClientTypeByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootClientTypesArgs = {
  distinct_on?: InputMaybe<Array<ClientTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientTypes_Order_By>>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};


export type Query_RootClientTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClientTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientTypes_Order_By>>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};


export type Query_RootConsentByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootConsentsArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


export type Query_RootConsentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


export type Query_RootCsvRecordsArgs = {
  distinct_on?: InputMaybe<Array<CsvRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CsvRecords_Order_By>>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};


export type Query_RootCsvRecordsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CsvRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CsvRecords_Order_By>>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};


export type Query_RootCsvRecordsByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootDataAccessLogByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootDataAccessLogsArgs = {
  distinct_on?: InputMaybe<Array<DataAccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataAccessLogs_Order_By>>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};


export type Query_RootDataAccessLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DataAccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataAccessLogs_Order_By>>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};


export type Query_RootDetectionByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootDetectionLogByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootDetectionLogsArgs = {
  distinct_on?: InputMaybe<Array<DetectionLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionLogs_Order_By>>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};


export type Query_RootDetectionLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionLogs_Order_By>>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};


export type Query_RootDetectionSetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootDetectionSetsArgs = {
  distinct_on?: InputMaybe<Array<DetectionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionSets_Order_By>>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};


export type Query_RootDetectionSetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionSets_Order_By>>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};


export type Query_RootDetectionStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootDetectionStatesArgs = {
  distinct_on?: InputMaybe<Array<Detection_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_States_Order_By>>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};


export type Query_RootDetectionStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_States_Order_By>>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};


export type Query_RootDetectionsArgs = {
  distinct_on?: InputMaybe<Array<Detections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detections_Order_By>>;
  where?: InputMaybe<Detections_Bool_Exp>;
};


export type Query_RootDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Detections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detections_Order_By>>;
  where?: InputMaybe<Detections_Bool_Exp>;
};


export type Query_RootEvacuationSettingByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootEvacuationSettingsArgs = {
  distinct_on?: InputMaybe<Array<EvacuationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvacuationSettings_Order_By>>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};


export type Query_RootEvacuationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EvacuationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvacuationSettings_Order_By>>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};


export type Query_RootEventByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Query_RootExecutionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<ExecutionHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExecutionHistories_Order_By>>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};


export type Query_RootExecutionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExecutionHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExecutionHistories_Order_By>>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};


export type Query_RootExecutionHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootFileStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootFileStatesArgs = {
  distinct_on?: InputMaybe<Array<File_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_States_Order_By>>;
  where?: InputMaybe<File_States_Bool_Exp>;
};


export type Query_RootFileStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<File_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_States_Order_By>>;
  where?: InputMaybe<File_States_Bool_Exp>;
};


export type Query_RootGroupByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Query_RootIdpByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootIdpTypeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootIdpTypesArgs = {
  distinct_on?: InputMaybe<Array<IdpTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdpTypes_Order_By>>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};


export type Query_RootIdpTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdpTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdpTypes_Order_By>>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};


export type Query_RootIdpsArgs = {
  distinct_on?: InputMaybe<Array<Idps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idps_Order_By>>;
  where?: InputMaybe<Idps_Bool_Exp>;
};


export type Query_RootIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Idps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idps_Order_By>>;
  where?: InputMaybe<Idps_Bool_Exp>;
};


export type Query_RootJobSettingByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootJobSettingsArgs = {
  distinct_on?: InputMaybe<Array<JobSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSettings_Order_By>>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};


export type Query_RootJobSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSettings_Order_By>>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};


export type Query_RootJobSiteAttributeByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootJobSiteAttributesArgs = {
  distinct_on?: InputMaybe<Array<JobSiteAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSiteAttributes_Order_By>>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};


export type Query_RootJobSiteAttributesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSiteAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSiteAttributes_Order_By>>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};


export type Query_RootJobSiteByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootJobSitesArgs = {
  distinct_on?: InputMaybe<Array<JobSites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSites_Order_By>>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};


export type Query_RootJobSitesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSites_Order_By>>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};


export type Query_RootLoginLogByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootLoginLogsArgs = {
  distinct_on?: InputMaybe<Array<Login_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Login_Logs_Order_By>>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};


export type Query_RootLoginLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Login_Logs_Order_By>>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};


export type Query_RootMessageByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootMessageFormatByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootMessageFormatsArgs = {
  distinct_on?: InputMaybe<Array<MessageFormats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageFormats_Order_By>>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};


export type Query_RootMessageFormatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageFormats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageFormats_Order_By>>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};


export type Query_RootMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Query_RootMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Query_RootMultipleDetectionByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootMultipleDetectionsArgs = {
  distinct_on?: InputMaybe<Array<MultipleDetections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MultipleDetections_Order_By>>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};


export type Query_RootMultipleDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MultipleDetections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MultipleDetections_Order_By>>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};


export type Query_RootNotificationConditionByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationConditionDetailByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationConditionDetailsArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


export type Query_RootNotificationConditionDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


export type Query_RootNotificationConditionsArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditions_Order_By>>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};


export type Query_RootNotificationConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditions_Order_By>>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};


export type Query_RootNotificationConditionsAggregateNativeArgs = {
  args: NotificationConditionsAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Query_RootNotificationCountAggregateNativeArgs = {
  args: NotificationCountAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationCountAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationCountAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Query_RootNotificationEventByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationEventsArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


export type Query_RootNotificationEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


export type Query_RootNotificationHistoriesArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


export type Query_RootNotificationHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


export type Query_RootNotificationHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationHistoryStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootNotificationHistoryStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_History_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_History_States_Order_By>>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};


export type Query_RootNotificationHistoryStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_History_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_History_States_Order_By>>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};


export type Query_RootNotificationServiceByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationServicesArgs = {
  distinct_on?: InputMaybe<Array<NotificationServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationServices_Order_By>>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};


export type Query_RootNotificationServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationServices_Order_By>>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};


export type Query_RootNotificationSettingByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationSettingsArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


export type Query_RootNotificationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


export type Query_RootNotificationStateAggregateNativeArgs = {
  args: NotificationStateAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationStateAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationStateAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Query_RootNotificationTargetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationTargetStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootNotificationTargetStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Target_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Target_States_Order_By>>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};


export type Query_RootNotificationTargetStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Target_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Target_States_Order_By>>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};


export type Query_RootNotificationTargetsArgs = {
  distinct_on?: InputMaybe<Array<NotificationTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTargets_Order_By>>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};


export type Query_RootNotificationTargetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTargets_Order_By>>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};


export type Query_RootNotificationTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Query_RootNotificationTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Query_RootNotificationUserByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationUserStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootNotificationUserStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_User_States_Order_By>>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};


export type Query_RootNotificationUserStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_User_States_Order_By>>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};


export type Query_RootNotificationUserTempArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


export type Query_RootNotificationUserTempAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


export type Query_RootNotificationUserTempByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootNotificationUsersArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


export type Query_RootNotificationUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


export type Query_RootPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};


export type Query_RootPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};


export type Query_RootPolicyArgs = {
  id: Scalars['String'];
  permissions?: InputMaybe<Scalars['AWSJSON']>;
};


export type Query_RootPolicyByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootPolicyDefineByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootPolicyDefineTypeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootPolicyDefineTypesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Define_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Define_Types_Order_By>>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};


export type Query_RootPolicyDefineTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Define_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Define_Types_Order_By>>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};


export type Query_RootPolicyDefinesArgs = {
  distinct_on?: InputMaybe<Array<PolicyDefines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyDefines_Order_By>>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};


export type Query_RootPolicyDefinesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyDefines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyDefines_Order_By>>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};


export type Query_RootPolicyTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootPolicyTemplatesArgs = {
  distinct_on?: InputMaybe<Array<PolicyTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyTemplates_Order_By>>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};


export type Query_RootPolicyTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyTemplates_Order_By>>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};


export type Query_RootProviderAssetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootProviderByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Query_RootProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Query_RootProvidersAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


export type Query_RootProvidersAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


export type Query_RootRelayApiServiceByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootRelayApiServicesArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


export type Query_RootRelayApiServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


export type Query_RootRelayServiceByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootRelayServicesArgs = {
  distinct_on?: InputMaybe<Array<RelayServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayServices_Order_By>>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};


export type Query_RootRelayServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayServices_Order_By>>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};


export type Query_RootRequestSettingByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootRequestSettingsArgs = {
  distinct_on?: InputMaybe<Array<RequestSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestSettings_Order_By>>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};


export type Query_RootRequestSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RequestSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestSettings_Order_By>>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};


export type Query_RootRequestTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootRequestTemplateTypeByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootRequestTemplateTypesArgs = {
  distinct_on?: InputMaybe<Array<Request_Template_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Template_Types_Order_By>>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};


export type Query_RootRequestTemplateTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Template_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Template_Types_Order_By>>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};


export type Query_RootRequestTemplatesArgs = {
  distinct_on?: InputMaybe<Array<RequestTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestTemplates_Order_By>>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};


export type Query_RootRequestTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RequestTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestTemplates_Order_By>>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};


export type Query_RootRequestsArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Requests_Order_By>>;
  where?: InputMaybe<Requests_Bool_Exp>;
};


export type Query_RootRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Requests_Order_By>>;
  where?: InputMaybe<Requests_Bool_Exp>;
};


export type Query_RootRest2graphqlSettingsArgs = {
  distinct_on?: InputMaybe<Array<Rest2graphqlSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rest2graphqlSettings_Order_By>>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};


export type Query_RootRest2graphqlSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Rest2graphqlSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rest2graphqlSettings_Order_By>>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};


export type Query_RootRest2graphqlSettingsByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootScheduleByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schedules_Order_By>>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};


export type Query_RootSchedulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schedules_Order_By>>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};


export type Query_RootSensitiveInformationArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformation_Order_By>>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};


export type Query_RootSensitiveInformationAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformation_Order_By>>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};


export type Query_RootSensitiveInformationByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationCategoriesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationCategories_Order_By>>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};


export type Query_RootSensitiveInformationCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationCategories_Order_By>>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};


export type Query_RootSensitiveInformationCategoryByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationHistoriesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


export type Query_RootSensitiveInformationHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


export type Query_RootSensitiveInformationHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationItemByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationItemsArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


export type Query_RootSensitiveInformationItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


export type Query_RootSensitiveInformationRequestServiceByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationRequestServicesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationRequestServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationRequestServices_Order_By>>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};


export type Query_RootSensitiveInformationRequestServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationRequestServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationRequestServices_Order_By>>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};


export type Query_RootSensitiveInformationStoreServiceConnectionByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootSensitiveInformationStoreServiceConnectionsArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Order_By>>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};


export type Query_RootSensitiveInformationStoreServicesConnectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Order_By>>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};


export type Query_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Query_RootServicesByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootStoreSensitiveInformationItemByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootStoreSensitiveInformationItemsArgs = {
  distinct_on?: InputMaybe<Array<StoreSensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StoreSensitiveInformationItems_Order_By>>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};


export type Query_RootStoreSensitiveInformationItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<StoreSensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StoreSensitiveInformationItems_Order_By>>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};


export type Query_RootTenantByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootTenantIdpByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootTenantPublicInfoArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<TenantPublicInfoWhereInput>;
};


export type Query_RootTenantPublicInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantPublicInfo_Order_By>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


export type Query_RootTenantPublicInfoByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootTenantServiceByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootTenantServicesArgs = {
  distinct_on?: InputMaybe<Array<TenantServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantServices_Order_By>>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};


export type Query_RootTenantServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantServices_Order_By>>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};


export type Query_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Query_RootTenantsIdpsArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


export type Query_RootTenantsIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


export type Query_RootUploadFileByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUploadFilesArgs = {
  distinct_on?: InputMaybe<Array<UploadFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UploadFiles_Order_By>>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};


export type Query_RootUploadFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UploadFiles_Order_By>>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};


export type Query_RootUserByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserExternalIdpByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserGroupByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUserPoliciesArgs = {
  distinct_on?: InputMaybe<Array<UserPolicies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPolicies_Order_By>>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};


export type Query_RootUserPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPolicies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPolicies_Order_By>>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};


export type Query_RootUserPolicyByPkArgs = {
  userId: Scalars['String'];
};


export type Query_RootUserRoleByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Query_RootUserStateByPkArgs = {
  value: Scalars['String'];
};


export type Query_RootUserStatesArgs = {
  distinct_on?: InputMaybe<Array<User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_States_Order_By>>;
  where?: InputMaybe<User_States_Bool_Exp>;
};


export type Query_RootUserStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_States_Order_By>>;
  where?: InputMaybe<User_States_Bool_Exp>;
};


export type Query_RootUsersArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<UsersOrderByInput>;
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type Query_RootUsersAggregateArgs = {
  permissions?: InputMaybe<Scalars['AWSJSON']>;
  where?: InputMaybe<UsersWhereInput>;
};


export type Query_RootUsersAssetByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUsersAssetsArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


export type Query_RootUsersAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


export type Query_RootUsersExternalUserByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUsersExternalUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersExternalUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersExternalUsers_Order_By>>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};


export type Query_RootUsersExternalUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersExternalUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersExternalUsers_Order_By>>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};


export type Query_RootUsersGroupsArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


export type Query_RootUsersGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


export type Query_RootUsersIdpsArgs = {
  distinct_on?: InputMaybe<Array<UsersIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersIdps_Order_By>>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};


export type Query_RootUsersIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersIdps_Order_By>>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};


export type Query_RootUsersUserByPkArgs = {
  id: Scalars['String'];
};


export type Query_RootUsersUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};


export type Query_RootUsersUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};

/** columns and relationships of "relay_api_services" */
export type RelayApiServices = {
  __typename?: 'relayApiServices';
  createdAt: Scalars['bigint'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  permissions: Scalars['jsonb'];
  /** An object relationship */
  relayService?: Maybe<RelayServices>;
  relayServiceId: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "relay_api_services" */
export type RelayApiServicesPermissionsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "relay_api_services" */
export type RelayApiServices_Aggregate = {
  __typename?: 'relayApiServices_aggregate';
  aggregate?: Maybe<RelayApiServices_Aggregate_Fields>;
  nodes: Array<RelayApiServices>;
};

export type RelayApiServices_Aggregate_Bool_Exp = {
  count?: InputMaybe<RelayApiServices_Aggregate_Bool_Exp_Count>;
};

export type RelayApiServices_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<RelayApiServices_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "relay_api_services" */
export type RelayApiServices_Aggregate_Fields = {
  __typename?: 'relayApiServices_aggregate_fields';
  avg?: Maybe<RelayApiServices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RelayApiServices_Max_Fields>;
  min?: Maybe<RelayApiServices_Min_Fields>;
  stddev?: Maybe<RelayApiServices_Stddev_Fields>;
  stddev_pop?: Maybe<RelayApiServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RelayApiServices_Stddev_Samp_Fields>;
  sum?: Maybe<RelayApiServices_Sum_Fields>;
  var_pop?: Maybe<RelayApiServices_Var_Pop_Fields>;
  var_samp?: Maybe<RelayApiServices_Var_Samp_Fields>;
  variance?: Maybe<RelayApiServices_Variance_Fields>;
};


/** aggregate fields of "relay_api_services" */
export type RelayApiServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "relay_api_services" */
export type RelayApiServices_Aggregate_Order_By = {
  avg?: InputMaybe<RelayApiServices_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<RelayApiServices_Max_Order_By>;
  min?: InputMaybe<RelayApiServices_Min_Order_By>;
  stddev?: InputMaybe<RelayApiServices_Stddev_Order_By>;
  stddev_pop?: InputMaybe<RelayApiServices_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<RelayApiServices_Stddev_Samp_Order_By>;
  sum?: InputMaybe<RelayApiServices_Sum_Order_By>;
  var_pop?: InputMaybe<RelayApiServices_Var_Pop_Order_By>;
  var_samp?: InputMaybe<RelayApiServices_Var_Samp_Order_By>;
  variance?: InputMaybe<RelayApiServices_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RelayApiServices_Append_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "relay_api_services" */
export type RelayApiServices_Arr_Rel_Insert_Input = {
  data: Array<RelayApiServices_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<RelayApiServices_On_Conflict>;
};

/** aggregate avg on columns */
export type RelayApiServices_Avg_Fields = {
  __typename?: 'relayApiServices_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "relay_api_services" */
export type RelayApiServices_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "relay_api_services". All fields are combined with a logical 'AND'. */
export type RelayApiServices_Bool_Exp = {
  _and?: InputMaybe<Array<RelayApiServices_Bool_Exp>>;
  _not?: InputMaybe<RelayApiServices_Bool_Exp>;
  _or?: InputMaybe<Array<RelayApiServices_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  permissions?: InputMaybe<Jsonb_Comparison_Exp>;
  relayService?: InputMaybe<RelayServices_Bool_Exp>;
  relayServiceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "relay_api_services" */
export enum RelayApiServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelayApiServicesPkey = 'relay_api_services_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RelayApiServices_Delete_At_Path_Input = {
  permissions?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RelayApiServices_Delete_Elem_Input = {
  permissions?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RelayApiServices_Delete_Key_Input = {
  permissions?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "relay_api_services" */
export type RelayApiServices_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relay_api_services" */
export type RelayApiServices_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  relayService?: InputMaybe<RelayServices_Obj_Rel_Insert_Input>;
  relayServiceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type RelayApiServices_Max_Fields = {
  __typename?: 'relayApiServices_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  relayServiceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "relay_api_services" */
export type RelayApiServices_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  relayServiceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type RelayApiServices_Min_Fields = {
  __typename?: 'relayApiServices_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  relayServiceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "relay_api_services" */
export type RelayApiServices_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  relayServiceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "relay_api_services" */
export type RelayApiServices_Mutation_Response = {
  __typename?: 'relayApiServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RelayApiServices>;
};

/** on_conflict condition type for table "relay_api_services" */
export type RelayApiServices_On_Conflict = {
  constraint: RelayApiServices_Constraint;
  update_columns?: Array<RelayApiServices_Update_Column>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};

/** Ordering options when selecting data from "relay_api_services". */
export type RelayApiServices_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  permissions?: InputMaybe<Order_By>;
  relayService?: InputMaybe<RelayServices_Order_By>;
  relayServiceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relay_api_services */
export type RelayApiServices_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RelayApiServices_Prepend_Input = {
  permissions?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "relay_api_services" */
export enum RelayApiServices_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  RelayServiceId = 'relayServiceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "relay_api_services" */
export type RelayApiServices_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  relayServiceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type RelayApiServices_Stddev_Fields = {
  __typename?: 'relayApiServices_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "relay_api_services" */
export type RelayApiServices_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type RelayApiServices_Stddev_Pop_Fields = {
  __typename?: 'relayApiServices_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "relay_api_services" */
export type RelayApiServices_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type RelayApiServices_Stddev_Samp_Fields = {
  __typename?: 'relayApiServices_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "relay_api_services" */
export type RelayApiServices_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "relayApiServices" */
export type RelayApiServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RelayApiServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RelayApiServices_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  permissions?: InputMaybe<Scalars['jsonb']>;
  relayServiceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RelayApiServices_Sum_Fields = {
  __typename?: 'relayApiServices_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "relay_api_services" */
export type RelayApiServices_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "relay_api_services" */
export enum RelayApiServices_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  Permissions = 'permissions',
  /** column name */
  RelayServiceId = 'relayServiceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RelayApiServices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RelayApiServices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RelayApiServices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RelayApiServices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RelayApiServices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RelayApiServices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RelayApiServices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelayApiServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: RelayApiServices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RelayApiServices_Var_Pop_Fields = {
  __typename?: 'relayApiServices_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "relay_api_services" */
export type RelayApiServices_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type RelayApiServices_Var_Samp_Fields = {
  __typename?: 'relayApiServices_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "relay_api_services" */
export type RelayApiServices_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type RelayApiServices_Variance_Fields = {
  __typename?: 'relayApiServices_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "relay_api_services" */
export type RelayApiServices_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "relay_services" */
export type RelayServices = {
  __typename?: 'relayServices';
  commonHeaders: Scalars['jsonb'];
  createdAt: Scalars['bigint'];
  description?: Maybe<Scalars['String']>;
  domain: Scalars['String'];
  expirationTime: Scalars['bigint'];
  /** An object relationship */
  group?: Maybe<Groups>;
  groupId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  notBefore: Scalars['bigint'];
  owner: Scalars['String'];
  protocol: Scalars['String'];
  /** An array relationship */
  relayApiServices: Array<RelayApiServices>;
  /** An aggregate relationship */
  relayApiServices_aggregate: RelayApiServices_Aggregate;
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['String'];
};


/** columns and relationships of "relay_services" */
export type RelayServicesCommonHeadersArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "relay_services" */
export type RelayServicesRelayApiServicesArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


/** columns and relationships of "relay_services" */
export type RelayServicesRelayApiServices_AggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};

/** aggregated selection of "relay_services" */
export type RelayServices_Aggregate = {
  __typename?: 'relayServices_aggregate';
  aggregate?: Maybe<RelayServices_Aggregate_Fields>;
  nodes: Array<RelayServices>;
};

/** aggregate fields of "relay_services" */
export type RelayServices_Aggregate_Fields = {
  __typename?: 'relayServices_aggregate_fields';
  avg?: Maybe<RelayServices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RelayServices_Max_Fields>;
  min?: Maybe<RelayServices_Min_Fields>;
  stddev?: Maybe<RelayServices_Stddev_Fields>;
  stddev_pop?: Maybe<RelayServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RelayServices_Stddev_Samp_Fields>;
  sum?: Maybe<RelayServices_Sum_Fields>;
  var_pop?: Maybe<RelayServices_Var_Pop_Fields>;
  var_samp?: Maybe<RelayServices_Var_Samp_Fields>;
  variance?: Maybe<RelayServices_Variance_Fields>;
};


/** aggregate fields of "relay_services" */
export type RelayServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RelayServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RelayServices_Append_Input = {
  commonHeaders?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type RelayServices_Avg_Fields = {
  __typename?: 'relayServices_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "relay_services". All fields are combined with a logical 'AND'. */
export type RelayServices_Bool_Exp = {
  _and?: InputMaybe<Array<RelayServices_Bool_Exp>>;
  _not?: InputMaybe<RelayServices_Bool_Exp>;
  _or?: InputMaybe<Array<RelayServices_Bool_Exp>>;
  commonHeaders?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  domain?: InputMaybe<String_Comparison_Exp>;
  expirationTime?: InputMaybe<Bigint_Comparison_Exp>;
  group?: InputMaybe<Groups_Bool_Exp>;
  groupId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  notBefore?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  protocol?: InputMaybe<String_Comparison_Exp>;
  relayApiServices?: InputMaybe<RelayApiServices_Bool_Exp>;
  relayApiServices_aggregate?: InputMaybe<RelayApiServices_Aggregate_Bool_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  user?: InputMaybe<Users_Bool_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "relay_services" */
export enum RelayServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  RelayServicesPkey = 'relay_services_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RelayServices_Delete_At_Path_Input = {
  commonHeaders?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RelayServices_Delete_Elem_Input = {
  commonHeaders?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RelayServices_Delete_Key_Input = {
  commonHeaders?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "relay_services" */
export type RelayServices_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  expirationTime?: InputMaybe<Scalars['bigint']>;
  notBefore?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "relay_services" */
export type RelayServices_Insert_Input = {
  commonHeaders?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  expirationTime?: InputMaybe<Scalars['bigint']>;
  group?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notBefore?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  protocol?: InputMaybe<Scalars['String']>;
  relayApiServices?: InputMaybe<RelayApiServices_Arr_Rel_Insert_Input>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  user?: InputMaybe<Users_Obj_Rel_Insert_Input>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type RelayServices_Max_Fields = {
  __typename?: 'relayServices_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  expirationTime?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notBefore?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  protocol?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type RelayServices_Min_Fields = {
  __typename?: 'relayServices_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  domain?: Maybe<Scalars['String']>;
  expirationTime?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  notBefore?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  protocol?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "relay_services" */
export type RelayServices_Mutation_Response = {
  __typename?: 'relayServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RelayServices>;
};

/** input type for inserting object relation for remote table "relay_services" */
export type RelayServices_Obj_Rel_Insert_Input = {
  data: RelayServices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<RelayServices_On_Conflict>;
};

/** on_conflict condition type for table "relay_services" */
export type RelayServices_On_Conflict = {
  constraint: RelayServices_Constraint;
  update_columns?: Array<RelayServices_Update_Column>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};

/** Ordering options when selecting data from "relay_services". */
export type RelayServices_Order_By = {
  commonHeaders?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  domain?: InputMaybe<Order_By>;
  expirationTime?: InputMaybe<Order_By>;
  group?: InputMaybe<Groups_Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  notBefore?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  protocol?: InputMaybe<Order_By>;
  relayApiServices_aggregate?: InputMaybe<RelayApiServices_Aggregate_Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  user?: InputMaybe<Users_Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: relay_services */
export type RelayServices_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RelayServices_Prepend_Input = {
  commonHeaders?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "relay_services" */
export enum RelayServices_Select_Column {
  /** column name */
  CommonHeaders = 'commonHeaders',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Domain = 'domain',
  /** column name */
  ExpirationTime = 'expirationTime',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NotBefore = 'notBefore',
  /** column name */
  Owner = 'owner',
  /** column name */
  Protocol = 'protocol',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "relay_services" */
export type RelayServices_Set_Input = {
  commonHeaders?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  expirationTime?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notBefore?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  protocol?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type RelayServices_Stddev_Fields = {
  __typename?: 'relayServices_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RelayServices_Stddev_Pop_Fields = {
  __typename?: 'relayServices_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RelayServices_Stddev_Samp_Fields = {
  __typename?: 'relayServices_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "relayServices" */
export type RelayServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RelayServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RelayServices_Stream_Cursor_Value_Input = {
  commonHeaders?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  domain?: InputMaybe<Scalars['String']>;
  expirationTime?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  notBefore?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  protocol?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type RelayServices_Sum_Fields = {
  __typename?: 'relayServices_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  expirationTime?: Maybe<Scalars['bigint']>;
  notBefore?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "relay_services" */
export enum RelayServices_Update_Column {
  /** column name */
  CommonHeaders = 'commonHeaders',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Domain = 'domain',
  /** column name */
  ExpirationTime = 'expirationTime',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NotBefore = 'notBefore',
  /** column name */
  Owner = 'owner',
  /** column name */
  Protocol = 'protocol',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type RelayServices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RelayServices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RelayServices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RelayServices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RelayServices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RelayServices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RelayServices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelayServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: RelayServices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RelayServices_Var_Pop_Fields = {
  __typename?: 'relayServices_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RelayServices_Var_Samp_Fields = {
  __typename?: 'relayServices_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RelayServices_Variance_Fields = {
  __typename?: 'relayServices_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  expirationTime?: Maybe<Scalars['Float']>;
  notBefore?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "request_settings" */
export type RequestSettings = {
  __typename?: 'requestSettings';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestTemplateId: Scalars['String'];
  settings: Scalars['jsonb'];
  targetId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "request_settings" */
export type RequestSettingsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "request_settings" */
export type RequestSettings_Aggregate = {
  __typename?: 'requestSettings_aggregate';
  aggregate?: Maybe<RequestSettings_Aggregate_Fields>;
  nodes: Array<RequestSettings>;
};

/** aggregate fields of "request_settings" */
export type RequestSettings_Aggregate_Fields = {
  __typename?: 'requestSettings_aggregate_fields';
  avg?: Maybe<RequestSettings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RequestSettings_Max_Fields>;
  min?: Maybe<RequestSettings_Min_Fields>;
  stddev?: Maybe<RequestSettings_Stddev_Fields>;
  stddev_pop?: Maybe<RequestSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RequestSettings_Stddev_Samp_Fields>;
  sum?: Maybe<RequestSettings_Sum_Fields>;
  var_pop?: Maybe<RequestSettings_Var_Pop_Fields>;
  var_samp?: Maybe<RequestSettings_Var_Samp_Fields>;
  variance?: Maybe<RequestSettings_Variance_Fields>;
};


/** aggregate fields of "request_settings" */
export type RequestSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RequestSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestSettings_Append_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type RequestSettings_Avg_Fields = {
  __typename?: 'requestSettings_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "request_settings". All fields are combined with a logical 'AND'. */
export type RequestSettings_Bool_Exp = {
  _and?: InputMaybe<Array<RequestSettings_Bool_Exp>>;
  _not?: InputMaybe<RequestSettings_Bool_Exp>;
  _or?: InputMaybe<Array<RequestSettings_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  requestTemplateId?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  targetId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_settings" */
export enum RequestSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestSettingsPkey = 'request_settings_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestSettings_Delete_At_Path_Input = {
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestSettings_Delete_Elem_Input = {
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestSettings_Delete_Key_Input = {
  settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "request_settings" */
export type RequestSettings_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_settings" */
export type RequestSettings_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestTemplateId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type RequestSettings_Max_Fields = {
  __typename?: 'requestSettings_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestTemplateId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type RequestSettings_Min_Fields = {
  __typename?: 'requestSettings_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestTemplateId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "request_settings" */
export type RequestSettings_Mutation_Response = {
  __typename?: 'requestSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestSettings>;
};

/** on_conflict condition type for table "request_settings" */
export type RequestSettings_On_Conflict = {
  constraint: RequestSettings_Constraint;
  update_columns?: Array<RequestSettings_Update_Column>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "request_settings". */
export type RequestSettings_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestTemplateId?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  targetId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_settings */
export type RequestSettings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestSettings_Prepend_Input = {
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "request_settings" */
export enum RequestSettings_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestTemplateId = 'requestTemplateId',
  /** column name */
  Settings = 'settings',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "request_settings" */
export type RequestSettings_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestTemplateId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type RequestSettings_Stddev_Fields = {
  __typename?: 'requestSettings_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RequestSettings_Stddev_Pop_Fields = {
  __typename?: 'requestSettings_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RequestSettings_Stddev_Samp_Fields = {
  __typename?: 'requestSettings_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "requestSettings" */
export type RequestSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RequestSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestSettings_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestTemplateId?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RequestSettings_Sum_Fields = {
  __typename?: 'requestSettings_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "request_settings" */
export enum RequestSettings_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestTemplateId = 'requestTemplateId',
  /** column name */
  Settings = 'settings',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RequestSettings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestSettings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestSettings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestSettings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestSettings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestSettings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestSettings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: RequestSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RequestSettings_Var_Pop_Fields = {
  __typename?: 'requestSettings_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RequestSettings_Var_Samp_Fields = {
  __typename?: 'requestSettings_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RequestSettings_Variance_Fields = {
  __typename?: 'requestSettings_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "request_templates" */
export type RequestTemplates = {
  __typename?: 'requestTemplates';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  overridable: Scalars['jsonb'];
  owner?: Maybe<Scalars['String']>;
  settings: Scalars['jsonb'];
  targetId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: Maybe<Request_Template_Types_Enum>;
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "request_templates" */
export type RequestTemplatesOverridableArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "request_templates" */
export type RequestTemplatesSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "request_templates" */
export type RequestTemplates_Aggregate = {
  __typename?: 'requestTemplates_aggregate';
  aggregate?: Maybe<RequestTemplates_Aggregate_Fields>;
  nodes: Array<RequestTemplates>;
};

/** aggregate fields of "request_templates" */
export type RequestTemplates_Aggregate_Fields = {
  __typename?: 'requestTemplates_aggregate_fields';
  avg?: Maybe<RequestTemplates_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<RequestTemplates_Max_Fields>;
  min?: Maybe<RequestTemplates_Min_Fields>;
  stddev?: Maybe<RequestTemplates_Stddev_Fields>;
  stddev_pop?: Maybe<RequestTemplates_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<RequestTemplates_Stddev_Samp_Fields>;
  sum?: Maybe<RequestTemplates_Sum_Fields>;
  var_pop?: Maybe<RequestTemplates_Var_Pop_Fields>;
  var_samp?: Maybe<RequestTemplates_Var_Samp_Fields>;
  variance?: Maybe<RequestTemplates_Variance_Fields>;
};


/** aggregate fields of "request_templates" */
export type RequestTemplates_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<RequestTemplates_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RequestTemplates_Append_Input = {
  overridable?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type RequestTemplates_Avg_Fields = {
  __typename?: 'requestTemplates_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "request_templates". All fields are combined with a logical 'AND'. */
export type RequestTemplates_Bool_Exp = {
  _and?: InputMaybe<Array<RequestTemplates_Bool_Exp>>;
  _not?: InputMaybe<RequestTemplates_Bool_Exp>;
  _or?: InputMaybe<Array<RequestTemplates_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  overridable?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Jsonb_Comparison_Exp>;
  targetId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Request_Template_Types_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_templates" */
export enum RequestTemplates_Constraint {
  /** unique or primary key constraint on columns "id" */
  RequestTemplatesPkey = 'request_templates_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RequestTemplates_Delete_At_Path_Input = {
  overridable?: InputMaybe<Array<Scalars['String']>>;
  settings?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RequestTemplates_Delete_Elem_Input = {
  overridable?: InputMaybe<Scalars['Int']>;
  settings?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RequestTemplates_Delete_Key_Input = {
  overridable?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "request_templates" */
export type RequestTemplates_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "request_templates" */
export type RequestTemplates_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overridable?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Request_Template_Types_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type RequestTemplates_Max_Fields = {
  __typename?: 'requestTemplates_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type RequestTemplates_Min_Fields = {
  __typename?: 'requestTemplates_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "request_templates" */
export type RequestTemplates_Mutation_Response = {
  __typename?: 'requestTemplates_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<RequestTemplates>;
};

/** on_conflict condition type for table "request_templates" */
export type RequestTemplates_On_Conflict = {
  constraint: RequestTemplates_Constraint;
  update_columns?: Array<RequestTemplates_Update_Column>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};

/** Ordering options when selecting data from "request_templates". */
export type RequestTemplates_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  overridable?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  settings?: InputMaybe<Order_By>;
  targetId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_templates */
export type RequestTemplates_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RequestTemplates_Prepend_Input = {
  overridable?: InputMaybe<Scalars['jsonb']>;
  settings?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "request_templates" */
export enum RequestTemplates_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Overridable = 'overridable',
  /** column name */
  Owner = 'owner',
  /** column name */
  Settings = 'settings',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "request_templates" */
export type RequestTemplates_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overridable?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Request_Template_Types_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type RequestTemplates_Stddev_Fields = {
  __typename?: 'requestTemplates_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type RequestTemplates_Stddev_Pop_Fields = {
  __typename?: 'requestTemplates_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type RequestTemplates_Stddev_Samp_Fields = {
  __typename?: 'requestTemplates_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "requestTemplates" */
export type RequestTemplates_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: RequestTemplates_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type RequestTemplates_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  overridable?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Scalars['jsonb']>;
  targetId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Request_Template_Types_Enum>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type RequestTemplates_Sum_Fields = {
  __typename?: 'requestTemplates_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "request_templates" */
export enum RequestTemplates_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Overridable = 'overridable',
  /** column name */
  Owner = 'owner',
  /** column name */
  Settings = 'settings',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type RequestTemplates_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RequestTemplates_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<RequestTemplates_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<RequestTemplates_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<RequestTemplates_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RequestTemplates_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RequestTemplates_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RequestTemplates_Set_Input>;
  /** filter the rows which have to be updated */
  where: RequestTemplates_Bool_Exp;
};

/** aggregate var_pop on columns */
export type RequestTemplates_Var_Pop_Fields = {
  __typename?: 'requestTemplates_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type RequestTemplates_Var_Samp_Fields = {
  __typename?: 'requestTemplates_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type RequestTemplates_Variance_Fields = {
  __typename?: 'requestTemplates_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "request_template_types" */
export type Request_Template_Types = {
  __typename?: 'request_template_types';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "request_template_types" */
export type Request_Template_Types_Aggregate = {
  __typename?: 'request_template_types_aggregate';
  aggregate?: Maybe<Request_Template_Types_Aggregate_Fields>;
  nodes: Array<Request_Template_Types>;
};

/** aggregate fields of "request_template_types" */
export type Request_Template_Types_Aggregate_Fields = {
  __typename?: 'request_template_types_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Request_Template_Types_Max_Fields>;
  min?: Maybe<Request_Template_Types_Min_Fields>;
};


/** aggregate fields of "request_template_types" */
export type Request_Template_Types_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Request_Template_Types_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "request_template_types". All fields are combined with a logical 'AND'. */
export type Request_Template_Types_Bool_Exp = {
  _and?: InputMaybe<Array<Request_Template_Types_Bool_Exp>>;
  _not?: InputMaybe<Request_Template_Types_Bool_Exp>;
  _or?: InputMaybe<Array<Request_Template_Types_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "request_template_types" */
export enum Request_Template_Types_Constraint {
  /** unique or primary key constraint on columns "value" */
  RequestTemplateTypesPkey = 'request_template_types_pkey'
}

export enum Request_Template_Types_Enum {
  Email = 'email'
}

/** Boolean expression to compare columns of type "request_template_types_enum". All fields are combined with logical 'AND'. */
export type Request_Template_Types_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Request_Template_Types_Enum>;
  _in?: InputMaybe<Array<Request_Template_Types_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Request_Template_Types_Enum>;
  _nin?: InputMaybe<Array<Request_Template_Types_Enum>>;
};

/** input type for inserting data into table "request_template_types" */
export type Request_Template_Types_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Request_Template_Types_Max_Fields = {
  __typename?: 'request_template_types_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Request_Template_Types_Min_Fields = {
  __typename?: 'request_template_types_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "request_template_types" */
export type Request_Template_Types_Mutation_Response = {
  __typename?: 'request_template_types_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Request_Template_Types>;
};

/** on_conflict condition type for table "request_template_types" */
export type Request_Template_Types_On_Conflict = {
  constraint: Request_Template_Types_Constraint;
  update_columns?: Array<Request_Template_Types_Update_Column>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};

/** Ordering options when selecting data from "request_template_types". */
export type Request_Template_Types_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: request_template_types */
export type Request_Template_Types_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "request_template_types" */
export enum Request_Template_Types_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "request_template_types" */
export type Request_Template_Types_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "request_template_types" */
export type Request_Template_Types_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Request_Template_Types_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Request_Template_Types_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "request_template_types" */
export enum Request_Template_Types_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type Request_Template_Types_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Request_Template_Types_Set_Input>;
  /** filter the rows which have to be updated */
  where: Request_Template_Types_Bool_Exp;
};

/** columns and relationships of "requests" */
export type Requests = {
  __typename?: 'requests';
  overridable?: Maybe<Scalars['jsonb']>;
  overrideSettings?: Maybe<Scalars['jsonb']>;
  owner?: Maybe<Scalars['String']>;
  requestSettingId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  templateSettings?: Maybe<Scalars['jsonb']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};


/** columns and relationships of "requests" */
export type RequestsOverridableArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "requests" */
export type RequestsOverrideSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "requests" */
export type RequestsTemplateSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "requests" */
export type Requests_Aggregate = {
  __typename?: 'requests_aggregate';
  aggregate?: Maybe<Requests_Aggregate_Fields>;
  nodes: Array<Requests>;
};

/** aggregate fields of "requests" */
export type Requests_Aggregate_Fields = {
  __typename?: 'requests_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Requests_Max_Fields>;
  min?: Maybe<Requests_Min_Fields>;
};


/** aggregate fields of "requests" */
export type Requests_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Requests_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "requests". All fields are combined with a logical 'AND'. */
export type Requests_Bool_Exp = {
  _and?: InputMaybe<Array<Requests_Bool_Exp>>;
  _not?: InputMaybe<Requests_Bool_Exp>;
  _or?: InputMaybe<Array<Requests_Bool_Exp>>;
  overridable?: InputMaybe<Jsonb_Comparison_Exp>;
  overrideSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  requestSettingId?: InputMaybe<String_Comparison_Exp>;
  targetId?: InputMaybe<String_Comparison_Exp>;
  templateSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Requests_Max_Fields = {
  __typename?: 'requests_max_fields';
  owner?: Maybe<Scalars['String']>;
  requestSettingId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Requests_Min_Fields = {
  __typename?: 'requests_min_fields';
  owner?: Maybe<Scalars['String']>;
  requestSettingId?: Maybe<Scalars['String']>;
  targetId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "requests". */
export type Requests_Order_By = {
  overridable?: InputMaybe<Order_By>;
  overrideSettings?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestSettingId?: InputMaybe<Order_By>;
  targetId?: InputMaybe<Order_By>;
  templateSettings?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** select columns of table "requests" */
export enum Requests_Select_Column {
  /** column name */
  Overridable = 'overridable',
  /** column name */
  OverrideSettings = 'overrideSettings',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestSettingId = 'requestSettingId',
  /** column name */
  TargetId = 'targetId',
  /** column name */
  TemplateSettings = 'templateSettings',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  Type = 'type'
}

/** Streaming cursor of the table "requests" */
export type Requests_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Requests_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Requests_Stream_Cursor_Value_Input = {
  overridable?: InputMaybe<Scalars['jsonb']>;
  overrideSettings?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  requestSettingId?: InputMaybe<Scalars['String']>;
  targetId?: InputMaybe<Scalars['String']>;
  templateSettings?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "rest2graphql_settings" */
export type Rest2graphqlSettings = {
  __typename?: 'rest2graphqlSettings';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  endpointPattern: Scalars['String'];
  graphqlQuery: Scalars['String'];
  id: Scalars['String'];
  method: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  templates: Scalars['jsonb'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  variables: Scalars['jsonb'];
};


/** columns and relationships of "rest2graphql_settings" */
export type Rest2graphqlSettingsTemplatesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "rest2graphql_settings" */
export type Rest2graphqlSettingsVariablesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "rest2graphql_settings" */
export type Rest2graphqlSettings_Aggregate = {
  __typename?: 'rest2graphqlSettings_aggregate';
  aggregate?: Maybe<Rest2graphqlSettings_Aggregate_Fields>;
  nodes: Array<Rest2graphqlSettings>;
};

/** aggregate fields of "rest2graphql_settings" */
export type Rest2graphqlSettings_Aggregate_Fields = {
  __typename?: 'rest2graphqlSettings_aggregate_fields';
  avg?: Maybe<Rest2graphqlSettings_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Rest2graphqlSettings_Max_Fields>;
  min?: Maybe<Rest2graphqlSettings_Min_Fields>;
  stddev?: Maybe<Rest2graphqlSettings_Stddev_Fields>;
  stddev_pop?: Maybe<Rest2graphqlSettings_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Rest2graphqlSettings_Stddev_Samp_Fields>;
  sum?: Maybe<Rest2graphqlSettings_Sum_Fields>;
  var_pop?: Maybe<Rest2graphqlSettings_Var_Pop_Fields>;
  var_samp?: Maybe<Rest2graphqlSettings_Var_Samp_Fields>;
  variance?: Maybe<Rest2graphqlSettings_Variance_Fields>;
};


/** aggregate fields of "rest2graphql_settings" */
export type Rest2graphqlSettings_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Rest2graphqlSettings_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Rest2graphqlSettings_Append_Input = {
  templates?: InputMaybe<Scalars['jsonb']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Rest2graphqlSettings_Avg_Fields = {
  __typename?: 'rest2graphqlSettings_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "rest2graphql_settings". All fields are combined with a logical 'AND'. */
export type Rest2graphqlSettings_Bool_Exp = {
  _and?: InputMaybe<Array<Rest2graphqlSettings_Bool_Exp>>;
  _not?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
  _or?: InputMaybe<Array<Rest2graphqlSettings_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  endpointPattern?: InputMaybe<String_Comparison_Exp>;
  graphqlQuery?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  method?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  templates?: InputMaybe<Jsonb_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  variables?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "rest2graphql_settings" */
export enum Rest2graphqlSettings_Constraint {
  /** unique or primary key constraint on columns "id" */
  Rest2graphqlSettingsPkey = 'rest2graphql_settings_pkey',
  /** unique or primary key constraint on columns "endpoint_pattern", "tenant_id", "method" */
  Rest2graphqlSettingsTenantIdEndpointPatternMethodKey = 'rest2graphql_settings_tenant_id_endpoint_pattern_method_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Rest2graphqlSettings_Delete_At_Path_Input = {
  templates?: InputMaybe<Array<Scalars['String']>>;
  variables?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Rest2graphqlSettings_Delete_Elem_Input = {
  templates?: InputMaybe<Scalars['Int']>;
  variables?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Rest2graphqlSettings_Delete_Key_Input = {
  templates?: InputMaybe<Scalars['String']>;
  variables?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "rest2graphql_settings" */
export type Rest2graphqlSettings_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "rest2graphql_settings" */
export type Rest2graphqlSettings_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  endpointPattern?: InputMaybe<Scalars['String']>;
  graphqlQuery?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Rest2graphqlSettings_Max_Fields = {
  __typename?: 'rest2graphqlSettings_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  endpointPattern?: Maybe<Scalars['String']>;
  graphqlQuery?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Rest2graphqlSettings_Min_Fields = {
  __typename?: 'rest2graphqlSettings_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  endpointPattern?: Maybe<Scalars['String']>;
  graphqlQuery?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  method?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "rest2graphql_settings" */
export type Rest2graphqlSettings_Mutation_Response = {
  __typename?: 'rest2graphqlSettings_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Rest2graphqlSettings>;
};

/** on_conflict condition type for table "rest2graphql_settings" */
export type Rest2graphqlSettings_On_Conflict = {
  constraint: Rest2graphqlSettings_Constraint;
  update_columns?: Array<Rest2graphqlSettings_Update_Column>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};

/** Ordering options when selecting data from "rest2graphql_settings". */
export type Rest2graphqlSettings_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  endpointPattern?: InputMaybe<Order_By>;
  graphqlQuery?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  method?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  templates?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  variables?: InputMaybe<Order_By>;
};

/** primary key columns input for table: rest2graphql_settings */
export type Rest2graphqlSettings_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Rest2graphqlSettings_Prepend_Input = {
  templates?: InputMaybe<Scalars['jsonb']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "rest2graphql_settings" */
export enum Rest2graphqlSettings_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndpointPattern = 'endpointPattern',
  /** column name */
  GraphqlQuery = 'graphqlQuery',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Owner = 'owner',
  /** column name */
  Templates = 'templates',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Variables = 'variables'
}

/** input type for updating data in table "rest2graphql_settings" */
export type Rest2graphqlSettings_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  endpointPattern?: InputMaybe<Scalars['String']>;
  graphqlQuery?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Rest2graphqlSettings_Stddev_Fields = {
  __typename?: 'rest2graphqlSettings_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Rest2graphqlSettings_Stddev_Pop_Fields = {
  __typename?: 'rest2graphqlSettings_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Rest2graphqlSettings_Stddev_Samp_Fields = {
  __typename?: 'rest2graphqlSettings_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "rest2graphqlSettings" */
export type Rest2graphqlSettings_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Rest2graphqlSettings_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Rest2graphqlSettings_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  endpointPattern?: InputMaybe<Scalars['String']>;
  graphqlQuery?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  method?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  templates?: InputMaybe<Scalars['jsonb']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  variables?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Rest2graphqlSettings_Sum_Fields = {
  __typename?: 'rest2graphqlSettings_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "rest2graphql_settings" */
export enum Rest2graphqlSettings_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  EndpointPattern = 'endpointPattern',
  /** column name */
  GraphqlQuery = 'graphqlQuery',
  /** column name */
  Id = 'id',
  /** column name */
  Method = 'method',
  /** column name */
  Owner = 'owner',
  /** column name */
  Templates = 'templates',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Variables = 'variables'
}

export type Rest2graphqlSettings_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Rest2graphqlSettings_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Rest2graphqlSettings_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Rest2graphqlSettings_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Rest2graphqlSettings_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Rest2graphqlSettings_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Rest2graphqlSettings_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Rest2graphqlSettings_Set_Input>;
  /** filter the rows which have to be updated */
  where: Rest2graphqlSettings_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Rest2graphqlSettings_Var_Pop_Fields = {
  __typename?: 'rest2graphqlSettings_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Rest2graphqlSettings_Var_Samp_Fields = {
  __typename?: 'rest2graphqlSettings_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Rest2graphqlSettings_Variance_Fields = {
  __typename?: 'rest2graphqlSettings_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "schedules" */
export type Schedules = {
  __typename?: 'schedules';
  createdAt: Scalars['bigint'];
  executionInterval?: Maybe<Scalars['Int']>;
  executionTime?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  jobSettingId: Scalars['String'];
  lastExecutionAt?: Maybe<Scalars['bigint']>;
  owner: Scalars['String'];
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};

/** aggregated selection of "schedules" */
export type Schedules_Aggregate = {
  __typename?: 'schedules_aggregate';
  aggregate?: Maybe<Schedules_Aggregate_Fields>;
  nodes: Array<Schedules>;
};

/** aggregate fields of "schedules" */
export type Schedules_Aggregate_Fields = {
  __typename?: 'schedules_aggregate_fields';
  avg?: Maybe<Schedules_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Schedules_Max_Fields>;
  min?: Maybe<Schedules_Min_Fields>;
  stddev?: Maybe<Schedules_Stddev_Fields>;
  stddev_pop?: Maybe<Schedules_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Schedules_Stddev_Samp_Fields>;
  sum?: Maybe<Schedules_Sum_Fields>;
  var_pop?: Maybe<Schedules_Var_Pop_Fields>;
  var_samp?: Maybe<Schedules_Var_Samp_Fields>;
  variance?: Maybe<Schedules_Variance_Fields>;
};


/** aggregate fields of "schedules" */
export type Schedules_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Schedules_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Schedules_Avg_Fields = {
  __typename?: 'schedules_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "schedules". All fields are combined with a logical 'AND'. */
export type Schedules_Bool_Exp = {
  _and?: InputMaybe<Array<Schedules_Bool_Exp>>;
  _not?: InputMaybe<Schedules_Bool_Exp>;
  _or?: InputMaybe<Array<Schedules_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  executionInterval?: InputMaybe<Int_Comparison_Exp>;
  executionTime?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  jobSettingId?: InputMaybe<String_Comparison_Exp>;
  lastExecutionAt?: InputMaybe<Bigint_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "schedules" */
export enum Schedules_Constraint {
  /** unique or primary key constraint on columns "id" */
  SchedulesPkey = 'schedules_pkey'
}

/** input type for incrementing numeric columns in table "schedules" */
export type Schedules_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionInterval?: InputMaybe<Scalars['Int']>;
  executionTime?: InputMaybe<Scalars['Int']>;
  lastExecutionAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "schedules" */
export type Schedules_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionInterval?: InputMaybe<Scalars['Int']>;
  executionTime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  lastExecutionAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Schedules_Max_Fields = {
  __typename?: 'schedules_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  executionInterval?: Maybe<Scalars['Int']>;
  executionTime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  jobSettingId?: Maybe<Scalars['String']>;
  lastExecutionAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Schedules_Min_Fields = {
  __typename?: 'schedules_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  executionInterval?: Maybe<Scalars['Int']>;
  executionTime?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  jobSettingId?: Maybe<Scalars['String']>;
  lastExecutionAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "schedules" */
export type Schedules_Mutation_Response = {
  __typename?: 'schedules_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Schedules>;
};

/** on_conflict condition type for table "schedules" */
export type Schedules_On_Conflict = {
  constraint: Schedules_Constraint;
  update_columns?: Array<Schedules_Update_Column>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};

/** Ordering options when selecting data from "schedules". */
export type Schedules_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  executionInterval?: InputMaybe<Order_By>;
  executionTime?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobSettingId?: InputMaybe<Order_By>;
  lastExecutionAt?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: schedules */
export type Schedules_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "schedules" */
export enum Schedules_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExecutionInterval = 'executionInterval',
  /** column name */
  ExecutionTime = 'executionTime',
  /** column name */
  Id = 'id',
  /** column name */
  JobSettingId = 'jobSettingId',
  /** column name */
  LastExecutionAt = 'lastExecutionAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "schedules" */
export type Schedules_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionInterval?: InputMaybe<Scalars['Int']>;
  executionTime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  lastExecutionAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Schedules_Stddev_Fields = {
  __typename?: 'schedules_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Schedules_Stddev_Pop_Fields = {
  __typename?: 'schedules_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Schedules_Stddev_Samp_Fields = {
  __typename?: 'schedules_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "schedules" */
export type Schedules_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Schedules_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Schedules_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  executionInterval?: InputMaybe<Scalars['Int']>;
  executionTime?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  jobSettingId?: InputMaybe<Scalars['String']>;
  lastExecutionAt?: InputMaybe<Scalars['bigint']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Schedules_Sum_Fields = {
  __typename?: 'schedules_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  executionInterval?: Maybe<Scalars['Int']>;
  executionTime?: Maybe<Scalars['Int']>;
  lastExecutionAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "schedules" */
export enum Schedules_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExecutionInterval = 'executionInterval',
  /** column name */
  ExecutionTime = 'executionTime',
  /** column name */
  Id = 'id',
  /** column name */
  JobSettingId = 'jobSettingId',
  /** column name */
  LastExecutionAt = 'lastExecutionAt',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Schedules_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Schedules_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Schedules_Set_Input>;
  /** filter the rows which have to be updated */
  where: Schedules_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Schedules_Var_Pop_Fields = {
  __typename?: 'schedules_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Schedules_Var_Samp_Fields = {
  __typename?: 'schedules_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Schedules_Variance_Fields = {
  __typename?: 'schedules_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  executionInterval?: Maybe<Scalars['Float']>;
  executionTime?: Maybe<Scalars['Float']>;
  lastExecutionAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sensitive_information" */
export type SensitiveInformation = {
  __typename?: 'sensitiveInformation';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  sensitiveInformationItemId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

/** columns and relationships of "sensitive_information_categories" */
export type SensitiveInformationCategories = {
  __typename?: 'sensitiveInformationCategories';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  lastUpdatedAt: Scalars['bigint'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  /** An array relationship */
  sensitiveInformationItems: Array<SensitiveInformationItems>;
  /** An aggregate relationship */
  sensitiveInformationItems_aggregate: SensitiveInformationItems_Aggregate;
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sensitive_information_categories" */
export type SensitiveInformationCategoriesSensitiveInformationItemsArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


/** columns and relationships of "sensitive_information_categories" */
export type SensitiveInformationCategoriesSensitiveInformationItems_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};

/** aggregated selection of "sensitive_information_categories" */
export type SensitiveInformationCategories_Aggregate = {
  __typename?: 'sensitiveInformationCategories_aggregate';
  aggregate?: Maybe<SensitiveInformationCategories_Aggregate_Fields>;
  nodes: Array<SensitiveInformationCategories>;
};

/** aggregate fields of "sensitive_information_categories" */
export type SensitiveInformationCategories_Aggregate_Fields = {
  __typename?: 'sensitiveInformationCategories_aggregate_fields';
  avg?: Maybe<SensitiveInformationCategories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformationCategories_Max_Fields>;
  min?: Maybe<SensitiveInformationCategories_Min_Fields>;
  stddev?: Maybe<SensitiveInformationCategories_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformationCategories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformationCategories_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformationCategories_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformationCategories_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformationCategories_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformationCategories_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_categories" */
export type SensitiveInformationCategories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformationCategories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SensitiveInformationCategories_Avg_Fields = {
  __typename?: 'sensitiveInformationCategories_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sensitive_information_categories". All fields are combined with a logical 'AND'. */
export type SensitiveInformationCategories_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformationCategories_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformationCategories_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  lastUpdatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationItems?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
  sensitiveInformationItems_aggregate?: InputMaybe<SensitiveInformationItems_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_categories" */
export enum SensitiveInformationCategories_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationCategoriesPkey = 'sensitive_information_categories_pkey'
}

/** input type for incrementing numeric columns in table "sensitive_information_categories" */
export type SensitiveInformationCategories_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_categories" */
export type SensitiveInformationCategories_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationItems?: InputMaybe<SensitiveInformationItems_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SensitiveInformationCategories_Max_Fields = {
  __typename?: 'sensitiveInformationCategories_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SensitiveInformationCategories_Min_Fields = {
  __typename?: 'sensitiveInformationCategories_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sensitive_information_categories" */
export type SensitiveInformationCategories_Mutation_Response = {
  __typename?: 'sensitiveInformationCategories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformationCategories>;
};

/** input type for inserting object relation for remote table "sensitive_information_categories" */
export type SensitiveInformationCategories_Obj_Rel_Insert_Input = {
  data: SensitiveInformationCategories_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SensitiveInformationCategories_On_Conflict>;
};

/** on_conflict condition type for table "sensitive_information_categories" */
export type SensitiveInformationCategories_On_Conflict = {
  constraint: SensitiveInformationCategories_Constraint;
  update_columns?: Array<SensitiveInformationCategories_Update_Column>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_categories". */
export type SensitiveInformationCategories_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationItems_aggregate?: InputMaybe<SensitiveInformationItems_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_categories */
export type SensitiveInformationCategories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "sensitive_information_categories" */
export enum SensitiveInformationCategories_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sensitive_information_categories" */
export type SensitiveInformationCategories_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SensitiveInformationCategories_Stddev_Fields = {
  __typename?: 'sensitiveInformationCategories_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformationCategories_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformationCategories_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformationCategories_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformationCategories_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sensitiveInformationCategories" */
export type SensitiveInformationCategories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformationCategories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformationCategories_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SensitiveInformationCategories_Sum_Fields = {
  __typename?: 'sensitiveInformationCategories_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sensitive_information_categories" */
export enum SensitiveInformationCategories_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SensitiveInformationCategories_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformationCategories_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformationCategories_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformationCategories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformationCategories_Var_Pop_Fields = {
  __typename?: 'sensitiveInformationCategories_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SensitiveInformationCategories_Var_Samp_Fields = {
  __typename?: 'sensitiveInformationCategories_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SensitiveInformationCategories_Variance_Fields = {
  __typename?: 'sensitiveInformationCategories_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sensitive_information_histories" */
export type SensitiveInformationHistories = {
  __typename?: 'sensitiveInformationHistories';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  requestItems?: Maybe<Scalars['jsonb']>;
  requestTime?: Maybe<Scalars['bigint']>;
  sensitiveInformationHistoryData?: Maybe<Scalars['jsonb']>;
  sensitiveInformationRequestServiceId: Scalars['String'];
  /** An object relationship */
  sensitiveInformationRequestServices?: Maybe<SensitiveInformationRequestServices>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
};


/** columns and relationships of "sensitive_information_histories" */
export type SensitiveInformationHistoriesRequestItemsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sensitive_information_histories" */
export type SensitiveInformationHistoriesSensitiveInformationHistoryDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sensitive_information_histories" */
export type SensitiveInformationHistories_Aggregate = {
  __typename?: 'sensitiveInformationHistories_aggregate';
  aggregate?: Maybe<SensitiveInformationHistories_Aggregate_Fields>;
  nodes: Array<SensitiveInformationHistories>;
};

export type SensitiveInformationHistories_Aggregate_Bool_Exp = {
  count?: InputMaybe<SensitiveInformationHistories_Aggregate_Bool_Exp_Count>;
};

export type SensitiveInformationHistories_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sensitive_information_histories" */
export type SensitiveInformationHistories_Aggregate_Fields = {
  __typename?: 'sensitiveInformationHistories_aggregate_fields';
  avg?: Maybe<SensitiveInformationHistories_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformationHistories_Max_Fields>;
  min?: Maybe<SensitiveInformationHistories_Min_Fields>;
  stddev?: Maybe<SensitiveInformationHistories_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformationHistories_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformationHistories_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformationHistories_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformationHistories_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformationHistories_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformationHistories_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_histories" */
export type SensitiveInformationHistories_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Aggregate_Order_By = {
  avg?: InputMaybe<SensitiveInformationHistories_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SensitiveInformationHistories_Max_Order_By>;
  min?: InputMaybe<SensitiveInformationHistories_Min_Order_By>;
  stddev?: InputMaybe<SensitiveInformationHistories_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SensitiveInformationHistories_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SensitiveInformationHistories_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SensitiveInformationHistories_Sum_Order_By>;
  var_pop?: InputMaybe<SensitiveInformationHistories_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SensitiveInformationHistories_Var_Samp_Order_By>;
  variance?: InputMaybe<SensitiveInformationHistories_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationHistories_Append_Input = {
  requestItems?: InputMaybe<Scalars['jsonb']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "sensitive_information_histories" */
export type SensitiveInformationHistories_Arr_Rel_Insert_Input = {
  data: Array<SensitiveInformationHistories_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SensitiveInformationHistories_On_Conflict>;
};

/** aggregate avg on columns */
export type SensitiveInformationHistories_Avg_Fields = {
  __typename?: 'sensitiveInformationHistories_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sensitive_information_histories". All fields are combined with a logical 'AND'. */
export type SensitiveInformationHistories_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformationHistories_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformationHistories_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  requestItems?: InputMaybe<Jsonb_Comparison_Exp>;
  requestTime?: InputMaybe<Bigint_Comparison_Exp>;
  sensitiveInformationHistoryData?: InputMaybe<Jsonb_Comparison_Exp>;
  sensitiveInformationRequestServiceId?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_histories" */
export enum SensitiveInformationHistories_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationHistoriesPkey = 'sensitive_information_histories_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SensitiveInformationHistories_Delete_At_Path_Input = {
  requestItems?: InputMaybe<Array<Scalars['String']>>;
  sensitiveInformationHistoryData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SensitiveInformationHistories_Delete_Elem_Input = {
  requestItems?: InputMaybe<Scalars['Int']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SensitiveInformationHistories_Delete_Key_Input = {
  requestItems?: InputMaybe<Scalars['String']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sensitive_information_histories" */
export type SensitiveInformationHistories_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  requestTime?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_histories" */
export type SensitiveInformationHistories_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestItems?: InputMaybe<Scalars['jsonb']>;
  requestTime?: InputMaybe<Scalars['bigint']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['jsonb']>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Obj_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SensitiveInformationHistories_Max_Fields = {
  __typename?: 'sensitiveInformationHistories_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestTime?: Maybe<Scalars['bigint']>;
  sensitiveInformationRequestServiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SensitiveInformationHistories_Min_Fields = {
  __typename?: 'sensitiveInformationHistories_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestTime?: Maybe<Scalars['bigint']>;
  sensitiveInformationRequestServiceId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sensitive_information_histories" */
export type SensitiveInformationHistories_Mutation_Response = {
  __typename?: 'sensitiveInformationHistories_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformationHistories>;
};

/** on_conflict condition type for table "sensitive_information_histories" */
export type SensitiveInformationHistories_On_Conflict = {
  constraint: SensitiveInformationHistories_Constraint;
  update_columns?: Array<SensitiveInformationHistories_Update_Column>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_histories". */
export type SensitiveInformationHistories_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestItems?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  sensitiveInformationHistoryData?: InputMaybe<Order_By>;
  sensitiveInformationRequestServiceId?: InputMaybe<Order_By>;
  sensitiveInformationRequestServices?: InputMaybe<SensitiveInformationRequestServices_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_histories */
export type SensitiveInformationHistories_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationHistories_Prepend_Input = {
  requestItems?: InputMaybe<Scalars['jsonb']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sensitive_information_histories" */
export enum SensitiveInformationHistories_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestItems = 'requestItems',
  /** column name */
  RequestTime = 'requestTime',
  /** column name */
  SensitiveInformationHistoryData = 'sensitiveInformationHistoryData',
  /** column name */
  SensitiveInformationRequestServiceId = 'sensitiveInformationRequestServiceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "sensitive_information_histories" */
export type SensitiveInformationHistories_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestItems?: InputMaybe<Scalars['jsonb']>;
  requestTime?: InputMaybe<Scalars['bigint']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['jsonb']>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SensitiveInformationHistories_Stddev_Fields = {
  __typename?: 'sensitiveInformationHistories_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformationHistories_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformationHistories_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformationHistories_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformationHistories_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sensitiveInformationHistories" */
export type SensitiveInformationHistories_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformationHistories_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformationHistories_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestItems?: InputMaybe<Scalars['jsonb']>;
  requestTime?: InputMaybe<Scalars['bigint']>;
  sensitiveInformationHistoryData?: InputMaybe<Scalars['jsonb']>;
  sensitiveInformationRequestServiceId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SensitiveInformationHistories_Sum_Fields = {
  __typename?: 'sensitiveInformationHistories_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  requestTime?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "sensitive_information_histories" */
export enum SensitiveInformationHistories_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestItems = 'requestItems',
  /** column name */
  RequestTime = 'requestTime',
  /** column name */
  SensitiveInformationHistoryData = 'sensitiveInformationHistoryData',
  /** column name */
  SensitiveInformationRequestServiceId = 'sensitiveInformationRequestServiceId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type SensitiveInformationHistories_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SensitiveInformationHistories_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SensitiveInformationHistories_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SensitiveInformationHistories_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SensitiveInformationHistories_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformationHistories_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SensitiveInformationHistories_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformationHistories_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformationHistories_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformationHistories_Var_Pop_Fields = {
  __typename?: 'sensitiveInformationHistories_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SensitiveInformationHistories_Var_Samp_Fields = {
  __typename?: 'sensitiveInformationHistories_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SensitiveInformationHistories_Variance_Fields = {
  __typename?: 'sensitiveInformationHistories_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestTime?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sensitive_information_histories" */
export type SensitiveInformationHistories_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  requestTime?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "sensitive_information_items" */
export type SensitiveInformationItems = {
  __typename?: 'sensitiveInformationItems';
  /** An array relationship */
  consents: Array<Consents>;
  /** An aggregate relationship */
  consents_aggregate: Consents_Aggregate;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  itemName: Scalars['String'];
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  /** An object relationship */
  sensitiveInformationCategories?: Maybe<SensitiveInformationCategories>;
  sensitiveInformationCategoriesId?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId: Scalars['String'];
  sensitiveInformationStoreServiceItemId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sensitive_information_items" */
export type SensitiveInformationItemsConsentsArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


/** columns and relationships of "sensitive_information_items" */
export type SensitiveInformationItemsConsents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};

/** aggregated selection of "sensitive_information_items" */
export type SensitiveInformationItems_Aggregate = {
  __typename?: 'sensitiveInformationItems_aggregate';
  aggregate?: Maybe<SensitiveInformationItems_Aggregate_Fields>;
  nodes: Array<SensitiveInformationItems>;
};

export type SensitiveInformationItems_Aggregate_Bool_Exp = {
  count?: InputMaybe<SensitiveInformationItems_Aggregate_Bool_Exp_Count>;
};

export type SensitiveInformationItems_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "sensitive_information_items" */
export type SensitiveInformationItems_Aggregate_Fields = {
  __typename?: 'sensitiveInformationItems_aggregate_fields';
  avg?: Maybe<SensitiveInformationItems_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformationItems_Max_Fields>;
  min?: Maybe<SensitiveInformationItems_Min_Fields>;
  stddev?: Maybe<SensitiveInformationItems_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformationItems_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformationItems_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformationItems_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformationItems_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformationItems_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformationItems_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_items" */
export type SensitiveInformationItems_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "sensitive_information_items" */
export type SensitiveInformationItems_Aggregate_Order_By = {
  avg?: InputMaybe<SensitiveInformationItems_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<SensitiveInformationItems_Max_Order_By>;
  min?: InputMaybe<SensitiveInformationItems_Min_Order_By>;
  stddev?: InputMaybe<SensitiveInformationItems_Stddev_Order_By>;
  stddev_pop?: InputMaybe<SensitiveInformationItems_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<SensitiveInformationItems_Stddev_Samp_Order_By>;
  sum?: InputMaybe<SensitiveInformationItems_Sum_Order_By>;
  var_pop?: InputMaybe<SensitiveInformationItems_Var_Pop_Order_By>;
  var_samp?: InputMaybe<SensitiveInformationItems_Var_Samp_Order_By>;
  variance?: InputMaybe<SensitiveInformationItems_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "sensitive_information_items" */
export type SensitiveInformationItems_Arr_Rel_Insert_Input = {
  data: Array<SensitiveInformationItems_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<SensitiveInformationItems_On_Conflict>;
};

/** aggregate avg on columns */
export type SensitiveInformationItems_Avg_Fields = {
  __typename?: 'sensitiveInformationItems_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "sensitive_information_items". All fields are combined with a logical 'AND'. */
export type SensitiveInformationItems_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformationItems_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformationItems_Bool_Exp>>;
  consents?: InputMaybe<Consents_Bool_Exp>;
  consents_aggregate?: InputMaybe<Consents_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  itemName?: InputMaybe<String_Comparison_Exp>;
  lastUpdatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationCategories?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
  sensitiveInformationCategoriesId?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_items" */
export enum SensitiveInformationItems_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationItemsPkey = 'sensitive_information_items_pkey'
}

/** input type for incrementing numeric columns in table "sensitive_information_items" */
export type SensitiveInformationItems_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_items" */
export type SensitiveInformationItems_Insert_Input = {
  consents?: InputMaybe<Consents_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationCategories?: InputMaybe<SensitiveInformationCategories_Obj_Rel_Insert_Input>;
  sensitiveInformationCategoriesId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SensitiveInformationItems_Max_Fields = {
  __typename?: 'sensitiveInformationItems_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  sensitiveInformationCategoriesId?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemName?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationCategoriesId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type SensitiveInformationItems_Min_Fields = {
  __typename?: 'sensitiveInformationItems_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  itemName?: Maybe<Scalars['String']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  sensitiveInformationCategoriesId?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemName?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationCategoriesId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "sensitive_information_items" */
export type SensitiveInformationItems_Mutation_Response = {
  __typename?: 'sensitiveInformationItems_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformationItems>;
};

/** input type for inserting object relation for remote table "sensitive_information_items" */
export type SensitiveInformationItems_Obj_Rel_Insert_Input = {
  data: SensitiveInformationItems_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SensitiveInformationItems_On_Conflict>;
};

/** on_conflict condition type for table "sensitive_information_items" */
export type SensitiveInformationItems_On_Conflict = {
  constraint: SensitiveInformationItems_Constraint;
  update_columns?: Array<SensitiveInformationItems_Update_Column>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_items". */
export type SensitiveInformationItems_Order_By = {
  consents_aggregate?: InputMaybe<Consents_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  itemName?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationCategories?: InputMaybe<SensitiveInformationCategories_Order_By>;
  sensitiveInformationCategoriesId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_items */
export type SensitiveInformationItems_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "sensitive_information_items" */
export enum SensitiveInformationItems_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'itemName',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  SensitiveInformationCategoriesId = 'sensitiveInformationCategoriesId',
  /** column name */
  SensitiveInformationStoreServiceConnectionsId = 'sensitiveInformationStoreServiceConnectionsId',
  /** column name */
  SensitiveInformationStoreServiceItemId = 'sensitiveInformationStoreServiceItemId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sensitive_information_items" */
export type SensitiveInformationItems_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationCategoriesId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SensitiveInformationItems_Stddev_Fields = {
  __typename?: 'sensitiveInformationItems_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformationItems_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformationItems_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformationItems_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformationItems_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "sensitiveInformationItems" */
export type SensitiveInformationItems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformationItems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformationItems_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  itemName?: InputMaybe<Scalars['String']>;
  lastUpdatedAt?: InputMaybe<Scalars['bigint']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationCategoriesId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnectionsId?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SensitiveInformationItems_Sum_Fields = {
  __typename?: 'sensitiveInformationItems_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  lastUpdatedAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "sensitive_information_items" */
export enum SensitiveInformationItems_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ItemName = 'itemName',
  /** column name */
  LastUpdatedAt = 'lastUpdatedAt',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  SensitiveInformationCategoriesId = 'sensitiveInformationCategoriesId',
  /** column name */
  SensitiveInformationStoreServiceConnectionsId = 'sensitiveInformationStoreServiceConnectionsId',
  /** column name */
  SensitiveInformationStoreServiceItemId = 'sensitiveInformationStoreServiceItemId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SensitiveInformationItems_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformationItems_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformationItems_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformationItems_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformationItems_Var_Pop_Fields = {
  __typename?: 'sensitiveInformationItems_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type SensitiveInformationItems_Var_Samp_Fields = {
  __typename?: 'sensitiveInformationItems_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type SensitiveInformationItems_Variance_Fields = {
  __typename?: 'sensitiveInformationItems_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  lastUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "sensitive_information_items" */
export type SensitiveInformationItems_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  lastUpdatedAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServices = {
  __typename?: 'sensitiveInformationRequestServices';
  /** An array relationship */
  consents: Array<Consents>;
  /** An aggregate relationship */
  consents_aggregate: Consents_Aggregate;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  requestServiceAuthenticationKey?: Maybe<Scalars['jsonb']>;
  requestServiceInformation?: Maybe<Scalars['jsonb']>;
  requestServiceInformationUpdatedAt: Scalars['bigint'];
  requestServiceKey: Scalars['String'];
  requestServiceTermsUpdatedAt: Scalars['bigint'];
  requestServiceTermsUrl: Scalars['String'];
  /** An array relationship */
  sensitiveInformationHistories: Array<SensitiveInformationHistories>;
  /** An aggregate relationship */
  sensitiveInformationHistories_aggregate: SensitiveInformationHistories_Aggregate;
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesConsentsArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesConsents_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesRequestServiceAuthenticationKeyArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesRequestServiceInformationArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesSensitiveInformationHistoriesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


/** columns and relationships of "sensitive_information_request_services" */
export type SensitiveInformationRequestServicesSensitiveInformationHistories_AggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};

/** aggregated selection of "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Aggregate = {
  __typename?: 'sensitiveInformationRequestServices_aggregate';
  aggregate?: Maybe<SensitiveInformationRequestServices_Aggregate_Fields>;
  nodes: Array<SensitiveInformationRequestServices>;
};

/** aggregate fields of "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Aggregate_Fields = {
  __typename?: 'sensitiveInformationRequestServices_aggregate_fields';
  avg?: Maybe<SensitiveInformationRequestServices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformationRequestServices_Max_Fields>;
  min?: Maybe<SensitiveInformationRequestServices_Min_Fields>;
  stddev?: Maybe<SensitiveInformationRequestServices_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformationRequestServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformationRequestServices_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformationRequestServices_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformationRequestServices_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformationRequestServices_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformationRequestServices_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformationRequestServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationRequestServices_Append_Input = {
  requestServiceAuthenticationKey?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformation?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SensitiveInformationRequestServices_Avg_Fields = {
  __typename?: 'sensitiveInformationRequestServices_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sensitive_information_request_services". All fields are combined with a logical 'AND'. */
export type SensitiveInformationRequestServices_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformationRequestServices_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformationRequestServices_Bool_Exp>>;
  consents?: InputMaybe<Consents_Bool_Exp>;
  consents_aggregate?: InputMaybe<Consents_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  requestServiceAuthenticationKey?: InputMaybe<Jsonb_Comparison_Exp>;
  requestServiceInformation?: InputMaybe<Jsonb_Comparison_Exp>;
  requestServiceInformationUpdatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  requestServiceKey?: InputMaybe<String_Comparison_Exp>;
  requestServiceTermsUpdatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  requestServiceTermsUrl?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationHistories?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
  sensitiveInformationHistories_aggregate?: InputMaybe<SensitiveInformationHistories_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_request_services" */
export enum SensitiveInformationRequestServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationRequestServicesPkey = 'sensitive_information_request_services_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SensitiveInformationRequestServices_Delete_At_Path_Input = {
  requestServiceAuthenticationKey?: InputMaybe<Array<Scalars['String']>>;
  requestServiceInformation?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SensitiveInformationRequestServices_Delete_Elem_Input = {
  requestServiceAuthenticationKey?: InputMaybe<Scalars['Int']>;
  requestServiceInformation?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SensitiveInformationRequestServices_Delete_Key_Input = {
  requestServiceAuthenticationKey?: InputMaybe<Scalars['String']>;
  requestServiceInformation?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  requestServiceInformationUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceTermsUpdatedAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Insert_Input = {
  consents?: InputMaybe<Consents_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestServiceAuthenticationKey?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformation?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformationUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceKey?: InputMaybe<Scalars['String']>;
  requestServiceTermsUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceTermsUrl?: InputMaybe<Scalars['String']>;
  sensitiveInformationHistories?: InputMaybe<SensitiveInformationHistories_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SensitiveInformationRequestServices_Max_Fields = {
  __typename?: 'sensitiveInformationRequestServices_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['bigint']>;
  requestServiceKey?: Maybe<Scalars['String']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['bigint']>;
  requestServiceTermsUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SensitiveInformationRequestServices_Min_Fields = {
  __typename?: 'sensitiveInformationRequestServices_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['bigint']>;
  requestServiceKey?: Maybe<Scalars['String']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['bigint']>;
  requestServiceTermsUrl?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Mutation_Response = {
  __typename?: 'sensitiveInformationRequestServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformationRequestServices>;
};

/** input type for inserting object relation for remote table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Obj_Rel_Insert_Input = {
  data: SensitiveInformationRequestServices_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<SensitiveInformationRequestServices_On_Conflict>;
};

/** on_conflict condition type for table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_On_Conflict = {
  constraint: SensitiveInformationRequestServices_Constraint;
  update_columns?: Array<SensitiveInformationRequestServices_Update_Column>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_request_services". */
export type SensitiveInformationRequestServices_Order_By = {
  consents_aggregate?: InputMaybe<Consents_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  requestServiceAuthenticationKey?: InputMaybe<Order_By>;
  requestServiceInformation?: InputMaybe<Order_By>;
  requestServiceInformationUpdatedAt?: InputMaybe<Order_By>;
  requestServiceKey?: InputMaybe<Order_By>;
  requestServiceTermsUpdatedAt?: InputMaybe<Order_By>;
  requestServiceTermsUrl?: InputMaybe<Order_By>;
  sensitiveInformationHistories_aggregate?: InputMaybe<SensitiveInformationHistories_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_request_services */
export type SensitiveInformationRequestServices_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationRequestServices_Prepend_Input = {
  requestServiceAuthenticationKey?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformation?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sensitive_information_request_services" */
export enum SensitiveInformationRequestServices_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestServiceAuthenticationKey = 'requestServiceAuthenticationKey',
  /** column name */
  RequestServiceInformation = 'requestServiceInformation',
  /** column name */
  RequestServiceInformationUpdatedAt = 'requestServiceInformationUpdatedAt',
  /** column name */
  RequestServiceKey = 'requestServiceKey',
  /** column name */
  RequestServiceTermsUpdatedAt = 'requestServiceTermsUpdatedAt',
  /** column name */
  RequestServiceTermsUrl = 'requestServiceTermsUrl',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sensitive_information_request_services" */
export type SensitiveInformationRequestServices_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestServiceAuthenticationKey?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformation?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformationUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceKey?: InputMaybe<Scalars['String']>;
  requestServiceTermsUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceTermsUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SensitiveInformationRequestServices_Stddev_Fields = {
  __typename?: 'sensitiveInformationRequestServices_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformationRequestServices_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformationRequestServices_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformationRequestServices_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformationRequestServices_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sensitiveInformationRequestServices" */
export type SensitiveInformationRequestServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformationRequestServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformationRequestServices_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  requestServiceAuthenticationKey?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformation?: InputMaybe<Scalars['jsonb']>;
  requestServiceInformationUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceKey?: InputMaybe<Scalars['String']>;
  requestServiceTermsUpdatedAt?: InputMaybe<Scalars['bigint']>;
  requestServiceTermsUrl?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SensitiveInformationRequestServices_Sum_Fields = {
  __typename?: 'sensitiveInformationRequestServices_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['bigint']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sensitive_information_request_services" */
export enum SensitiveInformationRequestServices_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  RequestServiceAuthenticationKey = 'requestServiceAuthenticationKey',
  /** column name */
  RequestServiceInformation = 'requestServiceInformation',
  /** column name */
  RequestServiceInformationUpdatedAt = 'requestServiceInformationUpdatedAt',
  /** column name */
  RequestServiceKey = 'requestServiceKey',
  /** column name */
  RequestServiceTermsUpdatedAt = 'requestServiceTermsUpdatedAt',
  /** column name */
  RequestServiceTermsUrl = 'requestServiceTermsUrl',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SensitiveInformationRequestServices_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SensitiveInformationRequestServices_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SensitiveInformationRequestServices_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SensitiveInformationRequestServices_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SensitiveInformationRequestServices_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformationRequestServices_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SensitiveInformationRequestServices_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformationRequestServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformationRequestServices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformationRequestServices_Var_Pop_Fields = {
  __typename?: 'sensitiveInformationRequestServices_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SensitiveInformationRequestServices_Var_Samp_Fields = {
  __typename?: 'sensitiveInformationRequestServices_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SensitiveInformationRequestServices_Variance_Fields = {
  __typename?: 'sensitiveInformationRequestServices_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  requestServiceInformationUpdatedAt?: Maybe<Scalars['Float']>;
  requestServiceTermsUpdatedAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections = {
  __typename?: 'sensitiveInformationStoreServiceConnections';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnection?: Maybe<Scalars['jsonb']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};


/** columns and relationships of "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnectionsSensitiveInformationStoreServiceConnectionArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Aggregate = {
  __typename?: 'sensitiveInformationStoreServiceConnections_aggregate';
  aggregate?: Maybe<SensitiveInformationStoreServiceConnections_Aggregate_Fields>;
  nodes: Array<SensitiveInformationStoreServiceConnections>;
};

/** aggregate fields of "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Aggregate_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_aggregate_fields';
  avg?: Maybe<SensitiveInformationStoreServiceConnections_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformationStoreServiceConnections_Max_Fields>;
  min?: Maybe<SensitiveInformationStoreServiceConnections_Min_Fields>;
  stddev?: Maybe<SensitiveInformationStoreServiceConnections_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformationStoreServiceConnections_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformationStoreServiceConnections_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformationStoreServiceConnections_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformationStoreServiceConnections_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformationStoreServiceConnections_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformationStoreServiceConnections_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationStoreServiceConnections_Append_Input = {
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type SensitiveInformationStoreServiceConnections_Avg_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sensitive_information_store_service_connections". All fields are combined with a logical 'AND'. */
export type SensitiveInformationStoreServiceConnections_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationStoreServiceConnection?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_store_service_connections" */
export enum SensitiveInformationStoreServiceConnections_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationStoreServiceConnectionsPkey = 'sensitive_information_store_service_connections_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type SensitiveInformationStoreServiceConnections_Delete_At_Path_Input = {
  sensitiveInformationStoreServiceConnection?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type SensitiveInformationStoreServiceConnections_Delete_Elem_Input = {
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type SensitiveInformationStoreServiceConnections_Delete_Key_Input = {
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type SensitiveInformationStoreServiceConnections_Max_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type SensitiveInformationStoreServiceConnections_Min_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Mutation_Response = {
  __typename?: 'sensitiveInformationStoreServiceConnections_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformationStoreServiceConnections>;
};

/** on_conflict condition type for table "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_On_Conflict = {
  constraint: SensitiveInformationStoreServiceConnections_Constraint;
  update_columns?: Array<SensitiveInformationStoreServiceConnections_Update_Column>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_store_service_connections". */
export type SensitiveInformationStoreServiceConnections_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  sensitiveInformationStoreServiceConnection?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_store_service_connections */
export type SensitiveInformationStoreServiceConnections_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type SensitiveInformationStoreServiceConnections_Prepend_Input = {
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "sensitive_information_store_service_connections" */
export enum SensitiveInformationStoreServiceConnections_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  SensitiveInformationStoreServiceConnection = 'sensitiveInformationStoreServiceConnection',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sensitive_information_store_service_connections" */
export type SensitiveInformationStoreServiceConnections_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type SensitiveInformationStoreServiceConnections_Stddev_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformationStoreServiceConnections_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformationStoreServiceConnections_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sensitiveInformationStoreServiceConnections" */
export type SensitiveInformationStoreServiceConnections_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformationStoreServiceConnections_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformationStoreServiceConnections_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  sensitiveInformationStoreServiceConnection?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type SensitiveInformationStoreServiceConnections_Sum_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sensitive_information_store_service_connections" */
export enum SensitiveInformationStoreServiceConnections_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  SensitiveInformationStoreServiceConnection = 'sensitiveInformationStoreServiceConnection',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type SensitiveInformationStoreServiceConnections_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<SensitiveInformationStoreServiceConnections_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<SensitiveInformationStoreServiceConnections_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformationStoreServiceConnections_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<SensitiveInformationStoreServiceConnections_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformationStoreServiceConnections_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformationStoreServiceConnections_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformationStoreServiceConnections_Var_Pop_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SensitiveInformationStoreServiceConnections_Var_Samp_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SensitiveInformationStoreServiceConnections_Variance_Fields = {
  __typename?: 'sensitiveInformationStoreServiceConnections_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregated selection of "sensitive_information" */
export type SensitiveInformation_Aggregate = {
  __typename?: 'sensitiveInformation_aggregate';
  aggregate?: Maybe<SensitiveInformation_Aggregate_Fields>;
  nodes: Array<SensitiveInformation>;
};

/** aggregate fields of "sensitive_information" */
export type SensitiveInformation_Aggregate_Fields = {
  __typename?: 'sensitiveInformation_aggregate_fields';
  avg?: Maybe<SensitiveInformation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<SensitiveInformation_Max_Fields>;
  min?: Maybe<SensitiveInformation_Min_Fields>;
  stddev?: Maybe<SensitiveInformation_Stddev_Fields>;
  stddev_pop?: Maybe<SensitiveInformation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<SensitiveInformation_Stddev_Samp_Fields>;
  sum?: Maybe<SensitiveInformation_Sum_Fields>;
  var_pop?: Maybe<SensitiveInformation_Var_Pop_Fields>;
  var_samp?: Maybe<SensitiveInformation_Var_Samp_Fields>;
  variance?: Maybe<SensitiveInformation_Variance_Fields>;
};


/** aggregate fields of "sensitive_information" */
export type SensitiveInformation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<SensitiveInformation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type SensitiveInformation_Avg_Fields = {
  __typename?: 'sensitiveInformation_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sensitive_information". All fields are combined with a logical 'AND'. */
export type SensitiveInformation_Bool_Exp = {
  _and?: InputMaybe<Array<SensitiveInformation_Bool_Exp>>;
  _not?: InputMaybe<SensitiveInformation_Bool_Exp>;
  _or?: InputMaybe<Array<SensitiveInformation_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  sensitiveInformationItemId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information" */
export enum SensitiveInformation_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationPkey = 'sensitive_information_pkey',
  /** unique or primary key constraint on columns "sensitive_information_item_id", "user_id" */
  SensitiveInformationUserItemUnique = 'sensitive_information_user_item_unique'
}

/** input type for incrementing numeric columns in table "sensitive_information" */
export type SensitiveInformation_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information" */
export type SensitiveInformation_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type SensitiveInformation_Max_Fields = {
  __typename?: 'sensitiveInformation_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  sensitiveInformationItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type SensitiveInformation_Min_Fields = {
  __typename?: 'sensitiveInformation_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  sensitiveInformationItemId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "sensitive_information" */
export type SensitiveInformation_Mutation_Response = {
  __typename?: 'sensitiveInformation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<SensitiveInformation>;
};

/** on_conflict condition type for table "sensitive_information" */
export type SensitiveInformation_On_Conflict = {
  constraint: SensitiveInformation_Constraint;
  update_columns?: Array<SensitiveInformation_Update_Column>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information". */
export type SensitiveInformation_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sensitiveInformationItemId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information */
export type SensitiveInformation_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "sensitive_information" */
export enum SensitiveInformation_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  SensitiveInformationItemId = 'sensitiveInformationItemId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "sensitive_information" */
export type SensitiveInformation_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type SensitiveInformation_Stddev_Fields = {
  __typename?: 'sensitiveInformation_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type SensitiveInformation_Stddev_Pop_Fields = {
  __typename?: 'sensitiveInformation_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type SensitiveInformation_Stddev_Samp_Fields = {
  __typename?: 'sensitiveInformation_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "sensitiveInformation" */
export type SensitiveInformation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: SensitiveInformation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type SensitiveInformation_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  sensitiveInformationItemId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type SensitiveInformation_Sum_Fields = {
  __typename?: 'sensitiveInformation_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sensitive_information" */
export enum SensitiveInformation_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  SensitiveInformationItemId = 'sensitiveInformationItemId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId',
  /** column name */
  Value = 'value'
}

export type SensitiveInformation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<SensitiveInformation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SensitiveInformation_Set_Input>;
  /** filter the rows which have to be updated */
  where: SensitiveInformation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type SensitiveInformation_Var_Pop_Fields = {
  __typename?: 'sensitiveInformation_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type SensitiveInformation_Var_Samp_Fields = {
  __typename?: 'sensitiveInformation_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type SensitiveInformation_Variance_Fields = {
  __typename?: 'sensitiveInformation_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "services" */
export type Services = {
  __typename?: 'services';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "services" */
export type Services_Aggregate = {
  __typename?: 'services_aggregate';
  aggregate?: Maybe<Services_Aggregate_Fields>;
  nodes: Array<Services>;
};

/** aggregate fields of "services" */
export type Services_Aggregate_Fields = {
  __typename?: 'services_aggregate_fields';
  avg?: Maybe<Services_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Services_Max_Fields>;
  min?: Maybe<Services_Min_Fields>;
  stddev?: Maybe<Services_Stddev_Fields>;
  stddev_pop?: Maybe<Services_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Services_Stddev_Samp_Fields>;
  sum?: Maybe<Services_Sum_Fields>;
  var_pop?: Maybe<Services_Var_Pop_Fields>;
  var_samp?: Maybe<Services_Var_Samp_Fields>;
  variance?: Maybe<Services_Variance_Fields>;
};


/** aggregate fields of "services" */
export type Services_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Services_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Services_Avg_Fields = {
  __typename?: 'services_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "services". All fields are combined with a logical 'AND'. */
export type Services_Bool_Exp = {
  _and?: InputMaybe<Array<Services_Bool_Exp>>;
  _not?: InputMaybe<Services_Bool_Exp>;
  _or?: InputMaybe<Array<Services_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  shortId?: InputMaybe<Bigint_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "services" */
export enum Services_Constraint {
  /** unique or primary key constraint on columns "id" */
  ServicesPkey = 'services_pkey',
  /** unique or primary key constraint on columns "short_id" */
  ServicesShortIdKey = 'services_short_id_key'
}

/** input type for incrementing numeric columns in table "services" */
export type Services_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "services" */
export type Services_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type Services_Max_Fields = {
  __typename?: 'services_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type Services_Min_Fields = {
  __typename?: 'services_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "services" */
export type Services_Mutation_Response = {
  __typename?: 'services_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Services>;
};

/** on_conflict condition type for table "services" */
export type Services_On_Conflict = {
  constraint: Services_Constraint;
  update_columns?: Array<Services_Update_Column>;
  where?: InputMaybe<Services_Bool_Exp>;
};

/** Ordering options when selecting data from "services". */
export type Services_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  shortId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: services */
export type Services_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "services" */
export enum Services_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "services" */
export type Services_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type Services_Stddev_Fields = {
  __typename?: 'services_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Services_Stddev_Pop_Fields = {
  __typename?: 'services_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Services_Stddev_Samp_Fields = {
  __typename?: 'services_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "services" */
export type Services_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Services_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Services_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type Services_Sum_Fields = {
  __typename?: 'services_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "services" */
export enum Services_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Services_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Services_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Services_Set_Input>;
  /** filter the rows which have to be updated */
  where: Services_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Services_Var_Pop_Fields = {
  __typename?: 'services_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Services_Var_Samp_Fields = {
  __typename?: 'services_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Services_Variance_Fields = {
  __typename?: 'services_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "sensitive_information_items" */
export type StoreSensitiveInformationItems = {
  __typename?: 'storeSensitiveInformationItems';
  categoryId: Scalars['String'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "sensitive_information_items" */
export type StoreSensitiveInformationItems_Aggregate = {
  __typename?: 'storeSensitiveInformationItems_aggregate';
  aggregate?: Maybe<StoreSensitiveInformationItems_Aggregate_Fields>;
  nodes: Array<StoreSensitiveInformationItems>;
};

/** aggregate fields of "sensitive_information_items" */
export type StoreSensitiveInformationItems_Aggregate_Fields = {
  __typename?: 'storeSensitiveInformationItems_aggregate_fields';
  avg?: Maybe<StoreSensitiveInformationItems_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<StoreSensitiveInformationItems_Max_Fields>;
  min?: Maybe<StoreSensitiveInformationItems_Min_Fields>;
  stddev?: Maybe<StoreSensitiveInformationItems_Stddev_Fields>;
  stddev_pop?: Maybe<StoreSensitiveInformationItems_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<StoreSensitiveInformationItems_Stddev_Samp_Fields>;
  sum?: Maybe<StoreSensitiveInformationItems_Sum_Fields>;
  var_pop?: Maybe<StoreSensitiveInformationItems_Var_Pop_Fields>;
  var_samp?: Maybe<StoreSensitiveInformationItems_Var_Samp_Fields>;
  variance?: Maybe<StoreSensitiveInformationItems_Variance_Fields>;
};


/** aggregate fields of "sensitive_information_items" */
export type StoreSensitiveInformationItems_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<StoreSensitiveInformationItems_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type StoreSensitiveInformationItems_Avg_Fields = {
  __typename?: 'storeSensitiveInformationItems_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "sensitive_information_items". All fields are combined with a logical 'AND'. */
export type StoreSensitiveInformationItems_Bool_Exp = {
  _and?: InputMaybe<Array<StoreSensitiveInformationItems_Bool_Exp>>;
  _not?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
  _or?: InputMaybe<Array<StoreSensitiveInformationItems_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "sensitive_information_items" */
export enum StoreSensitiveInformationItems_Constraint {
  /** unique or primary key constraint on columns "id" */
  SensitiveInformationItemsPkey = 'sensitive_information_items_pkey'
}

/** input type for incrementing numeric columns in table "sensitive_information_items" */
export type StoreSensitiveInformationItems_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "sensitive_information_items" */
export type StoreSensitiveInformationItems_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type StoreSensitiveInformationItems_Max_Fields = {
  __typename?: 'storeSensitiveInformationItems_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type StoreSensitiveInformationItems_Min_Fields = {
  __typename?: 'storeSensitiveInformationItems_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "sensitive_information_items" */
export type StoreSensitiveInformationItems_Mutation_Response = {
  __typename?: 'storeSensitiveInformationItems_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<StoreSensitiveInformationItems>;
};

/** on_conflict condition type for table "sensitive_information_items" */
export type StoreSensitiveInformationItems_On_Conflict = {
  constraint: StoreSensitiveInformationItems_Constraint;
  update_columns?: Array<StoreSensitiveInformationItems_Update_Column>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};

/** Ordering options when selecting data from "sensitive_information_items". */
export type StoreSensitiveInformationItems_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: sensitive_information_items */
export type StoreSensitiveInformationItems_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "sensitive_information_items" */
export enum StoreSensitiveInformationItems_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "sensitive_information_items" */
export type StoreSensitiveInformationItems_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type StoreSensitiveInformationItems_Stddev_Fields = {
  __typename?: 'storeSensitiveInformationItems_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type StoreSensitiveInformationItems_Stddev_Pop_Fields = {
  __typename?: 'storeSensitiveInformationItems_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type StoreSensitiveInformationItems_Stddev_Samp_Fields = {
  __typename?: 'storeSensitiveInformationItems_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "storeSensitiveInformationItems" */
export type StoreSensitiveInformationItems_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: StoreSensitiveInformationItems_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type StoreSensitiveInformationItems_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type StoreSensitiveInformationItems_Sum_Fields = {
  __typename?: 'storeSensitiveInformationItems_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "sensitive_information_items" */
export enum StoreSensitiveInformationItems_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type StoreSensitiveInformationItems_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<StoreSensitiveInformationItems_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<StoreSensitiveInformationItems_Set_Input>;
  /** filter the rows which have to be updated */
  where: StoreSensitiveInformationItems_Bool_Exp;
};

/** aggregate var_pop on columns */
export type StoreSensitiveInformationItems_Var_Pop_Fields = {
  __typename?: 'storeSensitiveInformationItems_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type StoreSensitiveInformationItems_Var_Samp_Fields = {
  __typename?: 'storeSensitiveInformationItems_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type StoreSensitiveInformationItems_Variance_Fields = {
  __typename?: 'storeSensitiveInformationItems_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "access_logs" using primary key columns */
  accessLogByPk?: Maybe<AccessLogs>;
  /** fetch data from the table: "access_logs" */
  accessLogs: Array<AccessLogs>;
  /** fetch aggregated fields from the table: "access_logs" */
  accessLogsAggregate: AccessLogs_Aggregate;
  /** fetch data from the table in a streaming manner: "access_logs" */
  accessLogs_stream: Array<AccessLogs>;
  /** fetch data from the table: "assets_assets" using primary key columns */
  assetAssetByPk?: Maybe<AssetsAssets>;
  /** fetch data from the table: "assets" using primary key columns */
  assetByPk?: Maybe<Assets>;
  /** fetch data from the table: "asset_images" using primary key columns */
  assetImageByPk?: Maybe<AssetImages>;
  /** An array relationship */
  assetImages: Array<AssetImages>;
  /** fetch aggregated fields from the table: "asset_images" */
  assetImagesAggregate: AssetImages_Aggregate;
  /** fetch data from the table in a streaming manner: "asset_images" */
  assetImages_stream: Array<AssetImages>;
  /** An array relationship */
  assetProperties: Array<AssetProperties>;
  /** fetch aggregated fields from the table: "asset_properties" */
  assetPropertiesAggregate: AssetProperties_Aggregate;
  /** fetch data from the table in a streaming manner: "asset_properties" */
  assetProperties_stream: Array<AssetProperties>;
  /** fetch data from the table: "asset_properties" using primary key columns */
  assetPropertyByPk?: Maybe<AssetProperties>;
  /** fetch data from the table: "asset_states" using primary key columns */
  assetStateByPk?: Maybe<Asset_States>;
  /** fetch data from the table: "asset_states" */
  assetStates: Array<Asset_States>;
  /** fetch aggregated fields from the table: "asset_states" */
  assetStatesAggregate: Asset_States_Aggregate;
  /** fetch data from the table: "asset_tags" using primary key columns */
  assetTagByPk?: Maybe<AssetTags>;
  /** An array relationship */
  assetTags: Array<AssetTags>;
  /** fetch aggregated fields from the table: "asset_tags" */
  assetTagsAggregate: AssetTags_Aggregate;
  /** fetch data from the table in a streaming manner: "asset_tags" */
  assetTags_stream: Array<AssetTags>;
  /** fetch data from the table: "asset_types" using primary key columns */
  assetTypeByPk?: Maybe<AssetTypes>;
  /** fetch data from the table: "asset_types" */
  assetTypes: Array<AssetTypes>;
  /** fetch aggregated fields from the table: "asset_types" */
  assetTypesAggregate: AssetTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "asset_types" */
  assetTypes_stream: Array<AssetTypes>;
  /** fetch data from the table in a streaming manner: "asset_states" */
  asset_states_stream: Array<Asset_States>;
  /** An array relationship */
  assets: Array<Assets>;
  /** fetch aggregated fields from the table: "assets" */
  assetsAggregate: Assets_Aggregate;
  /** fetch data from the table: "assets_assets" */
  assetsAssets: Array<AssetsAssets>;
  /** fetch aggregated fields from the table: "assets_assets" */
  assetsAssetsAggregate: AssetsAssets_Aggregate;
  /** fetch data from the table in a streaming manner: "assets_assets" */
  assetsAssets_stream: Array<AssetsAssets>;
  /** fetch data from the table in a streaming manner: "assets" */
  assets_stream: Array<Assets>;
  /** fetch data from the table: "authorization_info" */
  authorizationInfo: Array<AuthorizationInfo>;
  /** fetch aggregated fields from the table: "authorization_info" */
  authorizationInfoAggregate: AuthorizationInfo_Aggregate;
  /** fetch data from the table: "authorization_info" using primary key columns */
  authorizationInfoByPk?: Maybe<AuthorizationInfo>;
  /** fetch data from the table in a streaming manner: "authorization_info" */
  authorizationInfo_stream: Array<AuthorizationInfo>;
  /** fetch data from the table: "authorization_tenant_service_info" */
  authorizationTenantServiceInfo: Array<AuthorizationTenantServiceInfo>;
  /** fetch aggregated fields from the table: "authorization_tenant_service_info" */
  authorizationTenantServiceInfoAggregate: AuthorizationTenantServiceInfo_Aggregate;
  /** fetch data from the table in a streaming manner: "authorization_tenant_service_info" */
  authorizationTenantServiceInfo_stream: Array<AuthorizationTenantServiceInfo>;
  /** fetch data from the table: "categories" */
  categories: Array<Categories>;
  /** fetch aggregated fields from the table: "categories" */
  categoriesAggregate: Categories_Aggregate;
  /** fetch data from the table in a streaming manner: "categories" */
  categories_stream: Array<Categories>;
  /** fetch data from the table: "categories" using primary key columns */
  categoryByPk?: Maybe<Categories>;
  /** fetch data from the table: "client_types" using primary key columns */
  clientTypeByPk?: Maybe<ClientTypes>;
  /** fetch data from the table: "client_types" */
  clientTypes: Array<ClientTypes>;
  /** fetch aggregated fields from the table: "client_types" */
  clientTypesAggregate: ClientTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "client_types" */
  clientTypes_stream: Array<ClientTypes>;
  /** fetch data from the table: "consents" using primary key columns */
  consentByPk?: Maybe<Consents>;
  /** An array relationship */
  consents: Array<Consents>;
  /** fetch aggregated fields from the table: "consents" */
  consentsAggregate: Consents_Aggregate;
  /** fetch data from the table in a streaming manner: "consents" */
  consents_stream: Array<Consents>;
  /** fetch data from the table: "csv_records" */
  csvRecords: Array<CsvRecords>;
  /** fetch aggregated fields from the table: "csv_records" */
  csvRecordsAggregate: CsvRecords_Aggregate;
  /** fetch data from the table: "csv_records" using primary key columns */
  csvRecordsByPk?: Maybe<CsvRecords>;
  /** fetch data from the table in a streaming manner: "csv_records" */
  csvRecords_stream: Array<CsvRecords>;
  /** fetch data from the table: "data_access_logs" using primary key columns */
  dataAccessLogByPk?: Maybe<DataAccessLogs>;
  /** fetch data from the table: "data_access_logs" */
  dataAccessLogs: Array<DataAccessLogs>;
  /** fetch aggregated fields from the table: "data_access_logs" */
  dataAccessLogsAggregate: DataAccessLogs_Aggregate;
  /** fetch data from the table in a streaming manner: "data_access_logs" */
  dataAccessLogs_stream: Array<DataAccessLogs>;
  /** fetch data from the table: "detections" using primary key columns */
  detectionByPk?: Maybe<Detections>;
  /** fetch data from the table: "detection_logs" using primary key columns */
  detectionLogByPk?: Maybe<DetectionLogs>;
  /** fetch data from the table: "detection_logs" */
  detectionLogs: Array<DetectionLogs>;
  /** fetch aggregated fields from the table: "detection_logs" */
  detectionLogsAggregate: DetectionLogs_Aggregate;
  /** fetch data from the table in a streaming manner: "detection_logs" */
  detectionLogs_stream: Array<DetectionLogs>;
  /** fetch data from the table: "detection_sets" using primary key columns */
  detectionSetByPk?: Maybe<DetectionSets>;
  /** fetch data from the table: "detection_sets" */
  detectionSets: Array<DetectionSets>;
  /** fetch aggregated fields from the table: "detection_sets" */
  detectionSetsAggregate: DetectionSets_Aggregate;
  /** fetch data from the table in a streaming manner: "detection_sets" */
  detectionSets_stream: Array<DetectionSets>;
  /** fetch data from the table: "detection_states" using primary key columns */
  detectionStateByPk?: Maybe<Detection_States>;
  /** fetch data from the table: "detection_states" */
  detectionStates: Array<Detection_States>;
  /** fetch aggregated fields from the table: "detection_states" */
  detectionStatesAggregate: Detection_States_Aggregate;
  /** fetch data from the table in a streaming manner: "detection_states" */
  detection_states_stream: Array<Detection_States>;
  /** fetch data from the table: "detections" */
  detections: Array<Detections>;
  /** fetch aggregated fields from the table: "detections" */
  detectionsAggregate: Detections_Aggregate;
  /** fetch data from the table in a streaming manner: "detections" */
  detections_stream: Array<Detections>;
  /** fetch data from the table: "evacuation_settings" using primary key columns */
  evacuationSettingByPk?: Maybe<EvacuationSettings>;
  /** fetch data from the table: "evacuation_settings" */
  evacuationSettings: Array<EvacuationSettings>;
  /** fetch aggregated fields from the table: "evacuation_settings" */
  evacuationSettingsAggregate: EvacuationSettings_Aggregate;
  /** fetch data from the table in a streaming manner: "evacuation_settings" */
  evacuationSettings_stream: Array<EvacuationSettings>;
  /** fetch data from the table: "events" using primary key columns */
  eventByPk?: Maybe<Events>;
  /** fetch data from the table: "events" */
  events: Array<Events>;
  /** fetch aggregated fields from the table: "events" */
  eventsAggregate: Events_Aggregate;
  /** fetch data from the table in a streaming manner: "events" */
  events_stream: Array<Events>;
  /** fetch data from the table: "execution_histories" */
  executionHistories: Array<ExecutionHistories>;
  /** fetch aggregated fields from the table: "execution_histories" */
  executionHistoriesAggregate: ExecutionHistories_Aggregate;
  /** fetch data from the table in a streaming manner: "execution_histories" */
  executionHistories_stream: Array<ExecutionHistories>;
  /** fetch data from the table: "execution_histories" using primary key columns */
  executionHistoryByPk?: Maybe<ExecutionHistories>;
  /** fetch data from the table: "file_states" using primary key columns */
  fileStateByPk?: Maybe<File_States>;
  /** fetch data from the table: "file_states" */
  fileStates: Array<File_States>;
  /** fetch aggregated fields from the table: "file_states" */
  fileStatesAggregate: File_States_Aggregate;
  /** fetch data from the table in a streaming manner: "file_states" */
  file_states_stream: Array<File_States>;
  /** fetch data from the table: "groups" using primary key columns */
  groupByPk?: Maybe<Groups>;
  /** fetch data from the table: "groups" */
  groups: Array<Groups>;
  /** fetch aggregated fields from the table: "groups" */
  groupsAggregate: Groups_Aggregate;
  /** fetch data from the table in a streaming manner: "groups" */
  groups_stream: Array<Groups>;
  /** fetch data from the table: "idps" using primary key columns */
  idpByPk?: Maybe<Idps>;
  /** fetch data from the table: "idp_types" using primary key columns */
  idpTypeByPk?: Maybe<IdpTypes>;
  /** fetch data from the table: "idp_types" */
  idpTypes: Array<IdpTypes>;
  /** fetch aggregated fields from the table: "idp_types" */
  idpTypesAggregate: IdpTypes_Aggregate;
  /** fetch data from the table in a streaming manner: "idp_types" */
  idpTypes_stream: Array<IdpTypes>;
  /** fetch data from the table: "idps" */
  idps: Array<Idps>;
  /** fetch aggregated fields from the table: "idps" */
  idpsAggregate: Idps_Aggregate;
  /** fetch data from the table in a streaming manner: "idps" */
  idps_stream: Array<Idps>;
  /** fetch data from the table: "job_settings" using primary key columns */
  jobSettingByPk?: Maybe<JobSettings>;
  /** fetch data from the table: "job_settings" */
  jobSettings: Array<JobSettings>;
  /** fetch aggregated fields from the table: "job_settings" */
  jobSettingsAggregate: JobSettings_Aggregate;
  /** fetch data from the table in a streaming manner: "job_settings" */
  jobSettings_stream: Array<JobSettings>;
  /** fetch data from the table: "job_site_attributes" using primary key columns */
  jobSiteAttributeByPk?: Maybe<JobSiteAttributes>;
  /** fetch data from the table: "job_site_attributes" */
  jobSiteAttributes: Array<JobSiteAttributes>;
  /** fetch aggregated fields from the table: "job_site_attributes" */
  jobSiteAttributesAggregate: JobSiteAttributes_Aggregate;
  /** fetch data from the table in a streaming manner: "job_site_attributes" */
  jobSiteAttributes_stream: Array<JobSiteAttributes>;
  /** fetch data from the table: "job_sites" using primary key columns */
  jobSiteByPk?: Maybe<JobSites>;
  /** fetch data from the table: "job_sites" */
  jobSites: Array<JobSites>;
  /** fetch aggregated fields from the table: "job_sites" */
  jobSitesAggregate: JobSites_Aggregate;
  /** fetch data from the table in a streaming manner: "job_sites" */
  jobSites_stream: Array<JobSites>;
  /** fetch data from the table: "login_logs" using primary key columns */
  loginLogByPk?: Maybe<Login_Logs>;
  /** fetch data from the table: "login_logs" */
  loginLogs: Array<Login_Logs>;
  /** fetch aggregated fields from the table: "login_logs" */
  loginLogsAggregate: Login_Logs_Aggregate;
  /** fetch data from the table in a streaming manner: "login_logs" */
  login_logs_stream: Array<Login_Logs>;
  /** fetch data from the table: "messages" using primary key columns */
  messageByPk?: Maybe<Messages>;
  /** fetch data from the table: "message_formats" using primary key columns */
  messageFormatByPk?: Maybe<MessageFormats>;
  /** fetch data from the table: "message_formats" */
  messageFormats: Array<MessageFormats>;
  /** fetch aggregated fields from the table: "message_formats" */
  messageFormatsAggregate: MessageFormats_Aggregate;
  /** fetch data from the table in a streaming manner: "message_formats" */
  messageFormats_stream: Array<MessageFormats>;
  /** An array relationship */
  messages: Array<Messages>;
  /** fetch aggregated fields from the table: "messages" */
  messagesAggregate: Messages_Aggregate;
  /** fetch data from the table in a streaming manner: "messages" */
  messages_stream: Array<Messages>;
  /** fetch data from the table: "multiple_detections" using primary key columns */
  multipleDetectionByPk?: Maybe<MultipleDetections>;
  /** fetch data from the table: "multiple_detections" */
  multipleDetections: Array<MultipleDetections>;
  /** fetch aggregated fields from the table: "multiple_detections" */
  multipleDetectionsAggregate: MultipleDetections_Aggregate;
  /** fetch data from the table in a streaming manner: "multiple_detections" */
  multipleDetections_stream: Array<MultipleDetections>;
  /** fetch data from the table: "notification_conditions" using primary key columns */
  notificationConditionByPk?: Maybe<NotificationConditions>;
  /** fetch data from the table: "notification_condition_details" using primary key columns */
  notificationConditionDetailByPk?: Maybe<NotificationConditionDetails>;
  /** An array relationship */
  notificationConditionDetails: Array<NotificationConditionDetails>;
  /** fetch aggregated fields from the table: "notification_condition_details" */
  notificationConditionDetailsAggregate: NotificationConditionDetails_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_condition_details" */
  notificationConditionDetails_stream: Array<NotificationConditionDetails>;
  /** fetch data from the table: "notification_conditions" */
  notificationConditions: Array<NotificationConditions>;
  /** fetch aggregated fields from the table: "notification_conditions" */
  notificationConditionsAggregate: NotificationConditions_Aggregate;
  notificationConditionsAggregateNative: Array<NotificationConditionsAggregateNativeModel>;
  /** fetch data from the table in a streaming manner: "notification_conditions" */
  notificationConditions_stream: Array<NotificationConditions>;
  notificationCountAggregateNative: Array<NotificationCountAggregateNativeModel>;
  /** fetch data from the table: "notification_events" using primary key columns */
  notificationEventByPk?: Maybe<NotificationEvents>;
  /** fetch data from the table: "notification_events" */
  notificationEvents: Array<NotificationEvents>;
  /** fetch aggregated fields from the table: "notification_events" */
  notificationEventsAggregate: NotificationEvents_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_events" */
  notificationEvents_stream: Array<NotificationEvents>;
  /** fetch data from the table: "notification_histories" */
  notificationHistories: Array<NotificationHistories>;
  /** fetch aggregated fields from the table: "notification_histories" */
  notificationHistoriesAggregate: NotificationHistories_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_histories" */
  notificationHistories_stream: Array<NotificationHistories>;
  /** fetch data from the table: "notification_histories" using primary key columns */
  notificationHistoryByPk?: Maybe<NotificationHistories>;
  /** fetch data from the table: "notification_history_states" using primary key columns */
  notificationHistoryStateByPk?: Maybe<Notification_History_States>;
  /** fetch data from the table: "notification_history_states" */
  notificationHistoryStates: Array<Notification_History_States>;
  /** fetch aggregated fields from the table: "notification_history_states" */
  notificationHistoryStatesAggregate: Notification_History_States_Aggregate;
  /** fetch data from the table: "notification_services" using primary key columns */
  notificationServiceByPk?: Maybe<NotificationServices>;
  /** fetch data from the table: "notification_services" */
  notificationServices: Array<NotificationServices>;
  /** fetch aggregated fields from the table: "notification_services" */
  notificationServicesAggregate: NotificationServices_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_services" */
  notificationServices_stream: Array<NotificationServices>;
  /** fetch data from the table: "notification_settings" using primary key columns */
  notificationSettingByPk?: Maybe<NotificationSettings>;
  /** An array relationship */
  notificationSettings: Array<NotificationSettings>;
  /** fetch aggregated fields from the table: "notification_settings" */
  notificationSettingsAggregate: NotificationSettings_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_settings" */
  notificationSettings_stream: Array<NotificationSettings>;
  notificationStateAggregateNative: Array<NotificationStateAggregateNativeModel>;
  /** fetch data from the table: "notification_targets" using primary key columns */
  notificationTargetByPk?: Maybe<NotificationTargets>;
  /** fetch data from the table: "notification_target_states" using primary key columns */
  notificationTargetStateByPk?: Maybe<Notification_Target_States>;
  /** fetch data from the table: "notification_target_states" */
  notificationTargetStates: Array<Notification_Target_States>;
  /** fetch aggregated fields from the table: "notification_target_states" */
  notificationTargetStatesAggregate: Notification_Target_States_Aggregate;
  /** fetch data from the table: "notification_targets" */
  notificationTargets: Array<NotificationTargets>;
  /** fetch aggregated fields from the table: "notification_targets" */
  notificationTargetsAggregate: NotificationTargets_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_targets" */
  notificationTargets_stream: Array<NotificationTargets>;
  /** fetch data from the table: "notification_templates" using primary key columns */
  notificationTemplateByPk?: Maybe<NotificationTemplates>;
  /** fetch data from the table: "notification_templates" */
  notificationTemplates: Array<NotificationTemplates>;
  /** fetch aggregated fields from the table: "notification_templates" */
  notificationTemplatesAggregate: NotificationTemplates_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_templates" */
  notificationTemplates_stream: Array<NotificationTemplates>;
  /** fetch data from the table: "notification_users" using primary key columns */
  notificationUserByPk?: Maybe<NotificationUsers>;
  /** fetch data from the table: "notification_user_states" using primary key columns */
  notificationUserStateByPk?: Maybe<Notification_User_States>;
  /** fetch data from the table: "notification_user_states" */
  notificationUserStates: Array<Notification_User_States>;
  /** fetch aggregated fields from the table: "notification_user_states" */
  notificationUserStatesAggregate: Notification_User_States_Aggregate;
  /** An array relationship */
  notificationUserTemp: Array<NotificationUserTemp>;
  /** fetch aggregated fields from the table: "notification_user_temp" */
  notificationUserTempAggregate: NotificationUserTemp_Aggregate;
  /** fetch data from the table: "notification_user_temp" using primary key columns */
  notificationUserTempByPk?: Maybe<NotificationUserTemp>;
  /** fetch data from the table in a streaming manner: "notification_user_temp" */
  notificationUserTemp_stream: Array<NotificationUserTemp>;
  /** An array relationship */
  notificationUsers: Array<NotificationUsers>;
  /** fetch aggregated fields from the table: "notification_users" */
  notificationUsersAggregate: NotificationUsers_Aggregate;
  /** fetch data from the table in a streaming manner: "notification_users" */
  notificationUsers_stream: Array<NotificationUsers>;
  /** fetch data from the table in a streaming manner: "notification_history_states" */
  notification_history_states_stream: Array<Notification_History_States>;
  /** fetch data from the table in a streaming manner: "notification_target_states" */
  notification_target_states_stream: Array<Notification_Target_States>;
  /** fetch data from the table in a streaming manner: "notification_user_states" */
  notification_user_states_stream: Array<Notification_User_States>;
  /** fetch data from the table: "policies" */
  policies: Array<Policies>;
  /** fetch aggregated fields from the table: "policies" */
  policiesAggregate: Policies_Aggregate;
  /** fetch data from the table in a streaming manner: "policies" */
  policies_stream: Array<Policies>;
  /** fetch data from the table: "policies" using primary key columns */
  policyByPk?: Maybe<Policies>;
  /** fetch data from the table: "policy_defines" using primary key columns */
  policyDefineByPk?: Maybe<PolicyDefines>;
  /** fetch data from the table: "policy_define_types" using primary key columns */
  policyDefineTypeByPk?: Maybe<Policy_Define_Types>;
  /** fetch data from the table: "policy_define_types" */
  policyDefineTypes: Array<Policy_Define_Types>;
  /** fetch aggregated fields from the table: "policy_define_types" */
  policyDefineTypesAggregate: Policy_Define_Types_Aggregate;
  /** fetch data from the table: "policy_defines" */
  policyDefines: Array<PolicyDefines>;
  /** fetch aggregated fields from the table: "policy_defines" */
  policyDefinesAggregate: PolicyDefines_Aggregate;
  /** fetch data from the table in a streaming manner: "policy_defines" */
  policyDefines_stream: Array<PolicyDefines>;
  /** fetch data from the table: "policy_templates" using primary key columns */
  policyTemplateByPk?: Maybe<PolicyTemplates>;
  /** fetch data from the table: "policy_templates" */
  policyTemplates: Array<PolicyTemplates>;
  /** fetch aggregated fields from the table: "policy_templates" */
  policyTemplatesAggregate: PolicyTemplates_Aggregate;
  /** fetch data from the table in a streaming manner: "policy_templates" */
  policyTemplates_stream: Array<PolicyTemplates>;
  /** fetch data from the table in a streaming manner: "policy_define_types" */
  policy_define_types_stream: Array<Policy_Define_Types>;
  /** fetch data from the table: "providers_assets" using primary key columns */
  providerAssetByPk?: Maybe<ProvidersAssets>;
  /** fetch data from the table: "providers" using primary key columns */
  providerByPk?: Maybe<Providers>;
  /** An array relationship */
  providers: Array<Providers>;
  /** fetch aggregated fields from the table: "providers" */
  providersAggregate: Providers_Aggregate;
  /** An array relationship */
  providersAssets: Array<ProvidersAssets>;
  /** fetch aggregated fields from the table: "providers_assets" */
  providersAssetsAggregate: ProvidersAssets_Aggregate;
  /** fetch data from the table in a streaming manner: "providers_assets" */
  providersAssets_stream: Array<ProvidersAssets>;
  /** fetch data from the table in a streaming manner: "providers" */
  providers_stream: Array<Providers>;
  /** fetch data from the table: "relay_api_services" using primary key columns */
  relayApiServiceByPk?: Maybe<RelayApiServices>;
  /** An array relationship */
  relayApiServices: Array<RelayApiServices>;
  /** fetch aggregated fields from the table: "relay_api_services" */
  relayApiServicesAggregate: RelayApiServices_Aggregate;
  /** fetch data from the table in a streaming manner: "relay_api_services" */
  relayApiServices_stream: Array<RelayApiServices>;
  /** fetch data from the table: "relay_services" using primary key columns */
  relayServiceByPk?: Maybe<RelayServices>;
  /** fetch data from the table: "relay_services" */
  relayServices: Array<RelayServices>;
  /** fetch aggregated fields from the table: "relay_services" */
  relayServicesAggregate: RelayServices_Aggregate;
  /** fetch data from the table in a streaming manner: "relay_services" */
  relayServices_stream: Array<RelayServices>;
  /** fetch data from the table: "request_settings" using primary key columns */
  requestSettingByPk?: Maybe<RequestSettings>;
  /** fetch data from the table: "request_settings" */
  requestSettings: Array<RequestSettings>;
  /** fetch aggregated fields from the table: "request_settings" */
  requestSettingsAggregate: RequestSettings_Aggregate;
  /** fetch data from the table in a streaming manner: "request_settings" */
  requestSettings_stream: Array<RequestSettings>;
  /** fetch data from the table: "request_templates" using primary key columns */
  requestTemplateByPk?: Maybe<RequestTemplates>;
  /** fetch data from the table: "request_template_types" using primary key columns */
  requestTemplateTypeByPk?: Maybe<Request_Template_Types>;
  /** fetch data from the table: "request_template_types" */
  requestTemplateTypes: Array<Request_Template_Types>;
  /** fetch aggregated fields from the table: "request_template_types" */
  requestTemplateTypesAggregate: Request_Template_Types_Aggregate;
  /** fetch data from the table: "request_templates" */
  requestTemplates: Array<RequestTemplates>;
  /** fetch aggregated fields from the table: "request_templates" */
  requestTemplatesAggregate: RequestTemplates_Aggregate;
  /** fetch data from the table in a streaming manner: "request_templates" */
  requestTemplates_stream: Array<RequestTemplates>;
  /** fetch data from the table in a streaming manner: "request_template_types" */
  request_template_types_stream: Array<Request_Template_Types>;
  /** fetch data from the table: "requests" */
  requests: Array<Requests>;
  /** fetch aggregated fields from the table: "requests" */
  requestsAggregate: Requests_Aggregate;
  /** fetch data from the table in a streaming manner: "requests" */
  requests_stream: Array<Requests>;
  /** fetch data from the table: "rest2graphql_settings" */
  rest2graphqlSettings: Array<Rest2graphqlSettings>;
  /** fetch aggregated fields from the table: "rest2graphql_settings" */
  rest2graphqlSettingsAggregate: Rest2graphqlSettings_Aggregate;
  /** fetch data from the table: "rest2graphql_settings" using primary key columns */
  rest2graphqlSettingsByPk?: Maybe<Rest2graphqlSettings>;
  /** fetch data from the table in a streaming manner: "rest2graphql_settings" */
  rest2graphqlSettings_stream: Array<Rest2graphqlSettings>;
  /** fetch data from the table: "schedules" using primary key columns */
  scheduleByPk?: Maybe<Schedules>;
  /** fetch data from the table: "schedules" */
  schedules: Array<Schedules>;
  /** fetch aggregated fields from the table: "schedules" */
  schedulesAggregate: Schedules_Aggregate;
  /** fetch data from the table in a streaming manner: "schedules" */
  schedules_stream: Array<Schedules>;
  /** fetch data from the table: "sensitive_information" */
  sensitiveInformation: Array<SensitiveInformation>;
  /** fetch aggregated fields from the table: "sensitive_information" */
  sensitiveInformationAggregate: SensitiveInformation_Aggregate;
  /** fetch data from the table: "sensitive_information" using primary key columns */
  sensitiveInformationByPk?: Maybe<SensitiveInformation>;
  /** fetch data from the table: "sensitive_information_categories" */
  sensitiveInformationCategories: Array<SensitiveInformationCategories>;
  /** fetch aggregated fields from the table: "sensitive_information_categories" */
  sensitiveInformationCategoriesAggregate: SensitiveInformationCategories_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information_categories" */
  sensitiveInformationCategories_stream: Array<SensitiveInformationCategories>;
  /** fetch data from the table: "sensitive_information_categories" using primary key columns */
  sensitiveInformationCategoryByPk?: Maybe<SensitiveInformationCategories>;
  /** An array relationship */
  sensitiveInformationHistories: Array<SensitiveInformationHistories>;
  /** fetch aggregated fields from the table: "sensitive_information_histories" */
  sensitiveInformationHistoriesAggregate: SensitiveInformationHistories_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information_histories" */
  sensitiveInformationHistories_stream: Array<SensitiveInformationHistories>;
  /** fetch data from the table: "sensitive_information_histories" using primary key columns */
  sensitiveInformationHistoryByPk?: Maybe<SensitiveInformationHistories>;
  /** fetch data from the table: "sensitive_information_items" using primary key columns */
  sensitiveInformationItemByPk?: Maybe<SensitiveInformationItems>;
  /** An array relationship */
  sensitiveInformationItems: Array<SensitiveInformationItems>;
  /** fetch aggregated fields from the table: "sensitive_information_items" */
  sensitiveInformationItemsAggregate: SensitiveInformationItems_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information_items" */
  sensitiveInformationItems_stream: Array<SensitiveInformationItems>;
  /** fetch data from the table: "sensitive_information_request_services" using primary key columns */
  sensitiveInformationRequestServiceByPk?: Maybe<SensitiveInformationRequestServices>;
  /** fetch data from the table: "sensitive_information_request_services" */
  sensitiveInformationRequestServices: Array<SensitiveInformationRequestServices>;
  /** fetch aggregated fields from the table: "sensitive_information_request_services" */
  sensitiveInformationRequestServicesAggregate: SensitiveInformationRequestServices_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information_request_services" */
  sensitiveInformationRequestServices_stream: Array<SensitiveInformationRequestServices>;
  /** fetch data from the table: "sensitive_information_store_service_connections" using primary key columns */
  sensitiveInformationStoreServiceConnectionByPk?: Maybe<SensitiveInformationStoreServiceConnections>;
  /** fetch data from the table: "sensitive_information_store_service_connections" */
  sensitiveInformationStoreServiceConnections: Array<SensitiveInformationStoreServiceConnections>;
  /** fetch data from the table in a streaming manner: "sensitive_information_store_service_connections" */
  sensitiveInformationStoreServiceConnections_stream: Array<SensitiveInformationStoreServiceConnections>;
  /** fetch aggregated fields from the table: "sensitive_information_store_service_connections" */
  sensitiveInformationStoreServicesConnectionAggregate: SensitiveInformationStoreServiceConnections_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information" */
  sensitiveInformation_stream: Array<SensitiveInformation>;
  /** fetch data from the table: "services" */
  services: Array<Services>;
  /** fetch aggregated fields from the table: "services" */
  servicesAggregate: Services_Aggregate;
  /** fetch data from the table: "services" using primary key columns */
  servicesByPk?: Maybe<Services>;
  /** fetch data from the table in a streaming manner: "services" */
  services_stream: Array<Services>;
  /** fetch data from the table: "sensitive_information_items" using primary key columns */
  storeSensitiveInformationItemByPk?: Maybe<StoreSensitiveInformationItems>;
  /** fetch data from the table: "sensitive_information_items" */
  storeSensitiveInformationItems: Array<StoreSensitiveInformationItems>;
  /** fetch aggregated fields from the table: "sensitive_information_items" */
  storeSensitiveInformationItemsAggregate: StoreSensitiveInformationItems_Aggregate;
  /** fetch data from the table in a streaming manner: "sensitive_information_items" */
  storeSensitiveInformationItems_stream: Array<StoreSensitiveInformationItems>;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantByPk?: Maybe<Tenants>;
  /** fetch data from the table: "tenants_idps" using primary key columns */
  tenantIdpByPk?: Maybe<TenantsIdps>;
  /** An array relationship */
  tenantPublicInfo: Array<TenantPublicInfo>;
  /** fetch aggregated fields from the table: "tenant_public_info" */
  tenantPublicInfoAggregate: TenantPublicInfo_Aggregate;
  /** fetch data from the table: "tenant_public_info" using primary key columns */
  tenantPublicInfoByPk?: Maybe<TenantPublicInfo>;
  /** fetch data from the table in a streaming manner: "tenant_public_info" */
  tenantPublicInfo_stream: Array<TenantPublicInfo>;
  /** fetch data from the table: "tenant_services" using primary key columns */
  tenantServiceByPk?: Maybe<TenantServices>;
  /** fetch data from the table: "tenant_services" */
  tenantServices: Array<TenantServices>;
  /** fetch aggregated fields from the table: "tenant_services" */
  tenantServicesAggregate: TenantServices_Aggregate;
  /** fetch data from the table in a streaming manner: "tenant_services" */
  tenantServices_stream: Array<TenantServices>;
  /** fetch data from the table: "tenants" */
  tenants: Array<Tenants>;
  /** fetch aggregated fields from the table: "tenants" */
  tenantsAggregate: Tenants_Aggregate;
  /** An array relationship */
  tenantsIdps: Array<TenantsIdps>;
  /** fetch aggregated fields from the table: "tenants_idps" */
  tenantsIdpsAggregate: TenantsIdps_Aggregate;
  /** fetch data from the table in a streaming manner: "tenants_idps" */
  tenantsIdps_stream: Array<TenantsIdps>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenants_stream: Array<Tenants>;
  /** fetch data from the table: "upload_files" using primary key columns */
  uploadFileByPk?: Maybe<UploadFiles>;
  /** fetch data from the table: "upload_files" */
  uploadFiles: Array<UploadFiles>;
  /** fetch aggregated fields from the table: "upload_files" */
  uploadFilesAggregate: UploadFiles_Aggregate;
  /** fetch data from the table in a streaming manner: "upload_files" */
  uploadFiles_stream: Array<UploadFiles>;
  /** fetch data from the table: "users" using primary key columns */
  userByPk?: Maybe<Users>;
  /** fetch data from the table: "users_idps" using primary key columns */
  userExternalIdpByPk?: Maybe<UsersIdps>;
  /** fetch data from the table: "users_groups" using primary key columns */
  userGroupByPk?: Maybe<UsersGroups>;
  /** fetch data from the table: "user_policies" */
  userPolicies: Array<UserPolicies>;
  /** fetch aggregated fields from the table: "user_policies" */
  userPoliciesAggregate: UserPolicies_Aggregate;
  /** fetch data from the table in a streaming manner: "user_policies" */
  userPolicies_stream: Array<UserPolicies>;
  /** fetch data from the table: "user_policies" using primary key columns */
  userPolicyByPk?: Maybe<UserPolicies>;
  /** fetch data from the table: "user_roles" using primary key columns */
  userRoleByPk?: Maybe<User_Roles>;
  /** fetch data from the table: "user_roles" */
  userRoles: Array<User_Roles>;
  /** fetch aggregated fields from the table: "user_roles" */
  userRolesAggregate: User_Roles_Aggregate;
  /** fetch data from the table: "user_states" using primary key columns */
  userStateByPk?: Maybe<User_States>;
  /** fetch data from the table: "user_states" */
  userStates: Array<User_States>;
  /** fetch aggregated fields from the table: "user_states" */
  userStatesAggregate: User_States_Aggregate;
  /** fetch data from the table in a streaming manner: "user_roles" */
  user_roles_stream: Array<User_Roles>;
  /** fetch data from the table in a streaming manner: "user_states" */
  user_states_stream: Array<User_States>;
  /** An array relationship */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: Users_Aggregate;
  /** fetch data from the table: "users_assets" using primary key columns */
  usersAssetByPk?: Maybe<UsersAssets>;
  /** An array relationship */
  usersAssets: Array<UsersAssets>;
  /** fetch aggregated fields from the table: "users_assets" */
  usersAssetsAggregate: UsersAssets_Aggregate;
  /** fetch data from the table in a streaming manner: "users_assets" */
  usersAssets_stream: Array<UsersAssets>;
  /** fetch data from the table: "users_external_users" using primary key columns */
  usersExternalUserByPk?: Maybe<UsersExternalUsers>;
  /** fetch data from the table: "users_external_users" */
  usersExternalUsers: Array<UsersExternalUsers>;
  /** fetch aggregated fields from the table: "users_external_users" */
  usersExternalUsersAggregate: UsersExternalUsers_Aggregate;
  /** fetch data from the table in a streaming manner: "users_external_users" */
  usersExternalUsers_stream: Array<UsersExternalUsers>;
  /** An array relationship */
  usersGroups: Array<UsersGroups>;
  /** fetch aggregated fields from the table: "users_groups" */
  usersGroupsAggregate: UsersGroups_Aggregate;
  /** fetch data from the table in a streaming manner: "users_groups" */
  usersGroups_stream: Array<UsersGroups>;
  /** fetch data from the table: "users_idps" */
  usersIdps: Array<UsersIdps>;
  /** fetch aggregated fields from the table: "users_idps" */
  usersIdpsAggregate: UsersIdps_Aggregate;
  /** fetch data from the table in a streaming manner: "users_idps" */
  usersIdps_stream: Array<UsersIdps>;
  /** fetch data from the table: "users_users" using primary key columns */
  usersUserByPk?: Maybe<UsersUsers>;
  /** An array relationship */
  usersUsers: Array<UsersUsers>;
  /** fetch aggregated fields from the table: "users_users" */
  usersUsersAggregate: UsersUsers_Aggregate;
  /** fetch data from the table in a streaming manner: "users_users" */
  usersUsers_stream: Array<UsersUsers>;
  /** fetch data from the table in a streaming manner: "users" */
  users_stream: Array<Users>;
};


export type Subscription_RootAccessLogByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAccessLogsArgs = {
  distinct_on?: InputMaybe<Array<AccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccessLogs_Order_By>>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};


export type Subscription_RootAccessLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AccessLogs_Order_By>>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};


export type Subscription_RootAccessLogs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AccessLogs_Stream_Cursor_Input>>;
  where?: InputMaybe<AccessLogs_Bool_Exp>;
};


export type Subscription_RootAssetAssetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetImageByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetImagesArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


export type Subscription_RootAssetImagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetImages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetImages_Order_By>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


export type Subscription_RootAssetImages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetImages_Stream_Cursor_Input>>;
  where?: InputMaybe<AssetImages_Bool_Exp>;
};


export type Subscription_RootAssetPropertiesArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


export type Subscription_RootAssetPropertiesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetProperties_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetProperties_Order_By>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


export type Subscription_RootAssetProperties_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetProperties_Stream_Cursor_Input>>;
  where?: InputMaybe<AssetProperties_Bool_Exp>;
};


export type Subscription_RootAssetPropertyByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootAssetStatesArgs = {
  distinct_on?: InputMaybe<Array<Asset_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_States_Order_By>>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};


export type Subscription_RootAssetStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Asset_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Asset_States_Order_By>>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};


export type Subscription_RootAssetTagByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetTagsArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


export type Subscription_RootAssetTagsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetTags_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTags_Order_By>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


export type Subscription_RootAssetTags_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetTags_Stream_Cursor_Input>>;
  where?: InputMaybe<AssetTags_Bool_Exp>;
};


export type Subscription_RootAssetTypeByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootAssetTypesArgs = {
  distinct_on?: InputMaybe<Array<AssetTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTypes_Order_By>>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};


export type Subscription_RootAssetTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetTypes_Order_By>>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};


export type Subscription_RootAssetTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<AssetTypes_Bool_Exp>;
};


export type Subscription_RootAsset_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Asset_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Asset_States_Bool_Exp>;
};


export type Subscription_RootAssetsArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


export type Subscription_RootAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Assets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Assets_Order_By>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


export type Subscription_RootAssetsAssetsArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


export type Subscription_RootAssetsAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<AssetsAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AssetsAssets_Order_By>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


export type Subscription_RootAssetsAssets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AssetsAssets_Stream_Cursor_Input>>;
  where?: InputMaybe<AssetsAssets_Bool_Exp>;
};


export type Subscription_RootAssets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Assets_Stream_Cursor_Input>>;
  where?: InputMaybe<Assets_Bool_Exp>;
};


export type Subscription_RootAuthorizationInfoArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationInfo_Order_By>>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};


export type Subscription_RootAuthorizationInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationInfo_Order_By>>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};


export type Subscription_RootAuthorizationInfoByPkArgs = {
  tenantAlias: Scalars['String'];
};


export type Subscription_RootAuthorizationInfo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthorizationInfo_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthorizationInfo_Bool_Exp>;
};


export type Subscription_RootAuthorizationTenantServiceInfoArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationTenantServiceInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationTenantServiceInfo_Order_By>>;
  where?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
};


export type Subscription_RootAuthorizationTenantServiceInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<AuthorizationTenantServiceInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<AuthorizationTenantServiceInfo_Order_By>>;
  where?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
};


export type Subscription_RootAuthorizationTenantServiceInfo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<AuthorizationTenantServiceInfo_Stream_Cursor_Input>>;
  where?: InputMaybe<AuthorizationTenantServiceInfo_Bool_Exp>;
};


export type Subscription_RootCategoriesArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Categories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Categories_Order_By>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Categories_Stream_Cursor_Input>>;
  where?: InputMaybe<Categories_Bool_Exp>;
};


export type Subscription_RootCategoryByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootClientTypeByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootClientTypesArgs = {
  distinct_on?: InputMaybe<Array<ClientTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientTypes_Order_By>>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};


export type Subscription_RootClientTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ClientTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ClientTypes_Order_By>>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};


export type Subscription_RootClientTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ClientTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<ClientTypes_Bool_Exp>;
};


export type Subscription_RootConsentByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootConsentsArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


export type Subscription_RootConsentsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Consents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Consents_Order_By>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


export type Subscription_RootConsents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Consents_Stream_Cursor_Input>>;
  where?: InputMaybe<Consents_Bool_Exp>;
};


export type Subscription_RootCsvRecordsArgs = {
  distinct_on?: InputMaybe<Array<CsvRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CsvRecords_Order_By>>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};


export type Subscription_RootCsvRecordsAggregateArgs = {
  distinct_on?: InputMaybe<Array<CsvRecords_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<CsvRecords_Order_By>>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};


export type Subscription_RootCsvRecordsByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootCsvRecords_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<CsvRecords_Stream_Cursor_Input>>;
  where?: InputMaybe<CsvRecords_Bool_Exp>;
};


export type Subscription_RootDataAccessLogByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDataAccessLogsArgs = {
  distinct_on?: InputMaybe<Array<DataAccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataAccessLogs_Order_By>>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};


export type Subscription_RootDataAccessLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DataAccessLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DataAccessLogs_Order_By>>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};


export type Subscription_RootDataAccessLogs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DataAccessLogs_Stream_Cursor_Input>>;
  where?: InputMaybe<DataAccessLogs_Bool_Exp>;
};


export type Subscription_RootDetectionByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDetectionLogByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDetectionLogsArgs = {
  distinct_on?: InputMaybe<Array<DetectionLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionLogs_Order_By>>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};


export type Subscription_RootDetectionLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionLogs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionLogs_Order_By>>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};


export type Subscription_RootDetectionLogs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DetectionLogs_Stream_Cursor_Input>>;
  where?: InputMaybe<DetectionLogs_Bool_Exp>;
};


export type Subscription_RootDetectionSetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootDetectionSetsArgs = {
  distinct_on?: InputMaybe<Array<DetectionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionSets_Order_By>>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};


export type Subscription_RootDetectionSetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<DetectionSets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<DetectionSets_Order_By>>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};


export type Subscription_RootDetectionSets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<DetectionSets_Stream_Cursor_Input>>;
  where?: InputMaybe<DetectionSets_Bool_Exp>;
};


export type Subscription_RootDetectionStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootDetectionStatesArgs = {
  distinct_on?: InputMaybe<Array<Detection_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_States_Order_By>>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};


export type Subscription_RootDetectionStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Detection_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detection_States_Order_By>>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};


export type Subscription_RootDetection_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Detection_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Detection_States_Bool_Exp>;
};


export type Subscription_RootDetectionsArgs = {
  distinct_on?: InputMaybe<Array<Detections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detections_Order_By>>;
  where?: InputMaybe<Detections_Bool_Exp>;
};


export type Subscription_RootDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Detections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Detections_Order_By>>;
  where?: InputMaybe<Detections_Bool_Exp>;
};


export type Subscription_RootDetections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Detections_Stream_Cursor_Input>>;
  where?: InputMaybe<Detections_Bool_Exp>;
};


export type Subscription_RootEvacuationSettingByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEvacuationSettingsArgs = {
  distinct_on?: InputMaybe<Array<EvacuationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvacuationSettings_Order_By>>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};


export type Subscription_RootEvacuationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<EvacuationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<EvacuationSettings_Order_By>>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};


export type Subscription_RootEvacuationSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<EvacuationSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<EvacuationSettings_Bool_Exp>;
};


export type Subscription_RootEventByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootEventsArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Events_Order_By>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootEvents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Events_Bool_Exp>;
};


export type Subscription_RootExecutionHistoriesArgs = {
  distinct_on?: InputMaybe<Array<ExecutionHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExecutionHistories_Order_By>>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};


export type Subscription_RootExecutionHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<ExecutionHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ExecutionHistories_Order_By>>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};


export type Subscription_RootExecutionHistories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ExecutionHistories_Stream_Cursor_Input>>;
  where?: InputMaybe<ExecutionHistories_Bool_Exp>;
};


export type Subscription_RootExecutionHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootFileStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootFileStatesArgs = {
  distinct_on?: InputMaybe<Array<File_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_States_Order_By>>;
  where?: InputMaybe<File_States_Bool_Exp>;
};


export type Subscription_RootFileStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<File_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<File_States_Order_By>>;
  where?: InputMaybe<File_States_Bool_Exp>;
};


export type Subscription_RootFile_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<File_States_Stream_Cursor_Input>>;
  where?: InputMaybe<File_States_Bool_Exp>;
};


export type Subscription_RootGroupByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootGroupsArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Groups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Groups_Order_By>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootGroups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Groups_Stream_Cursor_Input>>;
  where?: InputMaybe<Groups_Bool_Exp>;
};


export type Subscription_RootIdpByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootIdpTypeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdpTypesArgs = {
  distinct_on?: InputMaybe<Array<IdpTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdpTypes_Order_By>>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};


export type Subscription_RootIdpTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<IdpTypes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<IdpTypes_Order_By>>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};


export type Subscription_RootIdpTypes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<IdpTypes_Stream_Cursor_Input>>;
  where?: InputMaybe<IdpTypes_Bool_Exp>;
};


export type Subscription_RootIdpsArgs = {
  distinct_on?: InputMaybe<Array<Idps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idps_Order_By>>;
  where?: InputMaybe<Idps_Bool_Exp>;
};


export type Subscription_RootIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Idps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Idps_Order_By>>;
  where?: InputMaybe<Idps_Bool_Exp>;
};


export type Subscription_RootIdps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Idps_Stream_Cursor_Input>>;
  where?: InputMaybe<Idps_Bool_Exp>;
};


export type Subscription_RootJobSettingByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootJobSettingsArgs = {
  distinct_on?: InputMaybe<Array<JobSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSettings_Order_By>>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};


export type Subscription_RootJobSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSettings_Order_By>>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};


export type Subscription_RootJobSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<JobSettings_Bool_Exp>;
};


export type Subscription_RootJobSiteAttributeByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootJobSiteAttributesArgs = {
  distinct_on?: InputMaybe<Array<JobSiteAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSiteAttributes_Order_By>>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};


export type Subscription_RootJobSiteAttributesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSiteAttributes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSiteAttributes_Order_By>>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};


export type Subscription_RootJobSiteAttributes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobSiteAttributes_Stream_Cursor_Input>>;
  where?: InputMaybe<JobSiteAttributes_Bool_Exp>;
};


export type Subscription_RootJobSiteByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootJobSitesArgs = {
  distinct_on?: InputMaybe<Array<JobSites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSites_Order_By>>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};


export type Subscription_RootJobSitesAggregateArgs = {
  distinct_on?: InputMaybe<Array<JobSites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<JobSites_Order_By>>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};


export type Subscription_RootJobSites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<JobSites_Stream_Cursor_Input>>;
  where?: InputMaybe<JobSites_Bool_Exp>;
};


export type Subscription_RootLoginLogByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootLoginLogsArgs = {
  distinct_on?: InputMaybe<Array<Login_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Login_Logs_Order_By>>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};


export type Subscription_RootLoginLogsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Login_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Login_Logs_Order_By>>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};


export type Subscription_RootLogin_Logs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Login_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Login_Logs_Bool_Exp>;
};


export type Subscription_RootMessageByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootMessageFormatByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootMessageFormatsArgs = {
  distinct_on?: InputMaybe<Array<MessageFormats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageFormats_Order_By>>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};


export type Subscription_RootMessageFormatsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MessageFormats_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MessageFormats_Order_By>>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};


export type Subscription_RootMessageFormats_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MessageFormats_Stream_Cursor_Input>>;
  where?: InputMaybe<MessageFormats_Bool_Exp>;
};


export type Subscription_RootMessagesArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessagesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Messages_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Messages_Order_By>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMessages_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Messages_Stream_Cursor_Input>>;
  where?: InputMaybe<Messages_Bool_Exp>;
};


export type Subscription_RootMultipleDetectionByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootMultipleDetectionsArgs = {
  distinct_on?: InputMaybe<Array<MultipleDetections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MultipleDetections_Order_By>>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};


export type Subscription_RootMultipleDetectionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<MultipleDetections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<MultipleDetections_Order_By>>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};


export type Subscription_RootMultipleDetections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<MultipleDetections_Stream_Cursor_Input>>;
  where?: InputMaybe<MultipleDetections_Bool_Exp>;
};


export type Subscription_RootNotificationConditionByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationConditionDetailByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationConditionDetailsArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


export type Subscription_RootNotificationConditionDetailsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditionDetails_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionDetails_Order_By>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


export type Subscription_RootNotificationConditionDetails_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationConditionDetails_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationConditionDetails_Bool_Exp>;
};


export type Subscription_RootNotificationConditionsArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditions_Order_By>>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};


export type Subscription_RootNotificationConditionsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationConditions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditions_Order_By>>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};


export type Subscription_RootNotificationConditionsAggregateNativeArgs = {
  args: NotificationConditionsAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationConditionsAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationConditionsAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootNotificationConditions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationConditions_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationConditions_Bool_Exp>;
};


export type Subscription_RootNotificationCountAggregateNativeArgs = {
  args: NotificationCountAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationCountAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationCountAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationCountAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootNotificationEventByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationEventsArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


export type Subscription_RootNotificationEventsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationEvents_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationEvents_Order_By>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


export type Subscription_RootNotificationEvents_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationEvents_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationEvents_Bool_Exp>;
};


export type Subscription_RootNotificationHistoriesArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


export type Subscription_RootNotificationHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationHistories_Order_By>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


export type Subscription_RootNotificationHistories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationHistories_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationHistories_Bool_Exp>;
};


export type Subscription_RootNotificationHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationHistoryStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotificationHistoryStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_History_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_History_States_Order_By>>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};


export type Subscription_RootNotificationHistoryStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_History_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_History_States_Order_By>>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};


export type Subscription_RootNotificationServiceByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationServicesArgs = {
  distinct_on?: InputMaybe<Array<NotificationServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationServices_Order_By>>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};


export type Subscription_RootNotificationServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationServices_Order_By>>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};


export type Subscription_RootNotificationServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationServices_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationServices_Bool_Exp>;
};


export type Subscription_RootNotificationSettingByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationSettingsArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


export type Subscription_RootNotificationSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationSettings_Order_By>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


export type Subscription_RootNotificationSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationSettings_Bool_Exp>;
};


export type Subscription_RootNotificationStateAggregateNativeArgs = {
  args: NotificationStateAggregateNative_Arguments;
  distinct_on?: InputMaybe<Array<NotificationStateAggregateNativeModel_Enum_Name>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationStateAggregateNativeModel_Order_By>>;
  where?: InputMaybe<NotificationStateAggregateNativeModel_Bool_Exp_Bool_Exp>;
};


export type Subscription_RootNotificationTargetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationTargetStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotificationTargetStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_Target_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Target_States_Order_By>>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};


export type Subscription_RootNotificationTargetStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_Target_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_Target_States_Order_By>>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};


export type Subscription_RootNotificationTargetsArgs = {
  distinct_on?: InputMaybe<Array<NotificationTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTargets_Order_By>>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};


export type Subscription_RootNotificationTargetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTargets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTargets_Order_By>>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};


export type Subscription_RootNotificationTargets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationTargets_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationTargets_Bool_Exp>;
};


export type Subscription_RootNotificationTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationTemplatesArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationTemplates_Order_By>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationTemplates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationTemplates_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationTemplates_Bool_Exp>;
};


export type Subscription_RootNotificationUserByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationUserStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootNotificationUserStatesArgs = {
  distinct_on?: InputMaybe<Array<Notification_User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_User_States_Order_By>>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};


export type Subscription_RootNotificationUserStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Notification_User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Notification_User_States_Order_By>>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};


export type Subscription_RootNotificationUserTempArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


export type Subscription_RootNotificationUserTempAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUserTemp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUserTemp_Order_By>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


export type Subscription_RootNotificationUserTempByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootNotificationUserTemp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationUserTemp_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationUserTemp_Bool_Exp>;
};


export type Subscription_RootNotificationUsersArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


export type Subscription_RootNotificationUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<NotificationUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<NotificationUsers_Order_By>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


export type Subscription_RootNotificationUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<NotificationUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<NotificationUsers_Bool_Exp>;
};


export type Subscription_RootNotification_History_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_History_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_History_States_Bool_Exp>;
};


export type Subscription_RootNotification_Target_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_Target_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_Target_States_Bool_Exp>;
};


export type Subscription_RootNotification_User_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Notification_User_States_Stream_Cursor_Input>>;
  where?: InputMaybe<Notification_User_States_Bool_Exp>;
};


export type Subscription_RootPoliciesArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};


export type Subscription_RootPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policies_Order_By>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};


export type Subscription_RootPolicies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Policies_Stream_Cursor_Input>>;
  where?: InputMaybe<Policies_Bool_Exp>;
};


export type Subscription_RootPolicyByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPolicyDefineByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPolicyDefineTypeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootPolicyDefineTypesArgs = {
  distinct_on?: InputMaybe<Array<Policy_Define_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Define_Types_Order_By>>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};


export type Subscription_RootPolicyDefineTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Policy_Define_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Policy_Define_Types_Order_By>>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};


export type Subscription_RootPolicyDefinesArgs = {
  distinct_on?: InputMaybe<Array<PolicyDefines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyDefines_Order_By>>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};


export type Subscription_RootPolicyDefinesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyDefines_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyDefines_Order_By>>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};


export type Subscription_RootPolicyDefines_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyDefines_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyDefines_Bool_Exp>;
};


export type Subscription_RootPolicyTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootPolicyTemplatesArgs = {
  distinct_on?: InputMaybe<Array<PolicyTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyTemplates_Order_By>>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};


export type Subscription_RootPolicyTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<PolicyTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<PolicyTemplates_Order_By>>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};


export type Subscription_RootPolicyTemplates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<PolicyTemplates_Stream_Cursor_Input>>;
  where?: InputMaybe<PolicyTemplates_Bool_Exp>;
};


export type Subscription_RootPolicy_Define_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Policy_Define_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Policy_Define_Types_Bool_Exp>;
};


export type Subscription_RootProviderAssetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProviderByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootProvidersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootProvidersAssetsArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


export type Subscription_RootProvidersAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<ProvidersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<ProvidersAssets_Order_By>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


export type Subscription_RootProvidersAssets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<ProvidersAssets_Stream_Cursor_Input>>;
  where?: InputMaybe<ProvidersAssets_Bool_Exp>;
};


export type Subscription_RootProviders_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Providers_Stream_Cursor_Input>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


export type Subscription_RootRelayApiServiceByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRelayApiServicesArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


export type Subscription_RootRelayApiServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayApiServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayApiServices_Order_By>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


export type Subscription_RootRelayApiServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RelayApiServices_Stream_Cursor_Input>>;
  where?: InputMaybe<RelayApiServices_Bool_Exp>;
};


export type Subscription_RootRelayServiceByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRelayServicesArgs = {
  distinct_on?: InputMaybe<Array<RelayServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayServices_Order_By>>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};


export type Subscription_RootRelayServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RelayServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RelayServices_Order_By>>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};


export type Subscription_RootRelayServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RelayServices_Stream_Cursor_Input>>;
  where?: InputMaybe<RelayServices_Bool_Exp>;
};


export type Subscription_RootRequestSettingByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRequestSettingsArgs = {
  distinct_on?: InputMaybe<Array<RequestSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestSettings_Order_By>>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};


export type Subscription_RootRequestSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<RequestSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestSettings_Order_By>>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};


export type Subscription_RootRequestSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RequestSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<RequestSettings_Bool_Exp>;
};


export type Subscription_RootRequestTemplateByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRequestTemplateTypeByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootRequestTemplateTypesArgs = {
  distinct_on?: InputMaybe<Array<Request_Template_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Template_Types_Order_By>>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};


export type Subscription_RootRequestTemplateTypesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Request_Template_Types_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Request_Template_Types_Order_By>>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};


export type Subscription_RootRequestTemplatesArgs = {
  distinct_on?: InputMaybe<Array<RequestTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestTemplates_Order_By>>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};


export type Subscription_RootRequestTemplatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<RequestTemplates_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<RequestTemplates_Order_By>>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};


export type Subscription_RootRequestTemplates_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<RequestTemplates_Stream_Cursor_Input>>;
  where?: InputMaybe<RequestTemplates_Bool_Exp>;
};


export type Subscription_RootRequest_Template_Types_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Request_Template_Types_Stream_Cursor_Input>>;
  where?: InputMaybe<Request_Template_Types_Bool_Exp>;
};


export type Subscription_RootRequestsArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Requests_Order_By>>;
  where?: InputMaybe<Requests_Bool_Exp>;
};


export type Subscription_RootRequestsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Requests_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Requests_Order_By>>;
  where?: InputMaybe<Requests_Bool_Exp>;
};


export type Subscription_RootRequests_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Requests_Stream_Cursor_Input>>;
  where?: InputMaybe<Requests_Bool_Exp>;
};


export type Subscription_RootRest2graphqlSettingsArgs = {
  distinct_on?: InputMaybe<Array<Rest2graphqlSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rest2graphqlSettings_Order_By>>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};


export type Subscription_RootRest2graphqlSettingsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Rest2graphqlSettings_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Rest2graphqlSettings_Order_By>>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};


export type Subscription_RootRest2graphqlSettingsByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootRest2graphqlSettings_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Rest2graphqlSettings_Stream_Cursor_Input>>;
  where?: InputMaybe<Rest2graphqlSettings_Bool_Exp>;
};


export type Subscription_RootScheduleByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schedules_Order_By>>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};


export type Subscription_RootSchedulesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Schedules_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Schedules_Order_By>>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};


export type Subscription_RootSchedules_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Schedules_Stream_Cursor_Input>>;
  where?: InputMaybe<Schedules_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformation_Order_By>>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformation_Order_By>>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationCategoriesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationCategories_Order_By>>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationCategoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationCategories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationCategories_Order_By>>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationCategories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformationCategories_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformationCategories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationCategoryByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationHistoriesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationHistoriesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationHistories_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationHistories_Order_By>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationHistories_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformationHistories_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformationHistories_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationHistoryByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationItemByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationItemsArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationItems_Order_By>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationItems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformationItems_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationRequestServiceByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationRequestServicesArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationRequestServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationRequestServices_Order_By>>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationRequestServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationRequestServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationRequestServices_Order_By>>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationRequestServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformationRequestServices_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformationRequestServices_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationStoreServiceConnectionByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootSensitiveInformationStoreServiceConnectionsArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Order_By>>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationStoreServiceConnections_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformationStoreServiceConnections_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};


export type Subscription_RootSensitiveInformationStoreServicesConnectionAggregateArgs = {
  distinct_on?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<SensitiveInformationStoreServiceConnections_Order_By>>;
  where?: InputMaybe<SensitiveInformationStoreServiceConnections_Bool_Exp>;
};


export type Subscription_RootSensitiveInformation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<SensitiveInformation_Stream_Cursor_Input>>;
  where?: InputMaybe<SensitiveInformation_Bool_Exp>;
};


export type Subscription_RootServicesArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<Services_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Services_Order_By>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootServicesByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Services_Stream_Cursor_Input>>;
  where?: InputMaybe<Services_Bool_Exp>;
};


export type Subscription_RootStoreSensitiveInformationItemByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootStoreSensitiveInformationItemsArgs = {
  distinct_on?: InputMaybe<Array<StoreSensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StoreSensitiveInformationItems_Order_By>>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootStoreSensitiveInformationItemsAggregateArgs = {
  distinct_on?: InputMaybe<Array<StoreSensitiveInformationItems_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<StoreSensitiveInformationItems_Order_By>>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootStoreSensitiveInformationItems_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<StoreSensitiveInformationItems_Stream_Cursor_Input>>;
  where?: InputMaybe<StoreSensitiveInformationItems_Bool_Exp>;
};


export type Subscription_RootTenantByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTenantIdpByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTenantPublicInfoArgs = {
  distinct_on?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantPublicInfo_Order_By>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


export type Subscription_RootTenantPublicInfoAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantPublicInfo_Order_By>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


export type Subscription_RootTenantPublicInfoByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTenantPublicInfo_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TenantPublicInfo_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


export type Subscription_RootTenantServiceByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootTenantServicesArgs = {
  distinct_on?: InputMaybe<Array<TenantServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantServices_Order_By>>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};


export type Subscription_RootTenantServicesAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantServices_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantServices_Order_By>>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};


export type Subscription_RootTenantServices_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TenantServices_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};


export type Subscription_RootTenantsArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenantsAggregateArgs = {
  distinct_on?: InputMaybe<Array<Tenants_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tenants_Order_By>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootTenantsIdpsArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


export type Subscription_RootTenantsIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


export type Subscription_RootTenantsIdps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<TenantsIdps_Stream_Cursor_Input>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


export type Subscription_RootTenants_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tenants_Stream_Cursor_Input>>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};


export type Subscription_RootUploadFileByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUploadFilesArgs = {
  distinct_on?: InputMaybe<Array<UploadFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UploadFiles_Order_By>>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};


export type Subscription_RootUploadFilesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UploadFiles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UploadFiles_Order_By>>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};


export type Subscription_RootUploadFiles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UploadFiles_Stream_Cursor_Input>>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};


export type Subscription_RootUserByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUserExternalIdpByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUserGroupByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUserPoliciesArgs = {
  distinct_on?: InputMaybe<Array<UserPolicies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPolicies_Order_By>>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};


export type Subscription_RootUserPoliciesAggregateArgs = {
  distinct_on?: InputMaybe<Array<UserPolicies_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UserPolicies_Order_By>>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};


export type Subscription_RootUserPolicies_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UserPolicies_Stream_Cursor_Input>>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};


export type Subscription_RootUserPolicyByPkArgs = {
  userId: Scalars['String'];
};


export type Subscription_RootUserRoleByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUserRolesArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUserRolesAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Roles_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Roles_Order_By>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUserStateByPkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootUserStatesArgs = {
  distinct_on?: InputMaybe<Array<User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_States_Order_By>>;
  where?: InputMaybe<User_States_Bool_Exp>;
};


export type Subscription_RootUserStatesAggregateArgs = {
  distinct_on?: InputMaybe<Array<User_States_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_States_Order_By>>;
  where?: InputMaybe<User_States_Bool_Exp>;
};


export type Subscription_RootUser_Roles_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Roles_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};


export type Subscription_RootUser_States_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_States_Stream_Cursor_Input>>;
  where?: InputMaybe<User_States_Bool_Exp>;
};


export type Subscription_RootUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


export type Subscription_RootUsersAssetByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsersAssetsArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


export type Subscription_RootUsersAssetsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


export type Subscription_RootUsersAssets_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersAssets_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


export type Subscription_RootUsersExternalUserByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsersExternalUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersExternalUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersExternalUsers_Order_By>>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};


export type Subscription_RootUsersExternalUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersExternalUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersExternalUsers_Order_By>>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};


export type Subscription_RootUsersExternalUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersExternalUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};


export type Subscription_RootUsersGroupsArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


export type Subscription_RootUsersGroupsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


export type Subscription_RootUsersGroups_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersGroups_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


export type Subscription_RootUsersIdpsArgs = {
  distinct_on?: InputMaybe<Array<UsersIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersIdps_Order_By>>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};


export type Subscription_RootUsersIdpsAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersIdps_Order_By>>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};


export type Subscription_RootUsersIdps_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersIdps_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};


export type Subscription_RootUsersUserByPkArgs = {
  id: Scalars['String'];
};


export type Subscription_RootUsersUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};


export type Subscription_RootUsersUsersAggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};


export type Subscription_RootUsersUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<UsersUsers_Stream_Cursor_Input>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};


export type Subscription_RootUsers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Users_Stream_Cursor_Input>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "tenant_public_info" */
export type TenantPublicInfo = {
  __typename?: 'tenantPublicInfo';
  analyticsSettings?: Maybe<Scalars['jsonb']>;
  createdAt: Scalars['bigint'];
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  renderingResources: Scalars['jsonb'];
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt: Scalars['bigint'];
};


/** columns and relationships of "tenant_public_info" */
export type TenantPublicInfoAnalyticsSettingsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "tenant_public_info" */
export type TenantPublicInfoRenderingResourcesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "tenant_public_info" */
export type TenantPublicInfo_Aggregate = {
  __typename?: 'tenantPublicInfo_aggregate';
  aggregate?: Maybe<TenantPublicInfo_Aggregate_Fields>;
  nodes: Array<TenantPublicInfo>;
};

export type TenantPublicInfo_Aggregate_Bool_Exp = {
  count?: InputMaybe<TenantPublicInfo_Aggregate_Bool_Exp_Count>;
};

export type TenantPublicInfo_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TenantPublicInfo_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenant_public_info" */
export type TenantPublicInfo_Aggregate_Fields = {
  __typename?: 'tenantPublicInfo_aggregate_fields';
  avg?: Maybe<TenantPublicInfo_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TenantPublicInfo_Max_Fields>;
  min?: Maybe<TenantPublicInfo_Min_Fields>;
  stddev?: Maybe<TenantPublicInfo_Stddev_Fields>;
  stddev_pop?: Maybe<TenantPublicInfo_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantPublicInfo_Stddev_Samp_Fields>;
  sum?: Maybe<TenantPublicInfo_Sum_Fields>;
  var_pop?: Maybe<TenantPublicInfo_Var_Pop_Fields>;
  var_samp?: Maybe<TenantPublicInfo_Var_Samp_Fields>;
  variance?: Maybe<TenantPublicInfo_Variance_Fields>;
};


/** aggregate fields of "tenant_public_info" */
export type TenantPublicInfo_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tenant_public_info" */
export type TenantPublicInfo_Aggregate_Order_By = {
  avg?: InputMaybe<TenantPublicInfo_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TenantPublicInfo_Max_Order_By>;
  min?: InputMaybe<TenantPublicInfo_Min_Order_By>;
  stddev?: InputMaybe<TenantPublicInfo_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TenantPublicInfo_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TenantPublicInfo_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TenantPublicInfo_Sum_Order_By>;
  var_pop?: InputMaybe<TenantPublicInfo_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TenantPublicInfo_Var_Samp_Order_By>;
  variance?: InputMaybe<TenantPublicInfo_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type TenantPublicInfo_Append_Input = {
  analyticsSettings?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "tenant_public_info" */
export type TenantPublicInfo_Arr_Rel_Insert_Input = {
  data: Array<TenantPublicInfo_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TenantPublicInfo_On_Conflict>;
};

/** aggregate avg on columns */
export type TenantPublicInfo_Avg_Fields = {
  __typename?: 'tenantPublicInfo_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenant_public_info". All fields are combined with a logical 'AND'. */
export type TenantPublicInfo_Bool_Exp = {
  _and?: InputMaybe<Array<TenantPublicInfo_Bool_Exp>>;
  _not?: InputMaybe<TenantPublicInfo_Bool_Exp>;
  _or?: InputMaybe<Array<TenantPublicInfo_Bool_Exp>>;
  analyticsSettings?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  renderingResources?: InputMaybe<Jsonb_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_public_info" */
export enum TenantPublicInfo_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantPublicInfoPkey = 'tenant_public_info_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type TenantPublicInfo_Delete_At_Path_Input = {
  analyticsSettings?: InputMaybe<Array<Scalars['String']>>;
  renderingResources?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type TenantPublicInfo_Delete_Elem_Input = {
  analyticsSettings?: InputMaybe<Scalars['Int']>;
  renderingResources?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type TenantPublicInfo_Delete_Key_Input = {
  analyticsSettings?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "tenant_public_info" */
export type TenantPublicInfo_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "tenant_public_info" */
export type TenantPublicInfo_Insert_Input = {
  analyticsSettings?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type TenantPublicInfo_Max_Fields = {
  __typename?: 'tenantPublicInfo_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TenantPublicInfo_Min_Fields = {
  __typename?: 'tenantPublicInfo_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenant_public_info" */
export type TenantPublicInfo_Mutation_Response = {
  __typename?: 'tenantPublicInfo_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantPublicInfo>;
};

/** on_conflict condition type for table "tenant_public_info" */
export type TenantPublicInfo_On_Conflict = {
  constraint: TenantPublicInfo_Constraint;
  update_columns?: Array<TenantPublicInfo_Update_Column>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_public_info". */
export type TenantPublicInfo_Order_By = {
  analyticsSettings?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  renderingResources?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_public_info */
export type TenantPublicInfo_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type TenantPublicInfo_Prepend_Input = {
  analyticsSettings?: InputMaybe<Scalars['jsonb']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tenant_public_info" */
export enum TenantPublicInfo_Select_Column {
  /** column name */
  AnalyticsSettings = 'analyticsSettings',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenant_public_info" */
export type TenantPublicInfo_Set_Input = {
  analyticsSettings?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type TenantPublicInfo_Stddev_Fields = {
  __typename?: 'tenantPublicInfo_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TenantPublicInfo_Stddev_Pop_Fields = {
  __typename?: 'tenantPublicInfo_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TenantPublicInfo_Stddev_Samp_Fields = {
  __typename?: 'tenantPublicInfo_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenantPublicInfo" */
export type TenantPublicInfo_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantPublicInfo_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantPublicInfo_Stream_Cursor_Value_Input = {
  analyticsSettings?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  renderingResources?: InputMaybe<Scalars['jsonb']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TenantPublicInfo_Sum_Fields = {
  __typename?: 'tenantPublicInfo_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "tenant_public_info" */
export enum TenantPublicInfo_Update_Column {
  /** column name */
  AnalyticsSettings = 'analyticsSettings',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  RenderingResources = 'renderingResources',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TenantPublicInfo_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<TenantPublicInfo_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<TenantPublicInfo_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<TenantPublicInfo_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<TenantPublicInfo_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantPublicInfo_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<TenantPublicInfo_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantPublicInfo_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantPublicInfo_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantPublicInfo_Var_Pop_Fields = {
  __typename?: 'tenantPublicInfo_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TenantPublicInfo_Var_Samp_Fields = {
  __typename?: 'tenantPublicInfo_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TenantPublicInfo_Variance_Fields = {
  __typename?: 'tenantPublicInfo_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tenant_public_info" */
export type TenantPublicInfo_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "tenant_services" */
export type TenantServices = {
  __typename?: 'tenantServices';
  apiKey: Scalars['String'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  owner: Scalars['String'];
  serviceId: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregated selection of "tenant_services" */
export type TenantServices_Aggregate = {
  __typename?: 'tenantServices_aggregate';
  aggregate?: Maybe<TenantServices_Aggregate_Fields>;
  nodes: Array<TenantServices>;
};

/** aggregate fields of "tenant_services" */
export type TenantServices_Aggregate_Fields = {
  __typename?: 'tenantServices_aggregate_fields';
  avg?: Maybe<TenantServices_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TenantServices_Max_Fields>;
  min?: Maybe<TenantServices_Min_Fields>;
  stddev?: Maybe<TenantServices_Stddev_Fields>;
  stddev_pop?: Maybe<TenantServices_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantServices_Stddev_Samp_Fields>;
  sum?: Maybe<TenantServices_Sum_Fields>;
  var_pop?: Maybe<TenantServices_Var_Pop_Fields>;
  var_samp?: Maybe<TenantServices_Var_Samp_Fields>;
  variance?: Maybe<TenantServices_Variance_Fields>;
};


/** aggregate fields of "tenant_services" */
export type TenantServices_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantServices_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type TenantServices_Avg_Fields = {
  __typename?: 'tenantServices_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tenant_services". All fields are combined with a logical 'AND'. */
export type TenantServices_Bool_Exp = {
  _and?: InputMaybe<Array<TenantServices_Bool_Exp>>;
  _not?: InputMaybe<TenantServices_Bool_Exp>;
  _or?: InputMaybe<Array<TenantServices_Bool_Exp>>;
  apiKey?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenant_services" */
export enum TenantServices_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantServicesPkey = 'tenant_services_pkey',
  /** unique or primary key constraint on columns "tenant_id", "service_id" */
  TenantServicesTenantIdServiceIdKey = 'tenant_services_tenant_id_service_id_key'
}

/** input type for incrementing numeric columns in table "tenant_services" */
export type TenantServices_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "tenant_services" */
export type TenantServices_Insert_Input = {
  apiKey?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate max on columns */
export type TenantServices_Max_Fields = {
  __typename?: 'tenantServices_max_fields';
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** aggregate min on columns */
export type TenantServices_Min_Fields = {
  __typename?: 'tenantServices_min_fields';
  apiKey?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** response of any mutation on the table "tenant_services" */
export type TenantServices_Mutation_Response = {
  __typename?: 'tenantServices_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantServices>;
};

/** on_conflict condition type for table "tenant_services" */
export type TenantServices_On_Conflict = {
  constraint: TenantServices_Constraint;
  update_columns?: Array<TenantServices_Update_Column>;
  where?: InputMaybe<TenantServices_Bool_Exp>;
};

/** Ordering options when selecting data from "tenant_services". */
export type TenantServices_Order_By = {
  apiKey?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenant_services */
export type TenantServices_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "tenant_services" */
export enum TenantServices_Select_Column {
  /** column name */
  ApiKey = 'apiKey',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "tenant_services" */
export type TenantServices_Set_Input = {
  apiKey?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type TenantServices_Stddev_Fields = {
  __typename?: 'tenantServices_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type TenantServices_Stddev_Pop_Fields = {
  __typename?: 'tenantServices_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type TenantServices_Stddev_Samp_Fields = {
  __typename?: 'tenantServices_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tenantServices" */
export type TenantServices_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantServices_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantServices_Stream_Cursor_Value_Input = {
  apiKey?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type TenantServices_Sum_Fields = {
  __typename?: 'tenantServices_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "tenant_services" */
export enum TenantServices_Update_Column {
  /** column name */
  ApiKey = 'apiKey',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type TenantServices_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantServices_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantServices_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantServices_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantServices_Var_Pop_Fields = {
  __typename?: 'tenantServices_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type TenantServices_Var_Samp_Fields = {
  __typename?: 'tenantServices_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type TenantServices_Variance_Fields = {
  __typename?: 'tenantServices_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "tenants" */
export type Tenants = {
  __typename?: 'tenants';
  alias: Scalars['String'];
  categoryId?: Maybe<Scalars['String']>;
  changePasswordTemplate?: Maybe<Scalars['jsonb']>;
  createdAt?: Maybe<Scalars['bigint']>;
  forgottenPasswordTemplate?: Maybe<Scalars['jsonb']>;
  id: Scalars['String'];
  name: Scalars['String'];
  owner: Scalars['String'];
  /** An array relationship */
  providers: Array<Providers>;
  /** An aggregate relationship */
  providers_aggregate: Providers_Aggregate;
  shortId?: Maybe<Scalars['bigint']>;
  /** An array relationship */
  tenantPublicInfo: Array<TenantPublicInfo>;
  /** An aggregate relationship */
  tenantPublicInfo_aggregate: TenantPublicInfo_Aggregate;
  /** An array relationship */
  tenantsIdps: Array<TenantsIdps>;
  /** An aggregate relationship */
  tenantsIdps_aggregate: TenantsIdps_Aggregate;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId: Scalars['String'];
  /** An array relationship */
  users: Array<Users>;
  /** An aggregate relationship */
  users_aggregate: Users_Aggregate;
};


/** columns and relationships of "tenants" */
export type TenantsChangePasswordTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "tenants" */
export type TenantsForgottenPasswordTemplateArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "tenants" */
export type TenantsProvidersArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsProviders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Providers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Providers_Order_By>>;
  where?: InputMaybe<Providers_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantPublicInfoArgs = {
  distinct_on?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantPublicInfo_Order_By>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantPublicInfo_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantPublicInfo_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantPublicInfo_Order_By>>;
  where?: InputMaybe<TenantPublicInfo_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantsIdpsArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantsIdps_AggregateArgs = {
  distinct_on?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<TenantsIdps_Order_By>>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsersArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};


/** columns and relationships of "tenants" */
export type TenantsUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Users_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Users_Order_By>>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** columns and relationships of "tenants_idps" */
export type TenantsIdps = {
  __typename?: 'tenantsIdps';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  idpId: Scalars['String'];
  /** An object relationship */
  idps?: Maybe<Idps>;
  isAvailable?: Maybe<Scalars['Boolean']>;
  owner?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  tmpClientSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  using?: Maybe<Scalars['Boolean']>;
};

/** aggregated selection of "tenants_idps" */
export type TenantsIdps_Aggregate = {
  __typename?: 'tenantsIdps_aggregate';
  aggregate?: Maybe<TenantsIdps_Aggregate_Fields>;
  nodes: Array<TenantsIdps>;
};

export type TenantsIdps_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<TenantsIdps_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<TenantsIdps_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<TenantsIdps_Aggregate_Bool_Exp_Count>;
};

export type TenantsIdps_Aggregate_Bool_Exp_Bool_And = {
  arguments: TenantsIdps_Select_Column_TenantsIdps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TenantsIdps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type TenantsIdps_Aggregate_Bool_Exp_Bool_Or = {
  arguments: TenantsIdps_Select_Column_TenantsIdps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TenantsIdps_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type TenantsIdps_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<TenantsIdps_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "tenants_idps" */
export type TenantsIdps_Aggregate_Fields = {
  __typename?: 'tenantsIdps_aggregate_fields';
  avg?: Maybe<TenantsIdps_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<TenantsIdps_Max_Fields>;
  min?: Maybe<TenantsIdps_Min_Fields>;
  stddev?: Maybe<TenantsIdps_Stddev_Fields>;
  stddev_pop?: Maybe<TenantsIdps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<TenantsIdps_Stddev_Samp_Fields>;
  sum?: Maybe<TenantsIdps_Sum_Fields>;
  var_pop?: Maybe<TenantsIdps_Var_Pop_Fields>;
  var_samp?: Maybe<TenantsIdps_Var_Samp_Fields>;
  variance?: Maybe<TenantsIdps_Variance_Fields>;
};


/** aggregate fields of "tenants_idps" */
export type TenantsIdps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<TenantsIdps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "tenants_idps" */
export type TenantsIdps_Aggregate_Order_By = {
  avg?: InputMaybe<TenantsIdps_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<TenantsIdps_Max_Order_By>;
  min?: InputMaybe<TenantsIdps_Min_Order_By>;
  stddev?: InputMaybe<TenantsIdps_Stddev_Order_By>;
  stddev_pop?: InputMaybe<TenantsIdps_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<TenantsIdps_Stddev_Samp_Order_By>;
  sum?: InputMaybe<TenantsIdps_Sum_Order_By>;
  var_pop?: InputMaybe<TenantsIdps_Var_Pop_Order_By>;
  var_samp?: InputMaybe<TenantsIdps_Var_Samp_Order_By>;
  variance?: InputMaybe<TenantsIdps_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "tenants_idps" */
export type TenantsIdps_Arr_Rel_Insert_Input = {
  data: Array<TenantsIdps_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<TenantsIdps_On_Conflict>;
};

/** aggregate avg on columns */
export type TenantsIdps_Avg_Fields = {
  __typename?: 'tenantsIdps_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "tenants_idps" */
export type TenantsIdps_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "tenants_idps". All fields are combined with a logical 'AND'. */
export type TenantsIdps_Bool_Exp = {
  _and?: InputMaybe<Array<TenantsIdps_Bool_Exp>>;
  _not?: InputMaybe<TenantsIdps_Bool_Exp>;
  _or?: InputMaybe<Array<TenantsIdps_Bool_Exp>>;
  clientId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  idpId?: InputMaybe<String_Comparison_Exp>;
  idps?: InputMaybe<Idps_Bool_Exp>;
  isAvailable?: InputMaybe<Boolean_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  tmpClientSecret?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  using?: InputMaybe<Boolean_Comparison_Exp>;
};

/** unique or primary key constraints on table "tenants_idps" */
export enum TenantsIdps_Constraint {
  /** unique or primary key constraint on columns "id" */
  TenantsIdpsPkey = 'tenants_idps_pkey',
  /** unique or primary key constraint on columns "tenant_id", "idp_id" */
  TenantsIdpsTenantIdpIdx = 'tenants_idps_tenant_idp_idx'
}

/** input type for incrementing numeric columns in table "tenants_idps" */
export type TenantsIdps_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "tenants_idps" */
export type TenantsIdps_Insert_Input = {
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  idps?: InputMaybe<Idps_Obj_Rel_Insert_Input>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tmpClientSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  using?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type TenantsIdps_Max_Fields = {
  __typename?: 'tenantsIdps_max_fields';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  idpId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tmpClientSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "tenants_idps" */
export type TenantsIdps_Max_Order_By = {
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idpId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tmpClientSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type TenantsIdps_Min_Fields = {
  __typename?: 'tenantsIdps_min_fields';
  clientId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  idpId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  tmpClientSecret?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "tenants_idps" */
export type TenantsIdps_Min_Order_By = {
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idpId?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tmpClientSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "tenants_idps" */
export type TenantsIdps_Mutation_Response = {
  __typename?: 'tenantsIdps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantsIdps>;
};

/** on_conflict condition type for table "tenants_idps" */
export type TenantsIdps_On_Conflict = {
  constraint: TenantsIdps_Constraint;
  update_columns?: Array<TenantsIdps_Update_Column>;
  where?: InputMaybe<TenantsIdps_Bool_Exp>;
};

/** Ordering options when selecting data from "tenants_idps". */
export type TenantsIdps_Order_By = {
  clientId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idpId?: InputMaybe<Order_By>;
  idps?: InputMaybe<Idps_Order_By>;
  isAvailable?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  tmpClientSecret?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  using?: InputMaybe<Order_By>;
};

/** primary key columns input for table: tenants_idps */
export type TenantsIdps_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "tenants_idps" */
export enum TenantsIdps_Select_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdpId = 'idpId',
  /** column name */
  IsAvailable = 'isAvailable',
  /** column name */
  Owner = 'owner',
  /** column name */
  Reason = 'reason',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TmpClientSecret = 'tmpClientSecret',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Using = 'using'
}

/** select "tenantsIdps_aggregate_bool_exp_bool_and_arguments_columns" columns of table "tenants_idps" */
export enum TenantsIdps_Select_Column_TenantsIdps_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAvailable = 'isAvailable',
  /** column name */
  Using = 'using'
}

/** select "tenantsIdps_aggregate_bool_exp_bool_or_arguments_columns" columns of table "tenants_idps" */
export enum TenantsIdps_Select_Column_TenantsIdps_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAvailable = 'isAvailable',
  /** column name */
  Using = 'using'
}

/** input type for updating data in table "tenants_idps" */
export type TenantsIdps_Set_Input = {
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tmpClientSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  using?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type TenantsIdps_Stddev_Fields = {
  __typename?: 'tenantsIdps_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "tenants_idps" */
export type TenantsIdps_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type TenantsIdps_Stddev_Pop_Fields = {
  __typename?: 'tenantsIdps_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "tenants_idps" */
export type TenantsIdps_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type TenantsIdps_Stddev_Samp_Fields = {
  __typename?: 'tenantsIdps_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "tenants_idps" */
export type TenantsIdps_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "tenantsIdps" */
export type TenantsIdps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: TenantsIdps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantsIdps_Stream_Cursor_Value_Input = {
  clientId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  isAvailable?: InputMaybe<Scalars['Boolean']>;
  owner?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  tmpClientSecret?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  using?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type TenantsIdps_Sum_Fields = {
  __typename?: 'tenantsIdps_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "tenants_idps" */
export type TenantsIdps_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "tenants_idps" */
export enum TenantsIdps_Update_Column {
  /** column name */
  ClientId = 'clientId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdpId = 'idpId',
  /** column name */
  IsAvailable = 'isAvailable',
  /** column name */
  Owner = 'owner',
  /** column name */
  Reason = 'reason',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  TmpClientSecret = 'tmpClientSecret',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Using = 'using'
}

export type TenantsIdps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<TenantsIdps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantsIdps_Set_Input>;
  /** filter the rows which have to be updated */
  where: TenantsIdps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type TenantsIdps_Var_Pop_Fields = {
  __typename?: 'tenantsIdps_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "tenants_idps" */
export type TenantsIdps_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type TenantsIdps_Var_Samp_Fields = {
  __typename?: 'tenantsIdps_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "tenants_idps" */
export type TenantsIdps_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type TenantsIdps_Variance_Fields = {
  __typename?: 'tenantsIdps_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "tenants_idps" */
export type TenantsIdps_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregated selection of "tenants" */
export type Tenants_Aggregate = {
  __typename?: 'tenants_aggregate';
  aggregate?: Maybe<Tenants_Aggregate_Fields>;
  nodes: Array<Tenants>;
};

/** aggregate fields of "tenants" */
export type Tenants_Aggregate_Fields = {
  __typename?: 'tenants_aggregate_fields';
  avg?: Maybe<Tenants_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tenants_Max_Fields>;
  min?: Maybe<Tenants_Min_Fields>;
  stddev?: Maybe<Tenants_Stddev_Fields>;
  stddev_pop?: Maybe<Tenants_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tenants_Stddev_Samp_Fields>;
  sum?: Maybe<Tenants_Sum_Fields>;
  var_pop?: Maybe<Tenants_Var_Pop_Fields>;
  var_samp?: Maybe<Tenants_Var_Samp_Fields>;
  variance?: Maybe<Tenants_Variance_Fields>;
};


/** aggregate fields of "tenants" */
export type Tenants_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tenants_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Tenants_Append_Input = {
  changePasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Tenants_Avg_Fields = {
  __typename?: 'tenants_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type Tenants_Bool_Exp = {
  _and?: InputMaybe<Array<Tenants_Bool_Exp>>;
  _not?: InputMaybe<Tenants_Bool_Exp>;
  _or?: InputMaybe<Array<Tenants_Bool_Exp>>;
  alias?: InputMaybe<String_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  changePasswordTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  forgottenPasswordTemplate?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  providers?: InputMaybe<Providers_Bool_Exp>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Bool_Exp>;
  shortId?: InputMaybe<Bigint_Comparison_Exp>;
  tenantPublicInfo?: InputMaybe<TenantPublicInfo_Bool_Exp>;
  tenantPublicInfo_aggregate?: InputMaybe<TenantPublicInfo_Aggregate_Bool_Exp>;
  tenantsIdps?: InputMaybe<TenantsIdps_Bool_Exp>;
  tenantsIdps_aggregate?: InputMaybe<TenantsIdps_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userPoolId?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
  users_aggregate?: InputMaybe<Users_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "tenants" */
export enum Tenants_Constraint {
  /** unique or primary key constraint on columns "alias" */
  TenantsAliasKey = 'tenants_alias_key',
  /** unique or primary key constraint on columns "name" */
  TenantsNameKey = 'tenants_name_key',
  /** unique or primary key constraint on columns "id" */
  TenantsPkey = 'tenants_pkey',
  /** unique or primary key constraint on columns "short_id" */
  TenantsShortIdKey = 'tenants_short_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Tenants_Delete_At_Path_Input = {
  changePasswordTemplate?: InputMaybe<Array<Scalars['String']>>;
  forgottenPasswordTemplate?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Tenants_Delete_Elem_Input = {
  changePasswordTemplate?: InputMaybe<Scalars['Int']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Tenants_Delete_Key_Input = {
  changePasswordTemplate?: InputMaybe<Scalars['String']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "tenants" */
export type Tenants_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "tenants" */
export type Tenants_Insert_Input = {
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  changePasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  providers?: InputMaybe<Providers_Arr_Rel_Insert_Input>;
  shortId?: InputMaybe<Scalars['bigint']>;
  tenantPublicInfo?: InputMaybe<TenantPublicInfo_Arr_Rel_Insert_Input>;
  tenantsIdps?: InputMaybe<TenantsIdps_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Users_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tenants_Max_Fields = {
  __typename?: 'tenants_max_fields';
  alias?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tenants_Min_Fields = {
  __typename?: 'tenants_min_fields';
  alias?: Maybe<Scalars['String']>;
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userPoolId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tenants" */
export type Tenants_Mutation_Response = {
  __typename?: 'tenants_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenants>;
};

/** input type for inserting object relation for remote table "tenants" */
export type Tenants_Obj_Rel_Insert_Input = {
  data: Tenants_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Tenants_On_Conflict>;
};

/** on_conflict condition type for table "tenants" */
export type Tenants_On_Conflict = {
  constraint: Tenants_Constraint;
  update_columns?: Array<Tenants_Update_Column>;
  where?: InputMaybe<Tenants_Bool_Exp>;
};

/** Ordering options when selecting data from "tenants". */
export type Tenants_Order_By = {
  alias?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  changePasswordTemplate?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  forgottenPasswordTemplate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  providers_aggregate?: InputMaybe<Providers_Aggregate_Order_By>;
  shortId?: InputMaybe<Order_By>;
  tenantPublicInfo_aggregate?: InputMaybe<TenantPublicInfo_Aggregate_Order_By>;
  tenantsIdps_aggregate?: InputMaybe<TenantsIdps_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userPoolId?: InputMaybe<Order_By>;
  users_aggregate?: InputMaybe<Users_Aggregate_Order_By>;
};

/** primary key columns input for table: tenants */
export type Tenants_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Tenants_Prepend_Input = {
  changePasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "tenants" */
export enum Tenants_Select_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  ChangePasswordTemplate = 'changePasswordTemplate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ForgottenPasswordTemplate = 'forgottenPasswordTemplate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserPoolId = 'userPoolId'
}

/** input type for updating data in table "tenants" */
export type Tenants_Set_Input = {
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  changePasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tenants_Stddev_Fields = {
  __typename?: 'tenants_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tenants_Stddev_Pop_Fields = {
  __typename?: 'tenants_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tenants_Stddev_Samp_Fields = {
  __typename?: 'tenants_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tenants" */
export type Tenants_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tenants_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tenants_Stream_Cursor_Value_Input = {
  alias?: InputMaybe<Scalars['String']>;
  categoryId?: InputMaybe<Scalars['String']>;
  changePasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  forgottenPasswordTemplate?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  shortId?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userPoolId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tenants_Sum_Fields = {
  __typename?: 'tenants_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  shortId?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "tenants" */
export enum Tenants_Update_Column {
  /** column name */
  Alias = 'alias',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  ChangePasswordTemplate = 'changePasswordTemplate',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ForgottenPasswordTemplate = 'forgottenPasswordTemplate',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  ShortId = 'shortId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserPoolId = 'userPoolId'
}

export type Tenants_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Tenants_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Tenants_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Tenants_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Tenants_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tenants_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Tenants_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tenants_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tenants_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tenants_Var_Pop_Fields = {
  __typename?: 'tenants_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tenants_Var_Samp_Fields = {
  __typename?: 'tenants_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tenants_Variance_Fields = {
  __typename?: 'tenants_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  shortId?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "upload_files" */
export type UploadFiles = {
  __typename?: 'uploadFiles';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  meta?: Maybe<Scalars['jsonb']>;
  objectKey?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  state: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  uploadUrl?: Maybe<Scalars['String']>;
};


/** columns and relationships of "upload_files" */
export type UploadFilesMetaArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "upload_files" */
export type UploadFiles_Aggregate = {
  __typename?: 'uploadFiles_aggregate';
  aggregate?: Maybe<UploadFiles_Aggregate_Fields>;
  nodes: Array<UploadFiles>;
};

/** aggregate fields of "upload_files" */
export type UploadFiles_Aggregate_Fields = {
  __typename?: 'uploadFiles_aggregate_fields';
  avg?: Maybe<UploadFiles_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UploadFiles_Max_Fields>;
  min?: Maybe<UploadFiles_Min_Fields>;
  stddev?: Maybe<UploadFiles_Stddev_Fields>;
  stddev_pop?: Maybe<UploadFiles_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UploadFiles_Stddev_Samp_Fields>;
  sum?: Maybe<UploadFiles_Sum_Fields>;
  var_pop?: Maybe<UploadFiles_Var_Pop_Fields>;
  var_samp?: Maybe<UploadFiles_Var_Samp_Fields>;
  variance?: Maybe<UploadFiles_Variance_Fields>;
};


/** aggregate fields of "upload_files" */
export type UploadFiles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UploadFiles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UploadFiles_Append_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type UploadFiles_Avg_Fields = {
  __typename?: 'uploadFiles_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "upload_files". All fields are combined with a logical 'AND'. */
export type UploadFiles_Bool_Exp = {
  _and?: InputMaybe<Array<UploadFiles_Bool_Exp>>;
  _not?: InputMaybe<UploadFiles_Bool_Exp>;
  _or?: InputMaybe<Array<UploadFiles_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  meta?: InputMaybe<Jsonb_Comparison_Exp>;
  objectKey?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  uploadUrl?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "upload_files" */
export enum UploadFiles_Constraint {
  /** unique or primary key constraint on columns "id" */
  UploadFilesPkey = 'upload_files_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UploadFiles_Delete_At_Path_Input = {
  meta?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UploadFiles_Delete_Elem_Input = {
  meta?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UploadFiles_Delete_Key_Input = {
  meta?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "upload_files" */
export type UploadFiles_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "upload_files" */
export type UploadFiles_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  objectKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  uploadUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UploadFiles_Max_Fields = {
  __typename?: 'uploadFiles_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UploadFiles_Min_Fields = {
  __typename?: 'uploadFiles_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  objectKey?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  state?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  uploadUrl?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "upload_files" */
export type UploadFiles_Mutation_Response = {
  __typename?: 'uploadFiles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UploadFiles>;
};

/** on_conflict condition type for table "upload_files" */
export type UploadFiles_On_Conflict = {
  constraint: UploadFiles_Constraint;
  update_columns?: Array<UploadFiles_Update_Column>;
  where?: InputMaybe<UploadFiles_Bool_Exp>;
};

/** Ordering options when selecting data from "upload_files". */
export type UploadFiles_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  meta?: InputMaybe<Order_By>;
  objectKey?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  uploadUrl?: InputMaybe<Order_By>;
};

/** primary key columns input for table: upload_files */
export type UploadFiles_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UploadFiles_Prepend_Input = {
  meta?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "upload_files" */
export enum UploadFiles_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectKey = 'objectKey',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadUrl = 'uploadUrl'
}

/** input type for updating data in table "upload_files" */
export type UploadFiles_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  objectKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  uploadUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UploadFiles_Stddev_Fields = {
  __typename?: 'uploadFiles_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UploadFiles_Stddev_Pop_Fields = {
  __typename?: 'uploadFiles_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UploadFiles_Stddev_Samp_Fields = {
  __typename?: 'uploadFiles_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "uploadFiles" */
export type UploadFiles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UploadFiles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UploadFiles_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  meta?: InputMaybe<Scalars['jsonb']>;
  objectKey?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  uploadUrl?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UploadFiles_Sum_Fields = {
  __typename?: 'uploadFiles_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "upload_files" */
export enum UploadFiles_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Meta = 'meta',
  /** column name */
  ObjectKey = 'objectKey',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UploadUrl = 'uploadUrl'
}

export type UploadFiles_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UploadFiles_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UploadFiles_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UploadFiles_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UploadFiles_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UploadFiles_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UploadFiles_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UploadFiles_Set_Input>;
  /** filter the rows which have to be updated */
  where: UploadFiles_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UploadFiles_Var_Pop_Fields = {
  __typename?: 'uploadFiles_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UploadFiles_Var_Samp_Fields = {
  __typename?: 'uploadFiles_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UploadFiles_Variance_Fields = {
  __typename?: 'uploadFiles_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_policies" */
export type UserPolicies = {
  __typename?: 'userPolicies';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  mergedPolicies?: Maybe<Scalars['jsonb']>;
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
};


/** columns and relationships of "user_policies" */
export type UserPoliciesMergedPoliciesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "user_policies" */
export type UserPolicies_Aggregate = {
  __typename?: 'userPolicies_aggregate';
  aggregate?: Maybe<UserPolicies_Aggregate_Fields>;
  nodes: Array<UserPolicies>;
};

/** aggregate fields of "user_policies" */
export type UserPolicies_Aggregate_Fields = {
  __typename?: 'userPolicies_aggregate_fields';
  avg?: Maybe<UserPolicies_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UserPolicies_Max_Fields>;
  min?: Maybe<UserPolicies_Min_Fields>;
  stddev?: Maybe<UserPolicies_Stddev_Fields>;
  stddev_pop?: Maybe<UserPolicies_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UserPolicies_Stddev_Samp_Fields>;
  sum?: Maybe<UserPolicies_Sum_Fields>;
  var_pop?: Maybe<UserPolicies_Var_Pop_Fields>;
  var_samp?: Maybe<UserPolicies_Var_Samp_Fields>;
  variance?: Maybe<UserPolicies_Variance_Fields>;
};


/** aggregate fields of "user_policies" */
export type UserPolicies_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UserPolicies_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UserPolicies_Append_Input = {
  mergedPolicies?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type UserPolicies_Avg_Fields = {
  __typename?: 'userPolicies_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "user_policies". All fields are combined with a logical 'AND'. */
export type UserPolicies_Bool_Exp = {
  _and?: InputMaybe<Array<UserPolicies_Bool_Exp>>;
  _not?: InputMaybe<UserPolicies_Bool_Exp>;
  _or?: InputMaybe<Array<UserPolicies_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  mergedPolicies?: InputMaybe<Jsonb_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_policies" */
export enum UserPolicies_Constraint {
  /** unique or primary key constraint on columns "user_id" */
  UpstPkey = 'upst_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UserPolicies_Delete_At_Path_Input = {
  mergedPolicies?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UserPolicies_Delete_Elem_Input = {
  mergedPolicies?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UserPolicies_Delete_Key_Input = {
  mergedPolicies?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "user_policies" */
export type UserPolicies_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "user_policies" */
export type UserPolicies_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  mergedPolicies?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UserPolicies_Max_Fields = {
  __typename?: 'userPolicies_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UserPolicies_Min_Fields = {
  __typename?: 'userPolicies_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_policies" */
export type UserPolicies_Mutation_Response = {
  __typename?: 'userPolicies_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UserPolicies>;
};

/** on_conflict condition type for table "user_policies" */
export type UserPolicies_On_Conflict = {
  constraint: UserPolicies_Constraint;
  update_columns?: Array<UserPolicies_Update_Column>;
  where?: InputMaybe<UserPolicies_Bool_Exp>;
};

/** Ordering options when selecting data from "user_policies". */
export type UserPolicies_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  mergedPolicies?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_policies */
export type UserPolicies_Pk_Columns_Input = {
  userId: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UserPolicies_Prepend_Input = {
  mergedPolicies?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "user_policies" */
export enum UserPolicies_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  MergedPolicies = 'mergedPolicies',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "user_policies" */
export type UserPolicies_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  mergedPolicies?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UserPolicies_Stddev_Fields = {
  __typename?: 'userPolicies_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UserPolicies_Stddev_Pop_Fields = {
  __typename?: 'userPolicies_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UserPolicies_Stddev_Samp_Fields = {
  __typename?: 'userPolicies_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "userPolicies" */
export type UserPolicies_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UserPolicies_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UserPolicies_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  mergedPolicies?: InputMaybe<Scalars['jsonb']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UserPolicies_Sum_Fields = {
  __typename?: 'userPolicies_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "user_policies" */
export enum UserPolicies_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  MergedPolicies = 'mergedPolicies',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UserPolicies_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UserPolicies_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<UserPolicies_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<UserPolicies_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<UserPolicies_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserPolicies_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UserPolicies_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserPolicies_Set_Input>;
  /** filter the rows which have to be updated */
  where: UserPolicies_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UserPolicies_Var_Pop_Fields = {
  __typename?: 'userPolicies_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UserPolicies_Var_Samp_Fields = {
  __typename?: 'userPolicies_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UserPolicies_Variance_Fields = {
  __typename?: 'userPolicies_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "user_roles" */
export type User_Roles = {
  __typename?: 'user_roles';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_roles" */
export type User_Roles_Aggregate = {
  __typename?: 'user_roles_aggregate';
  aggregate?: Maybe<User_Roles_Aggregate_Fields>;
  nodes: Array<User_Roles>;
};

/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_Fields = {
  __typename?: 'user_roles_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Roles_Max_Fields>;
  min?: Maybe<User_Roles_Min_Fields>;
};


/** aggregate fields of "user_roles" */
export type User_Roles_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Roles_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_roles". All fields are combined with a logical 'AND'. */
export type User_Roles_Bool_Exp = {
  _and?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  _not?: InputMaybe<User_Roles_Bool_Exp>;
  _or?: InputMaybe<Array<User_Roles_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_roles" */
export enum User_Roles_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserRolesPkey = 'user_roles_pkey'
}

export enum User_Roles_Enum {
  /** ADMIN */
  Admin = 'ADMIN',
  /** PLATFORM */
  Platform = 'PLATFORM',
  /** PUBLIC */
  Public = 'PUBLIC',
  /** TENANT */
  Tenant = 'TENANT'
}

/** Boolean expression to compare columns of type "user_roles_enum". All fields are combined with logical 'AND'. */
export type User_Roles_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Roles_Enum>;
  _in?: InputMaybe<Array<User_Roles_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Roles_Enum>;
  _nin?: InputMaybe<Array<User_Roles_Enum>>;
};

/** input type for inserting data into table "user_roles" */
export type User_Roles_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Roles_Max_Fields = {
  __typename?: 'user_roles_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Roles_Min_Fields = {
  __typename?: 'user_roles_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_roles" */
export type User_Roles_Mutation_Response = {
  __typename?: 'user_roles_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Roles>;
};

/** on_conflict condition type for table "user_roles" */
export type User_Roles_On_Conflict = {
  constraint: User_Roles_Constraint;
  update_columns?: Array<User_Roles_Update_Column>;
  where?: InputMaybe<User_Roles_Bool_Exp>;
};

/** Ordering options when selecting data from "user_roles". */
export type User_Roles_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_roles */
export type User_Roles_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_roles" */
export enum User_Roles_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_roles" */
export type User_Roles_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_roles" */
export type User_Roles_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Roles_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Roles_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_roles" */
export enum User_Roles_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type User_Roles_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Roles_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Roles_Bool_Exp;
};

/** columns and relationships of "user_states" */
export type User_States = {
  __typename?: 'user_states';
  comment?: Maybe<Scalars['String']>;
  value: Scalars['String'];
};

/** aggregated selection of "user_states" */
export type User_States_Aggregate = {
  __typename?: 'user_states_aggregate';
  aggregate?: Maybe<User_States_Aggregate_Fields>;
  nodes: Array<User_States>;
};

/** aggregate fields of "user_states" */
export type User_States_Aggregate_Fields = {
  __typename?: 'user_states_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_States_Max_Fields>;
  min?: Maybe<User_States_Min_Fields>;
};


/** aggregate fields of "user_states" */
export type User_States_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_States_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_states". All fields are combined with a logical 'AND'. */
export type User_States_Bool_Exp = {
  _and?: InputMaybe<Array<User_States_Bool_Exp>>;
  _not?: InputMaybe<User_States_Bool_Exp>;
  _or?: InputMaybe<Array<User_States_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_states" */
export enum User_States_Constraint {
  /** unique or primary key constraint on columns "value" */
  UserStatesPkey = 'user_states_pkey'
}

export enum User_States_Enum {
  /** Deleted other than id. */
  Deleted = 'deleted',
  /** User cannot sign in. */
  Disabled = 'disabled',
  /** enabled */
  Enabled = 'enabled'
}

/** Boolean expression to compare columns of type "user_states_enum". All fields are combined with logical 'AND'. */
export type User_States_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_States_Enum>;
  _in?: InputMaybe<Array<User_States_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_States_Enum>;
  _nin?: InputMaybe<Array<User_States_Enum>>;
};

/** input type for inserting data into table "user_states" */
export type User_States_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_States_Max_Fields = {
  __typename?: 'user_states_max_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_States_Min_Fields = {
  __typename?: 'user_states_min_fields';
  comment?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_states" */
export type User_States_Mutation_Response = {
  __typename?: 'user_states_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_States>;
};

/** on_conflict condition type for table "user_states" */
export type User_States_On_Conflict = {
  constraint: User_States_Constraint;
  update_columns?: Array<User_States_Update_Column>;
  where?: InputMaybe<User_States_Bool_Exp>;
};

/** Ordering options when selecting data from "user_states". */
export type User_States_Order_By = {
  comment?: InputMaybe<Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_states */
export type User_States_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "user_states" */
export enum User_States_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "user_states" */
export type User_States_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_states" */
export type User_States_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_States_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_States_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_states" */
export enum User_States_Update_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  Value = 'value'
}

export type User_States_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_States_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_States_Bool_Exp;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'users';
  attributes: Scalars['jsonb'];
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  email: Scalars['String'];
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  owner: Scalars['String'];
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  role?: Maybe<User_Roles_Enum>;
  state?: Maybe<User_States_Enum>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username: Scalars['String'];
  /** An array relationship */
  usersAssets: Array<UsersAssets>;
  /** An aggregate relationship */
  usersAssets_aggregate: UsersAssets_Aggregate;
  /** An array relationship */
  usersGroups: Array<UsersGroups>;
  /** An aggregate relationship */
  usersGroups_aggregate: UsersGroups_Aggregate;
  /** An array relationship */
  usersUsers: Array<UsersUsers>;
  /** An aggregate relationship */
  usersUsers_aggregate: UsersUsers_Aggregate;
};


/** columns and relationships of "users" */
export type UsersAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "users" */
export type UsersUsersAssetsArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersAssets_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersAssets_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersAssets_Order_By>>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersGroupsArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersGroups_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersGroups_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersGroups_Order_By>>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersUsersArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};


/** columns and relationships of "users" */
export type UsersUsersUsers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<UsersUsers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<UsersUsers_Order_By>>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};

/** columns and relationships of "users_assets" */
export type UsersAssets = {
  __typename?: 'usersAssets';
  assetId: Scalars['String'];
  /** An object relationship */
  assets?: Maybe<Assets>;
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
  /** An object relationship */
  users?: Maybe<Users>;
};

/** aggregated selection of "users_assets" */
export type UsersAssets_Aggregate = {
  __typename?: 'usersAssets_aggregate';
  aggregate?: Maybe<UsersAssets_Aggregate_Fields>;
  nodes: Array<UsersAssets>;
};

export type UsersAssets_Aggregate_Bool_Exp = {
  count?: InputMaybe<UsersAssets_Aggregate_Bool_Exp_Count>;
};

export type UsersAssets_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UsersAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersAssets_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_assets" */
export type UsersAssets_Aggregate_Fields = {
  __typename?: 'usersAssets_aggregate_fields';
  avg?: Maybe<UsersAssets_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersAssets_Max_Fields>;
  min?: Maybe<UsersAssets_Min_Fields>;
  stddev?: Maybe<UsersAssets_Stddev_Fields>;
  stddev_pop?: Maybe<UsersAssets_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersAssets_Stddev_Samp_Fields>;
  sum?: Maybe<UsersAssets_Sum_Fields>;
  var_pop?: Maybe<UsersAssets_Var_Pop_Fields>;
  var_samp?: Maybe<UsersAssets_Var_Samp_Fields>;
  variance?: Maybe<UsersAssets_Variance_Fields>;
};


/** aggregate fields of "users_assets" */
export type UsersAssets_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersAssets_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_assets" */
export type UsersAssets_Aggregate_Order_By = {
  avg?: InputMaybe<UsersAssets_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsersAssets_Max_Order_By>;
  min?: InputMaybe<UsersAssets_Min_Order_By>;
  stddev?: InputMaybe<UsersAssets_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsersAssets_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsersAssets_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsersAssets_Sum_Order_By>;
  var_pop?: InputMaybe<UsersAssets_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsersAssets_Var_Samp_Order_By>;
  variance?: InputMaybe<UsersAssets_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_assets" */
export type UsersAssets_Arr_Rel_Insert_Input = {
  data: Array<UsersAssets_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersAssets_On_Conflict>;
};

/** aggregate avg on columns */
export type UsersAssets_Avg_Fields = {
  __typename?: 'usersAssets_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users_assets" */
export type UsersAssets_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_assets". All fields are combined with a logical 'AND'. */
export type UsersAssets_Bool_Exp = {
  _and?: InputMaybe<Array<UsersAssets_Bool_Exp>>;
  _not?: InputMaybe<UsersAssets_Bool_Exp>;
  _or?: InputMaybe<Array<UsersAssets_Bool_Exp>>;
  assetId?: InputMaybe<String_Comparison_Exp>;
  assets?: InputMaybe<Assets_Bool_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  serviceId?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "users_assets" */
export enum UsersAssets_Constraint {
  /** unique or primary key constraint on columns "asset_id", "user_id" */
  UniqueUserAsset = 'unique_user_asset',
  /** unique or primary key constraint on columns "id" */
  UsersAssetsPkey = 'users_assets_pkey'
}

/** input type for incrementing numeric columns in table "users_assets" */
export type UsersAssets_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users_assets" */
export type UsersAssets_Insert_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  assets?: InputMaybe<Assets_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UsersAssets_Max_Fields = {
  __typename?: 'usersAssets_max_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users_assets" */
export type UsersAssets_Max_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsersAssets_Min_Fields = {
  __typename?: 'usersAssets_min_fields';
  assetId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  serviceId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users_assets" */
export type UsersAssets_Min_Order_By = {
  assetId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_assets" */
export type UsersAssets_Mutation_Response = {
  __typename?: 'usersAssets_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersAssets>;
};

/** on_conflict condition type for table "users_assets" */
export type UsersAssets_On_Conflict = {
  constraint: UsersAssets_Constraint;
  update_columns?: Array<UsersAssets_Update_Column>;
  where?: InputMaybe<UsersAssets_Bool_Exp>;
};

/** Ordering options when selecting data from "users_assets". */
export type UsersAssets_Order_By = {
  assetId?: InputMaybe<Order_By>;
  assets?: InputMaybe<Assets_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  serviceId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: users_assets */
export type UsersAssets_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users_assets" */
export enum UsersAssets_Select_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_assets" */
export type UsersAssets_Set_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersAssets_Stddev_Fields = {
  __typename?: 'usersAssets_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users_assets" */
export type UsersAssets_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsersAssets_Stddev_Pop_Fields = {
  __typename?: 'usersAssets_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users_assets" */
export type UsersAssets_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsersAssets_Stddev_Samp_Fields = {
  __typename?: 'usersAssets_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users_assets" */
export type UsersAssets_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "usersAssets" */
export type UsersAssets_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersAssets_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersAssets_Stream_Cursor_Value_Input = {
  assetId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  serviceId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersAssets_Sum_Fields = {
  __typename?: 'usersAssets_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "users_assets" */
export type UsersAssets_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "users_assets" */
export enum UsersAssets_Update_Column {
  /** column name */
  AssetId = 'assetId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ServiceId = 'serviceId',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsersAssets_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersAssets_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersAssets_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersAssets_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersAssets_Var_Pop_Fields = {
  __typename?: 'usersAssets_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users_assets" */
export type UsersAssets_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsersAssets_Var_Samp_Fields = {
  __typename?: 'usersAssets_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users_assets" */
export type UsersAssets_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsersAssets_Variance_Fields = {
  __typename?: 'usersAssets_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users_assets" */
export type UsersAssets_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_external_users" */
export type UsersExternalUsers = {
  __typename?: 'usersExternalUsers';
  createdAt?: Maybe<Scalars['bigint']>;
  extarnalServiceId: Scalars['String'];
  externalUserId: Scalars['String'];
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
};

/** aggregated selection of "users_external_users" */
export type UsersExternalUsers_Aggregate = {
  __typename?: 'usersExternalUsers_aggregate';
  aggregate?: Maybe<UsersExternalUsers_Aggregate_Fields>;
  nodes: Array<UsersExternalUsers>;
};

/** aggregate fields of "users_external_users" */
export type UsersExternalUsers_Aggregate_Fields = {
  __typename?: 'usersExternalUsers_aggregate_fields';
  avg?: Maybe<UsersExternalUsers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersExternalUsers_Max_Fields>;
  min?: Maybe<UsersExternalUsers_Min_Fields>;
  stddev?: Maybe<UsersExternalUsers_Stddev_Fields>;
  stddev_pop?: Maybe<UsersExternalUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersExternalUsers_Stddev_Samp_Fields>;
  sum?: Maybe<UsersExternalUsers_Sum_Fields>;
  var_pop?: Maybe<UsersExternalUsers_Var_Pop_Fields>;
  var_samp?: Maybe<UsersExternalUsers_Var_Samp_Fields>;
  variance?: Maybe<UsersExternalUsers_Variance_Fields>;
};


/** aggregate fields of "users_external_users" */
export type UsersExternalUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersExternalUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UsersExternalUsers_Avg_Fields = {
  __typename?: 'usersExternalUsers_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users_external_users". All fields are combined with a logical 'AND'. */
export type UsersExternalUsers_Bool_Exp = {
  _and?: InputMaybe<Array<UsersExternalUsers_Bool_Exp>>;
  _not?: InputMaybe<UsersExternalUsers_Bool_Exp>;
  _or?: InputMaybe<Array<UsersExternalUsers_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  extarnalServiceId?: InputMaybe<String_Comparison_Exp>;
  externalUserId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_external_users" */
export enum UsersExternalUsers_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersExternalUsersPkey = 'users_external_users_pkey',
  /** unique or primary key constraint on columns "extarnal_service_id", "user_id", "external_user_id" */
  UsersExternalUsersUnique = 'users_external_users_unique'
}

/** input type for incrementing numeric columns in table "users_external_users" */
export type UsersExternalUsers_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users_external_users" */
export type UsersExternalUsers_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  extarnalServiceId?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsersExternalUsers_Max_Fields = {
  __typename?: 'usersExternalUsers_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  extarnalServiceId?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsersExternalUsers_Min_Fields = {
  __typename?: 'usersExternalUsers_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  extarnalServiceId?: Maybe<Scalars['String']>;
  externalUserId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users_external_users" */
export type UsersExternalUsers_Mutation_Response = {
  __typename?: 'usersExternalUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersExternalUsers>;
};

/** on_conflict condition type for table "users_external_users" */
export type UsersExternalUsers_On_Conflict = {
  constraint: UsersExternalUsers_Constraint;
  update_columns?: Array<UsersExternalUsers_Update_Column>;
  where?: InputMaybe<UsersExternalUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "users_external_users". */
export type UsersExternalUsers_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  extarnalServiceId?: InputMaybe<Order_By>;
  externalUserId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_external_users */
export type UsersExternalUsers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users_external_users" */
export enum UsersExternalUsers_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExtarnalServiceId = 'extarnalServiceId',
  /** column name */
  ExternalUserId = 'externalUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_external_users" */
export type UsersExternalUsers_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  extarnalServiceId?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersExternalUsers_Stddev_Fields = {
  __typename?: 'usersExternalUsers_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UsersExternalUsers_Stddev_Pop_Fields = {
  __typename?: 'usersExternalUsers_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UsersExternalUsers_Stddev_Samp_Fields = {
  __typename?: 'usersExternalUsers_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "usersExternalUsers" */
export type UsersExternalUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersExternalUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersExternalUsers_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  extarnalServiceId?: InputMaybe<Scalars['String']>;
  externalUserId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersExternalUsers_Sum_Fields = {
  __typename?: 'usersExternalUsers_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "users_external_users" */
export enum UsersExternalUsers_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExtarnalServiceId = 'extarnalServiceId',
  /** column name */
  ExternalUserId = 'externalUserId',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsersExternalUsers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersExternalUsers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersExternalUsers_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersExternalUsers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersExternalUsers_Var_Pop_Fields = {
  __typename?: 'usersExternalUsers_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UsersExternalUsers_Var_Samp_Fields = {
  __typename?: 'usersExternalUsers_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UsersExternalUsers_Variance_Fields = {
  __typename?: 'usersExternalUsers_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users_groups" */
export type UsersGroups = {
  __typename?: 'usersGroups';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  groupId: Scalars['String'];
  /** An object relationship */
  groups?: Maybe<Groups>;
  id: Scalars['String'];
  owner: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
  /** An object relationship */
  users?: Maybe<Users>;
};

/** aggregated selection of "users_groups" */
export type UsersGroups_Aggregate = {
  __typename?: 'usersGroups_aggregate';
  aggregate?: Maybe<UsersGroups_Aggregate_Fields>;
  nodes: Array<UsersGroups>;
};

export type UsersGroups_Aggregate_Bool_Exp = {
  count?: InputMaybe<UsersGroups_Aggregate_Bool_Exp_Count>;
};

export type UsersGroups_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UsersGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersGroups_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_groups" */
export type UsersGroups_Aggregate_Fields = {
  __typename?: 'usersGroups_aggregate_fields';
  avg?: Maybe<UsersGroups_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersGroups_Max_Fields>;
  min?: Maybe<UsersGroups_Min_Fields>;
  stddev?: Maybe<UsersGroups_Stddev_Fields>;
  stddev_pop?: Maybe<UsersGroups_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersGroups_Stddev_Samp_Fields>;
  sum?: Maybe<UsersGroups_Sum_Fields>;
  var_pop?: Maybe<UsersGroups_Var_Pop_Fields>;
  var_samp?: Maybe<UsersGroups_Var_Samp_Fields>;
  variance?: Maybe<UsersGroups_Variance_Fields>;
};


/** aggregate fields of "users_groups" */
export type UsersGroups_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersGroups_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_groups" */
export type UsersGroups_Aggregate_Order_By = {
  avg?: InputMaybe<UsersGroups_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsersGroups_Max_Order_By>;
  min?: InputMaybe<UsersGroups_Min_Order_By>;
  stddev?: InputMaybe<UsersGroups_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsersGroups_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsersGroups_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsersGroups_Sum_Order_By>;
  var_pop?: InputMaybe<UsersGroups_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsersGroups_Var_Samp_Order_By>;
  variance?: InputMaybe<UsersGroups_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_groups" */
export type UsersGroups_Arr_Rel_Insert_Input = {
  data: Array<UsersGroups_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersGroups_On_Conflict>;
};

/** aggregate avg on columns */
export type UsersGroups_Avg_Fields = {
  __typename?: 'usersGroups_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users_groups" */
export type UsersGroups_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_groups". All fields are combined with a logical 'AND'. */
export type UsersGroups_Bool_Exp = {
  _and?: InputMaybe<Array<UsersGroups_Bool_Exp>>;
  _not?: InputMaybe<UsersGroups_Bool_Exp>;
  _or?: InputMaybe<Array<UsersGroups_Bool_Exp>>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  groupId?: InputMaybe<String_Comparison_Exp>;
  groups?: InputMaybe<Groups_Bool_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "users_groups" */
export enum UsersGroups_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersGroupsPkey = 'users_groups_pkey',
  /** unique or primary key constraint on columns "user_id", "group_id" */
  UsersGroupsUserIdGroupIdKey = 'users_groups_user_id_group_id_key'
}

/** input type for incrementing numeric columns in table "users_groups" */
export type UsersGroups_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users_groups" */
export type UsersGroups_Insert_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  groups?: InputMaybe<Groups_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
  users?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UsersGroups_Max_Fields = {
  __typename?: 'usersGroups_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users_groups" */
export type UsersGroups_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsersGroups_Min_Fields = {
  __typename?: 'usersGroups_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  groupId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users_groups" */
export type UsersGroups_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_groups" */
export type UsersGroups_Mutation_Response = {
  __typename?: 'usersGroups_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersGroups>;
};

/** on_conflict condition type for table "users_groups" */
export type UsersGroups_On_Conflict = {
  constraint: UsersGroups_Constraint;
  update_columns?: Array<UsersGroups_Update_Column>;
  where?: InputMaybe<UsersGroups_Bool_Exp>;
};

/** Ordering options when selecting data from "users_groups". */
export type UsersGroups_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  groupId?: InputMaybe<Order_By>;
  groups?: InputMaybe<Groups_Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: users_groups */
export type UsersGroups_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users_groups" */
export enum UsersGroups_Select_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_groups" */
export type UsersGroups_Set_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersGroups_Stddev_Fields = {
  __typename?: 'usersGroups_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users_groups" */
export type UsersGroups_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsersGroups_Stddev_Pop_Fields = {
  __typename?: 'usersGroups_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users_groups" */
export type UsersGroups_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsersGroups_Stddev_Samp_Fields = {
  __typename?: 'usersGroups_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users_groups" */
export type UsersGroups_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "usersGroups" */
export type UsersGroups_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersGroups_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersGroups_Stream_Cursor_Value_Input = {
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  groupId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersGroups_Sum_Fields = {
  __typename?: 'usersGroups_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "users_groups" */
export type UsersGroups_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "users_groups" */
export enum UsersGroups_Update_Column {
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GroupId = 'groupId',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsersGroups_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersGroups_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersGroups_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersGroups_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersGroups_Var_Pop_Fields = {
  __typename?: 'usersGroups_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users_groups" */
export type UsersGroups_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsersGroups_Var_Samp_Fields = {
  __typename?: 'usersGroups_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users_groups" */
export type UsersGroups_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsersGroups_Variance_Fields = {
  __typename?: 'usersGroups_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users_groups" */
export type UsersGroups_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "users_idps" */
export type UsersIdps = {
  __typename?: 'usersIdps';
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  idpId: Scalars['String'];
  idpUserId: Scalars['String'];
  /** An object relationship */
  idps?: Maybe<Idps>;
  owner?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  userId: Scalars['String'];
};

/** aggregated selection of "users_idps" */
export type UsersIdps_Aggregate = {
  __typename?: 'usersIdps_aggregate';
  aggregate?: Maybe<UsersIdps_Aggregate_Fields>;
  nodes: Array<UsersIdps>;
};

/** aggregate fields of "users_idps" */
export type UsersIdps_Aggregate_Fields = {
  __typename?: 'usersIdps_aggregate_fields';
  avg?: Maybe<UsersIdps_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersIdps_Max_Fields>;
  min?: Maybe<UsersIdps_Min_Fields>;
  stddev?: Maybe<UsersIdps_Stddev_Fields>;
  stddev_pop?: Maybe<UsersIdps_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersIdps_Stddev_Samp_Fields>;
  sum?: Maybe<UsersIdps_Sum_Fields>;
  var_pop?: Maybe<UsersIdps_Var_Pop_Fields>;
  var_samp?: Maybe<UsersIdps_Var_Samp_Fields>;
  variance?: Maybe<UsersIdps_Variance_Fields>;
};


/** aggregate fields of "users_idps" */
export type UsersIdps_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersIdps_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type UsersIdps_Avg_Fields = {
  __typename?: 'usersIdps_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "users_idps". All fields are combined with a logical 'AND'. */
export type UsersIdps_Bool_Exp = {
  _and?: InputMaybe<Array<UsersIdps_Bool_Exp>>;
  _not?: InputMaybe<UsersIdps_Bool_Exp>;
  _or?: InputMaybe<Array<UsersIdps_Bool_Exp>>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  idpId?: InputMaybe<String_Comparison_Exp>;
  idpUserId?: InputMaybe<String_Comparison_Exp>;
  idps?: InputMaybe<Idps_Bool_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  userId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "users_idps" */
export enum UsersIdps_Constraint {
  /** unique or primary key constraint on columns "id" */
  UsersIdpsPkey = 'users_idps_pkey',
  /** unique or primary key constraint on columns "user_id", "idp_user_id" */
  UsersIdpsUserIdx = 'users_idps_user_idx'
}

/** input type for incrementing numeric columns in table "users_idps" */
export type UsersIdps_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users_idps" */
export type UsersIdps_Insert_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  idpUserId?: InputMaybe<Scalars['String']>;
  idps?: InputMaybe<Idps_Obj_Rel_Insert_Input>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type UsersIdps_Max_Fields = {
  __typename?: 'usersIdps_max_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  idpId?: Maybe<Scalars['String']>;
  idpUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type UsersIdps_Min_Fields = {
  __typename?: 'usersIdps_min_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  idpId?: Maybe<Scalars['String']>;
  idpUserId?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  userId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "users_idps" */
export type UsersIdps_Mutation_Response = {
  __typename?: 'usersIdps_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersIdps>;
};

/** on_conflict condition type for table "users_idps" */
export type UsersIdps_On_Conflict = {
  constraint: UsersIdps_Constraint;
  update_columns?: Array<UsersIdps_Update_Column>;
  where?: InputMaybe<UsersIdps_Bool_Exp>;
};

/** Ordering options when selecting data from "users_idps". */
export type UsersIdps_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  idpId?: InputMaybe<Order_By>;
  idpUserId?: InputMaybe<Order_By>;
  idps?: InputMaybe<Idps_Order_By>;
  owner?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  userId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: users_idps */
export type UsersIdps_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users_idps" */
export enum UsersIdps_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdpId = 'idpId',
  /** column name */
  IdpUserId = 'idpUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

/** input type for updating data in table "users_idps" */
export type UsersIdps_Set_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  idpUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type UsersIdps_Stddev_Fields = {
  __typename?: 'usersIdps_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type UsersIdps_Stddev_Pop_Fields = {
  __typename?: 'usersIdps_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type UsersIdps_Stddev_Samp_Fields = {
  __typename?: 'usersIdps_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "usersIdps" */
export type UsersIdps_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersIdps_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersIdps_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  idpId?: InputMaybe<Scalars['String']>;
  idpUserId?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  userId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type UsersIdps_Sum_Fields = {
  __typename?: 'usersIdps_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** update columns of table "users_idps" */
export enum UsersIdps_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IdpId = 'idpId',
  /** column name */
  IdpUserId = 'idpUserId',
  /** column name */
  Owner = 'owner',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UserId = 'userId'
}

export type UsersIdps_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersIdps_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersIdps_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersIdps_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersIdps_Var_Pop_Fields = {
  __typename?: 'usersIdps_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type UsersIdps_Var_Samp_Fields = {
  __typename?: 'usersIdps_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type UsersIdps_Variance_Fields = {
  __typename?: 'usersIdps_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "users_users" */
export type UsersUsers = {
  __typename?: 'usersUsers';
  childUserId: Scalars['String'];
  createdAt?: Maybe<Scalars['bigint']>;
  id: Scalars['String'];
  owner?: Maybe<Scalars['String']>;
  parentUserId: Scalars['String'];
  updatedAt?: Maybe<Scalars['bigint']>;
  /** An object relationship */
  users?: Maybe<Users>;
};

/** aggregated selection of "users_users" */
export type UsersUsers_Aggregate = {
  __typename?: 'usersUsers_aggregate';
  aggregate?: Maybe<UsersUsers_Aggregate_Fields>;
  nodes: Array<UsersUsers>;
};

export type UsersUsers_Aggregate_Bool_Exp = {
  count?: InputMaybe<UsersUsers_Aggregate_Bool_Exp_Count>;
};

export type UsersUsers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<UsersUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<UsersUsers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users_users" */
export type UsersUsers_Aggregate_Fields = {
  __typename?: 'usersUsers_aggregate_fields';
  avg?: Maybe<UsersUsers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<UsersUsers_Max_Fields>;
  min?: Maybe<UsersUsers_Min_Fields>;
  stddev?: Maybe<UsersUsers_Stddev_Fields>;
  stddev_pop?: Maybe<UsersUsers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<UsersUsers_Stddev_Samp_Fields>;
  sum?: Maybe<UsersUsers_Sum_Fields>;
  var_pop?: Maybe<UsersUsers_Var_Pop_Fields>;
  var_samp?: Maybe<UsersUsers_Var_Samp_Fields>;
  variance?: Maybe<UsersUsers_Variance_Fields>;
};


/** aggregate fields of "users_users" */
export type UsersUsers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<UsersUsers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users_users" */
export type UsersUsers_Aggregate_Order_By = {
  avg?: InputMaybe<UsersUsers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<UsersUsers_Max_Order_By>;
  min?: InputMaybe<UsersUsers_Min_Order_By>;
  stddev?: InputMaybe<UsersUsers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<UsersUsers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<UsersUsers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<UsersUsers_Sum_Order_By>;
  var_pop?: InputMaybe<UsersUsers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<UsersUsers_Var_Samp_Order_By>;
  variance?: InputMaybe<UsersUsers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "users_users" */
export type UsersUsers_Arr_Rel_Insert_Input = {
  data: Array<UsersUsers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<UsersUsers_On_Conflict>;
};

/** aggregate avg on columns */
export type UsersUsers_Avg_Fields = {
  __typename?: 'usersUsers_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users_users" */
export type UsersUsers_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users_users". All fields are combined with a logical 'AND'. */
export type UsersUsers_Bool_Exp = {
  _and?: InputMaybe<Array<UsersUsers_Bool_Exp>>;
  _not?: InputMaybe<UsersUsers_Bool_Exp>;
  _or?: InputMaybe<Array<UsersUsers_Bool_Exp>>;
  childUserId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  parentUserId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  users?: InputMaybe<Users_Bool_Exp>;
};

/** unique or primary key constraints on table "users_users" */
export enum UsersUsers_Constraint {
  /** unique or primary key constraint on columns "child_user_id", "parent_user_id" */
  UsersUsersParentUserIdChildUserIdKey = 'users_users_parent_user_id_child_user_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersUsersPkey = 'users_users_pkey'
}

/** input type for incrementing numeric columns in table "users_users" */
export type UsersUsers_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users_users" */
export type UsersUsers_Insert_Input = {
  childUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  users?: InputMaybe<Users_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type UsersUsers_Max_Fields = {
  __typename?: 'usersUsers_max_fields';
  childUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parentUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by max() on columns of table "users_users" */
export type UsersUsers_Max_Order_By = {
  childUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  parentUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type UsersUsers_Min_Fields = {
  __typename?: 'usersUsers_min_fields';
  childUserId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  id?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  parentUserId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by min() on columns of table "users_users" */
export type UsersUsers_Min_Order_By = {
  childUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  parentUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users_users" */
export type UsersUsers_Mutation_Response = {
  __typename?: 'usersUsers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<UsersUsers>;
};

/** on_conflict condition type for table "users_users" */
export type UsersUsers_On_Conflict = {
  constraint: UsersUsers_Constraint;
  update_columns?: Array<UsersUsers_Update_Column>;
  where?: InputMaybe<UsersUsers_Bool_Exp>;
};

/** Ordering options when selecting data from "users_users". */
export type UsersUsers_Order_By = {
  childUserId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  parentUserId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  users?: InputMaybe<Users_Order_By>;
};

/** primary key columns input for table: users_users */
export type UsersUsers_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** select columns of table "users_users" */
export enum UsersUsers_Select_Column {
  /** column name */
  ChildUserId = 'childUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ParentUserId = 'parentUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "users_users" */
export type UsersUsers_Set_Input = {
  childUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate stddev on columns */
export type UsersUsers_Stddev_Fields = {
  __typename?: 'usersUsers_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users_users" */
export type UsersUsers_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type UsersUsers_Stddev_Pop_Fields = {
  __typename?: 'usersUsers_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users_users" */
export type UsersUsers_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type UsersUsers_Stddev_Samp_Fields = {
  __typename?: 'usersUsers_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users_users" */
export type UsersUsers_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "usersUsers" */
export type UsersUsers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: UsersUsers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersUsers_Stream_Cursor_Value_Input = {
  childUserId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  id?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  parentUserId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** aggregate sum on columns */
export type UsersUsers_Sum_Fields = {
  __typename?: 'usersUsers_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "users_users" */
export type UsersUsers_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "users_users" */
export enum UsersUsers_Update_Column {
  /** column name */
  ChildUserId = 'childUserId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Owner = 'owner',
  /** column name */
  ParentUserId = 'parentUserId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type UsersUsers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UsersUsers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersUsers_Set_Input>;
  /** filter the rows which have to be updated */
  where: UsersUsers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type UsersUsers_Var_Pop_Fields = {
  __typename?: 'usersUsers_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users_users" */
export type UsersUsers_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type UsersUsers_Var_Samp_Fields = {
  __typename?: 'usersUsers_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users_users" */
export type UsersUsers_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type UsersUsers_Variance_Fields = {
  __typename?: 'usersUsers_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users_users" */
export type UsersUsers_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregated selection of "users" */
export type Users_Aggregate = {
  __typename?: 'users_aggregate';
  aggregate?: Maybe<Users_Aggregate_Fields>;
  nodes: Array<Users>;
};

export type Users_Aggregate_Bool_Exp = {
  count?: InputMaybe<Users_Aggregate_Bool_Exp_Count>;
};

export type Users_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Users_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "users" */
export type Users_Aggregate_Fields = {
  __typename?: 'users_aggregate_fields';
  avg?: Maybe<Users_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Users_Max_Fields>;
  min?: Maybe<Users_Min_Fields>;
  stddev?: Maybe<Users_Stddev_Fields>;
  stddev_pop?: Maybe<Users_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Users_Stddev_Samp_Fields>;
  sum?: Maybe<Users_Sum_Fields>;
  var_pop?: Maybe<Users_Var_Pop_Fields>;
  var_samp?: Maybe<Users_Var_Samp_Fields>;
  variance?: Maybe<Users_Variance_Fields>;
};


/** aggregate fields of "users" */
export type Users_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Users_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "users" */
export type Users_Aggregate_Order_By = {
  avg?: InputMaybe<Users_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Users_Max_Order_By>;
  min?: InputMaybe<Users_Min_Order_By>;
  stddev?: InputMaybe<Users_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Users_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Users_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Users_Sum_Order_By>;
  var_pop?: InputMaybe<Users_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Users_Var_Samp_Order_By>;
  variance?: InputMaybe<Users_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Users_Append_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "users" */
export type Users_Arr_Rel_Insert_Input = {
  data: Array<Users_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** aggregate avg on columns */
export type Users_Avg_Fields = {
  __typename?: 'users_avg_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "users" */
export type Users_Avg_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type Users_Bool_Exp = {
  _and?: InputMaybe<Array<Users_Bool_Exp>>;
  _not?: InputMaybe<Users_Bool_Exp>;
  _or?: InputMaybe<Array<Users_Bool_Exp>>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  categoryId?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Bigint_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  owner?: InputMaybe<String_Comparison_Exp>;
  phoneNumber?: InputMaybe<String_Comparison_Exp>;
  policyId?: InputMaybe<String_Comparison_Exp>;
  role?: InputMaybe<User_Roles_Enum_Comparison_Exp>;
  state?: InputMaybe<User_States_Enum_Comparison_Exp>;
  tenantId?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Bigint_Comparison_Exp>;
  updatedByServiceId?: InputMaybe<String_Comparison_Exp>;
  username?: InputMaybe<String_Comparison_Exp>;
  usersAssets?: InputMaybe<UsersAssets_Bool_Exp>;
  usersAssets_aggregate?: InputMaybe<UsersAssets_Aggregate_Bool_Exp>;
  usersGroups?: InputMaybe<UsersGroups_Bool_Exp>;
  usersGroups_aggregate?: InputMaybe<UsersGroups_Aggregate_Bool_Exp>;
  usersUsers?: InputMaybe<UsersUsers_Bool_Exp>;
  usersUsers_aggregate?: InputMaybe<UsersUsers_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "users" */
export enum Users_Constraint {
  /** unique or primary key constraint on columns "tenant_id", "email" */
  UniqueEmail = 'unique_email',
  /** unique or primary key constraint on columns "username", "tenant_id" */
  UniqueUsername = 'unique_username',
  /** unique or primary key constraint on columns "id" */
  UsersPkey = 'users_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Users_Delete_At_Path_Input = {
  attributes?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Users_Delete_Elem_Input = {
  attributes?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Users_Delete_Key_Input = {
  attributes?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "users" */
export type Users_Inc_Input = {
  createdAt?: InputMaybe<Scalars['bigint']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
};

/** input type for inserting data into table "users" */
export type Users_Insert_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Roles_Enum>;
  state?: InputMaybe<User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  updatedByServiceId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  usersAssets?: InputMaybe<UsersAssets_Arr_Rel_Insert_Input>;
  usersGroups?: InputMaybe<UsersGroups_Arr_Rel_Insert_Input>;
  usersUsers?: InputMaybe<UsersUsers_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Users_Max_Fields = {
  __typename?: 'users_max_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "users" */
export type Users_Max_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByServiceId?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Users_Min_Fields = {
  __typename?: 'users_min_fields';
  categoryId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['bigint']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  owner?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  policyId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['bigint']>;
  updatedByServiceId?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "users" */
export type Users_Min_Order_By = {
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByServiceId?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "users" */
export type Users_Mutation_Response = {
  __typename?: 'users_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type Users_Obj_Rel_Insert_Input = {
  data: Users_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Users_On_Conflict>;
};

/** on_conflict condition type for table "users" */
export type Users_On_Conflict = {
  constraint: Users_Constraint;
  update_columns?: Array<Users_Update_Column>;
  where?: InputMaybe<Users_Bool_Exp>;
};

/** Ordering options when selecting data from "users". */
export type Users_Order_By = {
  attributes?: InputMaybe<Order_By>;
  categoryId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  owner?: InputMaybe<Order_By>;
  phoneNumber?: InputMaybe<Order_By>;
  policyId?: InputMaybe<Order_By>;
  role?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  tenantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  updatedByServiceId?: InputMaybe<Order_By>;
  username?: InputMaybe<Order_By>;
  usersAssets_aggregate?: InputMaybe<UsersAssets_Aggregate_Order_By>;
  usersGroups_aggregate?: InputMaybe<UsersGroups_Aggregate_Order_By>;
  usersUsers_aggregate?: InputMaybe<UsersUsers_Aggregate_Order_By>;
};

/** primary key columns input for table: users */
export type Users_Pk_Columns_Input = {
  id: Scalars['String'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Users_Prepend_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "users" */
export enum Users_Select_Column {
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedByServiceId = 'updatedByServiceId',
  /** column name */
  Username = 'username'
}

/** input type for updating data in table "users" */
export type Users_Set_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Roles_Enum>;
  state?: InputMaybe<User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  updatedByServiceId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Users_Stddev_Fields = {
  __typename?: 'users_stddev_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "users" */
export type Users_Stddev_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Users_Stddev_Pop_Fields = {
  __typename?: 'users_stddev_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "users" */
export type Users_Stddev_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Users_Stddev_Samp_Fields = {
  __typename?: 'users_stddev_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "users" */
export type Users_Stddev_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "users" */
export type Users_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Users_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Users_Stream_Cursor_Value_Input = {
  attributes?: InputMaybe<Scalars['jsonb']>;
  categoryId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['bigint']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  owner?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  policyId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<User_Roles_Enum>;
  state?: InputMaybe<User_States_Enum>;
  tenantId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['bigint']>;
  updatedByServiceId?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Users_Sum_Fields = {
  __typename?: 'users_sum_fields';
  createdAt?: Maybe<Scalars['bigint']>;
  updatedAt?: Maybe<Scalars['bigint']>;
};

/** order by sum() on columns of table "users" */
export type Users_Sum_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** update columns of table "users" */
export enum Users_Update_Column {
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CategoryId = 'categoryId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Owner = 'owner',
  /** column name */
  PhoneNumber = 'phoneNumber',
  /** column name */
  PolicyId = 'policyId',
  /** column name */
  Role = 'role',
  /** column name */
  State = 'state',
  /** column name */
  TenantId = 'tenantId',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UpdatedByServiceId = 'updatedByServiceId',
  /** column name */
  Username = 'username'
}

export type Users_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Users_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Users_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Users_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Users_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Users_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Users_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Users_Set_Input>;
  /** filter the rows which have to be updated */
  where: Users_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Users_Var_Pop_Fields = {
  __typename?: 'users_var_pop_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "users" */
export type Users_Var_Pop_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Users_Var_Samp_Fields = {
  __typename?: 'users_var_samp_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "users" */
export type Users_Var_Samp_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Users_Variance_Fields = {
  __typename?: 'users_variance_fields';
  createdAt?: Maybe<Scalars['Float']>;
  updatedAt?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "users" */
export type Users_Variance_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

export type GetAssetsByAssetTypeQueryVariables = Exact<{
  assetTypeId: Scalars['String'];
}>;


export type GetAssetsByAssetTypeQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, assetTypeId?: string | null, description?: string | null, location: any, attributes: any, updatedAt?: any | null }> };

export type GetAssetsByAssetIdQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type GetAssetsByAssetIdQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, assetTypeId?: string | null, location: any, code?: string | null, state: Asset_States_Enum, attributes: any, updatedAt?: any | null }> };

export type AssetsByAssetTypesQueryVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  _stateFilter1?: InputMaybe<Asset_States_Enum>;
  _stateFilter2?: InputMaybe<Asset_States_Enum>;
}>;


export type AssetsByAssetTypesQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, code?: string | null, state: Asset_States_Enum, description?: string | null, assetTypeId?: string | null, location: any, attributes: any, updatedAt?: any | null, assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> }> };

export type AssetsByAssetTypesWithAssetPropertiesQueryVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  _stateFilter1?: InputMaybe<Asset_States_Enum>;
  _stateFilter2?: InputMaybe<Asset_States_Enum>;
}>;


export type AssetsByAssetTypesWithAssetPropertiesQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, code?: string | null, state: Asset_States_Enum, description?: string | null, assetTypeId?: string | null, location: any, attributes: any, updatedAt?: any | null, assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> }> };

export type AssetTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type AssetTypesQuery = { __typename?: 'query_root', assetTypes: Array<{ __typename?: 'assetTypes', id: string, name: string, attributes: any, assetAttributesSchema: any }> };

export type AssetTypesByAssetTypeIdQueryVariables = Exact<{
  assetTypeId: Scalars['String'];
}>;


export type AssetTypesByAssetTypeIdQuery = { __typename?: 'query_root', assetTypes: Array<{ __typename?: 'assetTypes', id: string, name: string, attributes: any, assetAttributesSchema: any }> };

export type LinkAssetTypesQueryVariables = Exact<{
  mapTypeFlg: Scalars['String'];
}>;


export type LinkAssetTypesQuery = { __typename?: 'query_root', assetTypes: Array<{ __typename?: 'assetTypes', id: string, name: string, attributes: any }> };

export type MessageQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type MessageQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'messages', id: string, assetId?: string | null, assetTypeId?: string | null, location: any, properties: any }> };

export type RangeOfMessagesQueryVariables = Exact<{
  orderByCreatedAt: Order_By;
  limit: Scalars['Int'];
  assetId: Scalars['String'];
  startTime: Scalars['bigint'];
  endTime: Scalars['bigint'];
}>;


export type RangeOfMessagesQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'messages', id: string, assetId?: string | null, assetTypeId?: string | null, location: any, properties: any, createdAt?: any | null, updatedAt?: any | null }> };

export type MessageByBusStopQueryVariables = Exact<{
  jsonFilter?: InputMaybe<Scalars['jsonb']>;
  startDatetime?: InputMaybe<Scalars['bigint']>;
}>;


export type MessageByBusStopQuery = { __typename?: 'query_root', events: Array<{ __typename?: 'events', id: string, assetId: string, action: string, occurredDatetime: any, compareDefinition: any, label?: string | null }> };

export type MessagesQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type MessagesQuery = { __typename?: 'query_root', messages: Array<{ __typename?: 'messages', id: string, assetId?: string | null, assetTypeId?: string | null, properties: any, createdAt?: any | null }> };

export type AssetPropertiesQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type AssetPropertiesQuery = { __typename?: 'query_root', assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> };

export type MessagesByAssetTypesQueryVariables = Exact<{
  assetTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  _stateFilter1?: InputMaybe<Asset_States_Enum>;
  _stateFilter2?: InputMaybe<Asset_States_Enum>;
  periodTime: Scalars['bigint'];
}>;


export type MessagesByAssetTypesQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, assetTypeId?: string | null, messages: Array<{ __typename?: 'messages', id: string, assetId?: string | null, createdAt?: any | null, location: any, properties: any, updatedAt?: any | null }> }> };

export type AssetPropertiesByAssetTypesQueryVariables = Exact<{
  assetTypeIds?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  _stateFilter1?: InputMaybe<Asset_States_Enum>;
  _stateFilter2?: InputMaybe<Asset_States_Enum>;
}>;


export type AssetPropertiesByAssetTypesQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, code?: string | null, state: Asset_States_Enum, description?: string | null, assetTypeId?: string | null, location: any, attributes: any, assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> }> };

export type UserByUsernameQueryVariables = Exact<{
  username: Scalars['String'];
}>;


export type UserByUsernameQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'User', id: string, usersGroups: Array<{ __typename?: 'UserGroup', groupId: string }> }>, groups: Array<{ __typename?: 'groups', id: string, name: string }> };

export type PostsWithSpotTypeByOwnerQueryVariables = Exact<{
  classification: Scalars['String'];
  subClass: Scalars['String'];
  owner: Scalars['String'];
}>;


export type PostsWithSpotTypeByOwnerQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', description?: string | null, attributes: any, id: string, location: any, name: string, owner?: string | null, updatedAt?: any | null, createdAt?: any | null, assetTypes?: { __typename?: 'assetTypes', id: string, name: string } | null }>, assetTypes: Array<{ __typename?: 'assetTypes', assetAttributesSchema: any, attributes: any, id: string, name: string }>, assetsAggregate: { __typename?: 'assets_aggregate', aggregate?: { __typename?: 'assets_aggregate_fields', count: number } | null } };

export type PostsByStatusAndOwnedPostsQueryVariables = Exact<{
  classification: Scalars['String'];
  subClass: Scalars['String'];
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  owner: Scalars['String'];
}>;


export type PostsByStatusAndOwnedPostsQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, code?: string | null, state: Asset_States_Enum, description?: string | null, assetTypeId?: string | null, location: any, attributes: any, updatedAt?: any | null, assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> }> };

export type PostsByStatusQueryVariables = Exact<{
  classification: Scalars['String'];
  subClass: Scalars['String'];
  status?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type PostsByStatusQuery = { __typename?: 'query_root', assets: Array<{ __typename?: 'assets', id: string, name: string, code?: string | null, state: Asset_States_Enum, description?: string | null, assetTypeId?: string | null, location: any, attributes: any, updatedAt?: any | null, assetProperties: Array<{ __typename?: 'assetProperties', id: string, assetId: string, value: any, createdAt: any, updatedAt: any }> }> };

export type CreateAssetMutationVariables = Exact<{
  assetTypeId: Scalars['String'];
  attributes: Scalars['jsonb'];
  description: Scalars['String'];
  location: Scalars['jsonb'];
  name: Scalars['String'];
  code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Asset_States_Enum>;
  owner?: InputMaybe<Scalars['String']>;
}>;


export type CreateAssetMutation = { __typename?: 'mutation_root', createAsset?: { __typename?: 'assets', id: string, assetTypeId?: string | null, attributes: any, description?: string | null, location: any, name: string, owner?: string | null } | null };

export type DeleteAssetsMutationVariables = Exact<{
  _in?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
}>;


export type DeleteAssetsMutation = { __typename?: 'mutation_root', deleteAssets?: { __typename?: 'assets_mutation_response', returning: Array<{ __typename?: 'assets', id: string }> } | null };

export type UpdateAssetMutationVariables = Exact<{
  assetTypeId: Scalars['String'];
  attributes: Scalars['jsonb'];
  code?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Asset_States_Enum>;
  description: Scalars['String'];
  id: Scalars['String'];
  location: Scalars['jsonb'];
  name: Scalars['String'];
}>;


export type UpdateAssetMutation = { __typename?: 'mutation_root', updateAssets?: { __typename?: 'assets_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'assets', attributes: any, code?: string | null, state: Asset_States_Enum, description?: string | null, location: any, name: string, owner?: string | null }> } | null };

export type UpdatePostLatestSerialNumberMutationVariables = Exact<{
  attributes: Scalars['jsonb'];
  id: Scalars['String'];
}>;


export type UpdatePostLatestSerialNumberMutation = { __typename?: 'mutation_root', updateAssetTypes?: { __typename?: 'assetTypes_mutation_response', affected_rows: number } | null };

export type LineNotificationServicesQueryVariables = Exact<{ [key: string]: never; }>;


export type LineNotificationServicesQuery = { __typename?: 'query_root', notificationServices: Array<{ __typename?: 'notificationServices', id: string, name?: string | null, notificationSettings: Array<{ __typename?: 'notificationSettings', id: string, notificationServiceId: string, tenantId: string, settings: any }> }> };

export type NotificationConditionsQueryVariables = Exact<{
  assetId: Scalars['String'];
}>;


export type NotificationConditionsQuery = { __typename?: 'query_root', notificationConditions: Array<{ __typename?: 'notificationConditions', id: string }> };

export type CreateNotificationTargetsMutationVariables = Exact<{
  notificationUserId: Scalars['String'];
  notificationConditionId: Scalars['String'];
  state: Notification_Target_States_Enum;
}>;


export type CreateNotificationTargetsMutation = { __typename?: 'mutation_root', createNotificationTargets?: { __typename?: 'notificationTargets_mutation_response', returning: Array<{ __typename?: 'notificationTargets', id: string }> } | null };

export type NotificationTargetsQueryVariables = Exact<{
  notificationUserId: Scalars['String'];
  notificationConditionId: Scalars['String'];
}>;


export type NotificationTargetsQuery = { __typename?: 'query_root', notificationTargets: Array<{ __typename?: 'notificationTargets', id: string }> };

export type TenantPublicInfoQueryVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type TenantPublicInfoQuery = { __typename?: 'query_root', tenantPublicInfo: Array<{ __typename?: 'TenantPublicInfoByAppSync', id?: string | null, renderingResources?: any | null, serviceId?: string | null, createdAt?: any | null, updatedAt?: any | null } | null> };


export const GetAssetsByAssetTypeDocument = `
    query getAssetsByAssetType($assetTypeId: String!) {
  assets(where: {assetTypeId: {_eq: $assetTypeId}}) {
    id
    name
    assetTypeId
    description
    location
    attributes
    updatedAt
  }
}
    `;
export const GetAssetsByAssetIdDocument = `
    query getAssetsByAssetId($assetId: String!) {
  assets(where: {id: {_eq: $assetId}}) {
    id
    name
    assetTypeId
    location
    code
    state
    attributes
    updatedAt
  }
}
    `;
export const AssetsByAssetTypesDocument = `
    query assetsByAssetTypes($_in: [String!], $_stateFilter1: asset_states_enum, $_stateFilter2: asset_states_enum) {
  assets(
    where: {assetTypeId: {_in: $_in}, _or: [{state: {_eq: $_stateFilter1}}, {state: {_eq: $_stateFilter2}}]}
  ) {
    id
    name
    code
    state
    description
    assetTypeId
    location
    attributes
    updatedAt
    assetProperties {
      id
      assetId
      value
      createdAt
      updatedAt
    }
  }
}
    `;
export const AssetsByAssetTypesWithAssetPropertiesDocument = `
    query assetsByAssetTypesWithAssetProperties($_in: [String!], $_stateFilter1: asset_states_enum, $_stateFilter2: asset_states_enum) {
  assets(
    where: {assetTypeId: {_in: $_in}, _or: [{state: {_eq: $_stateFilter1}}, {state: {_eq: $_stateFilter2}}]}
  ) {
    id
    name
    code
    state
    description
    assetTypeId
    location
    attributes
    state
    updatedAt
    assetProperties {
      id
      assetId
      value
      createdAt
      updatedAt
    }
  }
}
    `;
export const AssetTypesDocument = `
    query assetTypes {
  assetTypes {
    id
    name
    attributes
    assetAttributesSchema
  }
}
    `;
export const AssetTypesByAssetTypeIdDocument = `
    query assetTypesByAssetTypeId($assetTypeId: String!) {
  assetTypes(where: {id: {_eq: $assetTypeId}}) {
    id
    name
    attributes
    assetAttributesSchema
  }
}
    `;
export const LinkAssetTypesDocument = `
    query linkAssetTypes($mapTypeFlg: String!) {
  assetTypes(
    where: {attributes: {_contains: {classification: "link", mapType: $mapTypeFlg}}}
  ) {
    id
    name
    attributes
  }
}
    `;
export const MessageDocument = `
    query message($assetId: String!) {
  messages(
    limit: 1
    order_by: {updatedAt: desc}
    where: {assetId: {_eq: $assetId}}
  ) {
    id
    assetId
    assetTypeId
    location
    properties
  }
}
    `;
export const RangeOfMessagesDocument = `
    query rangeOfMessages($orderByCreatedAt: order_by!, $limit: Int!, $assetId: String!, $startTime: bigint!, $endTime: bigint!) {
  messages(
    limit: $limit
    order_by: {createdAt: $orderByCreatedAt}
    where: {assetId: {_eq: $assetId}, createdAt: {_gte: $startTime, _lte: $endTime}}
  ) {
    id
    assetId
    assetTypeId
    location
    properties
    createdAt
    updatedAt
  }
}
    `;
export const MessageByBusStopDocument = `
    query messageByBusStop($jsonFilter: jsonb, $startDatetime: bigint) {
  events(
    limit: 5
    order_by: {occurredDatetime: desc}
    where: {compareDefinition: {_contains: $jsonFilter}, occurredDatetime: {_gte: $startDatetime}}
  ) {
    id
    assetId
    action
    occurredDatetime
    compareDefinition
    label
  }
}
    `;
export const MessagesDocument = `
    query messages($assetId: String!) {
  messages(
    limit: 7
    order_by: {updatedAt: desc}
    where: {assetId: {_eq: $assetId}}
  ) {
    id
    assetId
    assetTypeId
    properties
    createdAt
  }
}
    `;
export const AssetPropertiesDocument = `
    query assetProperties($assetId: String!) {
  assetProperties(where: {assetId: {_eq: $assetId}, name: {_eq: "status"}}) {
    id
    assetId
    value
    createdAt
    updatedAt
  }
}
    `;
export const MessagesByAssetTypesDocument = `
    query messagesByAssetTypes($assetTypeIds: [String!], $_stateFilter1: asset_states_enum, $_stateFilter2: asset_states_enum, $periodTime: bigint!) {
  assets(
    where: {assetTypeId: {_in: $assetTypeIds}, _or: [{state: {_eq: $_stateFilter1}}, {state: {_eq: $_stateFilter2}}]}
  ) {
    id
    assetTypeId
    messages(
      limit: 1
      where: {updatedAt: {_gte: $periodTime}}
      order_by: {updatedAt: desc}
    ) {
      id
      assetId
      createdAt
      location
      properties
      updatedAt
    }
  }
}
    `;
export const AssetPropertiesByAssetTypesDocument = `
    query assetPropertiesByAssetTypes($assetTypeIds: [String!], $_stateFilter1: asset_states_enum, $_stateFilter2: asset_states_enum) {
  assets(
    where: {assetTypeId: {_in: $assetTypeIds}, _or: [{state: {_eq: $_stateFilter1}}, {state: {_eq: $_stateFilter2}}]}
  ) {
    id
    name
    code
    state
    description
    assetTypeId
    location
    attributes
    state
    assetProperties {
      id
      assetId
      value
      createdAt
      updatedAt
    }
  }
}
    `;
export const UserByUsernameDocument = `
    query userByUsername($username: String!) {
  users(where: {username: {_eq: $username}}) {
    id
    usersGroups(limit: 10000) {
      groupId
    }
  }
  groups {
    id
    name
  }
}
    `;
export const PostsWithSpotTypeByOwnerDocument = `
    query postsWithSpotTypeByOwner($classification: String!, $subClass: String!, $owner: String!) {
  assets(
    where: {assetTypes: {attributes: {_contains: {classification: $classification}}}, _and: {assetTypes: {attributes: {_contains: {subClass: $subClass}}}}, owner: {_eq: $owner}}
  ) {
    description
    assetTypes {
      id
      name
    }
    attributes
    id
    location
    name
    owner
    updatedAt
    createdAt
  }
  assetTypes(
    where: {attributes: {_contains: {classification: $classification}}, _and: {attributes: {_contains: {subClass: $subClass}}}}
  ) {
    assetAttributesSchema
    attributes
    id
    name
  }
  assetsAggregate(
    where: {assetTypes: {attributes: {_contains: {classification: $classification}}}, _and: {assetTypes: {attributes: {_contains: {subClass: $subClass}}}}, owner: {_eq: $owner}}
  ) {
    aggregate {
      count
    }
  }
}
    `;
export const PostsByStatusAndOwnedPostsDocument = `
    query postsByStatusAndOwnedPosts($classification: String!, $subClass: String!, $status: [String!], $owner: String!) {
  assets(
    where: {assetTypes: {attributes: {_contains: {classification: $classification}}}, _and: {assetTypes: {attributes: {_contains: {subClass: $subClass}}}}, _or: [{attributes: {_contains: {status: $status}}}, {owner: {_eq: $owner}}]}
  ) {
    id
    name
    code
    state
    description
    assetTypeId
    location
    attributes
    state
    updatedAt
    assetProperties {
      id
      assetId
      value
      createdAt
      updatedAt
    }
  }
}
    `;
export const PostsByStatusDocument = `
    query postsByStatus($classification: String!, $subClass: String!, $status: [String!]) {
  assets(
    where: {assetTypes: {attributes: {_contains: {classification: $classification}}}, _and: {assetTypes: {attributes: {_contains: {subClass: $subClass}}}, attributes: {_contains: {status: $status}}}}
  ) {
    id
    name
    code
    state
    description
    assetTypeId
    location
    attributes
    state
    updatedAt
    assetProperties {
      id
      assetId
      value
      createdAt
      updatedAt
    }
  }
}
    `;
export const CreateAssetDocument = `
    mutation createAsset($assetTypeId: String!, $attributes: jsonb!, $description: String!, $location: jsonb!, $name: String!, $code: String, $state: asset_states_enum, $owner: String) {
  createAsset(
    object: {assetTypeId: $assetTypeId, attributes: $attributes, description: $description, location: $location, name: $name, code: $code, state: $state, owner: $owner}
  ) {
    id
    assetTypeId
    attributes
    description
    location
    name
    owner
  }
}
    `;
export const DeleteAssetsDocument = `
    mutation deleteAssets($_in: [String!]) {
  deleteAssets(where: {id: {_in: $_in}}) {
    returning {
      id
    }
  }
}
    `;
export const UpdateAssetDocument = `
    mutation updateAsset($assetTypeId: String!, $attributes: jsonb!, $code: String, $state: asset_states_enum, $description: String!, $id: String!, $location: jsonb!, $name: String!) {
  updateAssets(
    where: {id: {_eq: $id}}
    _set: {assetTypeId: $assetTypeId, attributes: $attributes, code: $code, state: $state, description: $description, location: $location, name: $name}
  ) {
    affected_rows
    returning {
      attributes
      code
      state
      description
      location
      name
      owner
    }
  }
}
    `;
export const UpdatePostLatestSerialNumberDocument = `
    mutation updatePostLatestSerialNumber($attributes: jsonb!, $id: String!) {
  updateAssetTypes(where: {id: {_eq: $id}}, _set: {attributes: $attributes}) {
    affected_rows
  }
}
    `;
export const LineNotificationServicesDocument = `
    query lineNotificationServices {
  notificationServices(where: {name: {_eq: "LINE"}}) {
    id
    name
    notificationSettings {
      id
      notificationServiceId
      tenantId
      settings
    }
  }
}
    `;
export const NotificationConditionsDocument = `
    query notificationConditions($assetId: String!) {
  notificationConditions(where: {assetId: {_eq: $assetId}}) {
    id
  }
}
    `;
export const CreateNotificationTargetsDocument = `
    mutation createNotificationTargets($notificationUserId: String!, $notificationConditionId: String!, $state: notification_target_states_enum!) {
  createNotificationTargets(
    objects: {notificationUserId: $notificationUserId, notificationConditionId: $notificationConditionId, state: $state}
  ) {
    returning {
      id
    }
  }
}
    `;
export const NotificationTargetsDocument = `
    query notificationTargets($notificationUserId: String!, $notificationConditionId: String!) {
  notificationTargets(
    where: {notificationUserId: {_eq: $notificationUserId}, notificationConditionId: {_eq: $notificationConditionId}}
  ) {
    id
  }
}
    `;
export const TenantPublicInfoDocument = `
    query tenantPublicInfo($serviceId: String!) {
  tenantPublicInfo(where: {serviceId: {_eq: $serviceId}}) {
    id
    renderingResources
    serviceId
    createdAt
    updatedAt
  }
}
    `;

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAssetsByAssetType: build.query<GetAssetsByAssetTypeQuery, GetAssetsByAssetTypeQueryVariables>({
      query: (variables) => ({ document: GetAssetsByAssetTypeDocument, variables })
    }),
    getAssetsByAssetId: build.query<GetAssetsByAssetIdQuery, GetAssetsByAssetIdQueryVariables>({
      query: (variables) => ({ document: GetAssetsByAssetIdDocument, variables })
    }),
    assetsByAssetTypes: build.query<AssetsByAssetTypesQuery, AssetsByAssetTypesQueryVariables | void>({
      query: (variables) => ({ document: AssetsByAssetTypesDocument, variables })
    }),
    assetsByAssetTypesWithAssetProperties: build.query<AssetsByAssetTypesWithAssetPropertiesQuery, AssetsByAssetTypesWithAssetPropertiesQueryVariables | void>({
      query: (variables) => ({ document: AssetsByAssetTypesWithAssetPropertiesDocument, variables })
    }),
    assetTypes: build.query<AssetTypesQuery, AssetTypesQueryVariables | void>({
      query: (variables) => ({ document: AssetTypesDocument, variables })
    }),
    assetTypesByAssetTypeId: build.query<AssetTypesByAssetTypeIdQuery, AssetTypesByAssetTypeIdQueryVariables>({
      query: (variables) => ({ document: AssetTypesByAssetTypeIdDocument, variables })
    }),
    linkAssetTypes: build.query<LinkAssetTypesQuery, LinkAssetTypesQueryVariables>({
      query: (variables) => ({ document: LinkAssetTypesDocument, variables })
    }),
    message: build.query<MessageQuery, MessageQueryVariables>({
      query: (variables) => ({ document: MessageDocument, variables })
    }),
    rangeOfMessages: build.query<RangeOfMessagesQuery, RangeOfMessagesQueryVariables>({
      query: (variables) => ({ document: RangeOfMessagesDocument, variables })
    }),
    messageByBusStop: build.query<MessageByBusStopQuery, MessageByBusStopQueryVariables | void>({
      query: (variables) => ({ document: MessageByBusStopDocument, variables })
    }),
    messages: build.query<MessagesQuery, MessagesQueryVariables>({
      query: (variables) => ({ document: MessagesDocument, variables })
    }),
    assetProperties: build.query<AssetPropertiesQuery, AssetPropertiesQueryVariables>({
      query: (variables) => ({ document: AssetPropertiesDocument, variables })
    }),
    messagesByAssetTypes: build.query<MessagesByAssetTypesQuery, MessagesByAssetTypesQueryVariables>({
      query: (variables) => ({ document: MessagesByAssetTypesDocument, variables })
    }),
    assetPropertiesByAssetTypes: build.query<AssetPropertiesByAssetTypesQuery, AssetPropertiesByAssetTypesQueryVariables | void>({
      query: (variables) => ({ document: AssetPropertiesByAssetTypesDocument, variables })
    }),
    userByUsername: build.query<UserByUsernameQuery, UserByUsernameQueryVariables>({
      query: (variables) => ({ document: UserByUsernameDocument, variables })
    }),
    postsWithSpotTypeByOwner: build.query<PostsWithSpotTypeByOwnerQuery, PostsWithSpotTypeByOwnerQueryVariables>({
      query: (variables) => ({ document: PostsWithSpotTypeByOwnerDocument, variables })
    }),
    postsByStatusAndOwnedPosts: build.query<PostsByStatusAndOwnedPostsQuery, PostsByStatusAndOwnedPostsQueryVariables>({
      query: (variables) => ({ document: PostsByStatusAndOwnedPostsDocument, variables })
    }),
    postsByStatus: build.query<PostsByStatusQuery, PostsByStatusQueryVariables>({
      query: (variables) => ({ document: PostsByStatusDocument, variables })
    }),
    createAsset: build.mutation<CreateAssetMutation, CreateAssetMutationVariables>({
      query: (variables) => ({ document: CreateAssetDocument, variables })
    }),
    deleteAssets: build.mutation<DeleteAssetsMutation, DeleteAssetsMutationVariables | void>({
      query: (variables) => ({ document: DeleteAssetsDocument, variables })
    }),
    updateAsset: build.mutation<UpdateAssetMutation, UpdateAssetMutationVariables>({
      query: (variables) => ({ document: UpdateAssetDocument, variables })
    }),
    updatePostLatestSerialNumber: build.mutation<UpdatePostLatestSerialNumberMutation, UpdatePostLatestSerialNumberMutationVariables>({
      query: (variables) => ({ document: UpdatePostLatestSerialNumberDocument, variables })
    }),
    lineNotificationServices: build.query<LineNotificationServicesQuery, LineNotificationServicesQueryVariables | void>({
      query: (variables) => ({ document: LineNotificationServicesDocument, variables })
    }),
    notificationConditions: build.query<NotificationConditionsQuery, NotificationConditionsQueryVariables>({
      query: (variables) => ({ document: NotificationConditionsDocument, variables })
    }),
    createNotificationTargets: build.mutation<CreateNotificationTargetsMutation, CreateNotificationTargetsMutationVariables>({
      query: (variables) => ({ document: CreateNotificationTargetsDocument, variables })
    }),
    notificationTargets: build.query<NotificationTargetsQuery, NotificationTargetsQueryVariables>({
      query: (variables) => ({ document: NotificationTargetsDocument, variables })
    }),
    tenantPublicInfo: build.query<TenantPublicInfoQuery, TenantPublicInfoQueryVariables>({
      query: (variables) => ({ document: TenantPublicInfoDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useGetAssetsByAssetTypeQuery, useLazyGetAssetsByAssetTypeQuery, useGetAssetsByAssetIdQuery, useLazyGetAssetsByAssetIdQuery, useAssetsByAssetTypesQuery, useLazyAssetsByAssetTypesQuery, useAssetsByAssetTypesWithAssetPropertiesQuery, useLazyAssetsByAssetTypesWithAssetPropertiesQuery, useAssetTypesQuery, useLazyAssetTypesQuery, useAssetTypesByAssetTypeIdQuery, useLazyAssetTypesByAssetTypeIdQuery, useLinkAssetTypesQuery, useLazyLinkAssetTypesQuery, useMessageQuery, useLazyMessageQuery, useRangeOfMessagesQuery, useLazyRangeOfMessagesQuery, useMessageByBusStopQuery, useLazyMessageByBusStopQuery, useMessagesQuery, useLazyMessagesQuery, useAssetPropertiesQuery, useLazyAssetPropertiesQuery, useMessagesByAssetTypesQuery, useLazyMessagesByAssetTypesQuery, useAssetPropertiesByAssetTypesQuery, useLazyAssetPropertiesByAssetTypesQuery, useUserByUsernameQuery, useLazyUserByUsernameQuery, usePostsWithSpotTypeByOwnerQuery, useLazyPostsWithSpotTypeByOwnerQuery, usePostsByStatusAndOwnedPostsQuery, useLazyPostsByStatusAndOwnedPostsQuery, usePostsByStatusQuery, useLazyPostsByStatusQuery, useCreateAssetMutation, useDeleteAssetsMutation, useUpdateAssetMutation, useUpdatePostLatestSerialNumberMutation, useLineNotificationServicesQuery, useLazyLineNotificationServicesQuery, useNotificationConditionsQuery, useLazyNotificationConditionsQuery, useCreateNotificationTargetsMutation, useNotificationTargetsQuery, useLazyNotificationTargetsQuery, useTenantPublicInfoQuery, useLazyTenantPublicInfoQuery } = injectedRtkApi;

